import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterUser_template} from "./filterUser_template";
import { filterWebsiteUser_template } from "./filterWebsiteUser_template";
import {
    filterDropdown_template
} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {
    filterSingleDate_template
} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingleDate_template';
import {
    imagePicker_template
} from '../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template';
import {
    multipleSelector_template
} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterTag_template} from "./filterTag_template";
import {filterDataset_template} from "./filterDataset_template";
import {filterArticle_template} from "./filterArticle_template";
import {filterAutocomplete_template} from "./filterAutocomplete_template";
import {productReview_template} from "./productReview_template";
import {articleContent_template} from "./articleContent_template";
import {productReviewView_template} from "./productReviewVIew_template.";
import {articleReviewHistory_template} from "./articleReviewHistory_template";
import {directoryEdit_template} from './directoryEdit_template';
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import {articleUserList_template, User} from "./articleUserList_template";
import {tagPicker_template} from "./tagPicker_template";
import {quizPicker_template} from "./quizPicker_template";
import {pollPicker_template} from "./pollPicker_template";
import * as rfdc from "rfdc";
import {articlePinnedTags_template} from "./articlePinnedTags_template";
import {imageWidget_template} from "./imageWidget_template";
import {articleAnalytics_template} from "./articleAnalytics_template";
import {directoryView_template} from "./directoryView_template";
import {articleRecommendations_template} from "./articleRecommendations_template";

import {warningDialog_template} from "./warningDialog_template";
import {disableAllEditors} from "../../utils/Helpers";
import {DragAndDropHandler} from "../../utils/DragAndDropHandler";
import videoPicker_template from '../../../vendor/valnet/valnet_imagePicker/js/components/templates/videoPicker_template';
import {articlePicker_template} from "./articlePicker_template";
import {articlePicker_helper} from "../../modules/articlePicker_helper";
import {vignettePicker_template} from "./vignettePicker_template";
import {vignettePicker_helper} from "../../modules/vignettePicker_helper";
import EmbedsSizesGenerator from "../../utils/embeds/EmbedsSizesGenerator";
import {EmbedInfo, Result, ViewportSize} from "../../utils/embeds/types";

import {imagePickerHelper} from '../../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper';
import {videoPickerHelper} from '../../../vendor/valnet/valnet_imagePicker/js/modules/videoPickerHelper';
import { genericPrompt_template } from "./genericPrompt_template";
import { eeatScorePanel_template } from "./eeatScorePanel_template";
import EmbedHelper, { embedTypesList } from "../../utils/EmbedHelper";
import sensai_chat_template from "./sensai_chat_template";
import sensaiFeatureFeedback_template from "./sensaiFeatureFeedback_template";
import {articles_edit_new} from '../../modules/articles_edit_new';
import { AnchorPopup, AnchorPopupPlacement } from "../../utils/AnchorPopup";
import { publishAIActions_template } from "./publishAIActions_template";
import {filterListingPage_template} from "./filterListingPage_template";
import {HubPageSearchResult} from "../../utils/types/listing_page";
import {isImageCropPositionEnabled} from "../../utils/BrandHelper";

declare var ko: any;
declare var CKEDITOR: any;

enum Tab {
    ARTICLE = 'article',
    REVISION = 'revision',
    SANDBOX = 'sandbox',
    RECOVERY = 'recovery',
    REPUBLISH = 'republish',
    NEWSLETTER = 'newsletter',
    REVIEWS = 'reviews',
}
enum Previewable {
    ARTICLE = 'article',
    SANDBOX = 'sandbox',
    REPUBLISH = 'republish',
}

/** Output dimensions each image slot is cropped to, used for previews and crop bounds. */
const CROP_OUTPUT_SIZES: { [slot: string]: { width: number, height: number } } = {
    featuredImage: { width: 1600, height: 900 },
    featuredImageMobile: { width: 480, height: 360 },
    thumbnailImage: { width: 400, height: 300 }
};

enum Recoverable {
    CONTENT = 'content',
    SANDBOX = 'sandbox',
    REPUBLISH = 'republish',
}

enum ArticleStatus {
    DRAFT = 1,
    SUBMIT_FOR_APPROVAL,
    CHANGES_REQUIRED,
    COMPLETED = 6,
    TRASH,
    SANDBOX
}

enum AuthorPaymentTypeForRepublish {
    AMOUNT = "Amount",
    PERCENTAGE = "Percentage"
}

enum EmbedContext {
    FEATURED = "featured",
    CONTENT = "content"
}

const ID_TEMPLATE_VIDEO = 15;
const ID_TEMPLATE_THREAD = 16;
const ARTICLE_TITLE_MAX_CHARS = 1000;
const TEMPLATE_VIDEO_ENABLED = true;

const ID_PREMIUM_CLASSFICATION = 2;

let quizUniqueIdCounter = 0;
export class articlesEdit_template_new extends vnTemplate {

    DEFAULT_ARTICLE_TEMPLATE_ID = 2 //Regular
    set featureImageToolTip(value: infoButton_template) {
        this._featureImageToolTip = value;
    }


    protected filterUser_author: filterUser_template;
    protected filterUser_SrEditor: filterUser_template;
    protected filterUser_JrEditor: filterUser_template;
    protected filterUser_ideator: filterUser_template;
    public filterUser_republish_author: filterUser_template;
    public filterUser_republish_SrEditor: filterUser_template;
    public filterUser_republish_JrEditor: filterUser_template;
    public filterUser_scheduled_republish_author: filterUser_template;
    public filterUser_scheduled_republish_SrEditor: filterUser_template;
    public filterUser_scheduled_republish_JrEditor: filterUser_template;
    protected filterUser_display_author: filterUser_template;
    protected filterWebsiteUser_prompt_author: filterWebsiteUser_template;
    protected toolTip_prompt_author: infoButton_template;
    protected display_authors: articleUserList_template;
    public paymentCategoryFilter: filterDropdown_template;
    public scheduledRepublishPaymentCategoryFilter: filterDropdown_template;
    public filterCategory: multipleSelector_template;
    public filterTag: filterTag_template;
    public filterDataset: filterDataset_template;
    public datePicker: filterSingleDate_template;
    public scheduleDatePicker: filterSingleDate_template;
    public giveawayDatePicker: filterSingleDate_template;
    public republishDatePicker: filterSingleDate_template;
    public scheduledRepublishDatePicker: filterSingleDate_template;
    public dateDevelopingStoryCoverageStartPicker: filterSingleDate_template;
    public dateDevelopingStoryCoverageEndPicker: filterSingleDate_template;
    protected developingStoryCoverageToolTip: infoButton_template;
    protected developingStoryCoverageToolTipContent;
    public sensaiPromptTemplate: genericPrompt_template;
    public imagePicker: imagePicker_template;
    public filterArticle: filterArticle_template;
    public filterArticleDirectory: filterArticle_template;
    public articleDirectory: directoryEdit_template;
    public sandboxDirectory: directoryEdit_template;
    public revisionDirectory: directoryView_template;
    public recoveryDirectory: directoryView_template;
    public recoverySandboxDirectory: directoryView_template;
    public recoveryRepublishDirectory: directoryView_template;
    protected productReview: productReview_template;
    public productReviewSandbox: productReview_template;
    public productReviewRepublish: productReview_template;
    protected articleContent: articleContent_template;
    protected sandboxContent: articleContent_template;
    protected republishContent: articleContent_template;
    protected recoveryReviewSection: productReviewView_template;
    protected recoverySandboxReviewSection: productReviewView_template;
    protected recoveryRepublishReviewSection: productReviewView_template;
    protected articleAnalytics: articleAnalytics_template;
    protected articleReviewHistory: articleReviewHistory_template;
    protected revisionReviewSection: productReviewView_template;
    protected toolTipButton : infoButton_template;
    protected customRecipientsToolTipButton : infoButton_template;

    protected pinnedTagTooltip: infoButton_template;
    protected pinnedTagTooltipContent;
    protected selectProductTooltip: infoButton_template;
    protected selectProductTooltipContent;

    private _mobilePreviewToolTip: infoButton_template;
    protected mobilePreviewTooltipContent;

    private _featureImageToolTip: infoButton_template;
    protected featureImageTooltipContent;

    protected featuredTagSectionFeaturedImagePreview;
    protected featuredTagImagePreviewToolTip: infoButton_template;
    protected featuredTagSectionThumbnailImagePreview;
    protected featuredTagThumbnailPreviewToolTip: infoButton_template;

    protected thumbnailImageToolTip: infoButton_template;
    protected thumbnailImageTooltipContent;
    protected alternateSocialMediaImageToolTip: infoButton_template;
    protected alternateSocialMediaImageTooltipContent;

    protected emakiLabHelperTooltipContent;
    protected emakiLabHelperTooltip: infoButton_template;
    protected previewableTabs: Array<string> = [Previewable.ARTICLE, Previewable.SANDBOX, Previewable.REPUBLISH];
    public filterProducts: filterAutocomplete_template;
    public filterProductTypes: filterAutocomplete_template;
    public filterAffiliates: filterAutocomplete_template;
    public filterAiAgent: filterAutocomplete_template;
    public tagPicker: tagPicker_template;
    public quizPicker: quizPicker_template;
    public pollPicker: pollPicker_template;
    public filterPinnedTag: filterAutocomplete_template;
    public articlePinnedTags: articlePinnedTags_template;
    public articlePicker: articlePicker_template;
    public articlePickerHelper: articlePicker_helper;
    public vignettePicker: vignettePicker_template;
    public vignettePickerHelper: vignettePicker_helper;
    public filterReviewTag: filterAutocomplete_template;

    protected copyLeaksResultsSectionTooltipContent;
    protected copyLeaksResultsSectionTooltip: infoButton_template;

    public imageWidgetForThumbnailImage : imageWidget_template;
    public imageWidgetForAlternateImage : imageWidget_template;
    public imageWidgetForFeaturedImage : imageWidget_template;
    public imageWidgetForTagImageGroup : imageWidget_template;
    public imageWidgetForTagIcon : imageWidget_template;

    public warningDialog_WhenLogOut : warningDialog_template;
    public warningDialog_WhenArticleLock : warningDialog_template;

    public videoInstructionToolTip : infoButton_template;

    // public imageWidgetForFeaturedVideo : imageWidget_template

    public videoPicker : videoPicker_template;
    public sensaiFeatureFeedback: sensaiFeatureFeedback_template;

    public republishDirectory: directoryEdit_template;
    public warningDialog_sandboxDelete : warningDialog_template;
    public warningDialog_newsletterSendingConfirmation : warningDialog_template;
    public warningDialog_republishDelete : warningDialog_template;
    public warningDialog_republishCreateAndUpdate : warningDialog_template;
    public warningDialog_articleAiFaq : warningDialog_template;
    public warningDialog_threadSummary : warningDialog_template;
    public warningDialog_audioReader : warningDialog_template;
    public updateTimeToolTipButton: infoButton_template;
    public newsletterDateScheduledSelector: filterSingleDate_template;

    public eeatScorePanel: eeatScorePanel_template;
    private newsletterTemplateSelector: filterDropdown_template;
    public imagePickerHelper: imagePickerHelper;
    public videoPickerHelper: videoPickerHelper;
    public embedHelper: EmbedHelper;
    public sourceNewsDatePicker: filterSingleDate_template;

    public articleRecommendations: articleRecommendations_template;

    public sensaiChat: sensai_chat_template;
    public dealsCategoryPromotionListingPageFilter: filterListingPage_template;
    protected delay = 4000;
    protected debounceTimerId: number;
    private documentClickHandler?: (event: MouseEvent) => void;
    private popstateHandler?: () => void;
    private saveShortcutHandler?: (event: KeyboardEvent) => void;
    private saveShortcutPopstateHandler?: () => void;
    private saveShortcutBeforeUnloadHandler?: () => void;
    private currentUrl = window.location.href;
    protected isAiWidgetPopupDismissed: boolean = false;
    protected aiWidgetPublishAnchorPopup: AnchorPopup | null = null;
    protected aiWidgetActionsTemplate: publishAIActions_template | null = null;

    protected getTemplateHtml(): string {

        return /* html */ `

            <!-- faq add form -->
            <div class="w-form w-form-sub faq" data-bind="css: { 'is-showing' : isFaqAddFormShown }" xmlns="http://www.w3.org/1999/html">
                    <div class="form-header">
                        <h3 class="form-title">Add FAQ</h3>
                        <button class="close-button icon i-close-2" type="button" data-bind="event: { click: onClickCancelFaq }"></button>
                    </div>
                    <div class="w-form-body">
                        <div class="form-body full-width">
                            <div class="form-group inside-label">
                                <label for="" class="form-label">Question</label>
                                <textarea type="text" class="input-text" data-bind="value: question" data-bind="disable: idStatus() == 6 && !permissions()['article_edit_publishingControl'].write"></textarea>
                            </div>
                            <div class="form-group">
                                <label for="article_faq" class="form-label">Answer</label>
                                <textarea id="article_faq"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="form-footer">
                        <button class="btn" type="button" data-bind="event: { click: onClickCancelFaq }">Cancel</button>
                        <button class="btn highlight" type="button" data-bind="event: { click: onClickSaveFaq }">Add</button>
                    </div>
            </div>
            <!-- /faq add form end -->

            <!-- template selector -->
            <div class="w-form temp-selector-new" data-bind="css: { 'is-showing' : idTemplate() == ''}"> <!-- .is-showing -->
                    <div class="form-header">
                        <strong class="form-title">Select Preset</strong>
                        <button class="close-button icon i-close-2" type="button" data-bind="event: { click: onClickCancel }"></button>
                    </div>
                    <div class="w-form-body">
                        <div class="form-body">
                            <div class="form-group group-1">
                                <button class="btn-temp-new temp-regular" type="button" data-bind="event: { click: onClickTemplateTab.bind($data, 2) }"><div class="w-icon"><span class="icon i-regular-template"></span></div><div class="temp-info"><span>Regular</span><p>News, editorials, how-tos, general content</p></div></button>
                                <button class="btn-temp-new temp-list" type="button" data-bind="event: { click: onClickTemplateTab.bind($data, 3) }"><div class="w-icon"><span class="icon i-regular-template"></span></div><div class="temp-info"><span>List</span><p>Rankings, top lists, tips, groups of similar content</p></div></button>
                                <button class="btn-temp-new temp-regular" type="button" data-bind="event: { click: onClickTemplateTab.bind($data, 14) }"><div class="w-icon"><span class="icon i-regular-template"></div><div class="temp-info"><span>How to Watch</span><p>In-depth how-to focused guide</p></div></button>
                                <!--<button class="btn-temp temp-product-review" type="button" data-bind="event: { click: onClickTemplateTab.bind($data, 5) }"><img src="/assets/images/template-selector/temp-product-review.png" alt=""><div class="temp-info"><span>Product Review</span><p>Deep examination of a single product</p></div></button>-->
                                <!--<button class="btn-temp temp-buyers-guide" type="button" data-bind="event: { click: onClickTemplateTab.bind($data, 6) }"><img src="/assets/images/template-selector/temp-buyers-guide.png" alt=""><div class="temp-info"><span>Buyer's Guide</span><p>In-depth comparison of multiple products</p></div></button>-->
                            </div>
                            <div class="form-group group-2">
                                <button class="btn-temp-new temp-directory" type="button" data-bind="event: { click: onClickTemplateTab.bind($data, 7) }"><div class="w-icon"><span class="icon i-directory-template"></div><div class="temp-info"><span>Directory</span><p>Shared table of contents for a group of articles</p></div></button>
                            </div>
                            <div class="form-group group-3">
                                <button class="btn-temp-new temp-buyers-guide-light" type="button" data-bind="event: { click: onClickTemplateTab.bind($data, 9) }"><div class="w-icon"><span class="icon i-commerce-template"></div><div class="temp-info"><span>Buyer’s Guide Light</span><p>Lightweight commerce-focused purchasing guide</p></div></button>
                                <button class="btn-temp-new temp-buyers-guide-light" type="button" data-bind="event: { click: onClickTemplateTab.bind($data, 10) }"><div class="w-icon"><span class="icon i-commerce-template"></div><div class="temp-info"><span>Deals</span><p>Commerce-focused presentation of deals</p></div></button>
                                <button class="btn-temp-new temp-product-collection" type="button" data-bind="event: { click: onClickTemplateTab.bind($data, 12) }"><div class="w-icon"><span class="icon i-commerce-template"></div><div class="temp-info"><span>Collection</span><p>Quick comparison of several similar products</p></div></button>
                                <button class="btn-temp-new temp-versus" type="button" data-bind="event: { click: onClickTemplateTab.bind($data, 11) }"><div class="w-icon"><span class="icon i-commerce-template"></div><div class="temp-info"><span>Versus</span><p>In-depth comparison of two products with similar specs</p></div></button>
                            </div>
                            <div class="form-group group-4">
                                <button class="btn-temp-new" type="button" data-bind="event: { click: onClickTemplateTab.bind($data, 13) }"><div class="w-icon"><span class="icon i-sub-content-template"></div><div class="temp-info"><span>Sub-content</span><p>Published as child content of a listing page</p></div></button>
                                <button class="btn-temp-new" type="button" data-bind="event: { click: onClickTemplateTab.bind($data, 17) }"><div class="w-icon"><span class="icon i-sub-content-template"></div><div class="temp-info"><span>Sub-content with Sidebar</span><p>Published as child content with sidebar of a listing page</p></div></button>
                            </div>
                            <div class="form-group group-5">
                                <button class="btn-temp-new temp-regular" type="button" data-bind="event: { click: onClickTemplateTab.bind($data, ${ID_TEMPLATE_VIDEO}) }"><div class="w-icon"><span class="icon i-video-template"></span></div><div class="temp-info"><span>Video</span><p>Video-focused with supporting content</p></div></button>
                                <button class="btn-temp-new temp-regular" type="button" data-bind="event: { click: onClickTemplateTab.bind($data, ${ID_TEMPLATE_THREAD}) }"><div class="w-icon"><span class="icon i-thread-template"></span></div><div class="temp-info"><span>Thread</span><p>Focused on generating discussion on a topic</p></div></button>
                            </div>
                        </div>
                    </div>
            </div>
            <!-- /template selector end -->

            <!-- segment selector -->
            <div class="w-form temp-selector center" data-bind="css: { 'is-showing' : showSegmentTab}"> <!-- .is-showing -->
                <div class="form-header">
                    <strong class="form-title">Select Segment</strong>
                    <button class="close-button icon i-close-2" type="button" data-bind="event: { click: onClickCancel }"></button>
                </div>
                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group segments" data-bind="foreach : segments">
                            <button class="btn-temp temp-regular" type="button"
                            data-bind="event: { click: function() { $parent.onClickSegmentTab($data.id) } }">
                                <img data-bind="attr : { src: $data.logoPath }" alt="">
                                <div class="temp-info">
                                    <span data-bind="text : $data.name"></span>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /segment selector end -->

            <div class="ww-form w-form-article " data-bind="visible: (idTemplate() != '' && !showSegmentTab())">
                <div class="w-form w-form-large parent">
                    <div class="form-msg is-scheduled" data-bind="visible: idRepublish" >
                        <div>
                            <p class="icon i-scheduled">There is a scheduled republish for this article.  Changes to the article will not sync to the website until the schedule date is reached.</p>
                        </div>
                    </div>

                    <div class="form-pagination">
                        <button class=" icon" type="button" data-bind="event: { click: onClickTab.bind($data,'article') }, css: { 'is-activated' : selectedTab() == 'article'}"><span class="btn-text">Article</span></button>
                        <button class=" icon" type="button" data-bind="event: { click: onClickTab.bind($data,'settings') }, css: { 'is-activated' : selectedTab() == 'settings'}"><span class="btn-text">Attributes</span></button>
                        <!--<button class=" icon " type="button" data-bind="visible: (selectedTab() == 'republish' || isRepublishActive()), event: { click: onClickTab.bind($data,'republish') }, css: { 'is-activated' : selectedTab() == 'republish'}"><span class="btn-text">Republish Rewrite</span></button>
                        <button class=" icon" type="button" data-bind="visible: (selectedTab() == 'sandbox' || isSandboxActive()),  event: { click: onClickTab.bind($data,'sandbox') }, css: { 'is-activated' : selectedTab() == 'sandbox'}"><span class="btn-text">Sandbox</span></button>-->
                        <!-- ko if: idTemplate() != ${ID_TEMPLATE_VIDEO} && idTemplate() != ${ID_TEMPLATE_THREAD}  -->
                        <button class=" icon" type="button" data-bind="event: { click: onClickTab.bind($data,'sandboxAndRepublish') }, css: { 'is-activated' : selectedTab() == 'sandboxAndRepublish'}"><span class="btn-text">Sandbox / Republish</span></button>
                        <!-- /ko -->
                        <button class=" icon" type="button" data-bind="event: { click: onClickTab.bind($data,'extra') }, css: { 'is-activated' : selectedTab() == 'extra'}"><span class="btn-text">Additional Fields</span></button>
                        <button class=" icon" type="button" data-bind="event: { click: onClickTab.bind($data,'widgets') }, css: { 'is-activated' : selectedTab() == 'widgets'}"><span class="btn-text">Widgets</span></button>

                        <!-- ko if: idTemplate() != ${ID_TEMPLATE_VIDEO} && idTemplate() != ${ID_TEMPLATE_THREAD}  -->
                        <button class=" icon " type="button" data-bind="event: { click: onClickTab.bind($data,'revision') }, css: { 'is-activated' : selectedTab() == 'revision'}"><span class="btn-text">Revisions</span></button>
                        <!-- /ko -->

                        <!-- ko if: idTemplate() != ${ID_TEMPLATE_VIDEO} && idTemplate() != ${ID_TEMPLATE_THREAD}   -->
                        <button class=" icon recovery " type="button" data-bind="event: { click: onClickTab.bind($data,'recovery') }, css: { 'is-activated' : selectedTab() == 'recovery', 'highlight' : recoveryContent() != null || sandboxRecoveryContent() != null },"><span class="btn-text">Recovery </span></button>
                        <!-- /ko -->

                        <!-- ko if: idTemplate() != ${ID_TEMPLATE_VIDEO} && idTemplate() != ${ID_TEMPLATE_THREAD}   -->
                        <button class=" icon feedback " type="button" data-bind="event: { click: onClickTab.bind($data,'reviews') }, css: { 'is-activated' : selectedTab() == 'reviews', 'highlight' : hasNewFeedback() }"><span class="btn-text">Feedback</span></button>
                        <!-- /ko -->

                        <button class=" icon " type="button" data-bind="disable : isGlobalLockEnabled() ,event: { click: onClickTab.bind($data,'analytics') }, css: { 'is-activated' : selectedTab() == 'analytics', 'copyleaks' : plagiarismStatus() == 'Submitted'}"><span class="btn-text">Analytics</span></button>

                        <!-- ko if: idTemplate() != ${ID_TEMPLATE_VIDEO} && idTemplate() != ${ID_TEMPLATE_THREAD}   -->
                        <button class=" icon " type="button" data-bind="event: { click: onClickTab.bind($data,'newsletter') }, css: { 'is-activated' : selectedTab() == 'newsletter'}, visible: newsletterServiceType() && newsletterServiceType().value == 'Valnet' && permissions()['newsletter_email_edit'].write"><span class="btn-text">Newsletter</span></button>
                        <!-- /ko -->
                    </div>

                    <div class="form-sticky-toolbar">
                        <div class="form-action-bar">
                            <div class="">
                                <div class="form-side-header" data-bind="css: { 'is-locked': isArticleLocked(), 'is-autosave-error': isArticleAutoSaveError() }">
                                    <div class="w-savetime" data-bind="css: {  'is-lastsave-shown': showAutoSaveMessage(), 'is-lastsave-hidden': !showAutoSaveMessage(), 'is-autosaving': showIsAutosaving }">
                                        <div class="w-icon">
                                            <span class="icon"></span>
                                        </div>
                                            <span class="message-save">Last Autosaved:</span>
                                            <span class="message-save" data-bind="text: lastSaved"></span>
                                            <span class="message-lock">ARTICLE</span>
                                            <span class="message-lock">LOCKED</span>
                                            <span class="message-autosaving">Autosaving...</span>
                                    </div>
                                    <div class="w-btn">
                                            <button data-bind="event: { click: onClickCancel }, css: { 'is-disable' : isSaveButtonDisabled() && !isArticleLocked() }, disable: isSaveButtonDisabled() && !isArticleLocked()" class="btn secondary" type="button">Cancel</button>
                                            <button data-bind="event: { click: onClickSave }, css: { 'is-disable' : isSaveButtonDisabled() || isArticleLocked() }, disable: isSaveButtonDisabled() || isArticleLocked(), text: 'Save'"   class="btn highlight" type="button">Save</button>
                                            <button class="btn highlight" type="button" data-bind="event: { click: onClickSaveAndStay }, css: { 'is-disable' : isSaveButtonDisabled() || isArticleLocked() }, disable: isSaveButtonDisabled() || isArticleLocked(), text: 'Save & Stay', attr: { title: saveAndStayButtonTitle }">Save & Stay</button>
                                    </div>
                                </div>

                                <span class="sep"></span>

                                <div class="form-group">
                                    <label for="idStatus" class="form-label form-label-box">Article Status</label>
                                    <select id="idStatus" data-bind="disable: isPublishingControl() || isGlobalLockEnabled() || selectedTab() == 'republish', options: articleStatus_options, optionsText: 'name', value: idStatus, optionsValue: 'id', event: {change: onChangeArticleStatus}"></select>
                                </div>

                                <div class="form-group no-border">
                                    <label for="idPublishStatus" class="form-label form-label-box">Publish Status</label>
                                    <select id="idPublishStatus" data-bind="
                                        disable: !permissions()['article_edit_publishingControl'].write ||
                                        isGlobalLockEnabled() || selectedTab() == 'republish', options: publishStatuses, optionsText: 'name', value: idPublishStatus, optionsValue: 'id', event: {change: onChangePublishStatus}"></select>
                                </div>

                                <div class="form-group no-border w-dropdown-picker" data-bind="visible: idPublishStatus() == 2" style="position: relative">
                                    <button class="btn-form icon light no-wrap icon i-week" type="button" data-bind="event: {click: onShowScheduleDate}"></button>
                                    <div data-bind="visible: isScheduleDateVisible" class="dropdown-picker">
                                        <label for="scheduleDatePicker" class="form-label">Schedule Date</label>
                                        ${this.scheduleDatePicker.getHtmlBuild()}
                                    </div>
                                </div>

                                <span class="sep hide-small" style="margin-left: .5rem;"></span>


                                <div class="display-date first">

                                    <div class="form-group w-date">
                                        <label class="form-label">Display Date</label>
                                        <span class="date-display" data-bind="text: ko.computed(() => dateMostRecentPublishStatus() ? dateMostRecentPublishStatus() : 'N/A')"></span>
                                    </div>
                                    <!-- ko if: articlePageSettings()['isTimeUpdateEnable'] && datePublished().substr(0, 10) == new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10) && idPublishStatus() == 3 && republishes().length == 0 -->
                                    <div class="form-group current-date">
                                        <input type="checkbox" data-bind="checked: isUpdateTime, disable: !permissions()['article_edit_publishingControl'].write" id="update-time">
                                        <label title="Update Display Date to Current Time" for="update-time" class="form-label icon i-check"><span></span></label>

                                        <!--<div class="w-tooltips-adv pos-far-left mini" style="margin-top: .5rem">
                                            ${this.updateTimeToolTipButton.getHtmlBuild()}
                                        </div>-->
                                    </div>
                                    <!-- /ko -->

                                    <div class="form-group w-date">
                                        <button class="btn-form icon light no-wrap icon i-calendar" type="button"></button>
                                        <div class="date-display-drop">
                                            <div class="form-group">
                                                <label class="form-label">Created On</label>
                                                <span data-bind="text: ko.computed(() => dateCreated() ? dateCreated() : 'N/A')"></span>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Last Updated</label>
                                                <span data-bind="text: ko.computed(() => dateUpdated() ? dateUpdated() : 'N/A')"></span>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Last Article Status</label>
                                                <span data-bind="text: ko.computed(() => dateLastStatus() ? dateLastStatus() : 'N/A')"></span>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Last Publish Status</label>
                                                <span data-bind="text: ko.computed(() => dateLastPublishStatus() ? dateLastPublishStatus() : 'N/A')"></span>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Original Publish</label>
                                                <span data-bind="text: ko.computed(() => datePublished() ? datePublished() : 'N/A')"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                        </div>



                        <div>

                            <div class="display-date second" >

                                <div class="form-group w-date">
                                    <label class="form-label">Display Date</label>
                                    <span class="date-display" data-bind="text: ko.computed(() => dateMostRecentPublishStatus() ? dateMostRecentPublishStatus() : 'N/A')"></span>
                                </div>
                                <!-- ko if: articlePageSettings()['isTimeUpdateEnable'] && datePublished().substr(0, 10) == new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10) && idPublishStatus() == 3 && republishes().length == 0 -->
                                <div class="form-group current-date">
                                    <input type="checkbox" data-bind="checked: isUpdateTime, disable: !permissions()['article_edit_publishingControl'].write" id="update-time">
                                    <label title="Update Display Date to Current Time" for="update-time" class="form-label icon i-check"><span></span></label>

                                    <!--<div class="w-tooltips-adv pos-far-left mini" style="margin-top: .5rem">
                                        ${this.updateTimeToolTipButton.getHtmlBuild()}
                                    </div>-->
                                </div>
                                <!-- /ko -->

                                <div class="form-group w-date">
                                    <button class="btn-form icon light no-wrap icon i-calendar" type="button"></button>
                                    <div class="date-display-drop">
                                        <div class="form-group">
                                            <label class="form-label">Created On</label>
                                            <span data-bind="text: ko.computed(() => dateCreated() ? dateCreated() : 'N/A')"></span>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-label">Last Updated</label>
                                            <span data-bind="text: ko.computed(() => dateUpdated() ? dateUpdated() : 'N/A')"></span>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-label">Last Article Status</label>
                                            <span data-bind="text: ko.computed(() => dateLastStatus() ? dateLastStatus() : 'N/A')"></span>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-label">Last Publish Status</label>
                                            <span data-bind="text: ko.computed(() => dateLastPublishStatus() ? dateLastPublishStatus() : 'N/A')"></span>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-label">Original Publish</label>
                                            <span data-bind="text: ko.computed(() => datePublished() ? datePublished() : 'N/A')"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <span class="sep hide-large" style="margin-left: .5rem;"></span>

                            <div class="w-link">
                                <div class="form-group" data-bind="visible : !isSubContent()">
                                    <label class="form-label">Live</label>
                                    <a title="Live Version" class="btn-form icon light no-wrap icon i-external" type="button" data-bind="visible: !isSubContent(), css: { 'is-disabled': idPublishStatus() == 1 || idPublishStatus() == 2 }, event: { click: onClickViewOnSite }"></a>
                                </div>
                                <span class="sep" style="margin-left: .5rem;" data-bind="visible : !isSubContent()" ></span>
                                <div class="form-group">
                                    <label class="form-label">Preview</label>
                                    <div style="flex-direction: row;display: flex;gap: .5rem;">
                                        <button title="Desktop Preview" class="btn-form icon light no-wrap icon i-preview-desktop" type="button" data-bind="disable : (isSaveButtonDisabled() || isPublishingControl() || isGlobalLockEnabled() || id() =='' || id() ==null), event: { click: onClickPreviewNoSave.bind($data, 'article') }, title: isSaveButtonDisabled() ? 'Autosaving...' : 'Preview Article'"></button>
                                        <button title="Mobile Preview (Incompatible with Fullscreen Mode)" class="btn-form icon light no-wrap icon i-preview-mobile" type="button" data-bind="disable : (isSaveButtonDisabled() || isPublishingControl() || isGlobalLockEnabled() || id() =='' || id()==null), event: { click: onClickMobilePreviewNoSave.bind($data, 'article') },title: isSaveButtonDisabled() ? 'Autosaving...' : 'Preview on Mobile '"> <span class="btn-text"></span> </button>
                                    </div>
                                </div>
                                <span class="sep" style="margin-left: .5rem;" data-bind="visible : !isSubContent()"></span>
                                <div class="form-group" data-bind="visible : !isSubContent()">
                                    <label class="form-label" style="text-align: center">Sync</label>
                                    <div class="dropdown">
                                        <div class="w-sync-status dropdown-toggle">
                                            <span class="sync-status" data-bind="css: {'is-out-of-sync': syncStatus() === 'out of sync', 'is-synced': syncStatus() === 'synced', 'is-not-synced': syncStatus() === 'not synced' }" > </span>
                                        </div>
                                        <div class="dropdown-list" style="left: -120px !important;">
                                            <div class="form-group">
                                                <label class="form-label">Sync Status</label>
                                                <span data-bind="text: syncStatus() ? syncStatus().toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : 'N/A'" class="icon i-sync"></span>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Last Synced Date</label>
                                                <span data-bind="text: dateLastSyncStatus() ? dateLastSyncStatus() : 'N/A'"></span>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>

                </div>



                        <!-- ----------------- -->
                        <!-- Article Tab         -->
                        <!-- ----------------- -->
                        <div class="w-tabs-content bg" data-bind="css: { 'is-showing' : selectedTab() == 'article'}"><!-- .is-showing -->
                            <div class="w-form-body">

                                <div class="form-body full-width article-header">

                                    <div class="form-group">

                                        <div class="article-header-content">
                                            <div class="w-permalink" data-bind="css: { 'is-empty' : permalink() == '' || permalink() == null || !permalink() }">

                                                <div class="w-form-dropdown-menu" id="display-options-dropdown-menu" >

                                                    <button class="btn-form light template-option icon i-t-option hide-text-on-medium" type="button" data-bind="disable : isGlobalLockEnabled() ,event: { click: onClickDisplayOptionToggle }"><span class="btn-text"></span></button>

                                                        <div class="w-form form-dropdown-menu">

                                                            <button class="close-btn icon-only icon i-close" type="button" data-bind="event: { click: onClickDisplayOptionToggle }"><span class="hide-text">close</span></button>

                                                            <div class="form-group" >
                                                                <span class="form-sub-title" style="margin-bottom: 0">Visibility</span>

                                                                <label for="template" class="form-label form-label form-label-box"></label>
                                                                <div class="multi-row">
                                                                    <input type="radio" name="visibility" value="1" id="visibility-everywhere" data-bind=" checkedValue : 1, checked: displayConfiguration, disable: isPublishingControl() || isGlobalLockEnabled()">
                                                                    <label class="form-label icon i-check" for="visibility-everywhere">Visible Everywhere</label>
                                                                </div>
                                                                <div class="multi-row">
                                                                    <input type="radio" name="visibility" value="2" id="visibility-hide-homepage" data-bind=" checkedValue : 2, checked: displayConfiguration, disable: isPublishingControl() || isGlobalLockEnabled()">
                                                                    <label class="form-label icon i-check" for="visibility-hide-homepage">Hide From Homepage</label>
                                                                </div>
                                                                <div class="multi-row">
                                                                    <input type="radio" name="visibility" value="3" id="visibility-hide-website" data-bind=" checkedValue : 3,checked: displayConfiguration, disable: isPublishingControl() || isGlobalLockEnabled()">
                                                                    <label class="form-label icon i-check" for="visibility-hide-website">Hide From Website</label>
                                                                </div>
                                                                <div class="multi-row">
                                                                    <input type="radio" name="visibility" value="4" id="visibility-hide-trending" data-bind=" checkedValue : 4,checked: displayConfiguration, disable: isPublishingControl() || isGlobalLockEnabled()">
                                                                    <label class="form-label icon i-check" for="visibility-hide-trending">Hide From Trending</label>
                                                                </div>
                                                                <div class="multi-row">
                                                                    <input type="radio" name="visibility" value="24" id="visibility-hide-homepage-trending" data-bind=" checkedValue : 24,checked: displayConfiguration, disable: isPublishingControl() || isGlobalLockEnabled()">
                                                                    <label class="form-label icon i-check" for="visibility-hide-homepage-trending">Hide From Homepage and Trending</label>
                                                                </div>
                                                            </div>

                                                            <div class="form-group" data-bind="visible: showSponsoredDisclaimer() || showTableOfContents() || showQuickShopLinks()" >
                                                                <span class="form-sub-title">Auto Units</span>
                                                                <!-- ko if: showSponsoredDisclaimer()  -->
                                                                <div class="multi-row">
                                                                    <input type="checkbox" data-bind="disable: isPublishingControl() || isGlobalLockEnabled() , checked: isSponsored" id="sponsored-content">
                                                                    <label for="sponsored-content" class="form-label icon i-check" style="margin-right: 2rem">Sponsored Disclaimer</label>
                                                                </div>
                                                                <!-- /ko -->

                                                                <!-- ko if: showTableOfContents()  -->
                                                                <div class="multi-row">
                                                                    <input type="checkbox" data-bind="disable: isPublishingControl() || isGlobalLockEnabled(), checked: tableOfContents" id="tableOfContents">
                                                                    <label for="tableOfContents" class="form-label icon i-check" for="tableOfContents">Table of contents</label>
                                                                </div>
                                                                <!-- /ko -->
                                                                <!-- ko if: showQuickShopLinks()  -->

                                                                <div class="multi-row">
                                                                    <input type="checkbox" data-bind="checked: isDisplayCardQuickLinksShown" id="CardQuickLinks">
                                                                    <label class="form-label icon i-check" for="CardQuickLinks">Quick Shop Links</label>
                                                                </div>
                                                                <div class="multi-row">
                                                                    <input type="checkbox" data-bind="checked: isDisplayCardQuickLinksMobileShown" id="CardQuickLinksMobile">
                                                                    <label class="form-label icon i-check" for="CardQuickLinksMobile">Quick Shop Links (Mobile Only)</label>
                                                                </div>
                                                                <!-- /ko -->

                                                            </div>

                                                            <div class="form-group" data-bind="visible: idTemplate() == 3" >
                                                                <span class="form-sub-title">List Numbering </span>
                                                                <div class="multi-row">
                                                                    <input type="radio" name="list_numbering" id="list_numbering-ascending" data-bind="checked: listOrder, checkedValue: 'ascending', disable: isPublishingControl() || isGlobalLockEnabled()">
                                                                    <label class="form-label icon i-check" for="list_numbering-ascending">Ascending</label>
                                                                </div>
                                                                <div class="multi-row">
                                                                    <input type="radio" name="list_numbering" id="list_numbering-descending" data-bind="checked: listOrder, checkedValue: 'descending', disable: isPublishingControl() || isGlobalLockEnabled()">
                                                                    <label class="form-label icon i-check" for="list_numbering-descending">Descending</label>
                                                                </div>
                                                                <div class="multi-row">
                                                                    <input type="radio" name="list_numbering" id="list_numbering-none" data-bind="checked: listOrder, checkedValue: 'none', disable: isPublishingControl() || isGlobalLockEnabled()">
                                                                    <label class="form-label icon i-check" for="list_numbering-none">None</label>
                                                                </div>

                                                            </div>

                                                                <!-- ko if: isAutoLinkerEnabled() -->
                                                            <div class="form-group" data-bind="visible: isAutoLinkerEnabled" >
                                                                <span class="form-sub-title">Affiliate </span>


                                                                <div class="multi-row">
                                                                    <input type="checkbox" data-bind="disable: !permissions()['article_edit_config_affiliate_linker'].write || isPublishingControl() || isGlobalLockEnabled, checked: isAffiliateLinkerEnabled" id="disable-affiliate-linker">
                                                                    <label for="disable-affiliate-linker" class="form-label icon i-check">Auto-Affiliate Links</label>
                                                                </div>

                                                            </div>
                                                            <!-- /ko -->
                                                            <div class="form-group" data-bind="visible: permissions()['article_edit_display_options'].write">
                                                                <span class="form-sub-title">Layout</span>
                                                                <div class="multi-row" data-bind="visible: permissions()['article_edit_config_ads'].write">
                                                                    <input type="checkbox" data-bind="disable : isGlobalLockEnabled() ,checked: isAdHidden" id="AdHidden">
                                                                    <label class="form-label icon i-check" for="AdHidden">Hide Ads</label>
                                                                </div>
                                                                <div class="multi-row">
                                                                    <input type="checkbox" data-bind="checked: isReadNextDisabled" id="ReadNext">
                                                                    <label class="form-label icon i-check" for="ReadNext">Hide Read Next Footer</label>
                                                                </div>
                                                                <div class="multi-row">
                                                                    <input type="checkbox" data-bind="checked: isSidebarHidden" id="SidebarHidden">
                                                                    <label class="form-label icon i-check" for="SidebarHidden">Hide Sidebar</label>
                                                                </div>
                                                                <div class="multi-row">
                                                                    <input type="checkbox" data-bind="checked: isExcerptHidden" id="ExcerptHidden">
                                                                    <label class="form-label icon i-check" for="ExcerptHidden">Hide Excerpt</label>
                                                                </div>
                                                                <!-- ko if:isPortraitHeaderEnabled -->
                                                                <div class="multi-row">
                                                                    <input type="checkbox" data-bind="checked: isPortraitHeader" id="isPortraitHeader">
                                                                    <label class="form-label icon i-check" for="isPortraitHeader">Use Portrait Header</label>
                                                                </div>
                                                                <!-- /ko -->
                                                            </div>
                                                            <div class="form-group" style="width: auto;">
                                                                <span class="form-sub-title">General</span>
                                                                <div class="multi-row" data-bind="if: permissions()['article_edit_embargo'].read">
                                                                    <input type="checkbox" data-bind="disable: !permissions()['article_edit_embargo'].write || isPublishingControl() || isGlobalLockEnabled(), checked: isUnderEmbargo" id="under-embargo">
                                                                    <label for="under-embargo" class="form-label icon i-check" >Under Embargo</label>
                                                                </div>

                                                                <!-- ko if: idBrand() == 50 -->
                                                                <div class="multi-row">
                                                                    <input type="checkbox" data-bind="disable: isPublishingControl() || isGlobalLockEnabled(), checked: isSyndicated" id="is-syndicated">
                                                                    <label for="is-syndicated" class="form-label icon i-check">Syndicated</label>
                                                                </div>
                                                                 <!-- /ko -->
                                                                <!-- ko if: idBrand() == 50 && isSyndicated() -->
                                                                <div class="multi-row">
                                                                    <input type="checkbox" data-bind="disable: isPublishingControl() || isGlobalLockEnabled(), checked: noAuthorship" id="no-authorship">
                                                                    <label for="no-authorship" class="form-label icon i-check">No Authorship</label>
                                                                </div>
                                                                <!-- /ko -->

                                                                <!-- ko if: showSubContent()  -->
                                                                <div class="multi-row">
                                                                    <input type="checkbox" data-bind="checked: isSubContent, disable: isPublishingControl() || isGlobalLockEnabled()" class="input-checkbox" id="isSubContent">
                                                                    <label class="form-label icon i-check" for="isSubContent" >Sub Content</label>
                                                                </div>
                                                                <!-- /ko -->

                                                                <!-- ko if: false -->
                                                                <div class="multi-row">
                                                                    <input type="checkbox" data-bind="checked: isInstareadEnabled, disable: isPublishingControl() || isGlobalLockEnabled()" class="input-checkbox" id="isInstareadEnabled">
                                                                    <label class="form-label icon i-check" for="isInstareadEnabled" >Instaread</label>
                                                                </div>
                                                                <!-- /ko -->

                                                                <!-- ko if: showDevelopingStoryDisclaimer()  -->
                                                                <div class="multi-row">
                                                                    <!--<div class="w-tooltips-adv pos-top short" data-bind="visible: isDevelopingStory()" style="position: absolute;right: -25px;top: 10px;">

                                                                    </div> -->
                                                                    <input type="checkbox" data-bind="disable: isPublishingControl() || isGlobalLockEnabled(), checked: isDevelopingStory" id="developing-story">
                                                                    <label for="developing-story" class="form-label icon i-check">Live Blogging</label>
                                                                </div>
                                                                <!-- /ko -->
                                                                <div class="form-group date" style="width:auto;margin-top: 1rem !important;">

                                                                    <div style="display: flex;flex-direction: column;gap: 1rem;">
                                                                        <div class="form-group inside-label date-w no-border no-margin-inline" style="margin-left: 0;" data-bind="visible: (isDevelopingStory() && showDevelopingStoryDisclaimer())" style="margin-top: 1.5rem;">
                                                                            <label for="dateDevelopingStoryCoverageStartPicker" class="form-label">Developing Story Start Date</label>
                                                                            ${this.dateDevelopingStoryCoverageStartPicker.getHtmlBuild()}
                                                                        </div>
                                                                        <div class="form-group inside-label date-w no-border no-margin-inline" data-bind="visible: (isDevelopingStory() && showDevelopingStoryDisclaimer())">
                                                                            <label for="dateDevelopingStoryCoverageEndPicker" class="form-label">Developing Story End Date</label>
                                                                            ${this.dateDevelopingStoryCoverageEndPicker.getHtmlBuild()}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>

                                                </div>

                                                <div class="article-header--permalink" title="Permalink" data-bind="css: { 'is-empty' : permalink() == '' || permalink() == null || !permalink() },visible: !isSubContent()">
                                                    <input id="permalink" type="text" data-bind="event: { focus: onPermalinkFocus, focusout: onFocusOutPermalink, keydown: onKeyDownHeader.bind($data, 'permalink')}, value: permalink, valueUpdate: 'input', attr: { placeholder: 'Permalink' }" />
                                                    <div class="btn-confirm">
                                                        <button class="btn-form icon i-check" title="Confirm Changes" data-bind="event: { click: onClickConfirmHeader.bind($data, 'permalink') }"></button>
                                                        <button class="btn-form icon i-x-before" title="Discard Changes" data-bind="event: { click: onClickCancelHeader.bind($data, 'permalink') }"></button>
                                                    </div>
                                                    <button
                                                        data-bind="event: { click: onClickShowPermalinkHistoryModal }" class="btn-form redirect">
                                                        <span title="Permalink Changes" class="icon i-entry-history" data-bind="text: (permalinkHistory() && permalinkHistory().length ? permalinkHistory().length : 0)"></span>
                                                        <span title="Redirects" class="icon i-redirect" data-bind="text: (permalinkRedirects() && permalinkRedirects().length ? permalinkRedirects().length : 0)"></span>
                                                    </button>

                                                    <!-- old one -->
                                                    <button style="margin-top: .25rem;display: none;" class="input-checkbox permalink-button btn-form"
                                                        id="isPermalinkHistory"
                                                        data-bind="event: { click: onClickShowPermalinkHistoryModal }, css: { 'button-red': permalinkRedirects() && permalinkRedirects().length > 0 }">
                                                        <span class="permalink-history-changes-total"
                                                                id="permalinkHistoryChangesTotal"
                                                                data-bind="text: permalinkHistory() && permalinkHistory().length ? '(' + permalinkHistory().length + ')' : ''; " >
                                                        </span>

                                                        <span data-bind="html: permalinkHistory() && permalinkHistory().length > 0 ? '&nbsp;History |&nbsp;' : ''; "></span>
                                                        <span class="permalink-redirects"
                                                                id="permalinkRedirects"
                                                                data-bind="text: permalinkRedirects() && permalinkRedirects().length ? ' Active Redirect: ' +  permalinkRedirects().length : ' No redirects found'; ">
                                                        </span>
                                                    </button>
                                                    <!-- old one -->

                                                </div>

                                            </div>

                                            <div class="article-header--title 1" data-bind="css: { 'is-empty' : title() == '' || title() == null || !title() }">
                                                <textarea type="text" id="article-title" class="auto-resize" data-bind=" value: title(), event: { focusout: (d, e) => { onFocusOutTitle(d, e); resizeTextarea(d, e); }, focus: onTitleFocus, keydown: onKeyDownHeader.bind($data, 'title'),
                                                input: (d, e) => { resizeTextarea(d,e); onTitleCharCountInput(d, e); }, paste: (d, e) => { setTimeout(() => { resizeTextarea(d, e); onTitleCharCountInput(d, e); }, 0); return true; } }, attr: { placeholder: 'Title', maxlength: '${ARTICLE_TITLE_MAX_CHARS}' }, css: { 'is-disable' : isTitleDisabled() }" ></textarea>
                                                <div class="btn-confirm">
                                                    <button class="btn-form icon i-check" title="Confirm Changes" data-bind="event: { mousedown: onClickConfirmHeader.bind($data, 'title') }"></button>
                                                    <button class="btn-form icon i-x-before" title="Discard Changes" data-bind="event: { mousedown: onClickCancelHeader.bind($data, 'title') }"></button>
                                                </div>
                                                <div class="title-char-count" data-bind="css: { 'is-too-long': titleCharCount() >= ${ARTICLE_TITLE_MAX_CHARS} }">
                                                    <span data-bind="text: titleCharCount()"></span><span>/${ARTICLE_TITLE_MAX_CHARS}</span>
                                                </div>
                                                <div data-bind="visible: idTemplate() != ${ID_TEMPLATE_THREAD} && aiSettings().titleDiscoverandOptimizePromptAvailable " class="btn-form  analysis-button">
                                                    <button class="btn-form light icon i-ai-1 e-lab" title="Generate Title Suggestions"  id="title-analysis-button" data-bind="click: function() { onClickAnalyzeTitle('both')} , visible: idTemplate() != ${ID_TEMPLATE_THREAD}, disable: isAiAnalyzing()"  type="button"></button>
                                                </div>
                                            </div>

                                            <div class="article-header--excerpt"  data-bind="css: { 'is-empty' : excerpt() == '' || excerpt() == null || !excerpt() },visible: isExcerptVisible() && !isExcerptHidden()">

                                                <textarea class="auto-resize" id="article-excerpt" data-bind="value: excerpt, valueUpdate: ['input', 'afterkeydown', 'paste'], event: { focus: onExcerptFocus, focusout: (d, e) => { onFocusOutExcerpt(d, e); resizeTextarea(d,e); }, keydown: onKeyDownHeader.bind($data, 'excerpt'),
                                                input: (d, e) => resizeTextarea(d,e), paste: (d, e) => { setTimeout(() => resizeTextarea(d, e), 0); return true; } },
                                                attr: { placeholder: 'Excerpt' }" maxlength="150"></textarea>

                                                <div class="btn-confirm">
                                                    <button class="btn-form icon i-check" title="Confirm Changes" data-bind="event: { click: onClickConfirmHeader.bind($data, 'excerpt') }"></button>
                                                    <button class="btn-form icon i-x-before" title="Discard Changes" data-bind="event: { click: onClickCancelHeader.bind($data, 'excerpt') }"></button>
                                                </div>
                                                <div class="excerpt-char-count" data-bind="css: { 'is-too-long': excerptCharCount() >= 150 }">
                                                    <span data-bind="text: excerptCharCount()"></span><span>/150</span>
                                                </div>
                                                <div class="btn-form analysis-button" style="gap: 1rem;margin-left:0;">
                                                    <button class="btn-form light icon i-ai-1 e-lab" title="Suggest an Excerpt" id="excerpt-analysis-button"  data-bind=" click: function(){ onClickAnalyzeExcerpt() }, visible: idTemplate() != ${ID_TEMPLATE_THREAD} && aiSettings().excerptSuggestionPromptAvailable , disable: isAiAnalyzing()" type="button"></button>
                                                </div>

                                            </div>
                                            <!-- ko if: featuredImageIsPortrait -->
                                            <div class="w-alert">
                                                <p>Aspect ratio is too low. Featured images must have a minimum aspect ratio of 16:9. Image will be cropped to fit 16:9</p>
                                            </div>
                                            <!-- /ko -->
                                            <div class="article-header--img">

                                            <div class="g-feature" data-bind="css: {'has-img': featuredImage() || featuredVideo(), 'portrait': featuredImageIsPortrait() }" >

                                                <div class="w-edit-feature" data-bind="visible: isFeaturedToolbarVisible">
                                                <!-- Featured Image Options -->
                                                <!-- ko if: featuredType() === 'image' -->
                                                    <button title="Edit Featured Image" class="btn-form icon i-edit"
                                                        data-bind="css:{ 'i-edit': featuredImage(), 'i-image-2': !featuredImage() }, event: { click: onClickEditFeaturedImage }"></button>
                                                    <!-- ko if: canCropFeaturedImage -->
                                                    <button title="Set Featured Image Crop Position" class="btn-form icon i-crop" type="button"
                                                        data-bind="event: { click: onClickOpenCropSelector.bind($data, 'featuredImage') }"></button>
                                                    <!-- /ko -->
                                                    <button title="Clear Featured Image" class="btn-form icon i-delete"
                                                        data-bind="visible: featuredImage, event: { click: onClickClearFeaturedImage }"></button>
                                                <!-- /ko -->

                                                <!-- Featured Video Options -->
                                                <!-- ko if: featuredType() === 'video' -->
                                                    <button title="Edit Featured Video" class="btn-form icon i-edit"
                                                        data-bind="css:{ 'i-edit': featuredVideo(), 'i-video-2': !featuredVideo() }, event: { click: onClickEditFeaturedVideo }"></button>
                                                    <button title="Clear Featured Video" class="btn-form icon i-delete"
                                                        data-bind="visible: featuredVideo, event: { click: onClickRemoveFeaturedVideo }"></button>
                                                <!-- /ko -->

                                                <!-- Featured Embed Options (when embed is active, can also have featuredImage) -->
                                                <!-- ko if: featuredType() === 'embed' -->

                                                    <button title="Edit Featured Image" class="btn-form icon i-image-2"
                                                        data-bind="css:{ 'i-edit': featuredImage(), 'i-image-2': !featuredImage() }, event: { click: onClickEditFeaturedImage }"></button>
                                                    <!-- ko if: featuredImage() -->
                                                        <!-- ko if: canCropFeaturedImage -->
                                                        <button title="Set Featured Image Crop Position" class="btn-form icon i-crop" type="button"
                                                        data-bind="event: { click: onClickOpenCropSelector.bind($data, 'featuredImage') }"></button>
                                                        <!-- /ko -->
                                                        <button title="Clear Featured Image" class="btn-form icon i-delete"
                                                        data-bind="event: { click: onClickClearFeaturedImage }"></button>
                                                    <!-- /ko -->
                                                <!-- /ko -->

                                                <!-- Featured Tag Options (can also have featuredImage) -->
                                                <!-- ko if: featuredType() === 'tag' -->
                                                    <button title="Edit Featured Image" class="btn-form icon i-image-2"
                                                        data-bind="css:{ 'i-edit': featuredImage(), 'i-image-2': !featuredImage() }, event: { click: onClickEditFeaturedImage }"></button>
                                                    <!-- ko if: featuredImage() -->
                                                        <!-- ko if: canCropFeaturedImage -->
                                                        <button title="Set Featured Image Crop Position" class="btn-form icon i-crop" type="button"
                                                        data-bind="event: { click: onClickOpenCropSelector.bind($data, 'featuredImage') }"></button>
                                                        <!-- /ko -->
                                                        <button title="Clear Featured Image" class="btn-form icon i-delete"
                                                        data-bind="event: { click: onClickClearFeaturedImage }"></button>
                                                    <!-- /ko -->
                                                <!-- /ko -->
                                                </div>

                                                <!-- ko if: featuredType() === null -->
                                                <div class="w-btn-form">

                                                    <span>Add Featured Element</span>
                                                    <div class="inner-btn">
                                                        <!-- ko if: allowImage() -->
                                                        <button class="btn-form icon i-image-2" data-bind="event: { click: onClickSelectFeaturedImage }">Image</button>
                                                        <!-- /ko -->
                                                        <!-- ko if: allowVideo() -->
                                                        <button class="btn-form icon i-video-2" data-bind="event: { click: onClickSelectFeaturedVideo }">  Video</button>
                                                        <!-- /ko -->
                                                        <!-- ko if: allowEmbed() -->
                                                        <button class="btn-form icon i-insert-embed" data-bind="event: { click: onClickSelectFeaturedEmbed }">Embed</button>
                                                        <!-- /ko -->
                                                        <!-- ko if: allowTag() -->
                                                        <button class="btn-form icon i-tag"  data-bind="event: { click: onClickSelectFeaturedTag }" >Tag</button>
                                                        <!-- /ko -->
                                                    </div>
                                                </div>
                                                <!-- /ko -->

                                                <!-- ko if: showFeaturedImage() && featuredSectionValue() == 'featuredImage' || featuredSectionValue() == 'featuredTag' || (featuredSectionValue() == 'featuredVideo' && featuredEmbed()) -->
                                                    <div class="wrap-img" style="height: 100%;">
                                                        ${this.imageWidgetForFeaturedImage.getHtmlBuild()}
                                                    </div>
                                                <!-- /ko -->

                                                  <!-- ko if: featuredSectionValue() == 'featuredVideo' && featuredVideo() -->
                                                  <span class="video-icon icon i-video-article"></span>
                                                  <!-- /ko -->
                                                <span class="indict-type">
                                                    <span class="text">Desktop</span>
                                                    <span class="icon i-desktop"></span>
                                                </span>

                                                <!--
                                                <button class="btn-form icon i-edit-a" data-bind="click: onClickToggleFeaturedToolbar"></button>
                                                -->
                                                <!-- ko if: featuredSectionValue() == 'featuredVideo' && featuredVideo() -->
                                                    <div class="w-img">
                                                        <img
                                                            data-bind="attr: {
                                                                src: featuredVideo().thumbnail.url,
                                                                width: 650,
                                                                height: 365
                                                            }">
                                                        </img>
                                                    </div>
                                                <!-- /ko -->

                                                <div data-bind="if: featuredEmbed() && !featuredVideo()" class="w-embed">

                                                    <div class="" data-bind="html : featuredEmbed()"></div>
                                                    <!-- ko if: featuredType() === 'embed' -->
                                                    <div class="w-edit-feature-embed">
                                                        <button title="Edit Featured Embed" class="btn-form icon i-edit"
                                                            data-bind="click: onClickEditFeaturedEmbed"></button>
                                                        <button title="Clear Featured Embed" class="btn-form icon i-delete"
                                                            data-bind="click: onClickClearFeaturedEmbed"></button>
                                                    </div>
                                                    <!-- /ko -->


                                                </div>

                                                    <!-- ko if: featuredSectionValue() == 'featuredTag'  -->
                                                    <div class="w-tag-list">
                                                        <ul  class="tag-list" id="tag-selection" data-bind="foreach: (featuredTags() && featuredTags().tagObject) ? featuredTags().tagObject : []" style="height: auto;">

                                                            <li class="tag-item">
                                                                    <div class="w-img" data-bind="">
                                                                        <div class="ratio-content">

                                                                        <!-- ko if: $data.image -->
                                                                                <img data-bind="attr:{src: $data.image.url}" />
                                                                            <!-- /ko -->
                                                                        </div>
                                                                    </div>
                                                                    <div class="w-info">
                                                                        <strong data-bind="text:$data.name"></strong>
                                                                    </div>
                                                            </li>
                                                        </ul>
                                                         <!-- ko if: featuredType() === 'tag' -->
                                                        <div class="w-edit-feature-embed tag">
                                                            <button title="Edit Featured Tag" class="btn-form icon i-tag"
                                                                data-bind="event: { click: onClickEditFeaturedTag }"></button>
                                                            <button title="Clear Featured Tag" class="btn-form icon i-delete"
                                                                data-bind="event: { click: onClickClearFeaturedTag }"></button>
                                                        </div>
                                                        <!-- /ko -->
                                                    </div>
                                                    <!-- /ko -->

                                                    <div class="w-category-tag">

                                                        <div class="dropdown">
                                                            <span class="icon i-category icon i-edit-a dropdown-toggle cat" data-bind="
                                                            click: function() { onClickOpenArticleDetailsModal('articleCategorySection') },
                                                            text: categoryLabel,
                                                            attr: { title: categoryLabel }"></span>
                                                            <!-- ko if: selectedCategories().length > 0 -->
                                                            <!-- Only show list if there’s more than one category OR no primary category at all -->
                                                                <!-- ko if: selectedCategories().length > 1 || !primaryCategoryName() -->
                                                                    <ul class="full-list dropdown-list" data-bind="foreach: selectedCategories">
                                                                    <!-- If there’s a primary category, skip it; otherwise show all -->
                                                                    <!-- ko if: !$parent.primaryCategoryName() || $data.category.name !== $parent.primaryCategoryName() -->
                                                                        <li data-bind="text: $data.category.name"></li>
                                                                    <!-- /ko -->
                                                                    </ul>
                                                                <!-- /ko -->
                                                            <!-- /ko -->
                                                        </div>

                                                        <div class="dropdown">
                                                            <span class="icon i-tag i-edit-a dropdown-toggle tag" data-bind="
                                                            click: function() { onClickOpenArticleDetailsModal('articleTagSection', 'filterTag') },
                                                            text: tagLabel,
                                                            attr: { title: tagLabel }
                                                            "></span>
                                                            <!-- ko if: selectedTags().length > 0 -->
                                                                <!-- Only show the list if there’s at least one tag other than the primary, OR no primary at all -->
                                                                <!-- ko if: selectedTags().length > 1 || !primaryTagName() -->
                                                                    <ul class="full-list dropdown-list" data-bind="foreach: selectedTags">
                                                                    <!-- If we have a primaryTagName, skip that one; otherwise, show all -->
                                                                    <!-- ko if: !$parent.primaryTagName().id || $data.tag.id !== $parent.primaryTagName().id -->
                                                                        <li data-bind="text: $data.tag.name + ' ' + $data.tag.formattedTagTypeAndDataset"></li>
                                                                    <!-- /ko -->
                                                                    </ul>
                                                                <!-- /ko -->
                                                            <!-- /ko -->
                                                        </div>


                                                        <!-- ko if: [5, 24].includes(idContentType())  -->
                                                        <div class="dropdown">
                                                            <span class="icon i-premium i-edit-a dropdown-toggle review" data-bind="
                                                            click: function() { onClickOpenArticleDetailsModal('articleTagSection', 'filterAutocompleteReviewTag_template') },
                                                            text: reviewTagLabel,
                                                            attr: { title: reviewTagLabel }
                                                            "></span>
                                                        </div>
                                                        <!-- /ko -->

                                                    </div>
                                            </div>
                                            <div class="g-mobile-thumbnail" >
                                                <div class="g-mobile" data-bind="css: {'has-img': featuredImage() || featuredVideo(), 'portrait': featuredImageIsLessThan43() }">
                                                    <!-- ko if: showFeaturedImage() && featuredSectionValue() == 'featuredImage' || featuredSectionValue() == 'featuredTag' || (featuredSectionValue() == 'featuredVideo' && featuredEmbed()) -->
                                                    <!-- ko if: featuredImageMobilePreviewUrl() -->
                                                    <div class="w-img">
                                                        <img data-bind="attr: { src: featuredImageMobilePreviewUrl }" alt="" />
                                                    </div>
                                                    <!-- /ko -->
                                                    <!-- ko ifnot: featuredImageMobilePreviewUrl() -->
                                                    ${this.imageWidgetForFeaturedImage.getHtmlBuild()}
                                                    <!-- /ko -->
                                                    <!-- /ko -->
                                                    <!-- ko if: featuredSectionValue() == 'featuredVideo' && featuredVideo() -->

                                                    <div class="w-img">
                                                        <img
                                                            data-bind="attr: {
                                                                src: featuredVideo().thumbnail.url
                                                            }">
                                                        </img>
                                                    </div>
                                                    <!-- /ko -->
                                                    <span class="indict-type" >
                                                        <span class="text">mobile</span>
                                                        <span class="icon i-mobile"></span>
                                                    </span>
                                                    <!--
                                                    <button class="btn-form icon i-edit-a" data-bind="event: { click: onClickEditFeaturedImage }"></button>
                                                    -->
                                                    <!-- ko if: featuredSectionValue() == 'featuredVideo' && featuredVideo() -->
                                                    <span class="video-icon icon i-video-article"></span>
                                                    <!-- /ko -->
                                                </div>
                                                <div class="g-thumbnail"  data-bind="css: {'has-img': featuredImage() || featuredVideo(), 'portrait': featuredThumbnailImage() ? thumbnailImageIsPortrait() : featuredImageIsPortrait()}">
                                                    <!-- ko if: showFeaturedImage() -->

                                                        <!-- ko if: !featuredThumbnailImage() && featuredImage() -->
                                                            ${this.imageWidgetForFeaturedImage.getHtmlBuild()}
                                                        <!-- /ko -->
                                                        <!-- ko if: featuredThumbnailImage() -->
                                                            ${this.imageWidgetForThumbnailImage.getHtmlBuild()}
                                                        <!-- /ko -->
                                                    <!-- /ko -->
                                                    <!-- ko if: featuredSectionValue() == 'featuredVideo' -->

                                                            <!-- ko if: featuredThumbnailImage() -->
                                                                ${this.imageWidgetForThumbnailImage.getHtmlBuild()}
                                                            <!-- /ko -->
                                                            <!-- ko if: !featuredThumbnailImage() && featuredVideo() -->
                                                            <div class="w-img">
                                                                <img
                                                                    data-bind="attr: {
                                                                        src: featuredVideo().thumbnail.url,
                                                                        width: 250,
                                                                        height: 165
                                                                    }">
                                                                </img>
                                                            </div>
                                                            <!-- /ko -->

                                                    <!-- /ko -->

                                                    <!-- ko if: featuredSectionValue() == 'featuredVideo' && featuredVideo() -->
                                                    <span class="video-icon icon i-video-thumbnail"></span>
                                                    <!-- /ko -->
                                                    <span class="indict-type" >
                                                        <span class="text">thumbnail</span>
                                                        <span class="icon i-thumbnail"></span>
                                                    </span>

                                                    <div class="w-edit-feature-thumbnail">
                                                        <button data-bind="css: {'btn-form': true,'icon': true,'i-edit-a': featuredThumbnailImage(),'i-image-2': !featuredThumbnailImage()}, event: { click: onClickOpenThumbnail }"></button>
                                                        <!-- ko if: featuredThumbnailImage() -->
                                                            <!-- ko if: canCropThumbnailImage -->
                                                            <button class="btn-form icon i-crop" type="button" title="Set Thumbnail Crop Position"
                                                            data-bind="click: onClickOpenCropSelector.bind($data, 'thumbnailImage')"></button>
                                                            <!-- /ko -->
                                                            <button class="btn-form icon i-delete"
                                                            data-bind="click: onClickRemoveThumbnailImage"></button>
                                                        <!-- /ko -->
                                                    </div>

                                                </div>
                                            </div>

                                            <!-- <div class="article-header--toolbar">
                                                <div>
                                                    <button title="Edit Article Header" class="icon i-article-header" data-bind="click: function() { onClickOpenArticleDetailsModal('articleHeader') }"></button>
                                                    <button title="Edit Featured Element" class="icon i-image" data-bind="click: function() { onClickOpenArticleDetailsModal('articleFeaturedSection') }"></button>
                                                    <button title="Edit Categories" class="icon i-category" data-bind="click: function() { onClickOpenArticleDetailsModal('articleCategorySection') }"></button>
                                                    <button title="Edit Tags" class="icon i-tag" data-bind="click: function() { onClickOpenArticleDetailsModal('articleTagSection','filterTag') }"></button>
                                                </div>

                                            </div> -->
                                            <span class="icon-embargo icon i-embargo" title="Under Embargo"  data-bind="visible: isUnderEmbargo() || republishIsUnderEmbargo() "></span>

                                        </div>
                                    </div>
                                </div>

                                <!-- ----------------- -->
                                <!-- Top Bar - Article Tab -->
                                <!-- ----------------- -->
                            </div>

                            <!-- Excerpt  And Featured Image, Tags ,Video -->
                            <div class="w-form-body"></div>

                                <!-- end Excert , Tags, Featured Image, Thumbnail Image -->

                                <!-- ----------------- -->
                                <!-- Categorization  -- Article Tab   -->
                                <!-- ----------------- -->

                                ${this.productReview.getHtmlBuild()}

                                <div data-bind="visible: showContent" class="form-body full-width no-margin" style="padding-top: 0;">
                                    ${this.articleContent.getHtmlBuild()}
                                </div>

                                <div data-bind="visible: idTemplate() == 7" class="form-body full-width " style="border:0;padding-top: 2rem;">
                                    ${this.articleDirectory.getHtmlBuild()}
                                </div>


                            </div>
                        </div>
                        <!-- ----------------- -->
                        <!-- End Article Tab   -->
                        <!-- ----------------- -->

                        <!-- ----------------- -->
                        <!-- Attributes Tab    -->
                        <!-- ----------------- -->
                        <div class="w-tabs-content attributes bg" data-bind="css: { 'is-showing' : selectedTab() == 'settings'}">

                            <div class="w-form-body">
                                <!-- ----------------- -->
                                <!-- Categorization - Attributes  -->
                                <!-- ----------------- -->
                                <div class="form-body">

                                    <div class="form-section cat">

                                        <strong class="form-sub-title">Categorization</strong>

                                        <div class="list-select">

                                            <div class="form-group">
                                                <label class="form-label" style="margin:0;display: block;transform: translateY(1px);">Article ID</label>
                                                <span data-bind="text: id() === null ? 'Not Assigned' : id"></span>
                                            </div>

                                            <div class="form-group">
                                                <label for="" class="form-label form-label-box">Type</label>
                                                <select name="" id="template_selector" data-bind="disable: isPublishingControl() || isGlobalLockEnabled(), value: idTemplate, optionsCaption: 'Select', valueAllowUnset: true, event: { change: onChangeTemplate }">
                                                    <option value="2">Regular</option>
                                                    <option value="3">List</option>
                                                    <option value="5" disabled>Product Review</option>
                                                    <option value="6" disabled>Buyer's Guide</option>
                                                    <option value="9">Buyer's Guide Light</option>
                                                    <option value="10">Deals</option>
                                                    <option value="12">Collection</option>
                                                    <option value="7">Directory</option>
                                                    <option value="11">Versus</option>
                                                    <option value="13">Sub-Content</option>
                                                    <option value="14">How to Watch</option>
                                                    <option value="${ID_TEMPLATE_VIDEO}">Video</option>
                                                    <!-- Thread will be set only for CB and SF -->
                                                    <option value="${ID_TEMPLATE_THREAD}" data-bind="attr: { disabled: [26, 44].indexOf(idBrand()) == -1 }">Thread</option>
                                                    <option value="17">Sub-Content with Sidebar</option>
                                                </select>
                                            </div>

                                            <div class="form-group">
                                                <label for="" class="form-label form-label-box">Template</label>
                                                <select id="template_layout_selector" data-bind="visible: true, disable: isPublishingControl() || isGlobalLockEnabled(), options: templateLayoutsFiltered, optionsText: 'name', optionsValue: 'id', value: idTemplateLayout, valueAllowUnset: true, event: { change: onChangeTemplateLayout }">
                                                </select>
                                            </div>

                                            <div class="form-group">
                                                <label for="idClassification" class="form-label form-label-box">Classification</label>
                                                <select id="idClassification" data-bind="disable: isPublishingControl() || isGlobalLockEnabled(), options: classificationOptions, optionsText: 'name', value: idClassification, optionsValue: 'id'"></select>
                                                <!--<span data-bind="text: classificationName"></span>-->
                                            </div>


                                            <div class="form-group" style="flex:1 50%" data-bind="visible: segments().length > 0 ">
                                                <label for="idSegment" class="form-label form-label-box">Segment</label>
                                                <select id="idSegment" data-bind="disable: isPublishingControl() || isGlobalLockEnabled(), options: segment_options, optionsText: 'name', value: idSegment, optionsValue: 'id'"></select>
                                            </div>



                                            <div class="form-group">
                                                <label for="idNetworkCategory" class="form-label form-label-box">Network Category</label>
                                                <select id="idNetworkCategory" data-bind="disable: isPublishingControl() || isGlobalLockEnabled() , options: networkCategory_options, optionsText: 'name', value: idNetworkCategory, optionsValue: 'id'"></select>
                                            </div>

                                            <div class="form-group">
                                                <label for="idIntent" class="form-label form-label-box">Intent</label>
                                                <select id="idIntent"
                                                    data-bind="disable: isPublishingControl() || isGlobalLockEnabled(),
                                                    options: intent_options, optionsText: 'name', value: idIntent, optionsValue: 'id', event : { change: onIntentChange }"></select>
                                            </div>

                                            <div class="form-group">
                                                <label for="idContentType" class="form-label form-label-box">Content Type</label>
                                                <select id="idContentType"
                                                data-bind="disable: isPublishingControl() || isGlobalLockEnabled(),
                                                            options: contentType_options,
                                                            optionsText: 'name',
                                                            value: idContentType,
                                                            optionsValue: 'id',
                                                            event : { change: onContentTypeChange }
                                                            ">
                                                </select>
                                            </div>

                                        </div>

                                        <div data-bind="visible:isNewsArticle() || isSyndicated()" class="w-timeliness">
                                                <div class="form-group inside-label d-flex" style="align-items: center;gap: 1rem">
                                                    <label for="" class="form-label label-tooltips">
                                                        Source/Inspiration
                                                        <button class="w-tooltips icon i-tooltips" type="button">
                                                            <span class="tooltips">Input the URL of the original source where the news was first reported. If this article was the first to break the news, click the "Self" button to automatically populate the Source/Inspiration URL and DateTime fields with this article’s information.</span>
                                                        </button>
                                                    </label>
                                                    <input type="text" class="input-text" data-bind="attr: { readonly : isPublishingControl() || isGlobalLockEnabled() }, textInput: sourceUrl">
                                                    <span> Or </span>
                                                    <span class="d-flex">
                                                        <button class="input-checkbox btn-form label-height" id="sourceNewsIsFromSelf" data-bind="click: onClickSourceNewsIsSelf">
                                                            Self
                                                        </button>
                                                    </span>
                                                </div>
                                                <div class="form-group inside-label d-flex w-datetime">
                                                    <label for="" class="form-label label-tooltips">
                                                        Datetime
                                                        <button class="w-tooltips icon i-tooltips" type="button">
                                                            <span class="tooltips">Use the Datetime field to capture the original publish date and time of the Source/Inspiration URL. Click "Get Time" to attempt to auto-fill it; if unsuccessful, enter the date and time manually.</span>
                                                        </button>
                                                    </label>
                                                    ${this.sourceNewsDatePicker.getHtmlBuild()}
                                                    <span class="d-flex">
                                                        <button class="input-checkbox btn-form label-height" data-bind="click: onClickSourceNewsGetTime, css: { loading: isLoadingSrcTimeBtn }, enable: isSourceUrlValid">
                                                            Get Time
                                                        </button>
                                                    </span>

                                                </div>
                                                <div class="form-group" data-bind="visible: isSyndicated()">
                                                    <div class="multi-row">
                                                        <input type="checkbox" data-bind="disable: isPublishingControl() || isGlobalLockEnabled(), checked: isLinkToOriginalArticle" id="link-back-to-original">
                                                        <label for="link-back-to-original" class="form-label icon i-check">Link Back to Original Article</label>
                                                    </div>
                                                </div>
                                            </div>

                                    </div>


                                </div>

                                <!-- ----------------- -->
                                <!-- Contributors -- Attributes     -->
                                <!-- ----------------- -->
                                <div class="form-body">

                                    <div class="contributors">
                                        <strong class="form-sub-title">Contributors</strong>

                                        <div class="form-group inside-label">
                                                <label for="authorName" class="form-label">Author</label>
                                                ${this.filterUser_author.getHtmlBuild()}
                                        </div>

                                        <div class="form-group inside-label top">
                                                <label for="authorName" class="form-label label-tooltips">
                                                    Display Authors
                                                    <button class="w-tooltips icon i-tooltips" type="button">
                                                        <span class="tooltips">If this field is empty, the article on the website will have the name (and be on the author page) of the Author of this article.  If another user is tagged here, the article on the website will be attributed to the tagged user instead.  <br> <br>Note: this only effects what is used on the website, not in Emaki.</span>
                                                    </button>

                                                </label>
                                                ${this.filterUser_display_author.getHtmlBuild()}
                                                ${this.display_authors.getHtmlBuild()}
                                        </div>

                                        <div class="form-group inside-label" data-bind="visible: isSyndicated()">
                                                <label for="externalAuthorName" class="form-label">External Author Name</label>
                                                <input type="text" class="input-text" id="externalAuthorName" data-bind="disable: isPublishingControl() || isGlobalLockEnabled(), value: externalAuthorName" placeholder="External Author">
                                        </div>

                                        <div class="form-group inside-label">
                                                <label for="srEditorName" class="form-label">Segment Lead</label>
                                                ${this.filterUser_SrEditor.getHtmlBuild()}
                                        </div>


                                        <div class="form-group inside-label">
                                                <label for="jrEditorName" class="form-label">Editor</label>
                                                ${this.filterUser_JrEditor.getHtmlBuild()}
                                        </div>

                                        <div class="form-group inside-label">
                                                <label for="ideatorName" class="form-label">Ideator</label>
                                                ${this.filterUser_ideator.getHtmlBuild()}
                                        </div>

                                        <div class="form-group inside-label">
                                            <label for="aiAgent" class="form-label">AI Agents</label>
                                            ${this.filterAiAgent.getHtmlBuild()}
                                            <div  data-bind="visible: articleAiAgents().length > 0, foreach: articleAiAgents">
                                                <div class="btn-selection"><span data-bind="text: name"></span><button class="icon i-x-after" type="button" data-bind="event: { click:  $parent.onClickRemoveAiAgent.bind($data, $index) }"></button></div>
                                            </div>
                                        </div>

                                        <div class="list-select">
                                            <div class="form-group">
                                                <label for="idPaymentCategory" class="form-label">Payment Category</label>

                                                <select id="idPaymentCategory" data-bind="disable: !permissions()['article_edit_publishingControl'].write || isGlobalLockEnabled(), value: idPaymentCategory, foreach: paymentCategory_options">
                                                    <!-- ko if: $index() == 0 -->
                                                    <option value>Select an Option</option>
                                                    <!-- /ko -->
                                                    <optgroup  data-bind="attr:{label: $data.name}" label="">
                                                        <!-- ko foreach: $data.paymentCategories -->
                                                        <option data-bind="value: $data.id, text: $data.name"></option>
                                                        <!-- /ko -->
                                                    </optgroup>
                                                </select>
                                            </div>
                                        </div>

                                    </div>


                                </div>

                            </div>
                                <!-- ----------------- -->
                                <!-- Article Recommendations -->
                                <!-- ----------------- -->
                             <div class="w-form-body recommended">
                                ${this.articleRecommendations.getHtmlBuild()}
                            </div>

                                <!-- ----------------- -->
                                <!-- Republish History -->
                                <!-- ----------------- -->
                        </div>

                        <!-- ----------------- -->
                        <!-- End Attributes Tab   -->
                        <!-- ----------------- -->

                        <!-- ----------------- -->
                        <!-- widgets Tab    -->
                        <!-- ----------------- -->
                        <div class="w-tabs-content bg" data-bind="css: { 'is-showing' : selectedTab() == 'widgets'}">

                            <div class="w-form-body">
                                <div class="form-body full-width">
                                    <div class="w-form__vertical-tabs">
                                        <input class="visually-hidden" type="radio" name="vertical-tab" id="tab-articles" checked />
                                        <input class="visually-hidden" type="radio" name="vertical-tab" id="tab-thread" />
                                        <input class="visually-hidden" type="radio" name="vertical-tab" id="tab-newsletter" />
                                        <input class="visually-hidden" type="radio" name="vertical-tab" id="tab-faq" />

                                        <div class="form-vertical-tabs">
                                            <nav class="form-vertical-tabs__sidebar" aria-label="Section">
                                                <label for="tab-articles">
                                                    <span class="icon i-file"></span>
                                                    Article Summaries
                                                </label>
                                                <label for="tab-thread">
                                                    <span class="icon i-thread-summary"></span>
                                                    Thread Summary
                                                </label>
                                                <label for="tab-newsletter">
                                                    <span class="icon i-mail-2"></span>
                                                    Newsletter Promotion
                                                </label>
                                                <label for="tab-faq">
                                                    <span class="icon i-help"></span>
                                                    FAQ
                                                </label>
                                            </nav>

                                            <div class="form-vertical-tabs__content">
                                                <div class="form-vertical-tabs__panel panel-articles">
                                                    <div data-bind="visible: !showSummary()" >
                                                        <strong class="form-group form-sub-title">Summaries</strong>

                                                        <div class="form-group no-result">
                                                            <span class="icon i-review"></span>
                                                            <h2 class="form-title no-margin">This article is not currently eligible for this feature.</h2>
                                                        </div>
                                                    </div>
                                                    <div id="widgets-section-summary" data-bind="visible: showSummary()">
                                                        <strong class="form-group form-sub-title">Summaries</strong>

                                                        <div class="form-group widget-controls">

                                                            <span class="widget-controls__alert" data-bind="visible: isSummaryContentEmpty()" style="color: red; font-weight: bold;">Incomplete content will not sync to the website.</span>
                                                            <button class="btn highlight" type="button" data-bind="attr: { disabled : isPublishingControl() || isGlobalLockEnabled() }, click: onClickGenerateArticleSummaries">Generate Article Summaries</button>
                                                            <div class="form-check-inline" style="width: auto;">
                                                                <input type="checkbox" data-bind="checked: isFactualSummaryEnabled" class="input-checkbox" id="isFactualSummaryEnabled">
                                                                <label class="form-label icon i-check" for="isFactualSummaryEnabled">Factual Summary</label>
                                                            </div>
                                                            <div class="form-check-inline" style="width: auto;">
                                                                <input type="checkbox" data-bind="checked: isSimpleSummaryEnabled" class="input-checkbox" id="isSimpleSummaryEnabled">
                                                                <label class="form-label icon i-check" for="isSimpleSummaryEnabled">Simple Summary</label>
                                                            </div>
                                                            <div class="form-check-inline" style="width: auto;">
                                                                <input type="checkbox" data-bind="checked: isSatiricalCommentaryEnabled" class="input-checkbox" id="isSatiricalCommentaryEnabled">
                                                                <label class="form-label icon i-check" for="isSatiricalCommentaryEnabled">Lighthearted Summary</label>
                                                            </div>
                                                        </div>

                                                        <div class="form-group">
                                                            <label class="form-label">Factual Summary</label>
                                                            <textarea id="factualSummary" name="factualSummary" class="input-text" data-bind=" value: factualSummary"></textarea>
                                                        </div>

                                                        <div class="form-group">
                                                            <label class="form-label">Simple Summary</label>
                                                            <textarea id="simpleSummary" name="simpleSummary" class="input-text" data-bind="value: simpleSummary"></textarea>
                                                        </div>

                                                        <div class="form-group">
                                                            <label class="form-label">Lighthearted Summary</label>
                                                            <textarea id="satiricalCommentary" name="satiricalCommentary" class="input-text" data-bind="value: satiricalCommentary"></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-vertical-tabs__panel panel-thread">
                                                    <div data-bind="visible: !aiThreadSummaryFeatureAvailable()" id="ai-thread-section">
                                                        <strong class="form-group form-sub-title">Thread Summary</strong>
                                                        <div class="form-group no-result">
                                                            <span class="icon i-review"></span>
                                                            <h2 class="form-title no-margin">This article is not currently eligible for this feature.</h2>
                                                        </div>
                                                    </div>
                                                    <div data-bind="visible: aiThreadSummaryFeatureAvailable()" id="ai-thread-section">
                                                        <strong class="form-group form-sub-title">Thread Summary</strong>

                                                        <div class="form-group widget-controls" style="margin-top: .5rem">

                                                            <button class="btn highlight" type="button" data-bind="attr: { disabled : isPublishingControl() || isGlobalLockEnabled() || !isAiThreadSummaryEnabled() }, click: onClickGenerateThreadSummary">Generate Thread Summaries</button>
                                                            <div class="form-check-inline" style="width: auto;">
                                                                <input type="checkbox" data-bind="checked: isAiThreadSummaryEnabled" class="input-checkbox" id="isAiThreadSummaryEnabled">
                                                                <label class="form-label icon i-check" for="isAiThreadSummaryEnabled">Enabled</label>
                                                            </div>
                                                        </div>

                                                        <div class="form-group" id="ai-thread-summary-section">
                                                            <label class="form-label">Thread Summary</label>
                                                            <textarea id="aiThreadSummary" class="input-text" data-bind="value: parsedAiThreadSummary"></textarea><br>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-vertical-tabs__panel panel-newsletter">
                                                    <div class="" data-bind="visible: !showNewsletterPromotion()">
                                                        <strong class="form-group form-sub-title">Newsletter Promotion</strong>

                                                        <div class="form-group no-result">
                                                            <span class="icon i-review"></span>
                                                            <h2 class="form-title no-margin">This article is not currently eligible for this feature.</h2>
                                                        </div>
                                                    </div>

                                                    <div id="ai-newsletter-promotion-section" data-bind="visible: showNewsletterPromotion()">
                                                        <strong class="form-group form-sub-title">Newsletter Promotion</strong>

                                                        <div class="form-group widget-controls">
                                                            <span class="widget-controls__alert" data-bind="visible: isNewsletterPromotionContentEmpty()" style="color: red; font-weight: bold;">Incomplete content will not sync to the website.</span>
                                                            <button class="btn highlight" type="button" data-bind="attr: { disabled : isPublishingControl() || isGlobalLockEnabled() }, click: onClickGenerateNewsletterPromotion">Generate Newsletter Promotion</button>
                                                            <div class="form-check-inline" style="width: auto;">
                                                                <input type="checkbox" data-bind="checked: isAiNewsletterPromotionEnabled" class="input-checkbox" id="isAiNewsletterPromotionEnabled">
                                                                <label class="form-label icon i-check" for="isAiNewsletterPromotionEnabled">Enabled</label>
                                                            </div>
                                                        </div>

                                                        <div class="form-group">
                                                            <label class="form-label">Title</label>
                                                            <textarea id="newsletterPromotionTitle" name="newsletterPromotionTitle" class="input-text" data-bind=" textInput: aiNewsletterPromotionTitle"></textarea>
                                                        </div>
                                                        <div class="form-group">
                                                            <label class="form-label">Excerpt</label>
                                                            <textarea id="newsletterPromotionExcerpt" name="newsletterPromotionExcerpt" class="input-text" data-bind=" textInput: aiNewsletterPromotionExcerpt"></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-vertical-tabs__panel panel-faq">
                                                    <div class="is-hidden" data-bind="visible: !showAiFaq()">
                                                        <strong class="form-sub-title">FAQ</strong>

                                                        <div class="form-group no-result">
                                                            <span class="icon i-review"></span>
                                                            <h2 class="form-title no-margin">This article is not currently eligible for this feature.</h2>
                                                        </div>
                                                    </div>

                                                    <div class="is-hidden" data-bind="visible: showAiFaq()" id="ai-faqs-section">
                                                        <strong class="form-sub-title">FAQ</strong>

                                                        <div class="form-group widget-controls" style="margin-top: .5rem">

                                                            <button class="btn highlight" type="button" data-bind="attr: { disabled : isPublishingControl() || isGlobalLockEnabled() }, click: onClickGenerateArticleFaqs">Generate FAQ</button>
                                                            <div class="form-check-inline" style="width: auto;">
                                                                <input type="checkbox" data-bind="checked: isAiFaqEnabled" class="input-checkbox" id="isAiFaqEnabled">
                                                                <label class="form-label icon i-check" for="isAiFaqEnabled">Enabled</label>
                                                            </div>
                                                        </div>

                                                        <div class="form-group" data-bind="foreach: aiFaqs">
                                                            <label class="form-label" data-bind="text: 'FAQ Question ' + ($index() + 1)"></label>
                                                            <textarea disabled class="input-text" data-bind="value: question"></textarea><br>

                                                            <label class="form-label" data-bind="text: 'FAQ Answer ' + ($index() + 1)"></label>
                                                            <textarea disabled class="input-text" data-bind="value: answer"></textarea>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <!-- ----------------- -->
                        <!-- End widgets Tab   -->
                        <!-- ----------------- -->


                        <!-- ----------------- -->
                        <!-- Extra Tab    -->
                        <!-- ----------------- -->
                        <div class="w-tabs-content bg" data-bind="css: { 'is-showing' : selectedTab() == 'extra'}">

                            <div class="w-form-body">

                                <div class="form-body general" style="border-bottom:0;padding-bottom: 1rem;";>

                                    <strong class="form-sub-title">General</strong>
                                    
                                    <div class="form-group" style="display: flex;align-items: flex-start;gap: 1rem;margin-bottom: 0;">
                                        <div class="form-group inside-label" style="margin: 0;width: 100%;">
                                            <label for="template" class="form-label">Include in directory</label>
                                            ${this.filterArticleDirectory.getHtmlBuild()}
                                        </div>
                                    </div>

                                    <div class="form-group audio-reader-editor" id="audio-reader-section" data-bind="visible: isAudioReaderAvailableForArticleType">
                                        <strong class="form-sub-title">Audio Reader</strong>
                                        <div class="audio-reader-panel">
                                            <div class="audio-reader-controls">
                                                <div class="audio-reader-toggle">
                                                    <input type="checkbox" data-bind="checked: isAudioReaderEnabled, disable: isPublishingControl() || isGlobalLockEnabled()" class="input-checkbox" id="isAudioReaderEnabled">
                                                    <label class="form-label icon i-check" for="isAudioReaderEnabled">Audio Reader</label>
                                                </div>
                                            </div>

                                            <div class="audio-reader-actions">
                                                <button class="btn-form" type="button" data-bind="disable: !isAudioReaderEnabled() || isGeneratingAudioReader() || isAudioReaderBackgroundGenerationPending() || isPublishingControl() || isGlobalLockEnabled(), event: { click: onClickGenerateAudioReader }">
                                                    <span data-bind="text: isGeneratingAudioReader() ? 'Generating Audio...' : 'Generate Audio'"></span>
                                                </button>
                                                <!-- ko if: audioReaderStatus() -->
                                                <span class="audio-reader-status" data-bind="text: audioReaderStatus"></span>
                                                <!-- /ko -->
                                                <!-- ko if: audioReaderErrorMessage() -->
                                                <span class="audio-reader-error" data-bind="text: audioReaderErrorMessage"></span>
                                                <!-- /ko -->
                                                <!-- ko if: !isAudioReaderEnabled() -->
                                                <span class="audio-reader-helper">Enable Audio Reader to generate audio.</span>
                                                <!-- /ko -->
                                            </div>

                                            <div class="audio-reader-meta">
                                                <!-- ko if: isAudioReaderStateLoading() -->
                                                <span class="audio-reader-loading">Loading audio reader file...</span>
                                                <!-- /ko -->
                                                <!-- ko if: isAudioReaderDifferentFromSavedContent() -->
                                                <span class="audio-reader-warning">Current audio was generated from a different article version.</span>
                                                <!-- /ko -->
                                                <!-- ko if: audioReaderNoticeMessage() -->
                                                <span class="audio-reader-notice" data-bind="text: audioReaderNoticeMessage"></span>
                                                <!-- /ko -->
                                            </div>

                                            <!-- ko if: audioReaderFileUrl() -->
                                            <div class="audio-reader-preview">
                                                <span class="audio-reader-preview-label">Preview</span>
                                                <div class="audio-reader-demo-player" data-audio-reader-player>
                                                    <div class="audio-reader-demo-header">
                                                        <strong>Listen</strong>
                                                        <span data-audio-reader-duration>0:00</span>
                                                    </div>
                                                    <audio preload="none" data-bind="attr: { 'data-src': audioReaderFileUrl }"></audio>
                                                    <div class="audio-reader-waveform" data-audio-reader-waveform data-waveform-bars="200" data-bind="attr: { 'data-audio-reader-metadata-url': audioReaderMetadataUrl }"></div>
                                                    <div class="audio-reader-main-controls">
                                                        <button class="audio-reader-control-button" type="button" data-audio-reader-rewind aria-label="Rewind 15 seconds">-15</button>
                                                        <button class="audio-reader-play-button" type="button" data-audio-reader-toggle aria-label="Play Audio Reader">Play</button>
                                                        <button class="audio-reader-control-button" type="button" data-audio-reader-forward aria-label="Forward 15 seconds">+15</button>
                                                    </div>
                                                    <div class="audio-reader-progress-row">
                                                        <input class="audio-reader-progress" type="range" min="0" max="1000" value="0" data-audio-reader-progress aria-label="Audio Reader progress">
                                                        <span class="audio-reader-time"><span data-audio-reader-current>0:00</span> / <span data-audio-reader-total>0:00</span></span>
                                                        <select class="audio-reader-speed" data-audio-reader-speed aria-label="Playback speed">
                                                            <option value="0.75">0.75x</option>
                                                            <option value="1" selected>1x</option>
                                                            <option value="1.25">1.25x</option>
                                                            <option value="1.5">1.5x</option>
                                                            <option value="2">2x</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- /ko -->
                                        </div>
                                    </div>

                                </div>

                                <!-- ko if: newsNowBrands().includes(brand().id)  -->

                                <div class="form-body" style="position: relative">

                                    <strong class="form-sub-title amazon">

                                    <span>News Now</span>

                                    </strong>
                                    <div class="overlay">
                                    </div>
                                    <input type="checkbox" class="invert" data-bind="visible:newsNowBrands().includes(brand().id),checked: isNewsNowArticle ,disable: !permissions()['article_edit_publishingControl'].write" id="isNewsNowArticle">
                                    <label for="isNewsNowArticle" class="form-label icon i-check" style="color:#ffffff;line-height: 1.2;color: #ffffff;margin-top: .9rem;">Include in Feed</label>

                                    <div class="form-group inside-label" style="display:flex;justify-content: flex-start;">
                                        <label class="form-label" for="">Article title</label>
                                        <input type="text" class="input-text" data-bind="disable: isPublishingControl() || isGlobalLockEnabled() , value:  newsNowArticleTitle">
                                    </div>
                                </div>
                                <!-- /ko -->

                            </div>
                            <div class="w-form-body">
                                <!-- ko if: showSEO()  -->
                                <div class="form-body" style="border 0:">
                                    <!-- ----------------- -->
                                    <!-- SEO               -->
                                    <!-- ----------------- -->

                                    <strong class="form-sub-title">
                                        <span>SEO</span>
                                        <button title="Draft SEO Title & Description"  class="btn-form light icon i-ai-1 e-lab" id="seo-analysis-button" style="margin: 0;"  data-bind=" click: function(){ onClickAnalyzeSeo() }, visible: idTemplate() != ${ID_TEMPLATE_THREAD} && aiSettings().seoSuggestionPromptAvailable  , disable: isAiAnalyzing()" type="button"></button>
                                    </strong>

                                    <div class="form-group inside-label" data-bind="visible: idTemplate() != 15">
                                        <label for="seoTitle" class="form-label">Title</label>
                                        <input type="text" id="article-seoTitle" class="input-text" name="seoTitle" data-bind="attr :{readonly : isPublishingControl() || isGlobalLockEnabled() }, value: seoTitle"/>
                                    </div>

                                    <div class="form-group inside-label" data-bind="visible: idTemplate() != 15">
                                        <label for="seoDescription" class="form-label">Description (max 150 char)</label>
                                        <textarea id="article-seoDescription" class="input-text" name="seoDescription" maxlength="150" data-bind="attr :{readonly : isPublishingControl() || isGlobalLockEnabled() }, value: seoDescription"/></textarea>
                                    </div>

                                    <div class="form-group inside-label" data-bind="visible: idTemplate() != 7 && (idStatus() != 6 || (idStatus() == 6 && permissions()['article_edit_publishingControl'].write)) && !isSubContent()">
                                        <label class="form-label" for="idArticle" >Next/Recommended Article</label>
                                        ${this.filterArticle.getHtmlBuild()}
                                    </div>
                                </div>
                                <!-- /ko -->

                                <div class="form-body">

                                    <!-- ----------------- -->
                                    <!-- SMO               -->
                                    <!-- ----------------- -->
                                    <div class="social-media">
                                        <strong class="form-sub-title "><span>Social Media</span><button title="Create Social Media Copy" class="btn-form light icon i-ai-1 e-lab"  style="margin: 0;" id="socialmedia-analysis-button"  data-bind=" click: function(){ onClickAnalyzeSocialMedia() }, visible: idTemplate() != ${ID_TEMPLATE_THREAD} && aiSettings().socialmediaSuggestionPromptAvailable , disable: isAiAnalyzing()" type="button"></button></strong>

                                        <div class="form-group inside-label">
                                            <label for="smoTitle" class="form-label"><span>SMO Title<span></label>
                                            <input type="text" id="article-smoTitle" class="input-text" name="smoTitle" data-bind="attr :{readonly : isPublishingControl() || isGlobalLockEnabled() }, value: smoTitle"/>
                                        </div>

                                        <div class="form-group inside-label">
                                            <label for="smoDescription" class="form-label">SMO Description (max 150 char)</label>
                                            <textarea id="article-smoDescription" name="smoDescription" maxlength="150" data-bind="attr :{readonly : isPublishingControl() || isGlobalLockEnabled() }, value: smoDescription"/></textarea>
                                        </div>


                                        <div class="form-group inside-label">
                                            <label for="socialTagLine" class="form-label">Social Tagline</label>
                                            <input id="article-socialTagLine" type="text" class="input-text" name="socialTagLine" data-bind="attr :{readonly : isPublishingControl() || isGlobalLockEnabled() }, value: socialTagLine"/>
                                        </div>

                                        <div class="form-group img">
                                            <div style="display: flex;align-items: center">
                                                <label for="alternateImage" class="form-label">Alternate Image</label>
                                                <div class="w-tooltips-adv pos-top short">
                                                    ${this.alternateSocialMediaImageToolTip.getHtmlBuild()}
                                                </div>
                                            </div>
                                            ${this.imageWidgetForAlternateImage.getHtmlBuild()}
                                        </div>
                                    </div>
                                </div>

                                <div class="form-body full-width ">
                                    <div class="form-body" style="padding-top: 0;margin: 0rem 1rem 0 1rem;">
                                        <!-- ----------------- -->
                                        <!-- THREAD            -->
                                        <!-- ----------------- -->
                                        <strong class="form-sub-title" style="padding: .5rem .5rem .5rem 0;margin-top: 0;"><span>Thread</span><button title="Produce Thread Discussion Starters" class="btn-form light icon i-ai-1 e-lab"  style="margin: 0;" id="thread-analysis-button"  data-bind=" click: function(){ onClickAnalyzeThread() }, visible: idTemplate() != ${ID_TEMPLATE_THREAD} && aiSettings().threadSuggestionPromptAvailable , disable: isAiAnalyzing()" type="button"></button></strong>
                                        <div class="form-group inside-label">
                                            <label for="prompt" class="form-label">Prompt (max 150 char)</label>
                                            <input id="article-prompt" type="text" class="input-text" name="prompt" data-bind="attr :{readonly : isPublishingControl() || isGlobalLockEnabled() }, textInput: prompt, event: { focusout: onFocusOutPrompt }"/>
                                        </div>

                                        <div class="form-group">
                                            <label for="prompt_response" class="form-label">Prompt Response</label>
                                            <textarea id="prompt_response" name="prompt_response" maxlength="2000" data-bind="attr :{readonly : isPublishingControl() || isGlobalLockEnabled() }, textInput: promptResponse,  valueUpdate: ['afterkeydown', 'input']"/></textarea>
                                        </div>

                                        <div class="form-group inside-label" >
                                            <label for="prompt" class="form-label">Prompt Link</label>
                                            <input type="text" class="input-text" name="promptLink" data-bind="attr :{readonly : isPublishingControl() || isGlobalLockEnabled() }, value: promptLink,  valueUpdate: ['afterkeydown', 'input']"/>
                                        </div>


                                        <div style="display: flex; align-items: flex-start; gap: 1rem;">

                                            <div class="form-group inside-label" data-bind="visible: isPromptAuthorVisible()" style="width: 270px;">
                                                <label for="authorName" class="form-label label-tooltips" style="display: flex; align-items: center; gap: 8px; margin: 0; top: -.8rem;">
                                                    <span>
                                                        Prompt Author
                                                    </span>
                                                    <div class="w-tooltips-adv pos-right short">
                                                        ${this.toolTip_prompt_author.getHtmlBuild()}
                                                    </div>
                                                </label>
                                                ${this.filterWebsiteUser_prompt_author.getHtmlBuild()}
                                            </div>

                                            <div class="form-group inside-label" data-bind="hidden : idTemplate() == ${ID_TEMPLATE_THREAD}">
                                                <input type="checkbox" data-bind="checked: isCommentsDisabled" id="CommentsDisabled">
                                                <label class="icon i-check" for="CommentsDisabled">Hide Comments</label>
                                            </div>
                                            <div class="form-group inside-label">
                                                <input type="checkbox" data-bind="checked: isCommentsPaused" id="CommentsPaused">
                                                <label class="icon i-check" for="CommentsPaused">Pause Comments</label>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="form-body full-width" style="border:0;padding: 0;" data-bind="visible: isFAQSectionVisible()" style="border:0">

                                    <div class="form-section faq">
                                        <!-- ----------------- -->
                                        <!--FAQ                -->
                                        <!-- ----------------- -->
                                        <strong class="form-sub-title" style="margin-top: 0.5rem;">
                                            <span>FAQ</span>
                                            <button class="btn-form icon-only icon i-plus" type="button" data-bind="disable: isPublishingControl() || isGlobalLockEnabled() , event: { click: onClickAddFaq }"><span class="hide">Add Faq</span></button>
                                        </strong>


                                        <div class="form-group">
                                            <div class="w-list">
                                                <ul data-bind="foreach: faqs">
                                                    <li>
                                                        <div class="item-header">
                                                            <div>
                                                                <button class="btn-form icon i-delete" type="button" data-bind="disable: $parent.isPublishingControl()|| $parent.isGlobalLockEnabled() , visible: $parent.idStatus() != 6 || ($parent.idStatus() == 6 && $parent.permissions()['article_edit_publishingControl'].write),event: { click: $parent.onClickDeleteFaq }"><span class="hide">Delete</span></button>
                                                                <button class="btn-form icon i-edit" type="button" data-bind="disable: $parent.isPublishingControl() || $parent.isGlobalLockEnabled(), visible: $parent.idStatus() != 6 || ($parent.idStatus() == 6 && $parent.permissions()['article_edit_publishingControl'].write),event: { click: $parent.onClickEditFaq.bind($data, $index())  }"><span class="hide">Edit</span></button>
                                                            </div>
                                                        </div>
                                                        <strong data-bind="text: $data.question">Question</strong>
                                                        <p data-bind="html: $data.answer"></p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- ----------------- -->
                                <!--Pinned Tags        -->
                                <!-- ----------------- -->
                                <div data-bind="visible: showPinnedTags() && (idTemplate() == 2 || idTemplate() == 3 || idTemplate() == 9 || idTemplate() == 10 || idTemplate() == 14)">
                                    ${this.articlePinnedTags.getHtmlBuild()}
                                </div>

                            </div>

                        </div>
                        <!-- end w-tabs-content -->

                        <!-- ----------------- -->
                        <!-- Revision          -->
                        <!-- ----------------- -->
                        <div class="w-tabs-content bg" data-bind="css: { 'is-showing' : selectedTab() == 'revision'}"><!-- .is-showing -->

                            <div class="w-form-body revision"  data-bind="visible: revisions().length > 0">
                                <div class="form-body side">
                                    <div class="form-group">
                                        <ul class="user-list" data-bind="foreach: revisions">
                                            <li class="user-item" data-bind="css: { 'is-selected' : $index() == $parent.selectedRevisionIndex() }">
                                                <button class="user-link" type="button" data-bind="event: {click: $parent.onClickRevision.bind($data, $index) }">
                                                    <div>
                                                        <strong class="side" data-bind="text: $data.dateCreated" ></strong>
                                                        <span data-bind="if: $data.content.author"><span data-bind="text: $data.content.author.valnet_user.fullName"></span></span>
                                                    </div>
                                                </button>
                                            </li>
                                        </ul>

                                    </div>
                                </div>
                                <div class="form-body revision">
                                    <div class="form-group-header">
                                        <button class="btn-form icon i-compare" type="button" data-bind="disable: isGlobalLockEnabled() , css: {  'is-selected' : revisions().length > 1 && !isGlobalLockEnabled() }, event: { click: onClickCompareRevision }">compare</button>
                                        <!-- <button class="btn-form no-bg icon i-revision" type="button" data-bind="visible: idStatus() != 6 || permissions()['article_edit_publishingControl'].write, event: { click: onClickRevertRevision }">Revert</button>-->
                                        <button class="btn-form no-bg icon i-revision" type="button" data-bind="disable: isPublishingControl() || isGlobalLockEnabled(), event: { click: checkIfReviewItemsNeedAnUpdate.bind($data, 'revision') }">Revert</button>
                                    </div>

                                    <div class=" buyers-guide">
                                        ${this.revisionReviewSection.getHtmlBuild()}
                                    </div>

                                    <div class="w-content">
                                        <strong class="form-sub-title content" >Content</strong>
                                        <div class="form-group" data-bind="html: revisionContent"></div>
                                    </div>

                                    <div>
                                        ${this.revisionDirectory.getHtmlBuild()}
                                    </div>
                                </div>
                            </div>
                            <div class="w-form-body revision" data-bind="visible: revisions().length == 0">
                                <div class="form-group full-width">
                                    <p style="margin-top: 2rem;">No Revision Available</p>
                                </div>
                            </div>
                        </div>
                        <!-- end w-tabs-content -->


                        <!-- ----------------- -->
                        <!-- Sandbox          -->
                        <!-- ----------------- -->
                        <div class="w-tabs-content bg" data-bind="css: { 'is-showing' : (selectedArticleEditmode() == 'sandbox' || isSandboxActive() ) && selectedTab() == 'sandboxAndRepublish'}"><!-- .is-showing -->

                            <div class="w-form-body"><div class="w-form-body">


                                <div class="form-body full-width">

                                    <strong class="form-sub-title icon i-sandbox">Sandbox</strong>

                                    <div class="form-group w-justify" style="margin-bottom: 0;">
                                        <div class="w-left">
                                            <button class="btn-form light icon i-article-regular" data-bind="event: { click: checkIfReviewItemsNeedAnUpdate.bind($data, 'sandbox') }, visible: (selectedArticleEditmode() == 'sandbox' || isSandboxActive() ) && selectedTab() == 'sandboxAndRepublish', disable: (isPublishingControl() || isGlobalLockEnabled() || isSaveButtonDisabled()),  text: isSaveButtonDisabled() ? 'Autosaving...' : 'Insert Sandbox into Content'" type="button"></button>
                                            <button class="btn-form icon light" style="margin-left: 1rem" type="button" data-bind="event: { click: onClickDeleteSandbox}, text: 'Delete Sandbox'"></button>
                                        </div>
                                        <div class="w-right">
                                            <button class="btn-form icon i-compare" type="button" data-bind="disable : isGlobalLockEnabled(), css: {  'is-selected' : isSandboxContent()  && revisions().length > 0}, event: { click: onClickCompareSandbox.bind($data, 'sandbox')  }">Compare To Latest Revision</button>
                                            <button class="btn-form icon light" style="margin-left: 1rem" type="button" data-bind="disable: isGlobalLockEnabled() ,event: { click: onClickPreviewNoSave.bind($data, 'sandbox') }, text: 'Preview Sandbox'"></button>
                                        </div>
                                    </div>
                                    ${this.productReviewSandbox.getHtmlBuild()}
                                    ${this.sandboxContent.getHtmlBuild()}
                                </div>
                            </div>
                            ${this.sandboxDirectory.getHtmlBuild()}
                            </div>
                        </div>
                        <!-- end w-tabs-content -->

                        <div class="w-tabs-content bg" data-bind="css: { 'is-showing' : (selectedArticleEditmode() == 'republish' || isRepublishActive() ) && selectedTab() == 'sandboxAndRepublish'}">

                                <div class="w-form-body">

                                    <div class="form-body">
                                    <strong class="form-sub-title icon i-redo">Republish</strong>
                                        <div class="form-group w-justify" style="flex-wrap:wrap;">
                                            <div class="w-left">
                                                <button class="btn-form icon light alert align-left icon i-redo" style="margin-left: 1rem;width: 240px;white-space: break-spaces;" type="button" data-bind="disable: idRepublishStatus() != 6 || isPublishingControl() || isGlobalLockEnabled() ,event: { click: onClickRepublishCreateAndUpdate }, text: 'Create Republish and Update Article Content with this Version'"></button>
                                                <button class="btn-form icon light alert no-wrap icon i-delete" style="margin-left: 1rem" type="button" data-bind="event: { click: onClickDeleteRepublish}, text: 'Delete Republish'"></button>

                                            </div>
                                            <div class="w-right">
                                                <button class="btn-form icon i-compare" type="button" data-bind="disable : isGlobalLockEnabled(), css: {  'is-selected' : revisions().length > 0}, event: { click: onClickCompareSandbox.bind($data, 'republish') }">Compare To Latest Revision</button>
                                                <button class="btn-form icon light no-wrap icon i-view" style="margin-left: 1rem" type="button" data-bind="disable: isGlobalLockEnabled() ,event: { click: onClickPreviewNoSave.bind($data, 'republish')}, text: 'Preview Republish'"></button>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="w-form-body">
                                    <div class="form-body">
                                        <strong class="form-sub-title">Information</strong>
                                        <div class="form-group inside-label date">
                                            <label class="form-label">republish date</label>
                                            ${this.republishDatePicker.getHtmlBuild()}
                                        </div>
                                        <div class="form-group">
                                            <hr>
                                        </div>
                                        <div class="form-group" style="margin: 2rem 2rem">
                                            <label  class="form-label">Status</label>
                                            <select id="idStatusRepublish" data-bind="disable: (idRepublishStatus() == 6 && isPublishingControl()) || isGlobalLockEnabled(), options: articleRepublishStatus_options, optionsText: 'name', value: idRepublishStatus, optionsValue: 'id', event: {change: onChangeArticleStatus}"></select>
                                        </div>
                                        <div class="form-group">
                                            <hr>
                                        </div>

                                        <div class="form-group form-check-inline" data-bind="if: permissions()['article_edit_embargo'].read" style="margin: 0 2rem">
                                            <input type="checkbox" data-bind="disable: !permissions()['article_edit_embargo'].write || isPublishingControl() || isGlobalLockEnabled(), checked: republishIsUnderEmbargo" id="rep-under-embargo">
                                            <label for="rep-under-embargo" class="form-label icon i-check" style="display:flex">Republish Under Embargo</label>
                                        </div>



                                    </div>

                                    <div class="form-body">
                                        <strong class="form-sub-title">Contributors</strong>
                                        <div class="form-group inside-label">
                                            <label for="authorName" class="form-label">Author</label>
                                            ${this.filterUser_republish_author.getHtmlBuild()}
                                        </div>

                                        <div class="form-group inside-label">
                                            <label for="srEditorName" class="form-label">Segment Lead</label>
                                            ${this.filterUser_republish_SrEditor.getHtmlBuild()}
                                        </div>

                                        <div class="form-group inside-label">
                                            <label for="jrEditorName" class="form-label">Editor</label>
                                            ${this.filterUser_republish_JrEditor.getHtmlBuild()}
                                        </div>
                                    </div>

                                    <div class="form-body">

                                        <strong class="form-sub-title">Payment</strong>

                                        <div class="form-group row">
                                            <label class="form-label" style="width: 16rem">Payment Category</label>
                                            <div style="width: 100%">
                                                ${this.paymentCategoryFilter.getHtmlBuild()}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <hr>
                                        </div>

                                        <!--Payment type dropdown-->

                                        <div class="form-group row">
                                            <label class="form-label" style="width: 16rem;">Author Payment</label>
                                            <select
                                            data-bind="options: paymentTypeRepublish,
                                                    optionsCaption: 'Choose a payment type',
                                                    optionsValue: 'name',
                                                    optionsText: 'name' ,
                                                    value: choosenPaymentTypeRepublish,
                                                    event : {change : onChangepaymentTypeRepublish } "
                                                    >
                                            </select>
                                        </div>
                                        <!-- Show Input -->
                                        <div class="form-group row" data-bind="visible: choosenPaymentTypeRepublish">
                                            <!-- ko if: choosenPaymentTypeRepublish() == 'Amount' -->

                                            <div  style="display: flex;align-items: center;width: 50%;">
                                                <input  id="amountAuthor"
                                                    style="text-transform: capitalize;margin-right: 1rem"
                                                    data-bind="disable: !permissions()['article_edit_publishingControl'].write, value: amountAuthor, attr: { 'placeholder':  choosenPaymentTypeRepublish().toLowerCase() }"
                                                    class="input-text"
                                                    type="number"
                                                    min="0"
                                                >
                                                <span class="form-indic">$</span>
                                            </div>

                                            <!-- /ko -->

                                            <!-- ko if: choosenPaymentTypeRepublish() == 'Percentage' -->

                                            <div style="display: flex;align-items: center;width: 50%;">
                                                <input  id="percentageAuthor"
                                                    style="text-transform: capitalize;margin-right: 1rem"
                                                    data-bind=" disable: !permissions()['article_edit_publishingControl'].write,
                                                                value: percentageAuthor,
                                                                attr: { 'placeholder':  choosenPaymentTypeRepublish().toLowerCase() }"
                                                    class="input-text"
                                                    type="number"
                                                    min="0"
                                                    max="999"
                                                    step="any"
                                                >
                                                <span class="form-indic">%</span>
                                            </div>
                                            <!-- /ko -->
                                        </div>


                                        <div class="form-group">
                                            <hr>
                                        </div>

                                        <!-- Edirepublish-newtor percentage (Always %) -->
                                        <div class="form-group inside-label row start">
                                            <label class="form-label" style="width: 12rem;">Editor Payment</label>
                                            <div style="display: flex;align-items: center;width: 50%;">
                                                <input
                                                    data-bind=" disable: !permissions()['article_edit_publishingControl'].write,
                                                                value: percentageEditor,
                                                                attr: { 'placeholder': 'Percentage' }"
                                                    class="input-text num"
                                                    type="number"
                                                    min="0"
                                                    max="999"
                                                    step="any"
                                                    style="margin-right: 1rem"
                                                >
                                                <span class="form-indic">%</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-form-body">
                                    <div class="form-body">
                                        ${this.productReviewRepublish.getHtmlBuild()}
                                        <div style="width: 100%">
                                            ${this.republishContent.getHtmlBuild()}
                                        </div>
                                    </div>
                                </div>
                                ${this.republishDirectory.getHtmlBuild()}
                        </div>




                        <!-- ----------------- -->
                        <!-- Recovery          -->
                        <!-- ----------------- -->
                        <div class="w-tabs-content bg" data-bind="css: { 'is-showing' : selectedTab() == 'recovery'}"><!-- .is-showing -->

                            <div class="w-form-body recovery">
                               <div class="form-body full-width block" data-bind="visible: recoveryContent() != null || sandboxRecoveryContent() != null || republishRecoveryContent() != null">
                                    <div class="form-group-header tabs">
                                        <div class="form-group w-sub-tab">
                                            <button class="btn is-selected" type="button" data-bind="event: { click: onClickRecoveryTab }, css: { 'is-selected' : selectedRecoveryTab() == 'content'}">Content</button>
                                            <button class="btn" type="button" data-bind="visible: sandboxRecovery() != '', event: { click: onClickSandboxRecoveryTab }, css: { 'is-selected' : selectedRecoveryTab() == 'sandbox'}">Sandbox</button>
                                            <button class="btn" type="button" data-bind="visible: republishRecovery() != '', event: { click: onClickRepublishRecoveryTab }, css: { 'is-selected' : selectedRecoveryTab() == 'republish'}">Republish</button>
                                        </div>
                                         <div class="user-link">
                                            <!--<img src="/assets/images/default-user.png" alt="">-->
                                            <div style="text-align: left">
                                                <strong data-bind="text: dateRecovery"></strong>
                                                <span data-bind="text: recoveryUser"></span>
                                            </div>
                                         </div>
                                     </div>
                                </div>
                                <div class="form-body full-width is-selected " data-bind="visible: recoveryContent() != null || sandboxRecoveryContent() != null || republishRecoveryContent() != null">
                                    <div class="form-group-header border row">

                                        <button class="btn-form icon i-compare" type="button" data-bind="disable: isGlobalLockEnabled() , event: { click: onClickCompareRecovery.bind($data, 'content') }, css: {  'is-selected' :  revisions().length > 0 && !isGlobalLockEnabled()  }, visible: (selectedRecoveryTab() == 'content' && (idStatus() != 6 || permissions()['article_edit_publishingControl'].write))">Compare To Latest Revision</button>
                                        <!--<button class="btn-form icon i-revision" type="button" data-bind="event: { click: onClickRevertRecovery }, visible: (selectedRecoveryTab() == 'content' && (idStatus() != 6 || permissions()['article_edit_publishingControl'].write))">Revert Content</button>-->

                                        <button class="btn-form icon i-revision" type="button" data-bind="event: { click: checkIfReviewItemsNeedAnUpdate.bind($data, 'recovery') }, visible: selectedRecoveryTab() == 'content', disable: (isSaveButtonDisabled() || (selectedRecoveryTab() == 'content' && (isPublishingControl() || isGlobalLockEnabled()))),  text: isSaveButtonDisabled() ? 'Autosaving...' : 'Revert Content'"></button>
                                        <button class="btn-form icon i-compare" type="button" data-bind="event: { click: onClickCompareRecovery.bind($data, 'sandbox') }, css: {  'is-selected' : selectedRecoveryTab() == 'sandbox' && isSandboxContent()}, visible: selectedRecoveryTab() == 'sandbox', disable : isPublishingControl() || isGlobalLockEnabled() ">Compare To SandBox</button>
                                        <button class="btn-form icon i-compare" type="button" data-bind="event: { click: onClickCompareRecovery.bind($data, 'republish') }, css: {  'is-selected' : selectedRecoveryTab() == 'republish'}, visible: selectedRecoveryTab() == 'republish', disable : isPublishingControl() || isGlobalLockEnabled() ">Compare To Republish</button>
                                        <button class="btn-form icon i-revision" type="button" data-bind="event: { click: onClickRevertSandboxRecovery }, visible: selectedRecoveryTab() == 'sandbox', disable: isSaveButtonDisabled() || isGlobalLockEnabled() ,  text: isSaveButtonDisabled() ? 'Autosaving...' : 'Revert Sandbox'"></button>
                                        <button class="btn-form icon i-revision" type="button" data-bind="event: { click: onClickRevertRepublishRecovery }, visible: selectedRecoveryTab() == 'republish', disable: isSaveButtonDisabled() || isGlobalLockEnabled() ,  text: isSaveButtonDisabled() ? 'Autosaving...' : 'Revert Republish'"></button>
                                    </div>

                                    <div data-bind="visible: selectedRecoveryTab() == 'content'">

                                        <div class="form-group w-content buyers-guide">
                                            ${this.recoveryReviewSection.getHtmlBuild()}
                                        </div>

                                        <div class="form-group w-content">
                                            <strong class="form-sub-title content" >CONTENT</strong>
                                            <div data-bind="html: recoveryContent" ></div>
                                        </div>

                                         <div class="">
                                            ${this.recoveryDirectory.getHtmlBuild()}
                                        </div>

                                    </div>

                                    <div data-bind="visible: selectedRecoveryTab() == 'sandbox'">

                                        <div class="form-group w-content buyers-guide">
                                            ${this.recoverySandboxReviewSection.getHtmlBuild()}
                                        </div>

                                        <div class="form-group w-content">
                                            <strong class="form-sub-title content" >CONTENT</strong>
                                            <div data-bind="html: sandboxRecoveryContent" ></div>
                                        </div>

                                        <div class="form-group w-content">
                                            ${this.recoverySandboxDirectory.getHtmlBuild()}
                                        </div>
                                    </div>

                                    <div data-bind="visible: selectedRecoveryTab() == 'republish'">

                                        <div class="form-group-group" data-bind="visible: republishRecovery() && republishRecovery().republishes && republishRecovery().republishes.length > 0">
                                            <div class="form-group">
                                                <label class="form-label">Republish Date:</label>
                                                <span data-bind="text: republishRecoveryDate"></span>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Status:</label>
                                                <span data-bind="text: republishRecoveryStatus"></span>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Author:</label>
                                                <span data-bind="text: republishRecoveryAuthor"></span>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Sr Editior:</label>
                                                <span data-bind="text: republishRecoverySrEditor"></span>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Jr Editor:</label>
                                                <span data-bind="text: republishRecoveryJrEditor"></span>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Payment category:</label>
                                                <span data-bind="text: republishRecoveryPaymentCategory"></span>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Author Amount:</label>
                                                <span data-bind="text: republishRecoveryAuthorAmount"></span>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Author Percentage:</label>
                                                <span data-bind="text: republishRecoveryAuthorPercentage"></span>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Editor Payment:</label>
                                                <span data-bind="text: republishRecoveryEditorPercentage"></span>
                                            </div>

                                        </div>

                                        <div class="form-group w-content buyers-guide">
                                            ${this.recoveryRepublishReviewSection.getHtmlBuild()}
                                        </div>

                                        <div class="form-group w-content">
                                            <strong class="form-sub-title content" >CONTENT</strong>
                                            <div data-bind="html: republishRecoveryContent" ></div>
                                        </div>

                                        <div class="form-group w-content">
                                            ${this.recoveryRepublishDirectory.getHtmlBuild()}
                                        </div>
                                    </div>

                                </div>

                            </div>

                            <div class="w-form-body" data-bind="visible: recoveryContent() == null && sandboxRecoveryContent() == null && republishRecoveryContent() == null">
                                <div  class="form-group full-width">
                                    <p>No Recovery Available</p>
                                </div>
                            </div>


                        </div><!-- end w-tabs-content -->

                        <!-- ----------------- -->
                        <!-- Analytics         -->
                        <!-- ----------------- -->


                        <div class="w-tabs-content bg" id="analytics-tab" data-bind="css: { 'is-showing' : selectedTab() == 'analytics'}"><!-- .is-showing -->
                            ${this.articleAnalytics.getHtmlBuild()}
                        </div>
                        <!-- end w-tabs-content -->

                        <!-- ----------------- -->
                        <!-- Reviews         -->
                        <!-- ----------------- -->
                        <div class="w-tabs-content bg" data-bind="css: { 'is-showing' : selectedTab() == 'reviews'}"><!-- .is-showing -->
                            <div class="w-form-body review-items">

                                <!-- ko if : idTemplate() != ${ID_TEMPLATE_VIDEO} && idTemplate() != ${ID_TEMPLATE_THREAD} -->
                                    <div class="form-body full-width">
                                    ${this.eeatScorePanel.getHtmlBuild()}
                                    </div>
                                <!-- /ko -->
                                <div class="form-body full-width">
                                ${this.articleReviewHistory.getHtmlBuild()}
                                </div>
                            </div>
                        </div>
                        <!-- end w-tabs-content -->

                        <!-- ----------------- -->
                        <!-- Newsletter        -->
                        <!-- ----------------- -->
                        <div class="w-tabs-content bg " data-bind="css: { 'is-showing' : selectedTab() == 'newsletter'}"><!-- .is-showing -->
                            <div class="w-form-body">
                                <div class="form-body full-width">
                                    <strong class="form-sub-title" >INFORMATION</strong>
                                    <div class="form-group">
                                        <label for="subject" class="form-label">Subject</label>
                                        <div class="row link">
                                            <input id="subject" data-bind="value: newsletterSubject" type="text" class="input-text">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="previewText" class="form-label">Preview Text</label>
                                        <div class="row link">
                                            <input id="previewText" data-bind="value: newsletterPreviewText" type="text" class="input-text">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="w-recipents">
                                            <div>
                                                <label for="date" class="form-label">Template</label>
                                                ${this.newsletterTemplateSelector.getHtmlBuild()}
                                            </div>
                                            <div style="margin-left:1rem">
                                                <label for="date" class="form-label">Date Scheduled</label>
                                                ${this.newsletterDateScheduledSelector.getHtmlBuild()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>
                                <div class="w-form-body">
                                    <strong class="form-sub-title parent">Recipients</strong>
                                    <div class="form-body">
                                        <strong class="form-sub-title content">MAILING LISTS</strong>
                                        <div class="form-group mailinglist" >
                                            <div data-bind="foreach: newsletterMailingLists">
                                                    <input type="checkbox" data-bind="attr: {id: 'recipient' + id}, value: id, checked: $parent.selectedMailingLists">
                                                    <label class="form-label icon i-check"  data-bind="text: name, attr: {for: 'recipient' + id}"></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-body">
                                        <strong class="form-sub-title content">SPECIFIC EMAIL ADDRESSES</strong>
                                        <div class="form-group custom-mailing-list " data-bind="class: newsletterEmailErrors().length > 0 ? 'is-error' : ''">
                                            <label for="customRecipients" class="form-label">Custom
                                                <div class="w-tooltips-adv pos-far-right short" style="display: inline-block;transform: translateY(4px);">
                                                ${this.customRecipientsToolTipButton.getHtmlBuild()}
                                                </div>
                                            </label>
                                            <textarea id="customRecipients" data-bind="value: newsletterRecipientsEmails" type="text" class="input-text">
                                            </textarea>
                                            <ul data-bind="visible: newsletterEmailErrors().length > 0, foreach: newsletterEmailErrors" class="errors">
                                                <li data-bind="text: $data"></li>
                                            </ul>
                                        </div>
                                        <div class="form-group">
                                            <input id="myself" data-bind="checked: newsletterSendToSelf, value: 'self'" type="checkbox">
                                            <label for="myself" class="form-label icon i-check">Send to Email Address of Logged In User</label>
                                        </div>
                                    </div>

                            </div>
                            <div class="form-footer">
                                    <button class="btn highlight" data-bind="event: { click: onClickSendNewsletter }, text: 'Send', visible: permissions()['newsletter_email_edit'].write">Send</button>
                            </div>
                        </div>
                        <!-- end w-tabs-content -->

                    <!-- ----------------- -->
                    <!-- Republish And Sandbox -->
                    <!-- ----------------- -->
                    <div class="w-tabs-content bg" data-bind="css: { 'is-showing' : selectedTab() == 'sandboxAndRepublish'}">

                        <div class="w-form-body">
                            <div class="form-body" data-bind="visible: !isSandboxActive() && !isRepublishActive()" >
                                <div class="form-group w-justify" style="flex-wrap:wrap;">
                                    <div class="w-left">
                                    <!-- ko if: idTemplate() != ${ID_TEMPLATE_VIDEO} && idTemplate() != ${ID_TEMPLATE_THREAD}  -->
                                        <button class="btn-form icon light no-wrap icon i-sandbox" style="margin-left: 1rem" type="button" data-bind="event: { click: onClickOpenSandboxOrRepublish.bind($data, 'sandbox') }"><span class="btn-text">Open General Sandbox</span></button>
                                        <button class="btn-form icon light no-wrap icon i-redo" style="margin-left: 1rem" type="button" data-bind="event: { click: onClickOpenSandboxOrRepublish.bind($data, 'republish') }"><span class="btn-text">Begin a Rewrite for Republish</span></button>
                                    <!-- /ko -->

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="w-form-body">
                        <div class="form-body republish"  data-bind="visible: showScheduledRepublish() || republishesCount() > 0">
                            <strong class="form-sub-title highlight">Republish History <span data-bind="text:(republishesCount() > 0 ? '(' + republishesCount() + ')': '' )"></span></strong>

                                <div class="form-group">
                                    <button class="btn full-width dark icon i-x-before" type="button" data-bind="event: { click: onClickDeleteScheduledRepublish }, visible : idRepublish && showDeleteRepublishButton">Delete Scheduled Republish</button>
                                </div>

                                <div class="w-form-group republish-new is-showing" data-bind="visible: showScheduledRepublish()">

                                    <div class="form-group inside-label date date-fix">
                                        <label class="form-label">republish date</label>
                                        ${this.scheduledRepublishDatePicker.getHtmlBuild()}
                                    </div>
                                    <div class="form-group inside-label">
                                        <label for="authorName" class="form-label">Author</label>
                                        ${this.filterUser_scheduled_republish_author.getHtmlBuild()}
                                    </div>

                                    <div class="form-group inside-label">
                                        <label for="srEditorName" class="form-label">Segment Lead</label>
                                        ${this.filterUser_scheduled_republish_SrEditor.getHtmlBuild()}
                                    </div>

                                    <div class="form-group inside-label">
                                        <label for="jrEditorName" class="form-label">Editor</label>
                                        ${this.filterUser_scheduled_republish_JrEditor.getHtmlBuild()}
                                    </div>

                                    <div class="form-group w-form-sub-title">
                                        <strong class="form-sub-title">Payment</strong>
                                    </div>

                                    <div class="form-group">
                                        <label class="form-label form-label-box">Payment Category</label>
                                        ${this.scheduledRepublishPaymentCategoryFilter.getHtmlBuild()}
                                    </div>

                                    <div class="form-group">
                                        <hr>
                                    </div>

                                    <!--Payment type dropdown-->
                                    <div class="form-group-group select">
                                        <div class="form-group">
                                            <label class="form-label form-label-box">Author Payment</label>
                                            <select
                                            data-bind="options: paymentTypeRepublish,
                                                    optionsCaption: 'Choose a payment type',
                                                    optionsValue: 'name',
                                                    optionsText: 'name' ,
                                                    value: choosenScheduledPaymentTypeRepublish,
                                                    event : {change : onChangepaymentTypeRepublish } "
                                                    >
                                            </select>
                                        </div>
                                        <!-- Show Input -->
                                        <div class="form-group row" data-bind="visible: choosenScheduledPaymentTypeRepublish">
                                            <!-- ko if: choosenScheduledPaymentTypeRepublish() == 'Amount' -->

                                            <input  id="amountAuthor"
                                                style="text-transform: capitalize;"
                                                data-bind="disable: !permissions()['article_edit_publishingControl'].write, value: scheduledAmountAuthor, attr: { 'placeholder':  choosenScheduledPaymentTypeRepublish().toLowerCase() }"
                                                class="input-text"
                                                type="number"
                                                min="0"
                                            >
                                            <span class="form-indic">$</span>

                                            <!-- /ko -->

                                            <!-- ko if: choosenScheduledPaymentTypeRepublish() == 'Percentage' -->

                                            <input  id="percentageAuthor"
                                                style="text-transform: capitalize;"
                                                data-bind=" disable: !permissions()['article_edit_publishingControl'].write,
                                                            value: scheduledPercentageAuthor,
                                                            attr: { 'placeholder':  choosenScheduledPaymentTypeRepublish().toLowerCase() }"
                                                class="input-text"
                                                type="number"
                                                min="0"
                                                max="999"
                                                step="any"
                                            >
                                            <span class="form-indic">%</span>
                                            <!-- /ko -->
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <hr>
                                    </div>

                                    <!-- Edirepublish-newtor percentage (Always %) -->
                                    <div class="form-group inside-label row start">
                                        <label class="form-label" style="width: 9rem;">Editor Payment</label>
                                        <input
                                            data-bind=" disable: !permissions()['article_edit_publishingControl'].write,
                                                        value: scheduledPercentageEditor,
                                                        attr: { 'placeholder': 'Percentage' }"
                                            class="input-text num"
                                            type="number"
                                            min="0"
                                            max="999"
                                            step="any"
                                        >
                                        <span class="form-indic">%</span>
                                    </div>

                                </div>
                                <div class="republish-history" data-bind="foreach: republishes">
                                    <div class="republish-history-list">
                                        <div class="form-group form-group-header">
                                            <div>
                                                <label class="form-label">Republish date</label>
                                                <span data-bind="text: dateRepublished"></span>
                                            </div>
                                            <div style="margin-top: 1rem">
                                                <!-- ko if: $index() == 0 && $data.dateRepublished.substr(0, 10) == new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10) && $data.publishStatus.id == 3  -->

                                                <input type="checkbox" id="latest_republish"
                                                        data-bind="checked : $parent.updateLatestRepublishDateIsChecked,
                                                        value : $parent.updateLatestRepublishDateIsChecked ,
                                                        event : {change : $parent.onChangeUpdateLatestRepublishDate },
                                                        disable: !$parent.permissions()['article_edit_publishingControl'].write
                                                        "
                                                >
                                                <label class="icon i-check" style="line-height: 1rem;" for="latest_republish">Update Time</label>
                                                <!-- /ko -->
                                            </div>

                                        </div>
                                        <div class="form-group-group border">

                                        <div class="form-group">
                                            <label class="form-label">Author</label>
                                            <span data-bind="if: author"><span data-bind="text: author.valnet_user.fullName"></span></span>
                                        </div>

                                        <div class="form-group">
                                            <label class="form-label">Sr Editor</label>
                                            <span data-bind="if: editor"><span data-bind="text: editor.valnet_user.fullName"></span></span>
                                        </div>

                                        <div class="form-group">
                                            <label class="form-label">Jr Editor</label>
                                            <span data-bind="if: juniorEditor"><span data-bind="text: juniorEditor.valnet_user.fullName"></span></span>
                                        </div>

                                        <div class="form-group">
                                            <label class="form-label">Payment Category</label>
                                            <span data-bind="if: postPaymentCategory"><span data-bind="text: postPaymentCategory.name"></span></span>
                                        </div>
                                    </div>

                                </div>
                                </div>
                            </div>

                            </div>

                        </div> <!-- Republish History ends here ( i counted the divs ) -->
                    </div><!-- end w-tabs-content -->
                     <!-- ----------------- -->
                     <!-- SIDE FORM         -->
                     <!-- ----------------- -->

                     <div class="w-form w-form-side ">
                            <div class="form-side-header-assistant">
                                <button id="btn-sidebar-hide" class="btn-sidebar hide icon i-dropdown-simple-b" type="button" data-bind="click: onClickToggleAssistant"></button>
                                <div>
                                    <strong class="side-title icon i-ai-1">Assistant</strong>
                                    <!-- ko if: aiSettings().assistantFeatureFeedbackEnable -->
                                    <button class="btn-floatng" type="button" data-bind="click: onClickToggleAssistantFeedback" >Got Feedback?</button>
                                    <!-- /ko -->
                                </div>
                                <button id="btn-sidebar-expend" class="btn-sidebar expend icon i-expend" type="button" data-bind="click: onClickToggleAssistantExpand" ></button>
                                <!-- <button class="icon i-settings" type="button"></button> -->
                            </div>
                            <div class="form-body full-width cover w-title-analysis is-visible" id="title-analysis-window">



                            <div class="form-group w-chat-suggestions" data-bind="visible: haveAiChatHistory() && activeChatTab() === 'preset', html: titleAnalysis" id="title-analysis-content" style="height: calc(100% - 11.5rem);">

                            </div>
                            <div class="form-group chat-suggestions-buttons chat-suggestions-buttons-full " id="empty-title-analysis-content"  data-bind="visible: !haveAiChatHistory() && activeChatTab() === 'preset'" style="height: calc(100% - 10.5rem);">
                                    <h2 data-bind="visible: idTemplate()!= ${ID_TEMPLATE_THREAD}"> Select an option to get started </h2>
                                    <button class="btn-form light icon i-title"  data-bind=" click: function(){ onClickAnalyzeTitle('both') }, visible: idTemplate() != ${ID_TEMPLATE_THREAD}  && aiSettings().titleDiscoverandOptimizePromptAvailable, disable: isAiAnalyzing()" type="button"><span>Generate Title Suggestions</span></button>
                                    <!-- New model title suggestions disabled for launch until model switching is fully enabled.
                                    <button class="btn-form light icon i-title"  data-bind=" click: function(){ onClickAnalyzeTitle('ctrNewModel') }, visible: idTemplate() != ${ID_TEMPLATE_THREAD}  && aiSettings().titleDiscoverandOptimizePromptAvailable, disable: isAiAnalyzing()" type="button"><span>Generate Title Suggestions (New Model)</span></button>
                                    -->
                                    <button class="btn-form light icon i-excerpt"  data-bind=" click: function(){ onClickAnalyzeExcerpt() }, visible: idTemplate() != ${ID_TEMPLATE_THREAD} && aiSettings().excerptSuggestionPromptAvailable , disable: isAiAnalyzing()" type="button"><span>Suggest an Excerpt</span></button>
                                    <button class="btn-form light icon i-category"  data-bind=" click: function(){ onClickAutoCategorize() }, visible: idTemplate() != ${ID_TEMPLATE_THREAD}, disable: isAiAnalyzing()" type="button"><span>Propose Relevant Categories</span></button>
                                    <button class="btn-form light icon i-tag"  data-bind=" click: function(){ onClickAutoTag() }, visible: idTemplate() != ${ID_TEMPLATE_THREAD}, disable: isAiAnalyzing()" type="button"><span>Recommend Suitable Tags</span></button>
                                    <button class="btn-form light icon i-image" title="Provide Performant Articles & Images (disabled for now)" data-bind="visible: idTemplate() != ${ID_TEMPLATE_THREAD}, disable: true" type="button"><span>Provide Performant Articles & Images (disabled for now)</span></button>
                                    <button class="btn-form light icon i-thread"  data-bind=" click: function(){ onClickAnalyzeThread() }, visible: idTemplate() != ${ID_TEMPLATE_THREAD} && aiSettings().threadSuggestionPromptAvailable , disable: isAiAnalyzing()" type="button"><span>Produce Thread Discussion Starters</span></button>
                                    <button class="btn-form light icon i-seo"  data-bind=" click: function(){ onClickAnalyzeSeo() }, visible: idTemplate() != ${ID_TEMPLATE_THREAD} && aiSettings().seoSuggestionPromptAvailable , disable: isAiAnalyzing()" type="button"><span>Draft SEO Title & Description</span></button>
                                    <button class="btn-form light icon i-social-media"  data-bind=" click: function(){ onClickAnalyzeSocialMedia() }, visible: idTemplate() != ${ID_TEMPLATE_THREAD} && aiSettings().socialmediaSuggestionPromptAvailable , disable: isAiAnalyzing()" type="button"><span>Create Social Media Copy</span></button>
                                    <button class="btn-form light icon i-poll"  data-bind=" click: function(){ onClickAnalyzeWidgets() }, visible: idTemplate() != ${ID_TEMPLATE_THREAD} && showQuiz() && aiSettings().widgetsSuggestionPromptAvailable, disable: isAiAnalyzing()" type="button" title="Assess Opportunity for Widgets"><span>Assess Opportunity for Widgets</span></button>

                                        <h2 data-bind="visible: idTemplate() == ${ID_TEMPLATE_THREAD}"> This feature is not available for this article type </h2>
                            </div>

                            <div class="form-group w-chat-suggestions" data-bind="visible: activeChatTab() === 'custom', html: titleAnalysis" id="custom-prompts-content" style="height: calc(100% - 11.5rem);">

                            </div>

                                <div class="chat-suggestions" id="chat-suggestions" style="max-height: 0px;">
                                    <button class="btn-drawer light icon i-dropdown-simple"
                                        data-bind="click: function() { toggleChatSuggestions() }, disable: isAiAnalyzing()"
                                        type="button">
                                    </button>

                                    <div class="chat-suggestions-buttons chat-suggestions-buttons-short" id="chat-suggestions-buttons">

                                        <div class="w-chat-suggestions-tabs border-bottom">
                                            <div class="w-tabs">
                                                <button class="tab-btn" data-bind="click: () => activeChatTab('preset'), css: { active: activeChatTab() === 'preset' }">Preset Prompts</button>
                                                <button class="tab-btn" data-bind="click: () => activeChatTab('custom'), css: { active: activeChatTab() === 'custom' }">Custom Prompt</button>
                                            </div>
                                        </div>

                                        <!-- TAB: Custom Prompt -->
                                        <div data-bind="if: activeChatTab() === 'custom'" style="width: 100%;position: relative">
                                            <textarea  rows="5" style="resize: none; height: 13.1rem;padding-right: 5rem;margin: 10px 0 14px" class="input-text"
                                                    data-bind="value: customPrompt, event: { keyup: onTextareaKeyup }"
                                                    id="customPrompt"></textarea>
                                            <button class="btn-form light no-border icon i-submitted btn-submit"
                                                data-bind="click: function(){ onClickAnalyzeCustomPrompt() },
                                                        visible: idTemplate() != ${ID_TEMPLATE_THREAD},
                                                        disable: isAiAnalyzing() || customPrompt().length == 0"
                                                type="button">
                                            </button>
                                        </div>

                                        <!-- TAB: AI Suggestions -->
                                        <div class="w-btn-assistant" data-bind="if: activeChatTab() === 'preset'">

                                            <div class="w-label">
                                                <label class="form-label">Article-Level Suggestions</label>
                                            </div>
                                            <div Style="display: flex;flex-wrap: wrap; justify-content: space-between;gap: 5px;margin: 10px 0 14px">
                                                <button title="Generate Title Suggestions" class="btn-form light icon i-title"
                                                    data-bind="click: function(){ onClickAnalyzeTitle('both') },
                                                            visible: idTemplate() != ${ID_TEMPLATE_THREAD}  && aiSettings().titleDiscoverandOptimizePromptAvailable,
                                                            title: 'Generate Title Suggestions',
                                                            disable: isAiAnalyzing()"
                                                    type="button"> Title
                                                </button>
                                                <!-- New model title suggestions disabled for launch until model switching is fully enabled.
                                                <button title="Generate Title Suggestions (New Model)" class="btn-form light icon i-title"
                                                    data-bind="click: function(){ onClickAnalyzeTitle('ctrNewModel') },
                                                            visible: idTemplate() != ${ID_TEMPLATE_THREAD}  && aiSettings().titleDiscoverandOptimizePromptAvailable,
                                                            title: 'Generate Title Suggestions (New Model)',
                                                            disable: isAiAnalyzing()"
                                                    type="button"> Title (New)
                                                </button>
                                                -->
                                                <button title="Suggest an Excerpt" class="btn-form light icon i-excerpt"
                                                    data-bind="click: function(){ onClickAnalyzeExcerpt() },
                                                            visible: idTemplate() != ${ID_TEMPLATE_THREAD} && aiSettings().excerptSuggestionPromptAvailable,
                                                            title: 'Suggest an Excerpt',
                                                            disable: isAiAnalyzing()"
                                                    type="button"> Excerpt
                                                </button>
                                                <button     title="Propose Relevant Categories" class="btn-form light icon i-category"
                                                    data-bind="click: function(){ onClickAutoCategorize() },
                                                            visible: idTemplate() != ${ID_TEMPLATE_THREAD} ,
                                                            disable: isAiAnalyzing()"
                                                    type="button"> Categories
                                                </button>
                                                <button     title="Recommend Suitable Tags" class="btn-form light icon i-tag"
                                                    data-bind="click: function(){ onClickAutoTag() },
                                                            visible: idTemplate() != ${ID_TEMPLATE_THREAD},
                                                            disable: isAiAnalyzing()"
                                                    type="button"> Tags
                                                </button>

                                                <button     title="Provide Performant Articles & Images (disabled for now)" class="btn-form light icon i-image"
                                                    data-bind="visible: idTemplate() != ${ID_TEMPLATE_THREAD},
                                                            title: 'Provide Performant Articles & Images (disabled for now)',
                                                            disable: true"
                                                    type="button"> Images (Disabled)
                                                </button>
                                                <button     title="Produce Thread Discussion Starters" class="btn-form light icon i-thread"
                                                    data-bind="click: function(){ onClickAnalyzeThread() },
                                                            visible: idTemplate() != ${ID_TEMPLATE_THREAD} && aiSettings().threadSuggestionPromptAvailable  ,
                                                            title: 'Produce Thread Discussion Starters',
                                                            disable: isAiAnalyzing()"
                                                    type="button"> Thread
                                                </button>
                                                <button     title="Draft SEO Title & Description" class="btn-form light icon i-seo"
                                                    data-bind="click: function(){ onClickAnalyzeSeo() },
                                                            visible: idTemplate() != ${ID_TEMPLATE_THREAD} && aiSettings().seoSuggestionPromptAvailable,
                                                            title: 'Draft SEO Title & Description',
                                                            disable: isAiAnalyzing()"
                                                    type="button"> SEO
                                                </button>
                                                <button     title="Create Social Media Copy" class="btn-form light icon i-social-media"
                                                    data-bind="click: function(){ onClickAnalyzeSocialMedia() },
                                                            visible: idTemplate() != ${ID_TEMPLATE_THREAD} && aiSettings().socialmediaSuggestionPromptAvailable,
                                                            title: 'Create Social Media Copy',
                                                            disable: isAiAnalyzing()"
                                                    type="button"> SMO
                                                </button>
                                            </div>




                                            <div class="w-label" data-bind="visible: idTemplate() != ${ID_TEMPLATE_THREAD} && aiSettings().proofReadPromptAvailable || idTemplate() != ${ID_TEMPLATE_THREAD} && aiSettings().factCheckPromptAvailable">
                                                <label class="form-label">Content-Level Suggestions</label>
                                            </div>
                                            <div Style="display: flex;flex-wrap: wrap; justify-content: space-between;gap: 5px;margin: 10px 0 14px">

                                            <button title="Fact Check Text" class="btn-form light icon i-fact-check  i-prime-a"
                                                data-bind="click: function(){ onClickAnalyzeFactCheck() },
                                                            visible: idTemplate() != ${ID_TEMPLATE_THREAD}  && aiSettings().factCheckPromptAvailable,
                                                            disable: isAiAnalyzing()"
                                                type="button">Fact Check
                                            </button>

                                            <button title="Identify Interlinking Opportunities" class="btn-form light icon i-link "
                                                data-bind="click: function(){ onClickAnalyzeInterlinking() },
                                                            visible: idTemplate() != ${ID_TEMPLATE_THREAD}
                                                            disable: isAiAnalyzing()"
                                                type="button">Interlink
                                            </button>

                                            <!-- New model interlinking disabled for launch until model switching is fully enabled.
                                            <button title="Identify Interlinking Opportunities (New Model)" class="btn-form light icon i-link "
                                                data-bind="click: function(){ onClickAnalyzeInterlinkingNewModel() },
                                                            visible: idTemplate() != ${ID_TEMPLATE_THREAD}
                                                            disable: isAiAnalyzing()"
                                                type="button">Interlink (New)
                                            </button>
                                            -->

                                            <button  title="Proofread Text" class="btn-form light icon i-read"
                                                data-bind="click: function(){ onClickAnalyzeProofread() },
                                                            visible: idTemplate() != ${ID_TEMPLATE_THREAD}  && aiSettings().proofReadPromptAvailable,
                                                            disable: isAiAnalyzing()"
                                                type="button">Proofread
                                            </button>

                                             <button title="Assess Opportunity for Widgets" class="btn-form light icon i-poll" id="widgets-analysis-button"
                                                data-bind="click: function(){ onClickAnalyzeWidgets() },
                                                        visible: idTemplate() != ${ID_TEMPLATE_THREAD} && showQuiz() && aiSettings().widgetsSuggestionPromptAvailable,
                                                        title: 'Assess Opportunity for Widgets',
                                                        disable: isAiAnalyzing()"
                                                type="button"> Widgets
                                            </button>

                                            </div>
                                        </div>

                                        <div class="w-chat-suggestions-tabs border-top">
                                            <div class="w-context">
                                                <div class="w-label">
                                                    <label class="form-label">Include Content</label>
                                                    <label class="form-label">Style Guidance</label>
                                                </div>
                                                <div class="context-selection">
                                                    <div>
                                                        <div class="">
                                                            <input type="checkbox" data-bind="checked: aiPromptArticleIncluded, css: { active: aiPromptArticleIncluded }, disable: idStatus() == 6 && !permissions()['article_edit_publishingControl'].write"  id="aiPromptArticleIncluded">
                                                            <label class="form-label-btn icon i-article" for="aiPromptArticleIncluded" title="Pass Full Article Content">Full Content</label>
                                                        </div>
                                                        <div class="">
                                                            <input type="checkbox" data-bind="checked: aiPromptSelectedTextIncluded, disable: !aiPromptSelectedTextIncludedEnabled() || (idStatus() == 6 && !permissions()['article_edit_publishingControl'].write), css: { active: aiPromptSelectedTextIncluded() }"  id="aiPromptSelectedTextIncluded">
                                                            <label class="form-label-btn icon i-regular-template" for="aiPromptSelectedTextIncluded" title="Pass Selected Text if Applicable">Selected Text</label>
                                                        </div>
                                                    </div>

                                                    <div>
                                                        <div class="" style="margin-left: 5px;">
                                                            <input type="checkbox" data-bind="checked: aiPromptBrandContextIncluded, disable: !aiPromptBrandContextIncludedEnabled() || (idStatus() == 6 && !permissions()['article_edit_publishingControl'].write), css: { active: aiPromptBrandContextIncluded() }"  id="aiPromptBrandContextIncluded">
                                                            <label class="form-label-btn icon i-brand-2" for="aiPromptBrandContextIncluded" title="Use Brand Context">Brand Context</label>
                                                        </div>


                                                        <div class="">
                                                            <input type="checkbox" data-bind="checked: aiPromptAuthorToneIncluded, disable: !aiPromptAuthorToneIncludedEnabled() || (idStatus() == 6 && !permissions()['article_edit_publishingControl'].write), css: { active: aiPromptAuthorToneIncluded() }" id="aiPromptAuthorToneIncluded">
                                                            <label class="form-label-btn icon i-user" for="aiPromptAuthorToneIncluded" title="Use Author Tone">Author tone</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>


                    </div>

                <div class="w-lightbox light-theme w-compare right-space" id="compare-popup">
                    <div class="w-form">
                        <div class="form-header">
                            <strong class="form-title icon i-compare">Compare</strong>
                            <button type="button" class="btn only-icon no-bg icon i-close-2" data-bind="event: { click: onClickCloseComparePopUp }"></button>
                        </div>
                        <div class="w-form-body revision" id="compare-revisions">

                            <div class="form-body side">
                                <div class="form-group ">
                                    <ul class="user-list" data-bind="foreach: revisions">
                                        <li class="user-item" data-bind="css: { 'is-selected' : $index() == $parent.selectedRevisionIndex() }">
                                            <div class="w-btn">
                                                 <input type="radio" data-bind="checked: checked, checkedValue:'old',disable: $data.isOldDisable, event:{ change: $parent.onClickCompareRevisionUpdate}, attr:{ name: 'revision_old',  id: 'revision_old' + $data.id}"/>
                                                 <label class="form-label" title="Old" for="active_no" data-bind="attr: { for: 'revision_old' + $data.id }"></label>
                                            </div>
                                            <div class="w-info">
                                                <strong data-bind="text: $data.dateCreated"></strong>
                                                <span data-bind="if: $data.content.author"><span data-bind="text: $data.content.author.valnet_user.fullName"></span></span>

                                            </div>
                                             <div class="w-btn">
                                                 <input type="radio"  data-bind="checked: checked, checkedValue:'new',  disable: $data.isNewDisable, event:{ change: $parent.onClickCompareRevisionUpdate}, attr:{ name: 'revision_new', id: 'revision_new' + $data.id}"/>
                                                 <label class="form-label" title="New" for="active_no" data-bind="attr: { for: 'revision_new' + $data.id }"></label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div class="compare-body">
                                <div class="w-form-body">
                                    <div class="form-body compare w-compare-body-header">
                                        <div class="form-group compare-body-header">
                                            <div class="user-link" data-bind="if : oldVersion()">
                                                <strong data-bind="text :  oldVersion().dateCreated"></strong>
                                                <div data-bind="if : oldVersion().user">
                                                    <span data-bind="text : oldVersion().user.valnet_user.fullName"></span>
                                                </div>
                                                <button type="button" class="btn-form" data-bind="visible: selectedTab() == 'revision', event: {click: onClickShowRevision.bind($data, oldVersion()) }">show this version</button>
                                            </div>
                                            <div class="user-link" data-bind="if : newVersion()">
                                                <strong data-bind="text : newVersion().dateCreated"></strong>
                                                <div data-bind="if : newVersion().user">
                                                    <span data-bind="text : newVersion().user.valnet_user.fullName"></span>
                                                </div>
                                                <button type="button" class="btn-form" data-bind="visible: selectedTab() == 'revision', event: {click: onClickShowRevision.bind($data, newVersion()) }"> show this version </button>
                                            </div>

                                        </div>
                                       <div class="w-legend">
                                            <div>
                                                <span class="legend legend-removal">Change Removal</span>
                                                <span class="legend legend-deleted">Deleted</span>
                                            </div>
                                            <div>
                                                <span class="legend legend-addition">Change Addition</span>
                                                <span class="legend legend-added">Added</span>
                                            </div>
                                       </div>
                                       <div class="form-group w-dh2">
                                            <div data-bind="html: versionDiffResult"></div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>

                </div>

                <div data-bind="css: { 'is-visible': isRepublishMessageVisible }" class="w-lightbox light-theme right-space">
                    <div class="lightbox-content">
                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">Content in Sandbox</h3>
                            </div>

                            <div class="form-body">
                                <div class="form-group">
                                    <p class="form-text">The content in the sandbox doesn't match what's in the article.</p>
                                </div>
                                <div class="form-group">
                                    <p class="form-text">Are you sure you want to schedule what's in the article for republish without the sandbox changes?</p>
                                </div>
                             </div>

                            <div class="form-footer">
                                <button type="button" data-bind="event: { click: onClickContinueEditing }" class="btn">Cancel and Go Back</button>
                                <button type="button" data-bind="event: { click: onClickSaveAnyway }" class="btn highlight">Ignore and Save</button>
                            </div>
                        </div>
                    </div>
                </div>

                ${this.sensaiPromptTemplate.getHtmlBuild()}


                <div data-bind="css: { 'is-visible': isLockMessageVisible }" class="w-lightbox light-theme right-space">
                    <div class="lightbox-content">
                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">Edit Lock</h3>
                            </div>

                            <div class="form-body">
                                <div class="form-group">
                                    <p class="form-text" data-bind="text: lockMessage"></p>
                                </div>
                                <div class="form-group">
                                    <p class="form-text">The editing user will lose their unsaved changes if you take over.</p>
                                </div>
                                <div class="form-group">
                                    <p class="form-text">Would you like to take over the article ?</p>
                                </div>
                             </div>

                            <div class="form-footer">
                                <button type="button" data-bind="event: { click: onCancelTakeOver }" class="btn">Cancel</button>
                                <button type="button" data-bind="event: { click: onTakeOver}" class="btn highlight">Take Over</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div data-bind="css: { 'is-visible': isKickoutMessageVisible }" class="w-lightbox light-theme right-space">
                    <div class="lightbox-content">
                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">Edit Lock</h3>
                            </div>

                            <div class="form-body">
                                <div class="form-group">
                                    <p class="form-text" data-bind="text: kickoutMessage"></p>
                                </div>
                             </div>

                            <div class="form-footer">
                                <button type="button" data-bind="event: { click: onKickout}" class="btn highlight">OK</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="w-form w-form-sub form-buyers-guide" data-bind="css: { 'is-showing' : isReviewProductFormShown }" xmlns="http://www.w3.org/1999/html">
                   <div class="form-header">
                      <h3 class="form-title">Product Review</h3>
                      <button class="close-button icon i-close-2" type="button" data-bind="event: { click: onClickCancelSaveReviewItem }, css: { 'is-disable' : isSaveButtonDisabled() }, disable: isSaveButtonDisabled()"></button>
                   </div>

                   <!-- Beginning of new PRODUCT form -->

                   <div class="w-form-body-scroll">
                       <div class="w-form-body border">

                           <div class="form-body">

                                <div class="form-group inside-label" style="margin-bottom: 5rem">
                                    ${this.filterProductTypes.getHtmlBuild()}
                                </div>
                                <div class="form-group inside-label row">
                                    ${this.filterProducts.getHtmlBuild()}
                                    <div class="w-tooltips-adv pos-bottom x-short">
                                        ${this.selectProductTooltip.getHtmlBuild()}
                                    </div>
                                </div>

                           </div>

                           <div class="form-body" data-bind="visible: idTemplate() != 8">
                                <div class="form-group seo-description">
                                    <div style="display: flex;align-items: center">
                                        <label style="margin-bottom: 0" class="form-label" >SEO Description</label>
                                        <button class="w-tooltips icon i-tooltips" type="button">
                                            <span class="tooltips" >
                                            This is the description provided in the product schema on the website,
                                            which is leveraged by search engines (like Google), to better understand
                                            the content and can be displayed to users in search results.  It should be a short,
                                            natural, and engaging blurb about the product, which users would find relevant.
                                            </span>
                                        </button>
                                    </div>

                                    <textarea rows="3" data-bind=" value: reviewItemSeoDescription" /></textarea>
                                 </div>
                            </div>
                       </div>
                       <div class="w-form-body no-padding" data-bind="visible: idTemplate() != 8">
                            <div class="form-body">
                                <div class="form-group row start no-padding">
                                    <strong class="form-btn-title">specifications</strong>
                                    <button class="btn-form only-icon icon i-plus" type="button" data-bind="event: {click: onClickAddSpecification}"><span class="hide">add</span></button>
                                </div>
                            </div>
                       </div>
                       <div class="w-form-body list" data-bind="visible: idTemplate() != 8">
                            <div class="form-body" id="spec_section_list">
                                <!-- ko foreach: reviewItemTagSpecifications -->
                                      <div class="form-group row">
                                          <span class="form-span" data-bind="text: label"></span>
                                          <input class="input-text" data-bind="value: data, disable: dataType != 'text' " type="text">
                                          <!-- ko if: $data.canDelete -->
                                              <button type="button" class="btn icon only-icon i-close" data-bind="event: {click: $parent.onClickDeleteSpecification.bind($data, $index) }"></button>
                                         <!-- /ko -->
                                      </div>
                                <!-- /ko -->
                                <!-- ko foreach: addedReviewItemTagSpecifications -->
                                <div class="form-group row">
                                    <input class="input-text" data-bind="value: label" type="text">
                                    <input class="input-text" data-bind="value: data, disable: dataType != 'text'" type="text">
                                    <button type="button"  class="btn-form only-icon icon i-close" data-bind="event: {click: $parent.onClickDeleteAddedSpecification.bind($data,$index) }"></button>
                                </div>
                                <!-- /ko -->
                            </div>
                       </div>
                       <strong class="form-sub-title">Media</strong>
                       <div class="w-form-body">
                            <div class="form-body">
                                <div class="form-group row start">
                                    <strong class="form-btn-title">Images</strong>
                                    <button class="btn-form icon i-image" data-bind="event: { click: onClickSelectProductImages }">Select Image</button>
                                </div>
                                 <div class="form-group">
                                     <div class="w-img-article-list form" id="productImages">
                                           <ul id="img_list_product_review" class="img-article-list" data-bind="foreach: reviewItemImages">
                                                <li class="img-article-item" draggable="true" data-bind="attr: {id: id }">
                                                    <button class="btn-icon icon i-drag" ><span>drag</span></button>
                                                     <div class="w-btn">
                                                        <button class="btn-form icon i-delete" type="button" data-bind="event: { click: $parent.onClickDeleteProductImage.bind($data, $index) }"><span>delete</span></button>
                                                     </div>
                                                     <div class="ratio-content">
                                                        <img data-bind="attr: {src: url}">
                                                     </div>
                                                </li>
                                           </ul>
                                     </div>
                                </div>
                            </div>
                            <div class="form-body " data-bind="visible: idTemplate() != 8">
                                <div class="form-group row start no-padding">
                                    <strong class="form-btn-title">Videos</strong>
                                    <button class="btn-form only-icon icon i-plus" type="button" data-bind="event: { click: onClickAddReviewItemVideo }"><span class="hide">add</span></button>
                                </div>
                                <!-- ko foreach: reviewItemExtraVideos -->
                                     <div class="form-group row no-padding  inside-label">
                                         <label for="" class="form-label">URL</label>
                                         <input class="input-text" data-bind="value: data" type="text">
                                         <button class="btn-form only-icon icon i-close" type="button" data-bind="event: {click: $parent.onClickDeleteReviewItemVideo.bind($data, $index) }"></button>
                                     </div>
                                <!-- /ko -->
                            </div>

                       </div>


                       <strong class="form-sub-title" data-bind="visible: idTemplate() != 8">Reviews</strong>
                        <div class="w-form-body border" data-bind="visible: idTemplate() != 8">
                            <div class="form-body">
                                <div class="form-group row" id="featuredFive_section" data-bind="visible: idTemplate() == 6">
                                    <label for="template" class="form-label">FEATURED 5 SECTION</label>
                                    <select id="idTagAwards" data-bind="options: reviewItemAward_options, optionsCaption: 'Choose an option', optionsText: 'name', value: reviewItemIdAwardType, optionsValue: 'id' "></select>
                                </div>
                            </div>
                            <div class="form-body">
                                <div class="form-group row">
                                       <label class="form-label" for="">PRODUCT RATING (OUT OF 10)</label>
                                       <input class="input-text num"  type="text" data-bind="value: reviewItemRating">
                                </div>
                            </div>
                        </div>

                        <div class="w-form-body no-padding " data-bind="visible: idTemplate() != 8">
                            <div class="form-body">
                                <div class="form-group row start no-padding">
                                    <strong class="form-btn-title">KEY FEATURES</strong>
                                    <button class="btn-form only-icon icon i-plus" type="button" data-bind="event: { click: onClickAddKeyFeature } "><span class="hide">add</span></button>
                                </div>
                            </div>
                       </div>

                        <div class="w-form-body list border" data-bind="visible: idTemplate() != 8">
                            <div class="form-body">
                                <!-- ko foreach: reviewItemKeyFeatures -->
                                <div class="form-group row icon square-list">
                                    <input class="input-text" data-bind="value: data" type="text">
                                    <button class="btn-form only-icon icon i-close" data-bind="event: { click: $parent.onClickDeleteKeyFeature}" type="button"></button>
                                </div>
                                <!-- /ko -->
                            </div>
                       </div>

                       <div class="w-form-body no-padding" data-bind="visible: idTemplate() != 8">
                            <div class="form-body">
                                <div class="form-group row start no-padding">
                                    <strong class="form-btn-title">Pros</strong>
                                    <button class="btn-form only-icon icon i-plus pros" type="button" data-bind="event: { click: onClickAddPro } " ><span class="hide">add</span></button>
                                </div>
                            </div>
                             <div class="form-body" data-bind="visible: idTemplate() != 8">
                                <div class="form-group row start no-padding">
                                    <strong class="form-btn-title">Cons</strong>
                                    <button class="btn-form only-icon icon i-plus cons" type="button" data-bind="event: { click: onClickAddCon } "><span class="hide">add</span></button>
                                </div>
                            </div>
                       </div>
                       <div class="w-form-body" data-bind="visible: idTemplate() != 8">
                                <div class="form-body list" id="pros_section_list">
                                     <!-- ko foreach: reviewItemPros -->
                                              <div class="form-group row pros icon i-thumb-up">
                                                  <input class="input-text" data-bind="value: data" type="text">
                                                  <button class="btn-form only-icon icon i-close" type="button" data-bind="event: { click: $parent.onClickDeletePro.bind($data, $index)}"></button>
                                              </div>
                                     <!-- /ko -->
                                </div>
                                <div class="form-body list" id="cons_section_list">
                                     <!-- ko foreach: reviewItemCons -->
                                         <div class="form-group row icon cons i-thumb-down">
                                             <input class="input-text" data-bind="value: data" type="text">
                                             <button class="btn-form only-icon icon i-close" type="button" data-bind="event: { click: $parent.onClickDeleteCon.bind($data, $index)}"></button>
                                         </div>
                                     <!-- /ko -->
                                </div>
                       </div>

                       <strong class="form-sub-title">Affiliates</strong>

                       <div class="w-form-body no-padding">
                            <div class="form-body">
                                <div class="form-group inside-label top-align row">

                                    <!-- <strong class="form-btn-title">Affiliate</strong> -->
                                    ${this.filterAffiliates.getHtmlBuild()}
                                    <button class="btn-form only-icon icon i-plus" type="button" data-bind="event: {click: onClickAddAffiliateLink}"><span class="hide">add</span></button>
                                </div>
                            </div>
                       </div>

                       <div class="w-form-body list">
                            <div class="form-body"  ><!-- id="affiliate_links_section" -->


                                <!-- ko foreach: reviewItemAffiliateLinks -->
                                <div class="form-group row icon">

                                     <!-- <div class="inside-label">
                                          <label for="" class="form-label">type</label>
                                          <input class="input-text" data-bind="value: type" type="text">
                                    </div> -->
                                    <span class="form-span" data-bind="text: type"></span>

                                    <div class="inside-label">
                                        <label for="" class="form-label">url</label>
                                        <input class="input-text" style="border-radius:0;" data-bind="value: value" type="text">
                                    </div>
                                    <button class="btn-form only-icon icon i-close" type="button"  data-bind="event: { click: $parent.onClickDeleteAffiliateLinks.bind($data, $index) }"></button>
                                </div>
                                <!-- /ko -->
                            </div>
                       </div>
                       <div data-bind="visible: idTemplate() != 8">
                            <strong class="form-sub-title icon i-dropdown-simple" data-bind="click: collapseGiveawaySection, css: { 'is-open' : isGiveawaySectionCollapsed }">Giveaway</strong>
                       </div>
                       <div class="w-form-body" data-bind="visible: isGiveawaySectionCollapsed">
                            <div class="form-body">
                                 <div id="giveaway_url_section" class="form-group inside-label">
                                    <label class="form-label">Gleam Giveaway URL</label>
                                    <input type="text" class="input-text" data-bind="value: reviewItemGiveawayUrl, valueUpdate: 'keyup'" />
                                 </div>
                            </div>
                             <div class="form-body">
                                <div class="form-group inside-label">
                                    <label for="giveawayDatePicker" style="z-index: 10;" class="form-label">Giveaway Expiry Date</label>
                                    <div>
                                        ${this.giveawayDatePicker.getHtmlBuild()}
                                    </div>
                                </div>
                             </div>
                       </div>

                       <strong class="form-sub-title" data-bind="visible: amazonOnsite() && amazonOnsite().value == 'true'">Amazon Onsite</strong>

                       <div class="w-form-body" data-bind="visible: amazonOnsite() && amazonOnsite().value == 'true'">
                            <div class="form-body">
                                <div class="form-group inside-label" id="amazon_award_section" data-bind="visible: idTemplate() == 6 ">
                                    <label class="form-label">Amazon Award</label>
                                    <input type="text" class="input-text" data-bind="value:reviewItemAmazonAward, disable: selectedTab() == 'article' && datePublished() != '' && idReviewItem()" />
                                </div>
                                <div class="form-group inside-label" id="amazon_headline_section" data-bind=" visible: idTemplate() == 6">
                                    <label class="form-label">Amazon Headline</label>
                                    <textarea  data-bind="value: reviewItemAmazonHeadline, disable: selectedTab() == 'article' && datePublished() != '' && idReviewItem()" maxlength="200" rows="3" /></textarea>
                                </div>
                            </div>
                            <div class="form-body">
                                 <div class="form-group row">
                                       <label class="form-label" for="">Amazon Rating (OUT OF 10)</label>
                                       <input class="input-text num"  type="text" data-bind="value: reviewItemAmazonRating, disable: selectedTab() == 'article' && datePublished() != '' && idReviewItem()">
                                </div>
                                <div id="amazon_summary_section" class="form-group inside-label" data-bind=" visible: idTemplate() == 6">
                                    <label class="form-label">Amazon Summary</label>
                                    <textarea data-bind="value: reviewItemAmazonSummary, disable: selectedTab() == 'article' && datePublished() != '' && idReviewItem()" maxlength="200" rows="3"></textarea>
                                 </div>
                            </div>

                       </div>

                       <strong class="form-sub-title">Product Text</strong>

                        <div class="form-group form-group-textarea">
                            <textarea id="product_review_text" data-bind=" value: reviewItemReviewText" ></textarea>
                        </div>

                       <div class="w-form-body">
                          <div class="form-body full-width">
                             <div class="form-footer">
                                <button id="cancel_review" class="btn" data-bind="event: {click: onClickCancelSaveReviewItem }, css: { 'is-disable' : isSaveButtonDisabled() }, text: isSaveButtonDisabled() ? 'Autosaving...' : 'Cancel'" type="button"></button>
                                <button id="save_review" class="btn highlight" type="button" data-bind="event: {click: onClickAddReviewItem }, css: { 'is-disable' : isSaveButtonDisabled() }, text: isSaveButtonDisabled() ? 'Autosaving...' : 'Apply'"></button>
                             </div>
                          </div>
                       </div>
                   </div>
                </div>

                <div class="form-group row start">
                    <!-- Permalink Pop-up Window  Start -->
                    <div data-bind="css: {'is-visible' : isPermalinkPopupShown()}" id="permalink-popup" class="w-lightbox light-theme right-space">
                        <div class="lightbox-content w-form" id="permalinkEditWarning">
                            <div class="form-header warning-header">
                                <span class="form-title">Permalink History</span>
                                <button class="close-button icon i-close-2" data-bind="click: onClickClosePermalinkHistoryModal"></button>
                            </div>
                            <div class="form-body">
                                <div class="form-group">
                                    <p>
                                        <strong>Warning:</strong> Changing URLs can negatively impact performance if not handled carefully.
                                        URLs should only be changed to correct errors, or after keyword research and analysis.
                                        If a live article needs to have its URL changed more than once, please alert a Lead Editor or Content Manager so they can have a second redirected created by IT.
                                    </p>
                                </div>
                                <div class="form-group">
                                    <p>Permalink Changes</p>
                                </div>
                                <div class="form-group">
                                    <table class="list-action">
                                        <thead>
                                            <tr>
                                                <th><span>Date Created</span></th>
                                                <th><span>Permalinks</span></th>
                                            </tr>
                                        </thead>
                                        <tbody data-bind="foreach: permalinkHistory()">
                                            <tr>
                                                <td><span data-bind="text: $data.dateCreated"></span></td>
                                                <td><span data-bind="text: $data.newPermalink"></span></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="form-group">
                                    <p>Redirects</p>
                                </div>
                                <div class="form-group">
                                    <table class="list-action">
                                        <thead>
                                            <tr>
                                                <th><span>From</span></th>
                                                <th><span>Redirected To</span></th>
                                            </tr>
                                        </thead>
                                        <tbody data-bind="foreach: permalinkRedirects()">
                                            <tr>
                                                <td><span data-bind="text: $data.oldPermalink"></span></td>
                                                <td><span data-bind="text: $data.newPermalink"></span></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    <!-- Permalink Pop-up Window  End -->
                    </div>
                </div>
                    <!-- title and permalink amd exerpt lightbox -->
                <div class="w-lightbox light-theme right-space" style="z-index: 9999998;" data-bind="css: { 'is-visible': articleDetailsModal }">
                    <div class="lightbox-content">
                        <!-- feature image -->
                        <!-- ko if: articleDetailsModalType() == 'articleTagSection' -->
                        <div class="w-form w-form-large lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">Tags</h3>
                                <button class="close-button icon i-close-2" type="button" data-bind="event: { click: onClickCloseTagItems }"></button>
                            </div>

                            <div class="form-body">

                                <div data-bind="visible: (idStatus() != 6 || (idStatus() == 6 && permissions()['article_edit_publishingControl'].write))" >
                                    <div class="form-group inside-label icon row" style="align-items: flex-start;margin-bottom:0;">
                                    <label class="form-label" style="width: auto;">Tags</label>
                                    ${this.filterTag.getHtmlBuild()}
                                    <!--<input type="text" class="input-text" />-->
                                    <button id="tag-analysis-button"  class="btn-form light icon i-ai-1 e-lab" title="Recommend Suitable Tags"  style="margin-left:1rem;" data-bind="disable: isAiAnalyzing(),event: { click: onClickAutoTag }" type="button"><span class="counter" ></span></button>
                                    </div>
                                    <div class="form-group" data-bind="foreach: selectedTags, childrenComplete : handleDragAndDrop($element, selectedTags ,'.tag-element', { dragHandleSelector: '.drag-handle' })">
                                        <div class="btn-selection tag-element" data-bind="css: { 'is-inserting' :  $data.isAIGenerated }">
                                            <div class="drag-handle i-move short"><button type="button" class="btn no-bg icon i-drag"></button></div>
                                            <input type="radio" name="tag" data-bind="disable: $parent.isPublishingControl() || $parent.isGlobalLockEnabled(), attr: { value: $data.tag.id, id: 'tag_' + $data.tag.id }, checked: $parent.idPrimaryTag, event: { change: function() { $parent.primaryTagName($data.tag); } }">
                                            <label class="form-label" for="active_no" data-bind="text: $data.tag.name + ' ' + $data.tag.formattedTagTypeAndDataset, attr: { for: 'tag_' + $data.tag.id }"></label>
                                            <button class="icon i-x-after" type="button" data-bind="visible: $parent.idStatus() != 6 || ($parent.idStatus() == 6 && $parent.permissions()['article_edit_publishingControl'].write), event: { click: $parent.onClickDeleteSelectedTag }"></button>
                                        </div>
                                    </div>
                                </div>

                                <!-- ko if: [5, 24].includes(idContentType())  -->
                                <div data-bind="visible: (idStatus() != 6 || (idStatus() == 6 && permissions()['article_edit_publishingControl'].write))" style="margin-bottom: 40px;">
                                    <div class="form-group inside-label icon row" style="align-items: flex-start;">
                                        <div class="full-width">
                                            ${this.filterReviewTag.getHtmlBuild()}
                                        </div>
                                    </div>
                                </div>
                                <!-- /ko -->
                            </div>
                            <div class="form-footer">
                                <button type="button" class="btn secondary" data-bind="event: { click: onClickCloseTagItems }">Cancel</button>
                                <button type="button" class="btn highlight" data-bind="event: { click: onClickSaveTagItems }">Confirm</button>
                            </div>
                        </div>
                        <!-- /ko -->
                        <!-- ko if: articleDetailsModalType() == 'articleCategorySection' -->
                        <div class="w-form w-form-large lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">Categories</h3>
                                <button class="close-button icon i-close-2" type="button" data-bind="event: { click: onClickCloseCategoryItems }" ></button>
                            </div>

                            <div class="form-body">

                                <div data-bind="visible: idStatus() != 6 || (idStatus() == 6 && permissions()['article_edit_publishingControl'].write)" style="border-radius: 4px;">

                                    <div class="form-group row" style="justify-content:start;">
                                        ${this.filterCategory.getHtmlBuild()}
                                        <button id="categorize-analysis-button" class="btn-form light icon i-ai-1 e-lab" title="Propose Relevant Categories" style="margin-left: 1rem;" data-bind=" disable: isAiAnalyzing(),event: { click: onClickAutoCategorize }" type="button"><span class="counter" ></span></button>
                                        <div style="display: none;" id="filters-selected" class="filters-selected"></div>
                                    </div>
                                    <div class="form-group w-radio" data-bind="foreach: selectedCategories, childrenComplete : handleDragAndDrop($element, selectedCategories ,'.category-element', { dragHandleSelector: '.drag-handle' })">
                                        <div class="btn-selection category-element" data-bind="css: { 'is-inserting' :  $data.isAIGenerated }">
                                            <div class="drag-handle i-move short"><button type="button" class="btn no-bg icon i-drag"></button></div>
                                            <input type="radio" name="category" data-bind="disable: $parent.isPublishingControl() || $parent.isGlobalLockEnabled(), attr: { value: $data.category.id, id: 'category_' + $data.category.id }, checked: $parent.idPrimaryCategory , event: { change: function() { $parent.primaryCategoryName($data.category); } }">
                                            <label class="form-label" for="active_no" data-bind="text: $data.category.name, attr: { for: 'category_' + $data.category.id }"></label>
                                            <button class="icon i-x-after" type="button" data-bind="disable: $parent.isPublishingControl() || $parent.isGlobalLockEnabled(), visible: $parent.idStatus() != 6 || ($parent.idStatus() == 6 && $parent.permissions()['article_edit_publishingControl'].write), event: { click: $parent.onClickDeleteSelectedCategory }"></button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="form-footer">
                                <button type="button" class="btn secondary" data-bind="event: { click: onClickCloseCategoryItems }" >Cancel</button>
                                <button type="button" class="btn highlight" data-bind="event: { click: onClickSaveCategoryItems }" >Confirm</button>
                            </div>
                        </div>
                        <!-- /ko -->
                    </div>
                </div>

                <div data-bind="css: { 'is-visible': isFaqDeleteVisible }" class="w-lightbox light-theme right-space">
                    <div class="lightbox-content">
                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">Confirm deletion of FAQ item</h3>
                            </div>

                            <div class="form-body">
                                <div class="form-group">
                                    <p class="form-text">Do you confirm the deletion of this item?</p>
                                </div>
                             </div>

                            <div class="form-footer">
                                <button type="button" data-bind="event: { click: onClickConfirmFaqDelete}" class="btn highlight">Confirm</button>
                                <button type="button" data-bind="event: { click: onClickCancelFaqDelete}" class="btn ">Cancel</button>
                            </div>
                        </div>

                    </div>
                </div>

                <div data-bind="css: { 'is-visible': isReviewItemUpdatesFormShown }"  class="w-lightbox light-theme product-sand  right-space">
                    <div class="lightbox-content">
                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">Your review items have changed</h3>
                                <button class="close-button icon i-close-2" type="button" data-bind="event: { click: onReviewItemUpdateCancel }"></button>
                            </div>
                            <div class="form-body-scroll">
                            <!-- ko foreach: fieldValueChanges -->
                                <div class="form-body w-justify ">
                                    <div class="form-img w-left">
                                        <div class="w-img">
                                            <img data-bind="attr: { src: imageUrl }" onerror="this.src='/assets/images/placeholder-product.png\';" alt="">
                                        </div>
                                    </div>
                                    <div class="w-right column">
                                        <strong class="form-sub-title" data-bind="text: tag, attr: {src: imageUrl}"></strong>
                                        <div style="width: 100%;margin-left:2rem;" data-bind="if: tagNameChange">

                                            <div class="w-form-group" >

                                                <div class="form-group row">
                                                    <strong class="form-legend" data-bind="text: tag"></strong>

                                                    <button class="w-tooltips icon i-tooltips" type="button">
                                                        <span class="tooltips no-wrap" data-bind="text: 'In the time this product has been in the '+$root['edit_template_new'].sourceOfReversal()+' of this article, the name of the product on the website has been updated. The website product name will be used for the product card of this article.'">
                                                        </span>
                                                    </button>
                                                </div>
                                                <div class="form-group">
                                                    <p class="form-text">The tag this product is based on has been renamed to be <span data-bind="text: tagNameChange.oldName"></span> on the <span>website</span>.</p>
                                                    <p class="form-text">The <span>website</span> naming will be used in the article.</p>
                                                </div>
                                                <div class="form-group">
                                                    <hr>
                                                </div>

                                            </div>
                                        </div>
                                        <div style="width: 100%;margin-left:2rem;" data-bind="if: updatedLabels.length != 0">
                                            <div class="w-form-group" >

                                                <div class="form-group">

                                                </div>
                                                <div class="form-group row">
                                                    <strong class="form-legend">Specification Field Name</strong>

                                                    <button class="w-tooltips icon i-tooltips" type="button">
                                                        <span class="tooltips no-wrap" data-bind="text: 'In the time this product has been in the '+$root['edit_template_new'].sourceOfReversal()+' of this article, the name of a specification field on the website has been updated. The website specification field name will be used for the product card of this article.'">
                                                        </span>
                                                    </button>
                                                </div>
                                                <div class="form-group">
                                                    <p class="form-text">For all products of type <span data-bind="text: tagTypeName"></span>, the following fields were changed on the <span>website</span>:</p>

                                                    <ul class="disc" data-bind="foreach: updatedLabels">
                                                         <li>
                                                             <p class="form-text"><span data-bind="text: (newLabel !='' && typeof(newLabel) != 'undefined') ? newLabel : '(empty)' ">[sandboxSpecName]</span> was renamed to be <span data-bind="text: (oldLabel !='' && typeof(oldLabel) != 'undefined') ? oldLabel : '(empty)' ">[websiteSpecName]</span> on the <span>website</span>.</p>
                                                         </li>
                                                    </ul>
                                                    <p class="form-text">The <span>website</span> naming will be used in the article.</p>
                                                </div>
                                                <div class="form-group">
                                                    <hr>
                                                </div>
                                            </div>
                                        </div>
                                        <div style="width: 100%;margin-left:2rem;" data-bind="if: updatedValues().length != 0">

                                            <div class="w-form-group" >
                                                <div class="form-group">

                                                </div>
                                                <div class="form-group row">
                                                    <strong class="form-legend">Specification Value</strong>
                                                    <button class="w-tooltips icon i-tooltips" type="button">
                                                        <span class="tooltips no-wrap" data-bind="text: 'Differences were found in the product specification values between the '+$root['edit_template_new'].sourceOfReversal()+' version and the current website version.'+ ($root['edit_template_new'].sourceOfReversal() !='revision' ? ' Please confirm which values should be used for the product.' : '')">
                                                        </span>
                                                    </button>
                                                </div>
                                                <div class="form-group" data-bind="if: $root['edit_template_new'].sourceOfReversal() != 'revision'" >
                                                    <p class="form-text">Confirm which values should be used for this product going forward.</p>
                                                </div>
                                                <div class="form-group" data-bind="if: $root['edit_template_new'].sourceOfReversal() == 'revision'" >
                                                    <p class="form-text">Because you are reverting a revision, all values will remain to what they already are on the <span>website</span>.</p>
                                                </div>
                                                <div class="form-group" data-bind="if: $root['edit_template_new'].sourceOfReversal() == 'revision'">
                                                    <table class="list-action ">
                                                        <thead>
                                                        <tr>
                                                            <th><span>Spec</span></th>
                                                            <th><span>Revision</span></th>
                                                            <th><span>Website</span></th>
                                                        </tr>
                                                        </thead>
                                                              <tbody data-bind="foreach: updatedValues()">
                                                                  <tr>
                                                                      <td><span class="label" data-bind="text: label"></span></td>
                                                                       <!-- <td><span data-bind="attr: {class: $root['edit_template_new'].sourceOfReversal() == 'revision' ? 'icon i-to-arrow-left' : 'icon i-to-arrow-right'}"></span></td> -->
                                                                      <td><span data-bind="text: (oldValue !='' && typeof(oldValue) != 'undefined') ? oldValue : '(empty)'"></span></td>
                                                                      <td><span data-bind="text: (newValue !='' && typeof(newValue) != 'undefined') ? newValue : '(empty)'"></span></td>
                                                                  </tr>
                                                              </tbody>
                                                        </div>
                                                    </table>
                                                </div>

                                                <div class="form-group" data-bind="if: $root['edit_template_new'].sourceOfReversal() != 'revision'">
                                                    <table class="list-action">
                                                        <thead>
                                                        <tr>
                                                            <th><span>Spec</span></th>
                                                            <th><span data-bind="text: $root['edit_template_new'].sourceOfReversal()"></span></th>
                                                            <th><span>Website</span></th>
                                                        </tr>
                                                            <tbody data-bind="foreach: updatedValues()">
                                                                <tr>
                                                                    <td><span class="label" data-bind="text: label"></span></td>
                                                                    <td data-bind="click: $root['edit_template_new'].valueSwitch.bind($data, 'newValue')">
                                                                        <div class="form-check-inline">
                                                                            <input type="radio" data-bind="attr: {value: newValue}, checked: chosenValue()" >
                                                                            <label class="form-label"  data-bind="text: (newValue !='' && typeof(newValue) != 'undefined') ? newValue : '(empty)'"></label>
                                                                        </div>
                                                                    </td>
                                                                    <td data-bind="click: $root['edit_template_new'].valueSwitch.bind($data, 'oldValue')">
                                                                          <div class="form-check-inline">
                                                                              <input type="radio"  data-bind="attr: {value: oldValue}, checked: chosenValue()">
                                                                              <label class="form-label" data-bind="text: (oldValue !='' && typeof(oldValue) != 'undefined') ? oldValue : '(empty)'"></label>
                                                                          </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                    </table>
                                                </div>

                                                <div class="form-group" data-bind="if: $root['edit_template_new'].sourceOfReversal() != 'revision'">

                                                    <ul class="disc" data-bind="foreach: updatedValues()">
                                                        <div data-bind="if: chosenValue() == newValue">
                                                             <li>
                                                                 <p class="form-text">The value for <span data-bind="text: label"></span>  will be updated to match the <span data-bind="text: $root['edit_template_new'].sourceOfReversal()"></span>, <span data-bind="text: (chosenValue() !='' && typeof(chosenValue()) != 'undefined') ? chosenValue() : '(empty)' "></span>.</p>
                                                             </li>
                                                        </div>
                                                        <div data-bind="if: chosenValue() == oldValue">
                                                              <li>
                                                                  <p class="form-text">The value for <span data-bind="text: label"></span> will remain as what is already used on the <span>website</span>, <span data-bind="text: (chosenValue() !='' && typeof(chosenValue()) != 'undefined') ? chosenValue() : '(empty)' "></span>.</p>
                                                              </li>
                                                        </div>
                                                    </ul>
                                                    <p class="form-text">The <span>website</span> naming will be used in the article.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            <!-- /ko -->
                            </div>

                            <div class="form-footer">
                                <button type="button" data-bind="event: { click: onReviewItemUpdateCancel }" class="btn ">Cancel</button>
                                <button type="button" data-bind="event: { click: onReviewItemReversalConfirm }" class="btn highlight">Apply</button>

                            </div>

                        </div>
                    </div>
                 </div>


                <div data-bind="css: { 'is-visible': isEmbedPopUpVisible }" class="w-lightbox light-theme lightbox-embed right-space">
                    <div class="lightbox-content">
                        <div class="w-form lightbox-form">

                            <div class="form-header">
                                <h3 class="form-title">Insert Embed</h3>
                                <button type="button" class="close-button icon i-close-2" data-bind="event: { click: onClickCloseEmbedPopup }" ></button>
                            </div>


                            <div class="form-body">

                                 <div class="form-group">
                                    <button class="btn-form options icon i-dropdown-simple is-open" type="button" data-bind="event: { click: onClickToggleEmbedTypes }">Supported Platforms</button>
                                    <div class="inner-group" data-bind="foreach: embedType_options" >
                                        <div>
                                            <input type="radio" data-bind="checked: $parent.embedType, event:{change: $parent.onChangeEmbedInput}, attr: { value: $data.type, id: $data.type }">
                                            <label class="form-label" for="active_no" data-bind="text: $data.name, attr: { for: $data.type }"></label>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div style="display: flex;align-items: center">
                                        <label class="form-label" for="embedSource">Embed Creator</label>
                                        <div class="w-tooltips-adv pos-top">
                                            ${this.toolTipButton.getHtmlBuild()}
                                        </div>
                                    </div>
                                    <textarea style="width: 100%;height: 100px;" id="embedSource" placeholder="paste supported link or full embed code here" data-bind="textInput: embedSource, event: { input: onChangeEmbedInput }, valueUpdate : ['afterkeydown','propertychange','input'], hasFocus: isEmbedFocused" class="input-text"></textarea>
                                </div>
                                <div class="error form-group">
                                    <p class="form-text" data-bind="text: embedErrors().message" />
                                    <ul data-bind="foreach:embedErrors().softMatches">
                                        <li >
                                            <p class="form-text" data-bind="text: $data" /></p>
                                        </li>
                                    </ul>
                                    <p class="form-text" data-bind="if: embedErrors().softMatches && embedErrors().softMatches.length>0 ">Please choose a specific supported platform from the list.</p>
                                </div>

                                <div class="preview" data-bind="visible: embedCode">
                                    <div class="form-group">
                                        <label class="form-label" for="embedSource" data-bind="class: previewEmbedType">Embed Code Preview</label>
                                        <pre class="scrollable"  data-bind="text: embedCode, disable: true" ></pre>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group" id="embedGeneration">
                                <section id="calculation" hidden>
                                    <h2 class="form-title embed-animation">Generating Embed…</h2>
                                    <progress style="
                                        display: block;
                                        width: 100%;
                                        margin-bottom: 10px;">
                                        </progress>
                                    <p>
                                        Checking width:
                                        <span id="current-viewport-width"></span>
                                        <span>x</span>
                                        <span id="current-viewport-height"></span>
                                    </p>

                                    <div id="iframe-wrapper" style="position:absolute;left:0;top:0;opacity:0;pointer-events:none;z-index:-1;">
                                        <iframe src="about:blank"></iframe>
                                    </div>
                                </section>
                            </div>

                            <div class="form-footer">

                                <button type="button" data-bind="event: { click: onClickCloseEmbedPopup }" class="btn ">Cancel</button>
                                <button type="button" data-bind="disable: embedCode() == null || embedErrors() == null,  event: { click: onClickAddEmbed }" class="btn highlight">Insert</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div data-bind="css: { 'is-visible': isSensaiVaultVisible }" class="w-lightbox light-theme lightbox-embed right-space">
                    <div class="lightbox-content">
                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">Sensai Vault</h3>
                                <button type="button" class="close-button icon i-close-2" data-bind="event: { click: onClickCloseSensaiVaultPopup }" ></button>
                            </div>


                            <div class="form-body">

                                <div id="generatedContent" data-bind="html: sensaiVaultGeneratedHtml"></div>
                            </div>

                            <div class="form-footer">

                                <button type="button" data-bind="event: { click: onClickCloseSensaiVaultPopup }" class="btn ">Cancel</button>
                                <button type="button" data-bind="disable: embedCode() == null || embedErrors() == null,  event: { click: onClickAddEmbed }" class="btn highlight">Insert</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="w-lightbox" data-bind="css: { 'is-visible': isCropSelectorShown }">
                    <div class="lightbox-content">
                        <div class="w-form lightbox-form" style="width: 90vw; max-width: 88rem; max-height: 90vh; display: flex; flex-direction: column;">
                            <div class="form-header">
                                <h3 class="form-title" data-bind="text: cropSelectorTitle"></h3>
                                <button type="button" class="close-button icon i-close-2" data-bind="event: { click: onClickCancelCropSelector }"></button>
                            </div>
                            <div class="form-body" style="padding: 2rem; overflow-y: auto;">
                                <p class="form-text" style="margin-bottom: 1.5rem;">Drag the crop box to choose what should appear. Reset keeps the default center crop.</p>
                                <div style="display: flex; gap: 1.25rem; align-items: flex-start; justify-content: center; flex-wrap: nowrap;">
                                    <div style="flex: 0 1 auto; min-width: 0;">
                                        <label class="form-label" style="display: block; margin-bottom: 0.75rem;">Crop Area</label>
                                        <div style="text-align: center; max-height: 58vh; overflow: hidden;">
                                            <div style="position: relative; display: inline-block; max-width: 100%; line-height: 0; overflow: hidden;">
                                                <img data-bind="attr: { src: cropSelectorImage() ? cropSelectorImage().url : '' }" alt="" style="display: block; max-width: 100%; max-height: 58vh; width: auto; height: auto; user-select: none;" draggable="false" />
                                                <div data-bind="style: cropSelectorFrameStyle, event: { mousedown: onMouseDownCropSelectorFrame }"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="flex: 0 0 32rem; min-width: 0; align-self: stretch; display: flex; flex-direction: column;">
                                        <label class="form-label" style="display: block; margin-bottom: 0.75rem;">Cropped Preview</label>
                                        <div style="overflow: hidden; flex: none; margin: auto 0;" data-bind="style: cropSelectorPreviewStyle">
                                            <img data-bind="attr: { src: cropSelectorPreviewUrl }" alt="" style="display: block; width: 100%; height: 100%; object-fit: cover;" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-footer" style="display: flex; justify-content: flex-end; gap: 1rem; flex-shrink: 0;">
                                <button type="button" data-bind="event: { click: onClickResetCropSelector }" class="btn">Reset</button>
                                <button type="button" data-bind="event: { click: onClickCancelCropSelector }" class="btn">Cancel</button>
                                <button type="button" data-bind="event: { click: onClickApplyCropSelector }" class="btn highlight">Apply</button>
                            </div>
                        </div>
                    </div>
                </div>

                 ${this.imagePicker.getHtmlBuild()}
                 ${this.tagPicker.getHtmlBuild()}
                 ${this.quizPicker.getHtmlBuild()}
                 ${this.pollPicker.getHtmlBuild()}
                 ${this.videoPicker.getHtmlBuild()}
                 ${this.articlePicker.getHtmlBuild()}
                 ${this.vignettePicker.getHtmlBuild()}
                 ${this.warningDialog_WhenLogOut.getHtmlBuild()}
                 ${this.warningDialog_WhenArticleLock.getHtmlBuild()}
                 ${this.warningDialog_sandboxDelete.getHtmlBuild()}
                 ${this.warningDialog_newsletterSendingConfirmation.getHtmlBuild()}
                 ${this.warningDialog_republishDelete.getHtmlBuild()}
                 ${this.warningDialog_republishCreateAndUpdate.getHtmlBuild()}
                 ${this.warningDialog_articleAiFaq.getHtmlBuild()}
                 ${this.warningDialog_threadSummary.getHtmlBuild()}
                 ${this.warningDialog_audioReader.getHtmlBuild()}
                 ${this.sensaiFeatureFeedback.getHtmlBuild()}
                <style>
                .cke_button__linkbtn_label {
                    display:inline;
                }
                .cke_button__updatebtn_label {
                    display:inline;
                }
                .cke_button__linkbtn_icon{
                    display: none;
                }
                a.cke_button__keypointsbtn, .cke .cke_toolgroup a.cke_button__keypointsbtn.cke_button_off:hover {
                    background-image: rgb(99,0,143);
                    background-image: -moz-linear-gradient(0deg, rgba(99,0,143,1) 0%, rgba(24,112,185,1) 52%, rgba(43,188,171,1) 100%) !important;
                    background-image: -webkit-linear-gradient(0deg, rgba(99,0,143,1) 0%, rgba(24,112,185,1) 52%, rgba(43,188,171,1) 100%) !important;
                    background-image: linear-gradient(0deg, rgba(99,0,143,1) 0%, rgba(24,112,185,1) 52%, rgba(43,188,171,1) 100%) !important;
                    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#63008f",endColorstr="#2bbcab",GradientType=1);
                }
                .cke_button__keypointsbtn_label {
                    display:inline;
                    color: #ffffff;
                }
                .cke_button__keypointsbtn_icon {
                    background: url(/assets/images/keypoints.svg);
                }
                .cke_button__updatebtn_icon {
                    display: none;
                }
                [id^=cke_target]{
                    display:none !important;
                }
                </style>
                `;
    }

    protected initPartial(): void {

        this.filterUser_author = new filterUser_template("filterUser_author", this.getTemplateViewModel(), this.caller);
        this.filterUser_author.setUniqueIdentifier('authorId');

        this.filterUser_SrEditor = new filterUser_template("filterUser_SrEditor", this.getTemplateViewModel(), this.caller);
        this.filterUser_SrEditor.setUniqueIdentifier("srEditorId");

        this.filterUser_JrEditor = new filterUser_template("filterUser_JrEditor", this.getTemplateViewModel(), this.caller);
        this.filterUser_JrEditor.setUniqueIdentifier("jrEditorId");

        this.filterUser_ideator = new filterUser_template("filterUser_ideator", this.getTemplateViewModel(), this.caller);
        this.filterUser_ideator.setUniqueIdentifier("ideatorId");

        this.filterAiAgent = new filterAutocomplete_template("filterAutocompleteAiAgent_template", this.getTemplateViewModel(), this.caller);
        this.filterUser_ideator.setUniqueIdentifier("aiAgentId");
        this.filterAiAgent.setAddNewOptionEnabled(true);
        this.filterAiAgent.setNumberOfChars(1);
        this.filterAiAgent.setPlaceholder("Search AI Agents");
        this.filterAiAgent.setLabel("AI Agents");
        this.filterAiAgent.setOptionType("AI Agent");
        this.filterAiAgent.setFilterIconCSSClass("i-ai-1-a");

        const aiAgentSelf = this;
        this.filterAiAgent.getTemplateViewModel().addNewSelected.subscribe((isSelected: boolean) => {
            if (isSelected) {
                this.filterAiAgent.setLabel("AI Agent");
                aiAgentSelf.onClickAddAiAgent();
                const inputEl = document.getElementById("filterAutocompleteAiAgent_template_addNewInput") as HTMLInputElement;
                if (inputEl && !inputEl.dataset.enterHandlerAdded) {
                    inputEl.addEventListener("keyup", function(e: KeyboardEvent) {
                        if (e.key === "Enter") {
                            aiAgentSelf.onClickAddAiAgent();
                        }
                    });
                    inputEl.dataset.enterHandlerAdded = "1";
                }
            } else {
                this.filterAiAgent.setLabel("AI Agents");
            }
        });


        this.filterUser_republish_author = new filterUser_template("filterUser_republish_author", this.getTemplateViewModel(), this.caller);
        this.filterUser_republish_author.setUniqueIdentifier("repAuthorId")

        this.filterUser_republish_SrEditor = new filterUser_template("filterUser_republish_SrEditor", this.getTemplateViewModel(), this.caller);
        this.filterUser_republish_SrEditor.setUniqueIdentifier("repSrEditorID")

        this.filterUser_republish_JrEditor = new filterUser_template("filterUser_republish_JrEditor", this.getTemplateViewModel(), this.caller);
        this.filterUser_republish_JrEditor.setUniqueIdentifier("repJrEditorID")

        this.filterUser_scheduled_republish_author = new filterUser_template("filterUser_scheduled_republish_author", this.getTemplateViewModel(), this.caller);
        this.filterUser_scheduled_republish_author.setUniqueIdentifier("repAuthorId")

        this.filterUser_scheduled_republish_SrEditor = new filterUser_template("filterUser_scheduled_republish_SrEditor", this.getTemplateViewModel(), this.caller);
        this.filterUser_scheduled_republish_SrEditor.setUniqueIdentifier("scheduledRepSrEditorID")

        this.filterUser_scheduled_republish_JrEditor = new filterUser_template("filterUser_scheduled_republish_JrEditor", this.getTemplateViewModel(), this.caller);
        this.filterUser_scheduled_republish_JrEditor.setUniqueIdentifier("scheduledRepJrEditorID")

        this.filterUser_display_author = new filterUser_template("filterUser_display_author", this.getTemplateViewModel(), this.caller);
        this.filterUser_display_author.setUniqueIdentifier("displayAuthorId");

        this.filterWebsiteUser_prompt_author = new filterWebsiteUser_template("filterWebsiteUser_prompt_author", this.getTemplateViewModel(), this.caller);
        this.filterWebsiteUser_prompt_author.setUniqueIdentifier("promptAuthorId")

        this.toolTip_prompt_author = new infoButton_template("toolTip_prompt_author", this.getTemplateViewModel(), this.caller);
        this.toolTip_prompt_author.setTitle("Help: Prompt Author");
        this.toolTip_prompt_author.setContent(`The Thread can specify a website user as a prompt author. If none is set, the author of the article itself is used. Website users can be searched using display name or public ID on the brand.`)

        this.display_authors = new articleUserList_template("display_authors", this.getTemplateViewModel(), this.caller);

        this.filterProducts = new filterAutocomplete_template("filterAutocompleteProduct_template", this.getTemplateViewModel(), this.caller);
        // this.filterProducts.setFilterIconCSSClass( 'i-article-a' );
        this.filterProducts.setClearInputConfirmMessage("Are you sure you want to change the product name? Newly entered product specifications and selected fields will be lost");
        this.filterProducts.setAddNewClearConfirmMessage("Are you sure you want to add a new product name? Newly entered product specifications and selected fields will be lost");
        this.filterProducts.setAddNewOptionEnabled(true);
        this.filterProducts.setHasDisplayNameComplement(true);
        this.filterProducts.setNumberOfChars( 1 );
        this.filterProducts.setPlaceholderAndLabel( "Product" );
        this.filterProducts.setOptionType("Product name");

        this.filterAffiliates = new filterAutocomplete_template("filterAutocompleteAffiliate_template", this.getTemplateViewModel(), this.caller);
        // this.filterProducts.setFilterIconCSSClass( 'i-article-a' );
        this.filterAffiliates.setAddNewOptionEnabled(true);
        this.filterAffiliates.setNumberOfChars( 1 );
        this.filterAffiliates.setPlaceholderAndLabel( "Affiliate Partner" );
        this.filterAffiliates.setOptionType("Affiliate Partner");
        //TODO create a new filterAutoComplete_template with a new id template
        this.filterPinnedTag = new filterAutocomplete_template('filterAutocompletePinnedTags_template', this.getTemplateViewModel(), this.caller);
        this.filterPinnedTag.setPlaceholderAndLabel( 'Featured Tag' );
        this.filterPinnedTag.setOptionType("Featured Tag");
        this.filterPinnedTag.setAddNewOptionEnabled(false);

        this.filterProductTypes = new filterAutocomplete_template("filterAutocompleteProductType_template", this.getTemplateViewModel(), this.caller);
        // this.filterProductTypes.setFilterIconCSSClass( 'i-article-a' );
        this.filterProductTypes.setClearInputConfirmMessage("Are you sure you want to change the product type? Newly entered product specifications and selected fields will be lost");
        this.filterProductTypes.setAddNewClearConfirmMessage("Are you sure you want to add a new product type? Newly entered product specifications and selected fields will be lost");
        this.filterProductTypes.setPlaceholderAndLabel( 'Product Type' );
        this.filterProductTypes.setOptionType("Product Type");
        this.filterProductTypes.setNumberOfChars( 1 );
        this.filterProductTypes.setAddNewOptionEnabled(true);
        this.filterArticleDirectory = new filterArticle_template('filterAutocomplete_template', this.getTemplateViewModel(), this.caller);
        this.filterArticleDirectory = new filterArticle_template('filterArticleDirectory', this.getTemplateViewModel(), this.caller);

        this.paymentCategoryFilter = new filterDropdown_template("paymentCategoryFilter", this.getTemplateViewModel(), this.caller);
        this.paymentCategoryFilter.setLabel("Payment Category");

        this.scheduledRepublishPaymentCategoryFilter = new filterDropdown_template("scheduledRepublishPaymentCategoryFilter", this.getTemplateViewModel(), this.caller);
        this.scheduledRepublishPaymentCategoryFilter.setLabel("Payment Category");

        this.datePicker = new filterSingleDate_template("filterDate", this.getTemplateViewModel(), this.caller);
        this.imagePicker = new imagePicker_template("imagePicker", this.getTemplateViewModel(), this.caller);
        this.imagePicker.setNumberOfRecentImages(50);

        //this.imagePickerM = new imagePicker_template_mockup("imagePickerM", this.getTemplateViewModel(), this.caller);

        this.articleDirectory = new directoryEdit_template("article_directory", this.getTemplateViewModel(), this.caller)
        this.articleDirectory.setId('article_directory');

        this.filterCategory = new multipleSelector_template("article_categoryFilter", this.getTemplateViewModel(), this.caller);
        this.filterCategory.setFilterContainerClass('margin-neg');
        this.filterCategory.setSelectAllEnabled(false);
        this.filterCategory.setSearchEnabled(true);

        this.filterCategory.setLabel("Categories");

        this.filterTag = new filterTag_template("filterTag", this.getTemplateViewModel(), this.caller);
        this.filterDataset = new filterDataset_template("filterDataset", this.getTemplateViewModel(), this.caller);

        this.scheduleDatePicker = new filterSingleDate_template("filterScheduleDate", this.getTemplateViewModel(), this.caller);
        this.scheduleDatePicker.setDate(this.getFormattedEasternTimeZoneDateTime());
        this.scheduleDatePicker.setMinutesInterval(1);

        this.giveawayDatePicker = new filterSingleDate_template("giveawayDatePicker", this.getTemplateViewModel(), this.caller);

        this.republishDatePicker = new filterSingleDate_template("filterRepublishDate", this.getTemplateViewModel(), this.caller);
        this.republishDatePicker.setDate(this.getFormattedEasternTimeZoneDateTime());
        this.republishDatePicker.setMinutesInterval(1);

        this.scheduledRepublishDatePicker = new filterSingleDate_template("filterScheduledRepublishDate", this.getTemplateViewModel(), this.caller);
        this.scheduledRepublishDatePicker.setDate(this.getFormattedEasternTimeZoneDateTime());
        this.scheduledRepublishDatePicker.setMinutesInterval(1);

        this.dateDevelopingStoryCoverageStartPicker = new filterSingleDate_template("filterDateDevelopingStoryCoverageStart", this.getTemplateViewModel(), this.caller);
        this.dateDevelopingStoryCoverageStartPicker.setMinutesInterval(1);
        this.dateDevelopingStoryCoverageStartPicker.toggleClearButton(true);

        this.dateDevelopingStoryCoverageEndPicker = new filterSingleDate_template("filterDateDevelopingStoryCoverageEnd", this.getTemplateViewModel(), this.caller);
        this.dateDevelopingStoryCoverageEndPicker.setMinutesInterval(1);
        this.dateDevelopingStoryCoverageEndPicker.toggleClearButton(true);

        this.developingStoryCoverageToolTipContent = `
        <ul>
            <li>If you simply wish to display the “Live Blogging” with no schema changes, leave both datetime fields empty.</li>
            <li>Setting a start time and end time will enable LiveBlogPosting schema only during the specified time period.</li>
            <li>If you set a start time without an end time, the LiveBlogPosting schema will remain on the article indefinitely.</li>
        </ul>
        `;
        this.developingStoryCoverageToolTip = new infoButton_template('developingStoryCoverageToolTip', this.getTemplateViewModel(), this.caller);
        this.developingStoryCoverageToolTip.setTitle('Developing Story Coverage');
        this.developingStoryCoverageToolTip.setContent(this.developingStoryCoverageToolTipContent);

        this.filterArticle = new filterArticle_template("filterArticle", this.getTemplateViewModel(), this.caller);

        this.dealsCategoryPromotionListingPageFilter = new filterListingPage_template("dealsCategoryPromotionListingPageFilter", this.getTemplateViewModel(), this.caller);
        this.dealsCategoryPromotionListingPageFilter.setPlaceholder("Deals Category Hub Page");
        this.dealsCategoryPromotionListingPageFilter.setShowDetails(true);
        this.dealsCategoryPromotionListingPageFilter.setIsLoadingAnimationEnable(true);
        this.getTemplateViewModel().aiDealsCategoryPromotionListingPageId.subscribe((idListingPage) => {
            if (idListingPage) {
                this.dealsCategoryPromotionListingPageFilter.setListingPageId(idListingPage);
            } else {
                this.dealsCategoryPromotionListingPageFilter.clearInput();
            }
        });

        this.productReview = new productReview_template("productReview", this.getTemplateViewModel(), this);
        this.productReviewSandbox = new productReview_template("productReviewSandbox", this.getTemplateViewModel(), this);
        this.productReviewRepublish = new productReview_template("productReviewRepublish", this.getTemplateViewModel(), this);

        this.filterReviewTag = new filterAutocomplete_template('filterAutocompleteReviewTag_template', this.getTemplateViewModel(), this.caller);
        this.filterReviewTag.setPlaceholderAndLabel( 'Tag Reviewed by this Article' );
        this.filterReviewTag.setOptionType('Review Tag');
        this.filterReviewTag.setAddNewOptionEnabled(false);

        this.articleContent = new articleContent_template('article_content_section', this.getTemplateViewModel(), this);
        this.sandboxContent = new articleContent_template('article_sandbox_section', this.getTemplateViewModel(), this);
        this.republishContent = new articleContent_template('article_republish_section', this.getTemplateViewModel(), this);

        this.sandboxDirectory = new directoryEdit_template("sandbox_directory", this.getTemplateViewModel(), this.caller)
        this.sandboxDirectory.setId('sandbox_directory');

        this.republishDirectory = new directoryEdit_template("republish_directory", this.getTemplateViewModel(), this.caller)
        this.republishDirectory.setId('republish_directory');

        this.recoveryReviewSection = new productReviewView_template('recoveryReviewSection', this.getTemplateViewModel(), this);
        this.recoverySandboxReviewSection = new productReviewView_template('recoverySandboxReviewSection', this.getTemplateViewModel(), this);
        this.recoveryRepublishReviewSection = new productReviewView_template('recoveryRepublishReviewSection', this.getTemplateViewModel(), this);

        this.recoveryDirectory = new directoryView_template('recoveryDirectory', this.getTemplateViewModel(), this);
        this.recoverySandboxDirectory = new directoryView_template('recoverySandboxDirectory', this.getTemplateViewModel(), this);
        this.recoveryRepublishDirectory = new directoryView_template('recoveryRepublishDirectory', this.getTemplateViewModel(), this);

        this.revisionReviewSection = new productReviewView_template('revisionReviewSection', this.getTemplateViewModel(), this);
        this.revisionDirectory = new directoryView_template('revisionDirectory', this.getTemplateViewModel(), this);

        this.articleAnalytics = new articleAnalytics_template('articleAnalytics', this.getTemplateViewModel(), this);

        this.toolTipButton = new infoButton_template('toolTip', this.getTemplateViewModel(), this.caller)
        this.toolTipButton.setTitle('Help: Embed');

        let toolTipText =  '' +
            '<div style="display: flex;align-items: flex-start">' +
            '<video src="/assets/videos/article-embed.mp4" autoplay loop muted style="width: 40%; float: left; margin: 0 10px 5px 0;"></video><br>' +
            '<div>' +
            '<p>Paste into this text box information to generate the embed code.  The following are accepted:</p>' +
            '<ul>' +
            '<li>Full URL from supported platforms</li>' +
            '<li>ID of a post from supported platforms</li>' +
            '<li>Full embed code in html</li>' +
            '</ul>' +
            '</div>' +
            '</div>'
        ;

        this.toolTipButton.setContent(toolTipText);

        this.customRecipientsToolTipButton = new infoButton_template('customRecipientsToolTipButton', this.getTemplateViewModel(), this.caller)
        this.customRecipientsToolTipButton.setTitle('Help: Custom');

        let customRecipientstoolTipText =  '' +
            '<div style="display: flex;align-items: flex-start">' +
            '<p>Input comma-separated email addresses to receive a copy of the email. Spaces will be stripped.</p>' +
            '</div>'
        ;

        this.customRecipientsToolTipButton.setContent(customRecipientstoolTipText);


        this.pinnedTagTooltipContent = `
        <p>A tag must have an associated image and at least one specification value to be selected. Only those marked with a green indicator are available for use by your brand.</p>

        `
        this.pinnedTagTooltip = new infoButton_template('pinnedTagTooltip', this.getTemplateViewModel(), this.caller)
        this.pinnedTagTooltip.setTitle('Tag Selection');
        this.pinnedTagTooltip.setContent(this.pinnedTagTooltipContent);

        this.selectProductTooltipContent = `
        <p>All tags are displayed here but only those marked with a green indicator are currently available for use by your brand.</p>
        <ul>
            <li class="is-active">Available for use.</li>
            <li class="is-not-active">Not available for use.</li>
        </ul>
        `
        this.selectProductTooltip = new infoButton_template('selectProductTooltip', this.getTemplateViewModel(), this.caller)
        this.selectProductTooltip.setTitle('Tag Selection');
        this.selectProductTooltip.setContent(this.selectProductTooltipContent);

        this.copyLeaksResultsSectionTooltipContent = `
        <ul>
            <li>"Not Submitted" indicates an article will not be submitted for plagiarism detection.</li>
            <li>"Pending Submission" indicates an article will be submitted for plagiarism detection the first time it is "Scheduled" or "Published". It will also be submitted when there is a "Scheduled Republish" or it is "Republished".</li>
            <li>"Submitted" indicates an article has been submitted for plagiarism detection. Once a result is received, it will only be visible to users with the permission to publish or republish.</li>
        </ul>
        `
        this.copyLeaksResultsSectionTooltip = new infoButton_template('copyLeaksResultsSectionTooltip', this.getTemplateViewModel(), this.caller)
        this.copyLeaksResultsSectionTooltip.setTitle('COPYLEAKS Results');
        this.copyLeaksResultsSectionTooltip.setContent(this.copyLeaksResultsSectionTooltipContent);

        this.tagPicker = new tagPicker_template("tagPicker", this.getTemplateViewModel(), this.caller);
        this.tagPicker.setParent(this);
        this.tagPicker.set_isHyperLinkModeEnabled(true);
        this.quizPicker = new quizPicker_template("quizPicker", this.getTemplateViewModel(), this.caller);
        this.pollPicker = new pollPicker_template("pollPicker", this.getTemplateViewModel(), this.caller);
        this.articlePinnedTags = new articlePinnedTags_template('articlePinnedTags', this.getTemplateViewModel(), this.caller);

        this.articlePicker =  new articlePicker_template("articlePicker", this.getTemplateViewModel(), this.caller);
        this.articlePickerHelper = new articlePicker_helper(this.articlePicker, this.caller.getVnAppZone(), this.caller);
        this.articlePicker.setIsHyperLinkModeEnabled(true);
        this.articlePicker.setCaller(this.articlePickerHelper);

        this.vignettePicker =  new vignettePicker_template("vignettePicker", this.getTemplateViewModel(), this.caller);
        this.vignettePickerHelper = new vignettePicker_helper(this.vignettePicker, this.caller.getVnAppZone(), this.caller);
        this.vignettePicker.setCaller(this.vignettePickerHelper);

        this.mobilePreviewTooltipContent = `
        <p>The mobile preview will open in a new window. On some browsers, this may not work if the browser is in full-screen mode or if pop-ups are blocked.</p>
        `
        this._mobilePreviewToolTip = new infoButton_template('mobilePreviewTooltip', this.getTemplateViewModel(), this.caller);
        this._mobilePreviewToolTip.setTitle('Mobile Preview (Incompatible with Fullscreen Mode)');
        this._mobilePreviewToolTip.setContent(this.mobilePreviewTooltipContent);

        this.featureImageTooltipContent = `
        <p>The featured image is required and will always be displayed on the article page below the article title.</p>
        `
        this._featureImageToolTip = new infoButton_template('featureImageTooltip', this.getTemplateViewModel(), this.caller);
        this._featureImageToolTip.setTitle('Feature Image');
        this._featureImageToolTip.setContent(this.featureImageTooltipContent);


        //Featured Tag section
        this.featuredTagSectionFeaturedImagePreview = `<p>This is the default image that will be used when an article is presented on the homepage, listing pages, or sidebar of a website. If you do not want to use this image, select a Thumbnail Image to be used in its place</p>`;
        this.featuredTagImagePreviewToolTip = new infoButton_template('featuredTagImagePreviewToolTip', this.getTemplateViewModel(), this.caller);
        this.featuredTagImagePreviewToolTip.setTitle('Featured Image Preview');
        this.featuredTagImagePreviewToolTip.setContent(this.featuredTagSectionFeaturedImagePreview);

        this.featuredTagSectionThumbnailImagePreview = `<p>The thumbnail image is an optional image used when an article is presented on the homepage, listing pages, or sidebar of a website. If the thumbnail is left blank the defaulted tag image (previewed above) will be used in those cases</p>`
        this.featuredTagThumbnailPreviewToolTip = new infoButton_template('featuredTagThumbnailPreviewToolTip', this.getTemplateViewModel(), this.caller);
        this.featuredTagThumbnailPreviewToolTip.setTitle('Thumbnail Image Preview');
        this.featuredTagThumbnailPreviewToolTip.setContent(this.featuredTagSectionThumbnailImagePreview);

        this.thumbnailImageTooltipContent = `
        <p>The thumbnail image is an optional image used when an article is presented on the homepage, listing pages, or sidebar of a website. If the thumbnail is left blank the featured image will be used in place of the thumbnail image.</p>
        `
        this.thumbnailImageToolTip = new infoButton_template('thumbnailImageTooltip', this.getTemplateViewModel(), this.caller)
        this.thumbnailImageToolTip.setTitle('Thumbnail Image');
        this.thumbnailImageToolTip.setContent(this.thumbnailImageTooltipContent);

        this.alternateSocialMediaImageTooltipContent = `
        <p>The alternate image is an optional image used when the article is linked on social media platforms. If the alternate image is left blank the featured will be used in place of the alternate image.</p>
        `
        this.alternateSocialMediaImageToolTip = new infoButton_template('alternateImageTooltip', this.getTemplateViewModel(), this.caller)
        this.alternateSocialMediaImageToolTip.setTitle('Alternate Image');
        this.alternateSocialMediaImageToolTip.setContent(this.alternateSocialMediaImageTooltipContent);

        this.emakiLabHelperTooltipContent = `
        <p>This button is an <strong><em>EmakiLab Helper Tool</em></strong> and will <strong><em>Automatically Populate Tag and Category</em></strong> suggestions, based on the content of the article.</p>
        <p>This works best when all of the content of the article is written, as it will base itself on that content. The results may vary with each use of the button, but it is recommended to only use the button once.  There is a limit on the amount of times the button can be used on each article.</p>
        <p><strong>Note:</strong> The tool will only base itself on the Content of the article and cannot provide results for very long articles</p><p>~3000+ words.</p>
        `
        this.emakiLabHelperTooltip = new infoButton_template('emakiLabHelperTooltip', this.getTemplateViewModel(), this.caller)
        this.emakiLabHelperTooltip.setContent(this.emakiLabHelperTooltipContent);

        let optimizableImagesSections: string[] = [
            'article_content',
            'article_faq',
            'article_directory_item_description',
            'article_republish',
            'article_sandbox',
            'featured_image'
        ];
        this.imagePickerHelper = new imagePickerHelper(
            this.imagePicker,
            this.caller.viewModel,
            this.caller.getVnAppZone(),
            this.caller,
            optimizableImagesSections
        );
        this.embedHelper = new EmbedHelper(this.caller);

        this.imageWidgetForThumbnailImage = new imageWidget_template('thumbnail_image', this.getTemplateViewModel(), this)
        this.imageWidgetForThumbnailImage.setMode('single-select');
        this.imageWidgetForThumbnailImage.setCaller(this.imagePickerHelper);

        this.imageWidgetForAlternateImage = new imageWidget_template('alternate_image', this.getTemplateViewModel(), this)
        this.imageWidgetForAlternateImage.setMode('single-select');
        this.imageWidgetForAlternateImage.setCaller(this.imagePickerHelper);

        this.imageWidgetForFeaturedImage = new imageWidget_template('featured_image', this.getTemplateViewModel(), this);
        this.imageWidgetForFeaturedImage.setMode('single-select');
        this.imageWidgetForFeaturedImage.setCaller(this.imagePickerHelper);

        this.imageWidgetForTagImageGroup = new imageWidget_template('featured_image_group', this.getTemplateViewModel(), this);
        this.imageWidgetForTagImageGroup.setMode('multi-select-no-gallery');
        this.imageWidgetForTagImageGroup.setCaller(this.imagePickerHelper);


        this.warningDialog_WhenLogOut = new warningDialog_template('dialogLogout', this.getTemplateViewModel(), this)
        this.warningDialog_WhenArticleLock = new warningDialog_template('dialogArticleLock', this.getTemplateViewModel(), this)

        this.videoInstructionToolTip = new infoButton_template('videoInstruction', this.getTemplateViewModel(), this.caller)
        this.videoInstructionToolTip.setTitle("Video Upload Instruction")
        this.videoInstructionToolTip.setContent(`
        <p>Videos are associated with articles. If a video is uploaded but not used in the content, the stored copy will be deleted on save.
        Videos should therefore be uploaded for each article they will be used in. Videos must be in MP4 format and file sizes cannot exceed 200MB.
        `)

        this.sensaiFeatureFeedback = new sensaiFeatureFeedback_template("sensaiFeatureFeedback", this.getTemplateViewModel(), this);

        this.videoPicker = new videoPicker_template("videoPicker", this.getTemplateViewModel(), this.caller);

        this.videoPickerHelper = new videoPickerHelper(
            this.videoPicker,
            this.caller.viewModel,
            this.caller.getVnAppZone(),
            this.caller
        );

        this.warningDialog_sandboxDelete = new warningDialog_template('dialogSandboxDelete', this.getTemplateViewModel(), this.caller);
        this.warningDialog_sandboxDelete.setTitle('Confirm');
        this.warningDialog_sandboxDelete.setMessage('Are you sure you want to delete the sandbox. This version of the content will not be recoverable.');

        this.warningDialog_newsletterSendingConfirmation = new warningDialog_template('warningDialog_newsletterSendingConfirmation', this.getTemplateViewModel(), this.caller);
        this.warningDialog_newsletterSendingConfirmation.setTitle('Confirm');

        this.warningDialog_republishDelete = new warningDialog_template('dialogRepublishDelete', this.getTemplateViewModel(), this.caller);
        this.warningDialog_republishDelete.setTitle('Confirm');
        this.warningDialog_republishDelete.setMessage('Are you sure you want to delete the republish.  This version of the content will not be recoverable.');

        this.warningDialog_republishCreateAndUpdate = new warningDialog_template('dialogRepublishCreateAndUpdate', this.getTemplateViewModel(), this.caller);
        this.warningDialog_republishCreateAndUpdate.setTitle('Confirm');
        this.warningDialog_republishCreateAndUpdate.setMessage('Are you sure you want to create and update the article content with the republish.');

        this.updateTimeToolTipButton = new infoButton_template('toolTip', this.getTemplateViewModel(), this.caller)
        this.updateTimeToolTipButton.setTitle('Update Time');
        this.updateTimeToolTipButton.setContent('<p>If the article is saved with this option checked, the date displayed on the website will become the current time of the save. Note that this does not affect anything within Emaki.</p>');

        this.newsletterTemplateSelector = new filterDropdown_template('newsletterTemplateSelector', this.getTemplateViewModel(), this.caller);
        this.newsletterTemplateSelector.setLabel('Template');
        this.newsletterDateScheduledSelector = new filterSingleDate_template('newsletterDateScheduledSelector', this.getTemplateViewModel(), this.caller);
        this.newsletterDateScheduledSelector.setDate(this.getFormattedEasternTimeZoneDateTime());
        this.newsletterDateScheduledSelector.setMinutesInterval(1);

        this.sensaiPromptTemplate = new genericPrompt_template('sensaiPrompt', this.getTemplateViewModel(), this.caller);
        this.sensaiPromptTemplate.setEeatScoreRoot(this.getTemplateViewModel());
        this.sensaiPromptTemplate.setTitle("Content Value Guidelines");
        this.sensaiPromptTemplate.setContent(""); // revisit this will subsequently be updated..
        this.sensaiPromptTemplate.setSensaiRulePointThreshold(this.getTemplateViewModel().sensaiCoverageScore());

        this.articleReviewHistory = new articleReviewHistory_template('articleReviewHistory', this.getTemplateViewModel(), this.caller);

        this.eeatScorePanel = new eeatScorePanel_template('eeatScore', this.getTemplateViewModel(), this.caller);

        this.sensaiChat = new sensai_chat_template('sensAI_vault', this.getTemplateViewModel(), this.caller);

        this.sourceNewsDatePicker = new filterSingleDate_template('sourceNewsDatePicker', this.getTemplateViewModel(), this.caller);
        this.sourceNewsDatePicker.setDate(this.getFormattedEasternTimeZoneDateTime());
        this.sourceNewsDatePicker.setMinutesInterval(1);

        this.warningDialog_articleAiFaq = new warningDialog_template('dialogWarningDialog_articleAiFaq', this.getTemplateViewModel(), this.caller);
        this.warningDialog_articleAiFaq.setTitle('Confirm');
        this.warningDialog_articleAiFaq.setMessage('Are you sure you want to regenrate the AI FAQ? This will overwrite any existing AI FAQ content.');

        this.warningDialog_threadSummary = new warningDialog_template('dialogWarningDialog_threadSummary', this.getTemplateViewModel(), this.caller);
        this.warningDialog_threadSummary.setTitle('Confirm');
        this.warningDialog_threadSummary.setMessage('Are you sure you want to regenerate the thread summary? This will overwrite any existing thread summary content.');

        this.warningDialog_audioReader = new warningDialog_template('dialogWarningDialog_audioReader', this.getTemplateViewModel(), this.caller);
        this.warningDialog_audioReader.setTitle('Confirm');
        this.warningDialog_audioReader.setMessage('There is already an audio file for this article. Regenerate it?');

        this.articleRecommendations = new articleRecommendations_template("articleRecommendations", this.getTemplateViewModel(), this.caller);
        this.articleRecommendations.setParent(this);
    }

   public buildDatePickerCalendar() {
        this.datePicker.buildCalendar();

        this.giveawayDatePicker.buildCalendar();
        this.giveawayDatePicker.getTemplateViewModel().singleDatePicker(null);

        this.scheduleDatePicker.buildCalendar(this.createEasternTimeZoneDateTime());
        this.republishDatePicker.buildCalendar(this.createEasternTimeZoneDateTime());
        this.scheduledRepublishDatePicker.buildCalendar(this.createEasternTimeZoneDateTime());
        this.newsletterDateScheduledSelector.buildCalendar(this.createEasternTimeZoneDateTime());
        this.dateDevelopingStoryCoverageStartPicker.buildCalendar();
        this.dateDevelopingStoryCoverageStartPicker.getTemplateViewModel().singleDatePicker(null);
        this.dateDevelopingStoryCoverageEndPicker.buildCalendar();
        this.dateDevelopingStoryCoverageEndPicker.getTemplateViewModel().singleDatePicker(null);

        this.tagPicker.buildDatePickerCalendars();
        this.sourceNewsDatePicker.buildCalendar();
        this.sourceNewsDatePicker.getTemplateViewModel().singleDatePicker(null);


    }

    protected getTemplateName(): string {

        return "articlesEdit_template_new";
    }

    protected buildViewModel(): any {

        const self = this;

        //set isAiThreadSummaryEnabled to true if brand id is CB, TPS, or HC
        const idBrand = this.caller.getIdBrand();

        let isAiThreadSummaryEnabled = false;
        if(idBrand === 44 || idBrand === 30 || idBrand === 13) {
            isAiThreadSummaryEnabled = true;
        }

        const vm =
            {
            id: ko.observable(""),
            permalinkHistory: ko.observableArray([]),
            isPermalinkPopupShown: ko.observable(false),
            permalinkRedirects: ko.observableArray([]),
            prompt: ko.observable(""),
            promptResponse: ko.observable(""),
            promptLink: ko.observable(""),
            idTemplate: ko.observable(null),
            idTemplateLayout: ko.observable(null),
            idTemplateLayoutPrevious: ko.observable(null),
            templateLayout: ko.observable(null),
            templateLayouts: ko.observableArray([]),
            templateLayoutsFiltered: ko.observableArray([]),
            isFeaturedTagDisabled: ko.observable(false),
            isFeaturedVideoDisabled: ko.observable(false),
            isVerticalShortTemplateSelected: ko.observable(false),
            dateUpdated: ko.observable(""),
            dateCreated: ko.observable(""),
            title: ko.observable(""),
            titleCharCount: ko.observable(0),
            brand: ko.observable(""),
            idBrand: ko.observable(this.caller.getIdBrand()),
            isAutoLinkerEnabled: ko.observable(false),
            OSPBrands: ko.observableArray([21,31]),
            newsNowBrands: ko.observableArray([32,33,36]),
            selectedTab: ko.observable(Previewable.ARTICLE),
            selectedRecoveryTab: ko.observable(Recoverable.CONTENT),
            content: ko.observable(),
            recoveryContent: ko.observable(),
            sandboxRecoveryContent: ko.observable(),
            republishRecoveryContent: ko.observable(),
            sandboxRecoveryIntroText: ko.observable(),
            sandboxRecoveryReviewItems: ko.observable(),
            fieldValueChanges: ko.observableArray([]),
            tagNameChanges: ko.observableArray([]),
            recoveryReviewItems: ko.observable(),
            recoveryIntroText: ko.observable(),
            recoveryUser: ko.observable(),
            dateRecovery: ko.observable(),
            recovery: ko.observable(),
            sandboxRecovery: ko.observable(''),
            republishRecovery: ko.observable(''),
            selectedRevisionIndex: ko.observable(0),
            revisionContent: ko.observable(),
            revisionIntroText: ko.observable(),
            revisionReviewItems: ko.observableArray(),
            isAddingNewTypeOrProduct: ko.observable(false),
            reviewItemFormItemToAdd: ko.observable(""),
            newTypeOrProductName: ko.observable(""),
            idRevisionSelected: ko.observable(),
            isGiveawaySectionCollapsed: ko.observable(false),
            listOrder: ko.observable(),
            seoTitle: ko.observable(),
            featuredTags: ko.observable(null),
            defaultFeaturedTags: ko.observable(null),
            reviewTag: ko.observable(null),
            featuredImage: ko.observable(null),
            idFeaturedImage: ko.observable(""),
            IsFeaturedImageMobileOptimized: ko.observable(false),
            imageCropPositions: ko.observable(null),
            featuredImageMobilePreviewUrl: ko.observable(''),
            isCropSelectorShown: ko.observable(false),
            cropSelectorTarget: ko.observable(null),
            cropSelectorImage: ko.observable(null),
            cropSelectorX: ko.observable(0),
            cropSelectorY: ko.observable(0),
            defaultFeaturedImage: ko.observable(null),
            validAutoPricingPartnerNames: ko.observableArray([]),
            articlePageSettings: ko.observableArray([]),
            seoDescription: ko.observable(),
            smoTitle: ko.observable(),
            smoDescription: ko.observable(),
            articles: ko.observableArray([]),
            excerpt: ko.observable(""),
            displayConfiguration: ko.observable(1),
            isAdHidden: ko.observable(false),
            isAmpDisabled: ko.observable(false),
            isUnderEmbargo: ko.observable(false),
            isSyndicated: ko.observable(false),
            noAuthorship: ko.observable(false),
            externalAuthorName: ko.observable(""),
            isLinkToOriginalArticle: ko.observable(false),
            isUpdateTime: ko.observable(false),
            contentKeyPoints: ko.observable(''),
            isInstareadEnabled: ko.observable(false),
            isAudioReaderEnabled: ko.observable(false),
            audioReaderFileUrl: ko.observable(""),
            audioReaderMetadataUrl: ko.observable(""),
            audioReaderStatus: ko.observable(""),
            audioReaderErrorMessage: ko.observable(""),
            audioReaderNoticeMessage: ko.observable(""),
            isAudioReaderStateLoading: ko.observable(false),
            isAudioReaderBackgroundGenerationPending: ko.observable(false),
            audioReaderAllowedTemplateIds: ko.observableArray([]),
            isGeneratingAudioReader: ko.observable(false),
            isAudioReaderDifferentFromSavedContent: ko.observable(false),
            isAudioReaderAvailableForArticleType: ko.pureComputed(() => self.isAudioReaderAvailableForArticleType()),
            isDevelopingStory: ko.observable(false),
            isVersusStyle: ko.observable(false),
            reviewCategory: ko.observable(""),
            reviewItems: ko.observableArray([]),
            backupReviewItems: ko.observableArray([]),
            sandboxReviewItems: ko.observableArray([]),
            reviewItemsToDelete: ko.observableArray([]),
            fileUrl: ko.observable(""),
            tableOfContents: ko.observable(false),
            isNewsNowArticle: ko.observable(false),
            isSponsored: ko.observable(false),
            reference: ko.observable(""),
            editor: ko.observable(""),
            datePublished: ko.observable(""),
            dateLastPublishStatus: ko.observable(""),
            dateMostRecentPublishStatus: ko.observable(""),
            dateLastSyncStatus: ko.observable(""),
            dateLastStatus: ko.observable(""),
            author: ko.observable(""),
            displayAuthor: ko.observable(""),
            jrEditor: ko.observable(""),
            ideator: ko.observable(""),
            articleAiAgents: ko.observableArray([]),
            emakiAssistantAgentId: ko.observable(null),
            emakiAssistantEngagementAgentId: ko.observable(null),
            targetAudience: ko.observable(""),
            intent: ko.observable(""),
            contentType: ko.observable(""),
            segment: ko.observable(""),
            showSegmentTab: ko.observable(false),
            segments: ko.observable([]),
            networkCategory: ko.observable(""),
            postPaymentCategory: ko.observable(""),
            canSearchUsers: ko.observable(false),
            showNewRepublish: ko.observable(false),
            showScheduledRepublish: ko.observable(false),
            showDeleteRepublishButton: ko.observable(false),
            allowEditPermalink: ko.observable(true),
            pinnedTag: ko.observable(false),
            amazonsiteArticleTitle: ko.observable(""),
            newsNowArticleTitle: ko.observable(""),
            amazonsitePublishDate: ko.observable(""),
            updateAmazonsitePublishDate: ko.observable(false),
            articleRepublishHistory: ko.observableArray([]),
            newRepublishDate: ko.observableArray(""),
            permalink: ko.observableArray(""),
            republishes: ko.observableArray([]),
            idRepublish: ko.observable(null),
            idDeleteRepublish: ko.observable(null),
            republishesCount: ko.observable(0),
            amountAuthor: ko.observable(null),
            percentageAuthor: ko.observable(null),
            percentageEditor: ko.observable(null),
            scheduledAmountAuthor: ko.observable(null),
            scheduledPercentageAuthor: ko.observable(null),
            scheduledPercentageEditor: ko.observable(null),
            publishStatuses: ko.observableArray([]),
            articleStatus_options: ko.observableArray([]),
            articleRepublishStatus_options: ko.observableArray([]),
            reviewItemAward_options: ko.observableArray([]),
            revisions: ko.observableArray([]),
            sourceOfReversal: ko.observable(""),
            idSyncStatus: ko.observable(""),
            syncStatus: ko.observable(""),
            idPublishStatus: ko.observable(""),
            titleDiscoverandOptimizePrompt: ko.observable(""),
            customPrompt: ko.observable(""),
            customPromptPreviousResponseId: ko.observable(""),
            reviewItemToEdit: ko.observable(null),
            factualSummary : ko.observable(''),
            simpleSummary: ko.observable(''),
            satiricalCommentary : ko.observable(''),
            reactionPost : ko.observable(''),
            isSummaryContentEmpty: ko.pureComputed(() => {
                const _vm = this.getTemplateViewModel();
                const factual = _vm.factualSummary() && _vm.factualSummary().trim() !== "";
                const simple = _vm.simpleSummary() && _vm.simpleSummary().trim() !== "";
                const satirical = _vm.satiricalCommentary() && _vm.satiricalCommentary().trim() !== "";
                return !(factual || simple || satirical);
            }),
            isFactualSummaryEnabled : ko.observable(true),
            isSimpleSummaryEnabled : ko.observable(true),
            showSummary : ko.observable(true),
            showQuiz : ko.observable(false),
            isSatiricalCommentaryEnabled : ko.observable(true),
            updateSummariesWithContent : ko.observable(true),
            idChannel: ko.observable(null),
            channelName: ko.observable(null),
            activeChatTab: ko.observable('preset'),
            playlists: ko.observable([]),
            reviewItem: ko.observable({
                id: null,
                award: {id: null, name: null, slug: null},
                affiliateLinks: [],
                amazonHeadline: null,
                amazonSummary: null,
                amazonAward: null,
                tag: {
                    id: null,
                    name: null,
                    shortDescription: null,
                    description: null,
                    idType: null,
                    type: {id: null, name: null, slug: null, description: null},
                    data: {id: null, data: null},
                    idImage: null,
                    image: {url: null, altText: null}
                },
                seoDescription: null,
                giveawayUrl: null,
                giveawayExpiryDate: null,
                rating: null,
                extraImages: [],
                extraVideos: null,
                keyFeatures: null,
                pros: null,
                cons: null,
                reviewText: null
            }),
            reviewItemTagName: ko.observable(),
            reviewItemTagTypeName: ko.observable(),
            originalReviewItemTagTypeName: ko.observable(),
            reviewItemIdTag: ko.observable(),
            reviewItemIdTagType: ko.observable(),
            reviewItemIdAffiliate: ko.observable(0),
            reviewItemSeoDescription: ko.observable(),
            reviewItemAmazonAward: ko.observable(),
            reviewItemAmazonHeadline: ko.observable(),
            reviewItemAmazonSummary: ko.observable(),
            idReviewItem: ko.observable(),
            reviewItemRating: ko.observable(),
            reviewItemAmazonRating: ko.observable(),
            reviewItemGiveawayUrl: ko.observable(),
            reviewItemGiveawayExpiryDate: ko.observable(),
            reviewItemReviewText: ko.observable(),
            reviewItemIdAwardType: ko.observable(),
            reviewItemTagSpecifications: ko.observableArray([]),
            addedReviewItemTagSpecifications: ko.observableArray([]),
            reviewItemKeyFeatures: ko.observableArray([]),
            reviewItemAffiliateLinks: ko.observableArray([]),
            reviewItemPros: ko.observableArray([]),
            reviewItemCons: ko.observableArray([]),
            reviewItemImages: ko.observableArray([]),
            reviewItemExtraVideos: ko.observableArray([]),
            reviewItemExtraVideo: ko.observable(""),
            articleCurrentIdArticleStatus: ko.observable(""),
            networkCategory_options: ko.observableArray([]),
            idNetworkCategory: ko.observable(""),
            contentType_options: ko.observableArray([]),
            idContentType: ko.observable(""),
            segment_options: ko.observableArray([]),
            idSegment: ko.observable(""),
            intent_options: ko.observableArray([]),
            idIntent: ko.observable(""),
            paymentCategory_options: ko.observableArray([]),
            idPaymentCategory: ko.observable(""),
            idRepublishPaymentCategory: ko.observable(""),
            idStatus: ko.observable(1),
            idPreviousStatus: ko.observable(1),
            idRepublishStatus: ko.observable(1),
            idPreviousRepublishStatus: ko.observable(1),
            question: ko.observable(""),
            selectedFaqIndex: ko.observable(null),
            productTagName: ko.observable(""),
            idTagAward: ko.observable(""),
            updatedReviewItems: ko.observableArray([]),
            productTagSeoDescription: ko.observable(""),
            productTagShortDescription: ko.observable(""),
            idAffiliateLink: ko.observable(""),
            productSpecifications: ko.observableArray([]),
            affiliateLinks_options: ko.observableArray([]),
            isFaqAddFormShown: ko.observable(false),
            isSaveBoxSticky: ko.observable(false),
            isFaqDeleteVisible: ko.observable(false),
            isReviewItemUpdatesFormShown: ko.observable(false),
            isEmbedPopUpVisible: ko.observable(false),
            isEmbedFocused:ko.observable(false),
            embedSource:ko.observable(null),
            embedCode:ko.observable(null),
            embedErrors: ko.observableArray([]),
            embedType_options: ko.observableArray(embedTypesList()),
            embedType: ko.observable('all'),
            embedContext: ko.observable(EmbedContext.CONTENT),
            previewEmbedType: ko.observable(''),
            activeCkEditorInstance: ko.observable(null),
            isReviewProductFormShown: ko.observable(false),
            faqs: ko.observableArray([]),
            faqsToDelete: ko.observableArray([]),
            selectedCategories: ko.observableArray([]),
            selectedTags: ko.observableArray([]),
            categories: ko.observableArray([]),
            contentPresets: ko.observableArray([]),
            idPrimaryCategory: ko.observable(null),
            permissions: ko.observableArray(this.initPermissions(['article_edit_embargo', 'article_edit_takeover', 'article_edit_publishingControl','article_edit_config_amp','article_edit_config_ads','article_edit_display_options','article_edit_config_affiliate_linker','emaki_lab', 'newsletter_email_edit', 'newsletter_email_view', 'article_edit_config_ads'])),
            idPrimaryTag: ko.observable(null),
            isLockMessageVisible: ko.observable(false),
            isRepublishMessageVisible: ko.observable(false),
            saveType: ko.observable(null),
            isAffiliateLinkerEnabled: ko.observable(true),
            isSaveButtonDisabled: ko.observable(false),
            lastSaved: ko.observable("Never"),
            showAutoSaveMessage: ko.observable(false),
            autoSaveMessage: ko.observable(""),
            showIsAutosaving: ko.observable(false),
            lockMessage: ko.observable(""),
            isKickoutMessageVisible: ko.observable(false),
            isNoticeVisible: ko.observable(false),
            noticeMessage: ko.observable(""),
            isArticleLocked: ko.observable(false),
            isArticleAutoSaveError: ko.observable(false),
            kickoutMessage: ko.observable(""),
            tagImage: ko.observable(null),
            keyFeature: ko.observable(""),
            imagePickerTarget: ko.observable(null),
            tagPickerTarget: ko.observable(null),
            pro: ko.observable(""),
            con: ko.observable(""),
            faqToDelete: ko.observable(null),
            oldVersion: ko.observable(null),
            newVersion: ko.observable(null),
            versionDiffResult: ko.observable(false),
            isSandboxContent: ko.observable(false),
            previewContentType: ko.observable(Previewable.ARTICLE),
            amazonOnsite: ko.observable(null),
            newsletterServiceType: ko.observable(null),
            idClassification: ko.observable(null),
            classificationName: ko.observableArray(null),
            classificationOptions : ko.observableArray([]),
            classificationAllOptions : ko.observableArray([]),
            paymentTypeRepublish : ko.observableArray([{name: "Amount"}, {name: "Percentage"}]),
            choosenPaymentTypeRepublish : ko.observable(null),
            choosenScheduledPaymentTypeRepublish : ko.observable(null),
            isPinnedTagsFormVisible:ko.observable(false),
            isFeaturedTagActive:ko.observable(false),
            updateLatestRepublishDateIsChecked : ko.observable(false),
            latestRepublishId : ko.observable(''),
            template: ko.observable(""),
            isFeaturedImageHidden: ko.observable(false),
            isCommentsDisabled: ko.observable(false),
            isCommentsPaused: ko.observable(false),
            isRatingEnabled: ko.observable(false),
            isReadNextDisabled: ko.observable(false),
            isSidebarHidden: ko.observable(false),
            isExcerptHidden: ko.observable(false),
            isDisplayCardQuickLinksShown: ko.observable(false),
            isDisplayCardQuickLinksMobileShown: ko.observable(false),
            socialTagLine: ko.observable(),
            sessionExpiredOnSaveRecovery: ko.observable(false),
            lastSaveRecoveryAttempt: ko.observable(""),
            plagiarismStatus: ko.observable(null),
            isPublishingControl: ko.observable(false),
            isGlobalLockEnabled : ko.observable(false),
            isFeaturedVideoActive: ko.observable(false),
            isFeaturedEmbedActive: ko.observable(false),
            isFeaturedImageActive: ko.observable(true),
            featuredVideo : ko.observable(null),
            featuredEmbed : ko.observable(null),
            featuredSectionValue : ko.observable("featuredImage"),
            chosenFeaturedSectionValue : ko.observable("featuredImage"),
            autoCategorizationGenerationAttemptsRemaining : ko.observable(4),
            republishRecoveryDate: ko.observable(''),
            republishRecoveryStatus: ko.observable(''),
            republishRecoveryAuthor: ko.observable(''),
            republishRecoverySrEditor: ko.observable(''),
            republishRecoveryJrEditor: ko.observable(''),
            republishRecoveryPaymentCategory: ko.observable(''),
            republishRecoveryAuthorAmount: ko.observable(''),
            republishRecoveryAuthorPercentage: ko.observable(''),
            republishRecoveryEditorPercentage: ko.observable(''),
            isSandboxActive: ko.observable(false),
            isRepublishActive: ko.observable(false),
            isSubContent: ko.observable(false),
            newsletterSubject: ko.observable(""),
            newsletterPreviewText: ko.observable(""),
            newsletterSendToSelf: ko.observable(false),
            newsletterRecipientsEmails: ko.observable(""),
            newsletterMailingLists: ko.observableArray([]),
            selectedMailingLists: ko.observableArray([]),
            newsletterEmailErrors: ko.observableArray([]),
            sensaiPromptContent: ko.observableArray([]),
            articleReviewComments: ko.observable(""),
            articleHistoricalReviewComments: ko.observable([]),
            hasNewFeedback: ko.observable(false),
            showSubContent: ko.observable(true),
            showFeaturedImage: ko.observable(true),
            showSelectFeaturedVideo: ko.observable(true),
            showSelectFeaturedEmbed: ko.observable(true),
            showSEO: ko.observable(true),
            featuredVideoTitle: ko.observable(""),
            showFeaturedVideoTitle: ko.observable(false),
            featuredVideoDescription: ko.observable(""),
            showFeaturedVideoDescription: ko.observable(false),
            dateLastPreview: ko.observable(null),
            articleTypesWithFAQ: ko.observable([]),
            showContent: ko.observable(true),
            showSponsoredDisclaimer: ko.observable(true),
            showDevelopingStoryDisclaimer: ko.observable(true),
            showTableOfContents: ko.observable(true),
            showQuickShopLinks: ko.observable(true),
            isTitleDisabled: ko.observable(false),
            defaultThreadsImage: ko.observable(null),
            isAdmin: ko.observable(false),
            isPromptAuthorVisible: ko.observable(true),
            isExcerptVisible: ko.observable(true),
            previousIdPublishStatus: ko.observable(),
            sensaiCoverageScore : ko.observable(null),
            sensaiRuleScore : ko.observable(null),
            eeatExperienceScore: ko.observable(null),
            eeatExpertiseScore: ko.observable(null),
            eeatAuthorityScore: ko.observable(null),
            eeatTrustScore: ko.observable(null),
            eeatExperienceExplanation: ko.observable(null),
            eeatExpertiseExplanation: ko.observable(null),
            eeatAuthorityExplanation: ko.observable(null),
            eeatTrustExplanation: ko.observable(null),
            eeatRecalculateLoading: ko.observable(false),
            sensaiRulePointThreshold: ko.observable(null),
            showPinnedTags: ko.observable(true),
            republishIsUnderEmbargo: ko.observable(false),
            userPicture: ko.observable(""),
            roleName:  ko.observable(""),
            contentTypeName: ko.observable(""),
            monthName:  ko.observable(""),
            isSessionTrackerVisible: ko.observable(false),
            isUserHasTier2Rates: ko.observable(false),
            articleCount: ko.observable(0),
            sessionsPerArticle: ko.observable(0),
            articleGoal: ko.observable(0),
            articleGoalProgressPercentage: ko.observable(0),
            sessionGoalProgressPercentage: ko.observable(0),
            tier2SessionGoalProgressPercentage: ko.observable(0),
            sessionsPerArticleTarget: ko.observable(0),
            tier2SessionsPerArticleTarget: ko.observable(0),
            tier1Amount: ko.observable(0),
            tier2Amount: ko.observable(0),
            outputTransactionsTotal: ko.observable(0),
            brandSessionTarget: ko.observable(null),
            brandProgressPercentage: ko.observable(0),
            contentTypeProgressPercentage: ko.observable(0),
            brandContentTypeSessionTarget: ko.observable(null),
            selectedView:ko.observable("default"),
            isSensaiVaultVisible: ko.observable(false),
            sensaiVaultGeneratedHtml: ko.observable(""),
            // ----- SENSAI CHAT -----
            chatHistory: ko.observableArray([]),
            isChatDisabled: ko.observable(false),
            summaryReturned: ko.observable(false),
            similarArticlesReturned: ko.observable(false),
            systemPrompt: ko.observable(""),
            userQuery: ko.observable(""),
            temperature: ko.observable(0.5),
            summary: ko.observable(""),
            sensaiArticles: ko.observable(""),
            sensaiImagePickerTarget: ko.observable(null),
            sessionId: ko.observable(""),
            valnetImageData: ko.observable([]),
            titleAnalysis: ko.observable(""),
            isAiAnalyzing: ko.observable(false),
            haveAiChatHistory: ko.observable(false),
            aiPromptSelectedTextIncluded: ko.observable(true),
            aiPromptSelectedTextIncludedEnabled: ko.observable(false),
            aiPromptBrandContextIncluded: ko.observable(false),
            aiPromptBrandContextIncludedEnabled: ko.observable(false),
            aiPromptAuthorToneIncluded: ko.observable(false),
            aiPromptAuthorToneIncludedEnabled: ko.observable(false),
            aiPromptArticleIncluded: ko.observable(true),
            isTitleAnalysisVisible: ko.observable(true),
            isScheduleDateVisible: ko.observable(false),
            isFeaturedToolbarVisible: ko.observable(false),
            isAiFaqEnabled: ko.observable(true),
            aiFaqs: ko.observableArray([]),
            showAiFaq: ko.observable(true),
            isAiThreadSummaryEnabled: ko.observable(isAiThreadSummaryEnabled),
            aiThreadSummaryFeatureAvailable: ko.observable(false),
            aiThreadSummary: ko.observable(""),
            parsedAiThreadSummary: ko.observable(""),
            showAiThreadSummary: ko.observable(true),
            isPortraitHeaderEnabled : ko.observable(false),
            isPortraitHeader : ko.observable(false),

            // New Article Re-design Observables
            articleDetailsModal: ko.observable(false),
            articleDetailsModalType: ko.observable(""),
            selectedArticleEditmode: ko.observable(""),
            primaryTagName: ko.observable(""),
            primaryCategoryName: ko.observable(""),
            previousDetailsModal: ko.observable(""),
            featuredThumbnailImage: ko.observable(""),
            tagReviewedByArticle: ko.observable(""),
            categoryLabel: ko.observable(""),
            tagLabel: ko.observable(""),
            reviewTagLabel: ko.observable(""),
            featuredType: ko.observable(""),
            //newsetter promotion in widget tab
            showNewsletterPromotion: ko.observable(false),
            isAiNewsletterPromotionEnabled: ko.observable(false),
            aiNewsletterPromotionTitle: ko.observable(""),
            aiNewsletterPromotionExcerpt: ko.observable(""),
            isNewsletterPromotionContentEmpty: ko.pureComputed(() => {
                const _vm = this.getTemplateViewModel();
                const title = _vm.aiNewsletterPromotionTitle() && _vm.aiNewsletterPromotionTitle().trim() !== "";
                const excerpt = _vm.aiNewsletterPromotionExcerpt() && _vm.aiNewsletterPromotionExcerpt().trim() !== "";
                return !(title && excerpt);
            }),
            showDealsCategoryPromotion: ko.observable(false),
            isAiDealsCategoryPromotionEnabled: ko.observable(false),
            aiDealsCategoryPromotionTitle: ko.observable(""),
            aiDealsCategoryPromotionExcerpt: ko.observable(""),
            aiDealsCategoryPromotionListingPageId: ko.observable(""),
            isDealsCategoryPromotionContentEmpty:  ko.pureComputed(() => {
                const _vm = this.getTemplateViewModel();
                const title = _vm.aiDealsCategoryPromotionTitle() && _vm.aiDealsCategoryPromotionTitle().trim() !== "";
                const excerpt = _vm.aiDealsCategoryPromotionExcerpt() && _vm.aiDealsCategoryPromotionExcerpt().trim() !== "";
                const listingPage = _vm.aiDealsCategoryPromotionListingPageId && _vm.aiDealsCategoryPromotionListingPageId();
                return !(title && excerpt && listingPage);
            }),
            isFAQSectionVisible: function(data, event) {
                return this.articleTypesWithFAQ().indexOf(this.idTemplate()) != -1;
            },
            onClickGenerateArticleFaqs: function (data, event) {
                self.onClickGenerateArticleFaqs(data, event);
            },
            onClickGenerateThreadSummary: function (data, event) {
                self.onClickGenerateThreadSummary(data, event);
            },
            onClickSaveAiSummaries: function (data, event) {
                self.caller.saveArticleAiSummaries();
            },
            onShowScheduleDate: function (data, event) {
               self.showscheduleDate();

            },
            quizQuestions: ko.observableArray([]),
            isQuizContentInvalid: ko.pureComputed(() => {
                const _vm = this.getTemplateViewModel();
                const quizQuestions = _vm.quizQuestions && typeof _vm.quizQuestions === "function" ? _vm.quizQuestions() : [];
                if (!quizQuestions || quizQuestions.length === 0) {
                    return false;
                }
                return quizQuestions.some(question => {
                    if (question && typeof question.isQuestionValid === "function") {
                        return !ko.unwrap(question.isQuestionValid);
                    }

                    let qVal = "";
                    let rVal = "";
                    let opts: any[] = [];

                    if (question) {
                        if (typeof question.question === "function") {
                            qVal = question.question();
                        } else if (typeof question.question === "string") {
                            qVal = question.question;
                        }

                        if (typeof question.rationale === "function") {
                            rVal = question.rationale();
                        } else if (typeof question.rationale === "string") {
                            rVal = question.rationale;
                        }

                        if (typeof question.options === "function") {
                            opts = question.options();
                        } else if (Array.isArray(question.options)) {
                            opts = question.options;
                        }
                    }

                    if ((qVal || "").trim() === "" || (rVal || "").trim() === "" || !opts || opts.length === 0) {
                        return true;
                    }

                    return !opts.every(option => {
                        let textVal = "";
                        if (option) {
                            if (typeof option.text === "function") {
                                textVal = option.text();
                            } else if (typeof option.text === "string") {
                                textVal = option.text;
                            }
                        }
                        return (textVal || "").trim() !== "";
                    });
                });
            }),
            onClickToggleAllQuizQuestions: function () {
                self.toggleAllQuizQuestions();
            },
            onToggleQuizDynamicPlacement: function (data, event) {
                const checked = !!(event && event.target ? event.target.checked : this.quizIsDynamicPlacement());
                self.setQuizDynamicPlacementAttr(checked);
                return true;
            },
            quizTitle: ko.observable(""),
            quizIsDynamicPlacement: ko.observable(false),
            quizIsGenerating: ko.observable(false),
            aiSettings: ko.observable({}),
            onClickAddQuiz: function () {
                self.addQuizQuestion();
            },
            onClickAddQuizOption: function (question) {
                self.addQuizOption(question);
            },
            onClickRemoveQuizOption: function (question, optionIndex) {
                self.removeQuizOption(question, optionIndex);
            },
            onClickRemoveQuizQuestion: function (questionIndex) {
                self.removeQuizQuestion(questionIndex);
            },
            onClickSaveQuiz: function () {
                self.saveQuiz();
            },
            onClickQuickPrompt: function (data, event) {
                self.onClickQuickPrompt(data, event);
            },
            onClickSimilarArticles: function (data, event) {
                self.initiateSensaiChat(null);
                this.hideHistoryTitle();
                const textarea = document.querySelector('.sensai-vault-user-query textarea') as HTMLTextAreaElement;
                if (textarea) {
                    textarea.style.height = "auto";
                }
                // Add the 'clicked' class to the container
                const container = document.querySelector('.sensai-vault-user-query-container');
                if (container) {
                    container.classList.add('clicked');
                }
            },
            onEnterKey: function (data, event) {
                if (event.keyCode === 13 && !event.shiftKey) {
                    self.initiateSensaiChat(event.target.value);
                    event.target.value = "";
                    this.hideHistoryTitle();
                    event.target.style.height = "auto";
                    // Add the 'clicked' class to the container
                    const container = document.querySelector('.sensai-vault-user-query-container');
                    if (container) {
                        container.classList.add('clicked');
                    }
                    return false;
                }
                return true;
            },
            hideHistoryTitle: function () {
                const historyTitle = document.querySelector('.history-title-above');
                if (historyTitle) {
                    historyTitle.classList.add('hidden');
                } else {
                    console.error("Element with class 'history-title-above' not found.");
                }
            },
            onSensaiFeatureFeedbackClose: function(data, event) {
                self.onSensaiFeatureFeedbackClose(data, event);
            },
            onSensaiFeatureFeedbackConfirm: function(data, event) {
                self.onSensaiFeatureFeedbackConfirm(data, event);
            },
            showArticlePickerSensai: function (data, event) {
                self.showArticlePickerSensai(data, event);
            },
            onClickClearChatHistory: function (data, event) {
                self.clearChatHistory();
            },
            onClickImage: function (data, event) {
                self.onClickImage(data, event);
            },
            onClickNewTab: function (data, event) {
                self.onClickNewTab(data, event);
            },
            editArticleElement: function (data, event) {
                self.editArticleElement(data, event);
            },
            onClickOpenArticleNewTab: function (data, event) {
                self.onClickOpenArticleNewTab(data, event);
            },
            copyPermalink: function (data, event) {
                self.copyPermalink(data, event);
            },
            onClickTag: function (data, event) {
                self.onClickTag(data, event);
            },
            onClickTagOpenInNewTab: function (data, event) {
                self.onClickTagOpenInNewTab(data, event);
            },
            trackerTitle: ko.pureComputed(() => {
                const selectedView = this.getTemplateViewModel().selectedView();
                let title = this.getTemplateViewModel().roleName() + ": " + this.getTemplateViewModel().monthName();
                if (selectedView === 'default') {
                    title = title + " Compensation Tracker";
                } else if (selectedView === 'currency') {
                    title = title + " Compensation Details";
                } else{
                    title = title + " Content Performance";
                }
                return title;
            }),
            explanationText: ko.pureComputed(() => {
                let articleGoalProgressPercentage = this.getTemplateViewModel().articleGoalProgressPercentage();

                let isUserHasTier2Rates = this.getTemplateViewModel().isUserHasTier2Rates();

                let text = "Output target reached, Monthly S/A bonus unlocked!";
                if(articleGoalProgressPercentage < 100){

                    let remainingArticles = this.getTemplateViewModel().articleGoal() - this.getTemplateViewModel().articleCount();

                    text = remainingArticles + " more articles are needed to be eligible for Monthly S/A bonus.";
                }

                let sessionGoalProgressPercentage = this.getTemplateViewModel().sessionGoalProgressPercentage();
                let tier2SessionGoalProgressPercentage = this.getTemplateViewModel().tier2SessionGoalProgressPercentage();
                if(sessionGoalProgressPercentage < 100){

                    let sessionsPerArticleTarget = this.getTemplateViewModel().sessionsPerArticleTarget();

                    let sessionsPerArticle = this.getTemplateViewModel().sessionsPerArticle();

                    let remainingSessions = parseFloat(String(sessionsPerArticleTarget).replace(/,/g, '')) - parseFloat(String(sessionsPerArticle).replace(/,/g, ''));

                    let tier1Amount = this.getTemplateViewModel().tier1Amount();

                    text = text + " Improve S/A by " + remainingSessions.toLocaleString('en-US') + " in order to earn $" + tier1Amount + " bonus payout.";
                }else if(isUserHasTier2Rates && sessionGoalProgressPercentage >= 100 && tier2SessionGoalProgressPercentage < 100){

                    let sessionsPerArticleTarget = this.getTemplateViewModel().tier2SessionsPerArticleTarget();

                    let sessionsPerArticle = this.getTemplateViewModel().sessionsPerArticle();

                    let remainingSessions = parseFloat(String(sessionsPerArticleTarget).replace(/,/g, '')) - parseFloat(String(sessionsPerArticle).replace(/,/g, ''));

                    let tier1Amount = this.getTemplateViewModel().tier1Amount();
                    let tier2Amount = this.getTemplateViewModel().tier2Amount();

                    text = text + " On track for Tier 1 bonus of $" + tier1Amount + ". Improve S/A by " + remainingSessions.toLocaleString('en-US') + " in order to each Tier 2's $" + tier2Amount + " bonus!";
                }else if(!isUserHasTier2Rates && sessionGoalProgressPercentage >= 100){

                    let tier1Amount = this.getTemplateViewModel().tier1Amount();

                    text = text + " On track for Tier 1 bonus of $" + tier1Amount + ". Maintain this S/A through the month to earn it.";
                }else if(isUserHasTier2Rates && tier2SessionGoalProgressPercentage >= 100){

                    let tier2Amount = this.getTemplateViewModel().tier2Amount();

                    text = text + " Maxxed out for Tier 2 bonus of $" + tier2Amount + ". Maintain this S/A through the month to earn it.";
                }

                return text;
            }),
            onClickSelectView: function (data, event) {
                return self.onClickSelectView(event);
            },
            checkIfReviewItemsNeedAnUpdate: function ( value, data, event ) {
                self.checkIfReviewItemsNeedAnUpdate(value);
            },
            onClickFeaturedTag: function (value, data,event){
                self.onClickFeaturedTag(value);
            },
            onChangeTemplate: function (data, event) {
                let action = self.onChangeTemplate(data, event);
                if (action === false) {
                    event.preventDefault();
                } else {
                    let permlinkOriginal = self.getTemplateViewModel().permalink();
                    let permlinkNew = self.prefixPermalink(permlinkOriginal, event.target.value);
                    self.getTemplateViewModel().permalink(permlinkNew);
                }
            },
            onChangeTemplateLayout: function (data, event) {
                let idTemplateLayoutPrevious = self.getTemplateViewModel().idTemplateLayoutPrevious();
                let action = self.onChangeTemplateLayout(data, event);
                let idTemplateLayout = self.getTemplateViewModel().idTemplateLayout();
                self.getTemplateViewModel().isPortraitHeaderEnabled(idTemplateLayout === 36)
                idTemplateLayout !== 36 && self.getTemplateViewModel().isPortraitHeader(false);

                if (action === false) {
                    self.setIdTemplateLayout(idTemplateLayoutPrevious);
                    event.preventDefault();
                } else {
                    self.setIdTemplateLayoutPrevious(idTemplateLayout);
                }
            },
            onClickCancel: function (data, event) {
                self.onClickCancel();
            },
            onClickSave: function (data, event) {
                self.onClickSave();
            },
            onClickSaveAndStay: function (data, event) {
                self.onClickSaveAndStay();
            },
            onClickSaveAndPreview: function (contentType, data, event) {
                self.onClickSaveAndPreview(contentType);
            },
            onClickSaveAndPreviewAMP: function (contentType, data, event) {
                self.onClickSaveAndPreviewAMP(contentType);
            },
            onClickPreviewNoSave: function (contentType, data, event) {
                self.onClickPreviewNoSave(contentType);
            },
            onClickMobilePreviewNoSave: function (contentType, data, event) {
                self.onClickMobilePreviewNoSave(contentType);
            },
            onClickDeleteSandbox: function (data, event) {
                self.onClickDeleteSandbox();
            },
            onClickDeleteRepublish: function (data, event) {
                self.onClickDeleteRepublish();
            },
            onClickRepublishCreateAndUpdate: function (data, event) {
                self.onClickRepublishCreateAndUpdate();
            },
            onClickPreviewAMPNoSave: function (contentType, data, event) {
                self.onClickPreviewAMPNoSave(contentType);
            },
            onClickViewOnSite: function (data, event) {
                self.onClickViewOnSite();
            },
            onClickViewOnSiteAMP: function (data, event) {
                self.onClickViewOnSiteAMP();
            },
            onReviewItemReversalConfirm: function (data, event) {
                self.onReviewItemReversalConfirm();
            },
            onReviewItemUpdateCancel: function (data, event) {
                self.onReviewItemUpdateCancel();
            },
            onClickAddMedia: function (data, event) {
                self.onClickAddMedia();
            },
            onClickSelectProductImages: function (data, event) {
                self.onClickSelectProductImages();
            },
            onClickUsePinnedTagAsFeaturedImage:function (data,event){
                self.onClickUsePinnedTagAsFeaturedImage(data);
            },
            onClickAddTagImage: function (data, event) {
                self.onClickAddTagImage();
            },
            onClickEditTagImage: function (data, event) {
                self.onClickEditTagImage();
            },
            onClickViewTagImage: function (data, event) {
                self.onClickViewTagImage();
            },
            onClickFeaturedTagEdit: function(data,event){
                self.onClickFeaturedTagEdit();
            },
            onClickFeaturedTagDelete: function(data,event){
                self.onClickFeaturedTagDelete();
            },
            onClickCloseTagImage: function (data, event) {
                self.onClickCloseTagImage();
            },
            onClickToggleAssistant: function (data, event) {
                const wFormArticle = document.querySelector(".w-form-article");
                if (wFormArticle.classList.contains("is-sidebar-closed")) {
                    wFormArticle.classList.remove("is-sidebar-closed");
                } else {
                    wFormArticle.classList.remove("is-sidebar-expanded");
                    wFormArticle.classList.add("is-sidebar-closed");
                }
            },
            onClickToggleAssistantExpand: function (data, event) {
                const wFormArticle = document.querySelector(".w-form-article");
                if (wFormArticle.classList.contains("is-sidebar-expanded")) {
                    wFormArticle.classList.remove("is-sidebar-expanded");
                } else {
                    wFormArticle.classList.add("is-sidebar-expanded");
                }
            },

            onClickToggleAssistantFeedback: function (data, event) {
                let visible = self.sensaiFeatureFeedback.isVisible();
                if (visible) {
                    self.sensaiFeatureFeedback.hide();
                } else {
                    self.sensaiFeatureFeedback.show();
                }
            },

            onClickAnalysisSettings: function (data, event) {
                const settingsEl = document.getElementById("title-analysis-settings");
                if (!settingsEl) return;

                settingsEl.classList.toggle("is-visible");

                 const settingsB = document.getElementById("title-analysis-settings-button");
                if (!settingsB) return;
                settingsB.classList.toggle("i-settings");
                settingsB.classList.toggle("i-recat-log");


            },

            onClickRevertSandbox: function (data, event) {
                self.onClickRevertSandbox();
            },
            // onClickCopyContent: function (data, event) {
            //     self.onClickCopyContent();
            // },
            onClickAddFaq: function (data, event) {
                self.onClickAddFaq();
            },
            getPinnedTag: function(data,event){
                return self.getPinnedTag();
            },
            getFeaturedTag: function(data,event){
                return self.getFeaturedTag();
            },
            onClickEditFaq: function (value, data, event) {
                self.onClickEditFaq(value);
            },
            onClickDeleteFaq: function (data, event) {
                self.onClickDeleteFaq(data);
            },
            onClickClosePermalinkHistoryModal: function (data, event) {
                self.onClickClosePermalinkHistoryModal(false);
            },
            onClickShowPermalinkHistoryModal: function (data, event) {
                self.onClickShowPermalinkHistoryModal(true);
            },
            onClickCloseEmbedPopup: function (data, event) {
                self.onClickCloseEmbedPopup();
            },
            onClickCloseSensaiVaultPopup: function (data, event) {
                self.onClickCloseSensaiVaultPopup();
            },
            onClickToggleEmbedTypes: function (data, event) {
                self.onClickToggleEmbedTypes();
            },
            onClickAddEmbed:function (data, event) {
                self.onClickAddEmbed();
            },
            onChangeEmbedInput:function (data, event) {
                self.onChangeEmbedInput();
            },
            onClickDeleteSelectedCategory: function (data, event) {
                self.onClickDeleteSelectedCategory(data);
            },
            onClickDeleteSelectedTag: function (data, event) {
                self.onClickDeleteSelectedTag(data);
            },
            onClickSaveFaq: function (data, event) {
                self.onClickSaveFaq();
            },
            onClickCancelFaq: function (data, event) {
                self.onClickCancelFaq();
            },
            onScroll: function (data, event) {
                self.onScrollSaveBoxSticky(data, event);
            },
            onClickRevertRecovery: function (data, event) {
                self.onClickRevertRecovery();
            },
            onClickRevertSandboxRecovery: function (data, event) {
                self.onClickRevertSandboxRecovery();
            },
            onClickRevertRepublishRecovery: function (data, event) {
                self.onClickRevertRepublishRecovery();
            },
            onClickRevertRevision: function (data, event) {
                self.onClickRevertRevision();
            },
            onClickRevision: function (data, value) {
                self.onClickRevision(data, value);
            },
            onClickRecoveryTab: function (data, event) {
                self.setSelectedRecoveryTab(Recoverable.CONTENT);
            },
            onClickSandboxRecoveryTab: function (data, event) {
                self.setSelectedRecoveryTab(Recoverable.SANDBOX);
            },
            onClickRepublishRecoveryTab: function (data, event) {
                self.setSelectedRecoveryTab(Recoverable.REPUBLISH);
            },
            onFocusOutTitle: function (data, event) {
                self.onFocusOutTitle(event);
            },
            onFocusOutExcerpt: function (data, event) {
                self.onFocusOutExcerpt(event);
            },
            onFocusOutPermalink: function (data, event) {
                self.onFocusOutPermalink(event);
            },
            onFocusOutPrompt: function (data, event) {
                self.onFocusOutPrompt(event);
            },
            onClickTemplateTab: function (value, data, event) {
                self.onClickTemplateTab(value, event);
            },
            onClickSegmentTab: function (value) {
                self.onClickSegmentTab(value);
            },
            onClickTab: function (value, data, event) {
                self.onClickTab(value);
            },
            onClickOpenSandboxOrRepublish: function (value, data, event) {
                self.onClickOpenSandboxOrRepublish(value);
            },
            onCancelTakeOver: function (value, data, event) {
                self.onCancelTakeOver();
            },
            onTakeOver: function (value, data, event) {
                self.onTakeOver();
            },
            onKickout: function (value, data, event) {
                self.onKickout();
            },
            closeNotice: function(value, data, event) {
                self.closeNotice();
            },
            onClickDeleteScheduledRepublish: function (value, data, event) {
                self.deleteScheduledRepublish();
            },
            onChangeArticleStatus: function (data, event) {
                self.onChangeArticleStatus(data);
            },
            onChangePublishStatus: function (data, event) {
                self.onChangePublishStatus(data);
            },
            onClickAddProduct: function (value, data, event) {
                self.showReviewItemForm();
            },
            onClickAddReviewItem: function (value, data, event) {
                self.onClickAddReviewItem();
            },
            onClickCancelSaveReviewItem: function (value, data, event) {
                self.onClickCancelSaveReviewItem();
            },
            onClickAddReviewItemVideo: function (value, data, event) {
                self.onClickAddReviewItemVideo();
            },
            onClickDeleteReviewItemVideo: function (value, data, event) {
                self.onClickDeleteReviewItemVideo(data, value);
            },
            onClickAddAffiliateLink: function (value, data, event) {
                self.onClickAddAffiliateLink();
            },

            onClickAddAiAgent: function (value, data, event) {
                self.onClickAddAiAgent();
            },

            onClickRemoveAiAgent: function (value, data, event) {
                self.onClickRemoveAiAgent(data, value);
            },

            collapseGiveawaySection: function (value, data, event) {
                self.collapseGiveawaySection();
            },

            onClickDeleteAffiliateLinks: function (value, data, event) {
                self.onClickDeleteAffiliateLinks(data, value);
            },
            onClickAddSpecification: function (value, data, event) {
                self.onClickAddSpecification();
            },
            onClickDeleteSpecification: function (value, data, event) {
                self.onClickDeleteSpecification(data, value);
            },

            onClickDeleteAddedSpecification: function (value, data, event) {
                self.onClickDeleteAddedSpecification(data, value);
            },
            onClickAddKeyFeature: function (value, data, event) {
                self.onClickAddKeyFeature();
            },
            onClickDeleteKeyFeature: function (value, data, event) {
                self.onClickDeleteKeyFeature(value);
            },
            onClickAddPro: function (value, data, event) {
                self.onClickAddPro();
            },
            onClickDeletePro: function (value, data, event) {
                self.onClickDeletePro(data, value);
            },
            onClickAddCon: function (value, data, event) {
                self.onClickAddCon();
            },
            onClickDeleteCon: function (value, data, event) {
                self.onClickDeleteCon(data, value);
            },
            onClickDeleteProductImage: function (value, data, event) {
                self.onClickDeleteProductImage(data);
            },
            onClickConfirmFaqDelete: function (value, data, event) {
                self.onClickConfirmFaqDelete();
            },
            onClickCancelFaqDelete: function (value, data, event) {
                self.onClickCancelFaqDelete();
            },
            onClickCompareRevisionUpdate: function (data) {
                self.onClickCompareRevisionUpdate(data);
            },
            onClickCompareRevision: function (data, event) {
                self.onClickCompareRevision();
            },
            onClickCloseComparePopUp: function (value, data, event) {
                self.onClickCloseComparePopUp();
            },
            onClickCompareRecovery: function (type, data){
                self.onClickCompareRecovery(type);
            },
            onClickCompareSandbox: function (type, data){
                self.onClickCompareSandbox(type);
            },
            onClickShowRevision: function (revision, data) {
                self.onClickShowRevision(revision)
            },
            valueSwitch: function (value, data){
                self.valueSwitch(value, data);
            },
            onChangepaymentTypeRepublish: function (data, event) {
                self.onChangepaymentTypeRepublish(data, event)
            },
            onClickTogglePinnedTagsForm: function (value, data, event) {
                self.onClickTogglePinnedTagsForm(value);
            },
            onChangeFeaturedSection: function () {
                self.onChangeFeaturedSection();
            },
            onChangeUpdateLatestRepublishDate : function (data) {
                self.onChangeUpdateLatestRepublishDate(data)
            },
            onClickDisplayOptionToggle : function(data) {
                self.onClickDisplayOptionToggle();
            },
            onClickConfirmDialog : function (idElement) {
                self.onClickConfirmDialog(idElement)
            },
            onClickContinueEditing : function (idElement) {
                self.onClickContinueEditing()
            },
            onClickSaveAnyway : function (idElement) {
                self.onClickSaveAnyway()
            },
            onClickAutoCategorize: function (data, event) {
                self.onClickAutoCategorize();
            },
            onClickAutoTag: function (data, event) {
                self.onClickAutoTag();
            },
            onClickAnalyzeTitle: function (data, event) {
                document.getElementById("title-analysis-window").classList.add("is-visible");
                document.getElementById("title-analysis-window").classList.remove("is-collapsed");
                this.isAiAnalyzing(true);
                self.toggleChatSuggestions(true);
                self.onClickAnalyzeTitle(data);

                const settingsEl = document.getElementById("title-analysis-settings");
                if (!settingsEl) return;

                if (settingsEl.classList.contains("is-visible")) {
                    settingsEl.classList.remove("is-visible");

                     const settingsB = document.getElementById("title-analysis-settings-button");
                    if (!settingsB) return;
                    if (!settingsB.classList.contains("i-settings")) {
                        settingsB.classList.add("i-settings");
                    }
                    settingsB.classList.remove("i-recat-log");
                }
            },
            onClickAnalyzeImage: function (data, event) {

                document.getElementById("title-analysis-window").classList.add("is-visible");
                document.getElementById("title-analysis-window").classList.remove("is-collapsed");
                this.isAiAnalyzing(true);
                self.toggleChatSuggestions(true);
                self.onClickAnalyzeImage();
            },
            onClickAnalyzeSeo: function (data, event) {

                document.getElementById("title-analysis-window").classList.add("is-visible");
                document.getElementById("title-analysis-window").classList.remove("is-collapsed");
                this.isAiAnalyzing(true);
                self.toggleChatSuggestions(true);
                self.onClickAnalyzeSeo();
            },
              onClickAnalyzeProofread: function (data, event) {

                document.getElementById("title-analysis-window").classList.add("is-visible");
                document.getElementById("title-analysis-window").classList.remove("is-collapsed");
                this.isAiAnalyzing(true);
                self.toggleChatSuggestions(true);
                self.onClickAnalyzeProofread();
            },     onClickAnalyzeFactCheck: function (data, event) {

                document.getElementById("title-analysis-window").classList.add("is-visible");
                document.getElementById("title-analysis-window").classList.remove("is-collapsed");
                this.isAiAnalyzing(true);
                self.toggleChatSuggestions(true);
                self.onClickAnalyzeFactCheck();
            },
            onClickAnalyzeInterlinking: function (data, event) {

                document.getElementById("title-analysis-window").classList.add("is-visible");
                document.getElementById("title-analysis-window").classList.remove("is-collapsed");
                this.isAiAnalyzing(true);
                self.toggleChatSuggestions(true);
                self.onClickAnalyzeInterlinking();
            },
            onClickAnalyzeInterlinkingNewModel: function (data, event) {

                document.getElementById("title-analysis-window").classList.add("is-visible");
                document.getElementById("title-analysis-window").classList.remove("is-collapsed");
                this.isAiAnalyzing(true);
                self.toggleChatSuggestions(true);
                self.onClickAnalyzeInterlinkingNewModel();
            },
            onClickAnalyzeSocialMedia: function (data, event) {

                document.getElementById("title-analysis-window").classList.add("is-visible");
                document.getElementById("title-analysis-window").classList.remove("is-collapsed");
                this.isAiAnalyzing(true);
                self.toggleChatSuggestions(true);
                self.onClickAnalyzeSocialMedia();

            },
            onClickAnalyzeWidgets: function (data, event) {

                document.getElementById("title-analysis-window").classList.add("is-visible");
                document.getElementById("title-analysis-window").classList.remove("is-collapsed");
                this.isAiAnalyzing(true);
                self.toggleChatSuggestions(true);
                self.onClickAnalyzeWidgets();

            },
            onClickAnalyzeThread: function (data, event) {

                document.getElementById("title-analysis-window").classList.add("is-visible");
                document.getElementById("title-analysis-window").classList.remove("is-collapsed");
                this.isAiAnalyzing(true);
                self.toggleChatSuggestions(true);
                self.onClickAnalyzeThread();

            },
            onClickAnalyzeCustomPrompt: function (data, event) {


                this.isAiAnalyzing(true);
                self.toggleChatSuggestions(true);
                self.onClickAnalyzeCustomPrompt();

            },
            onTextareaKeyup: function (data, event) {
               if (event.key === 'Enter' && !event.shiftKey) {
                    event.preventDefault();
                    this.isAiAnalyzing(true);
                    self.toggleChatSuggestions(true);
                    const currentValue = event.target.value;
                    self.getTemplateViewModel().customPrompt(currentValue); // force-set, if needed

                    self.onClickAnalyzeCustomPrompt();
                }
                else{
                    const currentValue = event.target.value;
                    self.getTemplateViewModel().customPrompt(currentValue); // force-set, if needed
                }
                return true;

            }
            , toggleChatSuggestions: function (data, event) {
                self.toggleChatSuggestions();
            },
            onClickAnalyzeExcerpt: function (data, event) {
                document.getElementById("title-analysis-window").classList.add("is-visible");
                document.getElementById("title-analysis-window").classList.remove("is-collapsed");
                this.isAiAnalyzing(true);
                self.toggleChatSuggestions(true);
                self.onClickAnalyzeExcerpt();
            },
            toggleTitleAnalysis: function () {
                 document.getElementById("title-analysis-window").classList.toggle("is-visible");
            },
            toggleArticleSidebar: function () {
                 if (document.getElementById("title-analysis-window").classList.contains("is-visible")) {
                    document.getElementById("title-analysis-window").classList.remove("is-visible");
                 }
            },

            onIntentChange: function (data) {
                self.onIntentChange(data)
            },

            onSyndicatedChange: function (data) {
                self.onSyndicatedChange(data)
            },

            onContentTypeChange : function(data) {
                self.onContentTypeChange(data);
            },
            resizeTextarea: function (data, event) {
                const el = event.target;
                el.style.height = '';
                const neededHeight = el.scrollHeight;
                el.style.height = neededHeight + 'px';
            },
            onTitleCharCountInput: function (data, event) {
                const target = event.target as HTMLTextAreaElement | HTMLInputElement;
                self.getTemplateViewModel().titleCharCount(target && target.value !== undefined ? target.value.length : 0);
            },
            onClickSendNewsletter : function (idElement) {
                self.onClickSendNewsletter()
            },
            handleDragAndDrop: function(element, currentObservableArray, childrenSelector, options) { self.handleDragAndDrop(element, currentObservableArray, childrenSelector, options); },
            onClickSelectFeaturedVideo : function () {self.onClickSelectFeaturedVideo()},
            onClickSelectFeaturedEmbed : function () {self.onClickSelectFeaturedEmbed()},
            onClickSelectFeaturedEmbedImage : function () {self.onClickSelectFeaturedEmbedImage()},
            onClickPreviewFeaturedVideo : function () {self.onClickPreviewFeaturedVideo()},
            onClickEditFeaturedVideo : function () {self.onClickEditFeaturedVideo()},
            onClickRemoveFeaturedVideo : function () {self.onClickRemoveFeaturedVideo()},
            onClickRemoveFeaturedEmbed : function () {self.onClickRemoveFeaturedEmbed()},
            onClickEditFeaturedEmbed : function () {self.onClickEditFeaturedEmbed()},
            onClickClearFeaturedEmbed : function () {self.onClickClearFeaturedEmbed()},
            onClickEditFeaturedTag : function () {self.onClickEditFeaturedTag()},
            onClickClearFeaturedTag : function () {self.onClickClearFeaturedTag()},
            onClickEditFeaturedImage : function () {self.onClickEditFeaturedImage()},
            onClickClearFeaturedImage : function () {self.onClickClearFeaturedImage()},
            onClickRemoveThumbnailImage : function () {self.onClickRemoveThumbnailImage()},
            onClickOpenCropSelector : function (target) {self.onClickOpenCropSelector(target)},
            onClickApplyCropSelector : function () {self.onClickApplyCropSelector()},
            onClickCancelCropSelector : function () {self.onClickCancelCropSelector()},
            onClickResetCropSelector : function () {self.onClickResetCropSelector()},
            onMouseDownCropSelectorFrame : function (data: any, event: any) {return self.onMouseDownCropSelectorFrame(data, event)},
            onClickCreateRepublishAndUpdateArticle : function () {self.onClickCreateRepublishAndUpdateArticle()},
            onClickGenerateArticleSummaries : function () {self.onClickGenerateArticleSummaries()},
            onClickGenerateArticleQuiz : function () {self.onClickGenerateArticleQuiz()},
            handleDragStart: function(event, index) { self.caller.handleDragStart(event, index); },
            handleDragOver: function(event) { self.caller.handleDragOver(event); },
            handleDrop: function(event, observableArray) { self.caller.handleDrop(event, observableArray); },
            getSourceNewsDatetime : function (subVm) {self.scrappingExternalSourceNewsUrl(subVm)},
            isCompletedWithAllowedTypes : function () {self.isCompletedWithAllowedTypes()},
            onClickGenerateNewsletterPromotion : function () {self.onClickGenerateNewsletterPromotion()},
            onClickGenerateDealsCategoryPromotion : function () {self.onClickGenerateDealsCategoryPromotion()},
            onClickGenerateAudioReader : function () {self.onClickGenerateAudioReader()},
        }

        const excerptCharCount = ko.computed(() => {
            const excerptValue = vm.excerpt();
            return excerptValue ? excerptValue.length : 0;
        });

        vm.title.subscribe((t: string | null | undefined) => {
            vm.titleCharCount(t ? t.length : 0);
        });

        vm.isSyndicated.subscribe(() => {
            self.onSyndicatedChange(vm);
        });

        const checkIsNewsNowArticle = ko.pureComputed(function () {
            return vm.isNewsNowArticle() === false;
        }, vm);

        const featuredImageIsPortrait = ko.pureComputed(() => {
            const fi = vm.featuredImage();
            if (fi && vm.isFeaturedImageActive()) {
                const { width, height } = fi;
                if (width > 0 && height > 0) {
                    const ratio = width / height;
                    const SIXTEEN_NINE = 16 / 9; // 1.777...
                    return ratio < SIXTEEN_NINE;
                }
            }
            return false;
        });


        const thumbnailImageIsPortrait = ko.pureComputed(() => {
            const thumbnailImage = vm.featuredThumbnailImage();

            if (thumbnailImage) {
                const { width, height } = thumbnailImage;
                if (width > 0 && height > 0) {
                    const ratio = width / height;
                    const PORTRAIT_MAX = 1.776; // < ~16:9 but excludes 6000×3376 case
                    return ratio < PORTRAIT_MAX;
                }
            }

            return false;
        });

        const featuredImageIsLessThan169 = ko.pureComputed(() => {
            const fi = vm.featuredImage();
            if (fi && vm.isFeaturedImageActive()) {
                const { width, height } = fi;
                if (width > 0 && height > 0) {
                    const ratio = width / height;
                    const SIXTEEN_NINE = 16 / 9;   // 1.777...
                    const EPS = 0.02;              // tolerance (~2%)
                    return ratio < SIXTEEN_NINE;
                }
            }
            return false;
        });

        const featuredImageIsLessThan43 = ko.pureComputed(() => {
            const fi = vm.featuredImage();
            if (fi && vm.isFeaturedImageActive()) {
                const { width, height } = fi;
                if (width > 0 && height > 0) {
                    const ratio = width / height;
                    const FOUR_THREE = 4 / 3;   // 1.333...
                    const EPS = 0.02;              // tolerance (~2%)
                    return ratio < FOUR_THREE;
                }
            }
            return false;
        });

        const NEWS_ARTICLE_CONTENT_TYPES = [4, 13, 27]; // News, Niche News, Flash News

        let skipFirstHighlight = false;
        const newsArticle = {
            isNewsArticle: (() => {
                const computed = ko.pureComputed(() => NEWS_ARTICLE_CONTENT_TYPES.indexOf(vm.idContentType()) > -1, vm);
                computed.subscribe((newValue) => {
                    if (newValue === false) {
                        newsArticle.sourceUrl(null);
                        newsArticle.sourceNewsIsFromSelf(false);
                        if(self.sourceNewsDatePicker){
                            self.sourceNewsDatePicker.getTemplateViewModel().singleDatePicker(null)
                        }
                    }else{
                        if(!skipFirstHighlight){skipFirstHighlight = true; return;}
                        self.isNewsArticleHightlighted()
                    }
                });
                return computed;
            })(),
            sourceUrl: ko.observable(null),
            sourceNewsIsFromSelf: ko.observable(false),
            isLoadingSrcTimeBtn: ko.observable(false),
            isSourceUrlValid: ko.pureComputed(() => {
                const url = newsArticle.sourceUrl();
                if (!url) return false;

                if (!/^https?:\/\/.+/i.test(url)) return false;

                try {
                    // tslint:disable-next-line:no-unused-expression
                    new URL(url);
                    return true;
                } catch {
                    return false;
                }
            }),

            onClickSourceNewsIsSelf() {
                this.sourceNewsIsFromSelf(true);
                this.sourceUrl('(SELF)');
                if(self.sourceNewsDatePicker){
                    const datePublished = vm.datePublished() ? vm.datePublished() : null
                    self.sourceNewsDatePicker.getTemplateViewModel().singleDatePicker(datePublished)
                }
            },
            onClickSourceNewsGetTime() {
                const { sourceUrl, isLoadingSrcTimeBtn } = this;
                vm.getSourceNewsDatetime({ sourceUrl, isLoadingSrcTimeBtn });
            },

            // NEW ARTICLE FORM
            onPermalinkFocus: function (data,event) {
                self.onPermalinkFocus(data,event);
            },
            onTitleFocus: function (data,event) {
                self.onTitleFocus(data,event);
            },
            onExcerptFocus: function (data,event) {
                self.onExcerptFocus(data,event);
            },
            onClickOpenThumbnail: function () {
                self.onClickOpenThumbnail();
            },
            onClickSelectFeaturedImage: function () {
                self.onClickSelectFeaturedImage();
            },
            onClickSelectFeaturedTag: function () {
                self.onClickSelectFeaturedTag();
            },
            onClickToggleFeaturedToolbar: function () {
                self.onClickToggleFeaturedToolbar();
            },
            onKeyDownHeader: function (boxName: string, data, event) {

                const vm = self.getTemplateViewModel();
                const target = event.target as HTMLTextAreaElement;

                // let the browser update the input, then sync. Keydown is weird but we need to capture
                // enter value before the input is updated. This is a hack
                // observable doesn't get updated in keydown for some reason, so we update it manually
                setTimeout(() => {
                    const target = event.target as HTMLInputElement | HTMLTextAreaElement;
                    const obs = vm[boxName];
                    if (typeof obs === 'function') {
                        obs(target.value);
                    }
                }, 0);

                if (event.key === 'Escape') {
                    event.preventDefault();
                    self.resetHeaderValues(boxName);
                    target.blur();
                    return;
                }
                if (event.key === 'Tab' || event.key === 'Enter') {
                    event.preventDefault();

                    // Update observable for both Tab + Enter
                    var value = target.value;

                    if (value != null && value !== "") {
                        var finalValue = value;

                        // Only clean for title
                        if (boxName === "title") {
                            finalValue = value.replace(/[\r\n]+/g, " ").trim();
                        }

                        var obs = vm[boxName];

                        switch (boxName) {
                            case "title":
                            case "permalink":
                            case "excerpt":
                                if (typeof obs === "function") {
                                    obs(finalValue);

                                    if (typeof obs.valueHasMutated === "function") {
                                        obs.valueHasMutated();
                                    }
                                }
                                break;
                        }
                    }

                    // Tab gets extra behavior
                    if (event.key === 'Tab') {
                        self.onEnterAndTabBehavior(event);
                    }
                    self.resizeTextareaOnClick();
                    target.blur();
                    return;
                }



                return true;
            },
            onClickConfirmHeader: function (boxName: string, data, event) {
                self.onClickConfirmHeader(boxName);
            },
            onClickCancelHeader: function (boxName: string, data, event) {
                self.onClickCancelHeader(boxName);
            },
            onClickOpenArticleDetailsModal: function (data, focusItem) {
                self.onClickOpenArticleDetailsModal(data, focusItem);
            },
            onClickCloseArticleHeader: function () {
                //self.onClickCloseArticleHeader();
            },
            onClickSaveArticleHeader: function () {
                self.onClickSaveArticleHeader();
            },
            onClickCloseFeaturedItems: function (){
                self.onClickCloseFeaturedItems();
            },
            onClickSaveFeaturedItems: function (){
                self.onClickSaveFeaturedItems();
            },
            onClickCloseTagItems: function (){
                self.onClickCloseTagItems();
            },
            onClickSaveTagItems: function (){
                self.onClickSaveTagItems();
            },
            onClickCloseCategoryItems: function (){
                self.onClickCloseCategoryItems();
            },
            onClickSaveCategoryItems: function (){
                self.onClickSaveCategoryItems();
            }
        };
        let skipInitialChange = true;
        newsArticle.sourceUrl.subscribe((newValue) => {
            if(skipInitialChange){skipInitialChange = false; return;}
            if (newsArticle.sourceUrl() !== '(SELF)' && self.sourceNewsDatePicker) {
                self.sourceNewsDatePicker.getTemplateViewModel().singleDatePicker(null)
            }
        })

        vm.idPublishStatus.subscribe(oldValue => {
            vm.previousIdPublishStatus(oldValue)
        }, null, "beforeChange");

        vm.categoryLabel = ko.pureComputed(() => {
            const name = vm.primaryCategoryName() ? vm.primaryCategoryName().name : 'Categories';
            const count = vm.selectedCategories && vm.selectedCategories() ? vm.selectedCategories().length : 0;
            return count > 0 ? `${name} (${count})` : name;
        });

        vm.tagLabel = ko.pureComputed(() => {
            const tag = vm.primaryTagName ? vm.primaryTagName() : null;
            const name = tag ? tag.name : 'Tags';
            const formattedDataSet = tag ? tag.formattedTagTypeAndDataset || '' : '';
            const count = vm.selectedTags && vm.selectedTags() ? vm.selectedTags().length : 0;

            return count > 0
                ? `${name} ${formattedDataSet} (${count})`
                : name;
        });

        vm.reviewTagLabel = ko.pureComputed(() => {
            const tag = vm.tagReviewedByArticle ? vm.tagReviewedByArticle() : null;
            const name = tag ? tag.name : 'Review Tag';
            const formattedDataSet = tag ? tag.formattedTagTypeAndDataset || '' : '';

            // default single-tag fallback
            return `${name} ${formattedDataSet}`.trim();
        });

        // Single source of truth for featured content type
        // Priority: embed > video > tag > image (image can be used with embed/tag)
        const featuredType = ko.pureComputed(() => {
            if (vm.featuredEmbed && vm.featuredEmbed()) return "embed";
            if (vm.featuredVideo && vm.featuredVideo()) return "video";
            if (vm.featuredTags && vm.featuredTags() && !vm.isFeaturedTagDisabled()) return "tag";
            if (vm.featuredImage && vm.featuredImage()) return "image";
            return null;
        });

        // Check if layout is minimal
        const isMinimalLayout = ko.pureComputed(() => {
            if (!vm.templateLayout) return false;
            const layout = vm.templateLayout();
            if (!layout) return false;
            return layout.toLowerCase() === 'minimal';
        });

        const isReviewLayout = ko.pureComputed(() => {
            if (!vm.templateLayout) return false;
            const layout = vm.templateLayout();
            if (!layout) return false;
            return layout.toLowerCase() === 'review';
        });

        // Template-based permission helpers
        const allowImage = ko.pureComputed(() => {
            const template = parseInt(vm.idTemplate());
            return template === 16 || (template !== 15 && template !== 16);
        });

        const allowVideo = ko.pureComputed(() => {
            const template = parseInt(vm.idTemplate());
            // Video is allowed for template 15, or for non-Video/Thread templates when layout is NOT minimal
            if (template === 15) return true;
            if (template === 16) return false;
            return !isMinimalLayout() && !isReviewLayout();
        });

        const allowEmbed = ko.pureComputed(() => {
            const template = parseInt(vm.idTemplate());
            // Embed is only allowed for non-Video/Thread templates when layout is NOT minimal
            if (template === 15 || template === 16) return false;
            return !isMinimalLayout() && !isReviewLayout();
        });

        const allowTag = ko.pureComputed(() => {
            const template = parseInt(vm.idTemplate());
            // Tag is only allowed for non-Video/Thread templates when layout IS minimal
            if (template === 15 || template === 16) return false;
            return (isMinimalLayout() || isReviewLayout()) && !vm.isFeaturedTagDisabled();
        });

        // Computed observable for Save & Stay button title with platform-specific shortcut
        const saveAndStayButtonTitle = ko.pureComputed(() => {
            const isMac = /Mac|iPhone|iPod|iPad/i.test(navigator.platform) ||
                         /Mac|iPhone|iPod|iPad/i.test(navigator.userAgent);
            const shortcut = isMac ? '⌘ + S' : 'Ctrl + S';
            return 'Save & Stay (' + shortcut + ')';
        });

        const canCropImage = (image: any, slot: string): boolean => {
            if (!image || !image.width || !image.height) {
                return false;
            }

            const outputSize = CROP_OUTPUT_SIZES[slot];
            if (!outputSize) {
                return false;
            }

            const cropBounds = self.calculateCropSelectorBounds(
                Number(image.width),
                Number(image.height),
                outputSize.width,
                outputSize.height
            );

            return cropBounds.maxX > 0 || cropBounds.maxY > 0;
        };

        const isCropPositionEnabledForBrand = (): boolean => {
            const vnAppZone = self.caller ? self.caller.getVnAppZone() : null;

            if (!vnAppZone || !vnAppZone.app || !vnAppZone.app.params) {
                return false;
            }

            return isImageCropPositionEnabled(vnAppZone.app.params.idBrand);
        };

        const canCropFeaturedImage = ko.pureComputed(() => {
            if (!isCropPositionEnabledForBrand()) {
                return false;
            }

            const image = self.imageWidgetForFeaturedImage
                ? self.imageWidgetForFeaturedImage.getTemplateViewModel().image()
                : null;

            return canCropImage(image, 'featuredImage');
        });

        const canCropThumbnailImage = ko.pureComputed(() => {
            if (!isCropPositionEnabledForBrand()) {
                return false;
            }

            const image = self.imageWidgetForThumbnailImage
                ? self.imageWidgetForThumbnailImage.getTemplateViewModel().image()
                : null;

            return canCropImage(image, 'thumbnailImage');
        });

        const cropSelectorOutputSize = ko.pureComputed(() => {
            return CROP_OUTPUT_SIZES[vm.cropSelectorTarget()] || CROP_OUTPUT_SIZES.featuredImage;
        });

        const cropSelectorBounds = ko.pureComputed(() => {
            const image = vm.cropSelectorImage();
            const outputSize = cropSelectorOutputSize();

            return self.calculateCropSelectorBounds(
                Number(image && image.width) || 0,
                Number(image && image.height) || 0,
                outputSize.width,
                outputSize.height
            );
        });

        const cropSelectorTitle = ko.pureComputed(() => {
            return vm.cropSelectorTarget() === 'thumbnailImage'
                ? 'Thumbnail Crop Position'
                : 'Featured Image Crop Position';
        });

        // Rate limited so dragging the frame requests one CDN preview per gesture instead of per mousemove
        const cropSelectorPreviewUrl = ko.pureComputed(() => {
            const outputSize = cropSelectorOutputSize();

            return self.buildCropPreviewUrl(
                vm.cropSelectorImage(),
                {
                    x: Number(vm.cropSelectorX()) || 0,
                    y: Number(vm.cropSelectorY()) || 0,
                },
                outputSize.width,
                outputSize.height
            );
        }).extend({ rateLimit: { timeout: 100, method: 'notifyWhenChangesStop' } });

        // Reserves the preview box at the output aspect so swapping the image does not reflow the panel
        const cropSelectorPreviewStyle = ko.pureComputed(() => {
            const outputSize = cropSelectorOutputSize();

            return {
                aspectRatio: outputSize.width + ' / ' + outputSize.height
            };
        });

        const cropSelectorFrameStyle = ko.pureComputed(() => {
            const image = vm.cropSelectorImage();
            const imageWidth = Number(image && image.width) || 1;
            const imageHeight = Number(image && image.height) || 1;
            const cropBounds = cropSelectorBounds();
            const x = Math.min(Number(vm.cropSelectorX()) || 0, cropBounds.maxX);
            const y = Math.min(Number(vm.cropSelectorY()) || 0, cropBounds.maxY);

            return {
                position: 'absolute',
                left: ((x / imageWidth) * 100) + '%',
                top: ((y / imageHeight) * 100) + '%',
                width: ((cropBounds.cropWidth / imageWidth) * 100) + '%',
                height: ((cropBounds.cropHeight / imageHeight) * 100) + '%',
                border: '2px solid #fff',
                boxSizing: 'border-box',
                boxShadow: '0 0 0 9999px rgba(0, 0, 0, 0.45)',
                cursor: 'move'
            };
        });

        return {...vm, excerptCharCount, checkIsNewsNowArticle, featuredImageIsPortrait, thumbnailImageIsPortrait, featuredImageIsLessThan43, featuredType, isMinimalLayout, allowImage, allowVideo, allowEmbed, allowTag, isReviewLayout, saveAndStayButtonTitle, canCropFeaturedImage, canCropThumbnailImage, cropSelectorTitle, cropSelectorBounds, cropSelectorPreviewUrl, cropSelectorPreviewStyle, cropSelectorFrameStyle, ...newsArticle };
    }

    public initTagPickerCkEditors(): void{

        this.tagPicker.initializeCkEditors();
    }

    public setTitleAnalysis(html){

        let titleAnalysis = this.getTemplateViewModel().titleAnalysis();

        titleAnalysis = titleAnalysis + html;

        this.getTemplateViewModel().titleAnalysis(titleAnalysis);
    }

    protected collapseGiveawaySection() {

        this.getTemplateViewModel().isGiveawaySectionCollapsed(!this.getTemplateViewModel().isGiveawaySectionCollapsed());
    }

    public toggleChatSuggestions(onlyClose = false) {
        

            if (document.getElementById("chat-suggestions").classList.contains("active")) {
                document.getElementById("title-analysis-content").style.height = "calc(100% - 11.5rem)";
                document.getElementById("custom-prompts-content").style.height = "calc(100% - 11.5rem)";
                document.getElementById("empty-title-analysis-content").style.height = "calc(100% - 10.5rem)";
                document.getElementById("chat-suggestions").classList.remove("active");
        } else if (onlyClose === false) {
                document.getElementById("title-analysis-content").style.height = "calc(100% - 38.5rem)";
                document.getElementById("custom-prompts-content").style.height = "calc(100% - 38.5rem)";
                document.getElementById("empty-title-analysis-content").style.height = "calc(100% - 37.5rem)";
                document.getElementById("chat-suggestions").classList.add("active");
            }
    }
    protected showscheduleDate(){
            if(this.getTemplateViewModel().isScheduleDateVisible()){
                    this.getTemplateViewModel().isScheduleDateVisible(false);
                }else{
                     this.getTemplateViewModel().isScheduleDateVisible(true);
                }
    }
    protected onChangepaymentTypeRepublish(data , event){
        let paymentTypeSelected = event.target.value

        if(paymentTypeSelected === "Amount"){
            this.getTemplateViewModel().percentageAuthor(null)
        }

        if(paymentTypeSelected === "Percentage"){
            this.getTemplateViewModel().amountAuthor(null)
        }
    }

    protected valueSwitch(value, data) {

        if (value == "oldValue") {
            data.chosenValue(data.oldValue)
        } else if (value == "newValue" ) {
            data.chosenValue(data.newValue)
        }
    }
    private revertReviewItems(updatedReviewItems, fieldUpdates) {


        let reviewItemsBeforeUpdate = this.getTemplateViewModel().backupReviewItems()

        let tagNameChange, oldTagName, newName, compositeTagName, tagImageUrl, tagTypeName,
            oldValue, newValue, oldLabel, newLabel;
        let valuesChanges, labelChanges, valuesAdded, valuesKept, labelData, fieldId;
        let fieldValueChanges = [];
        let revertedFromRevision = this.getTemplateViewModel().sourceOfReversal() == "revision";

        for (let i=0; i < reviewItemsBeforeUpdate.length; i++ ) {

            tagNameChange = null;
            if (updatedReviewItems[i].tag.id != 0)
            {
                oldTagName = reviewItemsBeforeUpdate[i].tag.name;
                newName = updatedReviewItems[i].tag.name;
                tagTypeName = updatedReviewItems[i].tag.type.name;

                if ( oldTagName != newName) {

                    tagNameChange =  {
                        "oldName": revertedFromRevision ? newName : oldTagName,
                        "newName": revertedFromRevision ? oldTagName : newName } //"updatedReviewItemsIndices": [i]
                }

                valuesChanges = [];
                labelChanges = [];
                valuesAdded = [];
                valuesKept = [];
                compositeTagName = newName + " ( " + updatedReviewItems[i].tag.type.name+" ) ";
                tagImageUrl = updatedReviewItems[i].extraImages.length > 0 ? updatedReviewItems[i].extraImages[0].url: '';
                tagImageUrl = tagImageUrl ? tagImageUrl : '';
                //tagImage

                if (fieldUpdates.hasOwnProperty(compositeTagName) ) {

                    Object.keys(fieldUpdates[compositeTagName]).forEach((label, index, array) =>{

                        labelData = fieldUpdates[compositeTagName][label];
                        oldValue = labelData.oldValue;
                        newValue = labelData.newValue;
                        oldLabel = labelData.oldLabel;
                        newLabel = labelData.newLabel;
                        fieldId = labelData.id;

                        if ( oldLabel && (typeof(oldLabel) != "undefined") && newLabel && typeof (newLabel) != "undefined" && oldLabel != newLabel) {
                            labelChanges.push( ko.observable({
                                fieldId: fieldId,
                                oldLabel: revertedFromRevision ? newLabel : oldLabel,
                                newLabel: revertedFromRevision ? oldLabel : newLabel } ))

                        }

                        if (labelData.existed && labelData.new) {

                            oldValue = (typeof(oldValue) == "undefined" || !oldValue) ? "" : oldValue;
                            newValue = (typeof(newValue) == "undefined" || !newValue) ? "" : newValue;

                            if ( oldValue != newValue ) {
                                valuesChanges.push( ko.observable({
                                    fieldId: fieldId,
                                    label: label,
                                    oldValue: revertedFromRevision ? newValue : oldValue,
                                    newValue: revertedFromRevision ? oldValue : newValue,
                                    chosenValue: ko.observable(newValue) } ))
                            }
                        }
                        else if (typeof newValue == "undefined") {
                            //Kept from main content
                            valuesKept.push( { fieldId: fieldId, label: label, value: oldValue } )
                        }
                    })
                }



                if ( valuesChanges.length > 0 || tagNameChange || labelChanges.length > 0  ) {
                    fieldValueChanges.push(
                        ko.observable({
                            tag: compositeTagName,
                            tagNameChange: tagNameChange,
                            tagTypeName: tagTypeName,
                            imageUrl: tagImageUrl,
                            tagId: updatedReviewItems[i].tag.id,
                            updatedValues: ko.observableArray(valuesChanges),
                            updatedLabels: labelChanges,
                            keptValues: valuesKept }));
                }
            }
        }

        this.getTemplateViewModel().fieldValueChanges(fieldValueChanges);
        this.getTemplateViewModel().updatedReviewItems(updatedReviewItems);
        if (fieldValueChanges && Object.keys(fieldValueChanges).length !== 0) {
            this.makeBodyUnscrollable();
            this.getTemplateViewModel().isReviewItemUpdatesFormShown(true);
        }
        else {
            this.onReviewItemReversalConfirm()
        }
    }

    public getViewModelForRequest() {

        return {

            filters: {
                authorId: this.getTemplateViewModel().filterUser_author.idUser,
                srEditorId: this.getTemplateViewModel().filterUser_SrEditor.idUser,
                jrEditorId: this.getTemplateViewModel().filterUser_JrEditor.idUser,
                ideatorId: this.getTemplateViewModel().filterUser_ideator.idUser,
                paymentCategory: this.getTemplateViewModel().paymentCategoryFilter.selectedOption
            }
        }
    }

    public setFeaturedTags(featuredTags){
        this.getTemplateViewModel().featuredTags([]);
        this.getTemplateViewModel().featuredTags(featuredTags);
        if(featuredTags !==null && featuredTags.tagObject !== null){
            if(featuredTags.tagObject[0].image !== undefined && featuredTags.tagObject[0].image !== null){

                this.imageWidgetForFeaturedImage.setImage(featuredTags.tagObject[0].image);
                this.getTemplateViewModel().featuredImage(this.getFeaturedImage());
            }else if (featuredTags.tagObject[1] !== undefined && featuredTags.tagObject[1].image !== undefined && featuredTags.tagObject[1].image !== null){
                this.imageWidgetForFeaturedImage.setImage(featuredTags.tagObject[1].image);
                this.getTemplateViewModel().featuredImage(this.getFeaturedImage());
            }else{
                this.imageWidgetForFeaturedImage.setImage([]);
                this.getTemplateViewModel().featuredImage(null);
            }
        }
    }

    public setDefaultFeaturedTags(defaultFeaturedTags): void {
        this.getTemplateViewModel().defaultFeaturedTags(defaultFeaturedTags);
    }

    public getDefaultFeaturedTags() {
        return this.getTemplateViewModel().defaultFeaturedTags();
    }


    public setDefaultFeaturedImage(defaultFeaturedImage): void {
        this.getTemplateViewModel().defaultFeaturedImage(defaultFeaturedImage);
    }

    public getDefaultFeaturedImage() {
        return this.getTemplateViewModel().defaultFeaturedImage();
    }

    public setValidAutoPricingPartnerNames(validAutoPricingPartnerNames): void {
        this.tagPicker.setValidAutoPricingPartnerNames(validAutoPricingPartnerNames);
    }

    public getValidAutoPricingPartnerNames() {
        return this.getTemplateViewModel().validAutoPricingPartnerNames();
    }

    public onClickFeaturedTag(value){
        this.caller.showTagPicker("featuredTag");
    }

    public setTopKeyWordAnalytics(response): void{
        this.articleAnalytics.setAnalytics(response);
    }

    public getTopKeyWordAnalytics(){
        return this.articleAnalytics.getAnalytics();
    }

    public setShortTermReport(response): void{

        this.articleAnalytics.setShortTermReport(response);
    }

    public getIsVersusStyle(){
        return this.getTemplateViewModel().isVersusStyle();
    }

    public setIsUserHasTier2Rates(isUserHasTier2Rates: boolean): void {
        this.getTemplateViewModel().isUserHasTier2Rates(isUserHasTier2Rates);
    }

    public setIsSessionTrackerVisible(isSessionTrackerVisible: boolean): void {
        this.getTemplateViewModel().isSessionTrackerVisible(isSessionTrackerVisible);
    }

    public setUserPicture(userPicture): void {
        this.getTemplateViewModel().userPicture(userPicture);
    }

    public setArticleGoal(articleGoal): void {
        this.getTemplateViewModel().articleGoal(articleGoal);
    }

    public setMonthName(monthName): void {
        this.getTemplateViewModel().monthName(monthName);
    }

    public setRoleName(roleName): void {
        this.getTemplateViewModel().roleName(roleName);
    }

    public setContentTypeName(contentTypeName): void {
        this.getTemplateViewModel().contentTypeName(contentTypeName);
    }

    protected onClickSelectView(event) {

        if (event.target.dataset.wasChecked === "true") {
            event.target.dataset.wasChecked = "false";
            event.target.checked = false;
            this.getTemplateViewModel().selectedView(null);
        }else{
            event.target.dataset.wasChecked = "true";
            this.getTemplateViewModel().selectedView(event.target.value);
        }

        if(event.target.value =="currency"){
            document.getElementById('brandViewArticle').dataset.wasChecked = "false";
        }else{
            document.getElementById('currencyViewArticle').dataset.wasChecked = "false";
        }

        return true;
    }

    public setArticleGoalProgressPercentage(articleGoalProgressPercentage): void {
        this.getTemplateViewModel().articleGoalProgressPercentage(articleGoalProgressPercentage);
    }

    public setSessionGoalProgressPercentage(sessionGoalProgressPercentage): void {
        this.getTemplateViewModel().sessionGoalProgressPercentage(sessionGoalProgressPercentage);
    }

    public setTier2SessionGoalProgressPercentage(tier2SessionGoalProgressPercentage): void {
        this.getTemplateViewModel().tier2SessionGoalProgressPercentage(tier2SessionGoalProgressPercentage);
    }

    public setSessionsPerArticleTarget(sessionsPerArticleTarget): void {
        this.getTemplateViewModel().sessionsPerArticleTarget(sessionsPerArticleTarget);
    }

    public setTier2SessionsPerArticleTarget(tier2SessionsPerArticleTarget): void {
        this.getTemplateViewModel().tier2SessionsPerArticleTarget(tier2SessionsPerArticleTarget);
    }

    public setArticleCount(articleCount): void {
        this.getTemplateViewModel().articleCount(articleCount);
    }

    public setSessionsPerArticle(sessionsPerArticle): void {
        this.getTemplateViewModel().sessionsPerArticle(sessionsPerArticle);
    }

    public setTier1Amount(tier1Amount): void {
        this.getTemplateViewModel().tier1Amount(tier1Amount);
    }

    public setTier2Amount(tier2Amount): void {
        this.getTemplateViewModel().tier2Amount(tier2Amount);
    }

    public setOutputTransactionsTotal(outputTransactionsTotal): void {
        this.getTemplateViewModel().outputTransactionsTotal(outputTransactionsTotal);
    }

    public setBrandSessionTarget(brandSessionTarget): void {
        this.getTemplateViewModel().brandSessionTarget(brandSessionTarget);
    }

    public setBrandProgressPercentage(brandProgressPercentage): void {
        this.getTemplateViewModel().brandProgressPercentage(brandProgressPercentage);
    }

    public setContentTypeProgressPercentage(contentTypeProgressPercentage): void {
        this.getTemplateViewModel().contentTypeProgressPercentage(contentTypeProgressPercentage);
    }

    public setBrandContentTypeSessionTarget(brandContentTypeSessionTarget): void {
        this.getTemplateViewModel().brandContentTypeSessionTarget(brandContentTypeSessionTarget);
    }


    public setArticles(articles: Array<any>) {

        if (articles && articles[0]) {

            this.getTemplateViewModel().articles(articles);
        } else {

            this.getTemplateViewModel().articles(null);
        }
    }

    public setActiveCkEditorInstance(instance){

        this.getTemplateViewModel().activeCkEditorInstance(instance);
    }

    public getActiveCkEditorInstance(){

        return this.getTemplateViewModel().activeCkEditorInstance();
    }

    public setArticlesFilter(articles) {

        this.getTemplateViewModel().filterArticle.showDetails(true);
        this.getTemplateViewModel().filterArticle.articles(articles);
    }

    public setDirectoryArticlesFilter(articles) {

        this.getTemplateViewModel().filterArticleDirectory.showDetails(true);
        this.getTemplateViewModel().filterArticleDirectory.articles(articles);
    }
    public convertStringToHtmlDoc(htmlString){
        let div = document.createElement('div');
        div.innerHTML = htmlString.trim();
        return div.firstChild;
    }
    public onClickFeaturedTagEdit(){
        let items = this.getTemplateViewModel().featuredTags();

        if(items !==null && items.tagObject.length>1 && !items.tagObject[0].name.includes("Placeholder")){
            let bigItem = this.convertStringToHtmlDoc(items.block.source);
            this.caller.getTagData();
            this.caller.onClickCkEditorElement(bigItem,{name:"featuredTag"});
        }
        else if(items.tagObject[0].name.includes("Placeholder")){
            this.onClickFeaturedTag(null);
        }
        else{
            this.caller.showTagPicker("featuredTag");
            this.tagPicker.getOnlickView(items.tagObject[0]);
        }
    }

    public onClickFeaturedTagDelete(){
        this.getTemplateViewModel().featuredTags(null);
        this.imageWidgetForFeaturedImage.setImage([]);
    }

    public setDirectoryItemFilter(articles, sourceId) {

        let usedArticles = [];
        let directoryItems = []

        if (sourceId == "sandbox_directory") {
            directoryItems = this.sandboxDirectory.getTemplateViewModel().directoryItems();
        }else if(sourceId == "republish_directory"){
            directoryItems = this.republishDirectory.getTemplateViewModel().directoryItems();
        }else{
            directoryItems = this.articleDirectory.getTemplateViewModel().directoryItems();
        }

        let recursiveTraversal = function(array) {
            array.forEach( el => {

                if ( el.item() ){
                    usedArticles.push(el.item())
                }
                if ( el.directoryItems.length > 0 )
                    recursiveTraversal(el.directoryItems)
            });
        }

        recursiveTraversal(directoryItems)

        const articlesWithoutUsedOnes = articles.filter(({ id: id1 }) => !usedArticles.some(({ id: id2 }) => id2 == id1));

        if (sourceId == "sandbox_directory") {

            this.sandboxDirectory.getTemplateViewModel().filterDirectoryItem.articles(articlesWithoutUsedOnes);
        }else if (sourceId == "republish_directory") {

            this.republishDirectory.getTemplateViewModel().filterDirectoryItem.articles(articlesWithoutUsedOnes);
        }else{

            this.articleDirectory.getTemplateViewModel().filterDirectoryItem.articles(articlesWithoutUsedOnes);
        }

    }

    public setSelectedRecoveryTab(selectedRecoveryTab) {

        this.getTemplateViewModel().selectedRecoveryTab(selectedRecoveryTab);
    }


    public setFaqs(faqs) {

        this.getTemplateViewModel().faqs(faqs);
    }

    public setAmazonOnsite(amazonOnsite) {

        this.getTemplateViewModel().amazonOnsite(amazonOnsite);
    }

    public setNewsletterServiceType(newsletterServiceType) {

        this.getTemplateViewModel().newsletterServiceType(newsletterServiceType);
    }

    public setClassificationOptions(value : [{id: number, name: string}]){
        this.getTemplateViewModel().classificationOptions(value);
    }

    public setClassificationAllOptions(value : [{id: number, name: string}]){
        this.getTemplateViewModel().classificationAllOptions(value);
    }

    public setClassificationName(classificationName){
        this.getTemplateViewModel().classificationName(classificationName);
    }

    public setIdClassification(idClassification){
        this.getTemplateViewModel().idClassification(idClassification);
    }

    public setIsSubContent(isSubContent){
        this.getTemplateViewModel().isSubContent(isSubContent);
    }

    public setArticleHistoricalReviewComments(articleHistoricalReviewComments){

        this.getTemplateViewModel().hasNewFeedback(false);
        //check if any feedback has been made in the last 48 hours
        for(let comment of articleHistoricalReviewComments){

            let date = new Date(comment.dateCreated.date);
            let current = new Date();
            let diff = Math.abs(current.getTime() - date.getTime());
            //let diffDays = Math.ceil(diff / (1000 * 3600 * 24));
            let diffHours = Math.ceil(diff / (1000 * 3600));
            if(diffHours <= 48){
                this.getTemplateViewModel().hasNewFeedback(true);
            }

        }
        this.getTemplateViewModel().articleHistoricalReviewComments(articleHistoricalReviewComments);
        this.articleReviewHistory.setReviewItems(articleHistoricalReviewComments);

    }


    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions);
        this.productReview.setPermissions(permissions);
        this.productReviewSandbox.setPermissions(permissions);
        this.productReviewRepublish.setPermissions(permissions);
        this.articleContent.setPermissions(permissions);
        this.sandboxContent.setPermissions(permissions);
        this.republishContent.setPermissions(permissions);
        this.imagePicker.setPermissions(permissions);
        this.tagPicker.setPermissions(permissions);
        //
        this.imageWidgetForThumbnailImage.setPermissions(permissions);
        this.imageWidgetForAlternateImage.setPermissions(permissions);
        this.imageWidgetForFeaturedImage.setPermissions(permissions);
        this.articleAnalytics.setPermissions(permissions);
        this.videoPickerHelper.setPermissions(permissions);

    }

    public getPermissions() {

        return this.getTemplateViewModel().permissions();
    }

    public getPublishStatusOptions() {

        return this.getTemplateViewModel().publishStatuses();
    }

    public getArticleStatusOptions() {

        return this.getTemplateViewModel().articleStatus_options();
    }

    public getArticleRepublishStatusOptions() {

        return this.getTemplateViewModel().articleRepublishStatus_options();
    }

    public getReviewItemAwardOptions() {

        return this.getTemplateViewModel().reviewItemAward_options();
    }

    public updateSelectedTags() {

        let idTagSelected = this.filterTag.getTemplateViewModel().idTag();
        let tagSelected = this.filterTag.getTemplateViewModel().tagObj();
        let selectedTags = this.getTemplateViewModel().selectedTags();

        if (idTagSelected != null) {
            //add to selected tags if its not already selected
            let alreadySelected = selectedTags.find(t => t.tag.id == idTagSelected);

            if (!alreadySelected) {
                if(tagSelected.tagType != null){
                    tagSelected.type = {};
                    tagSelected.type.id = tagSelected.idType;
                    tagSelected.type.name = tagSelected.tagType;
                }
                selectedTags.push({id: null, tag: tagSelected});
            }
        }


        this.getTemplateViewModel().selectedTags([]);
        this.getTemplateViewModel().selectedTags(selectedTags);
        this.filterTag.clearInput();
    }

    public updateSelectedCategories() {


        let selectedFilterCategories = this.filterCategory.getSelectedItems();
        let categories = this.getTemplateViewModel().categories();
        let idPrimaryCategory = this.getTemplateViewModel().idPrimaryCategory();

        let categoryList = [];
        //build list of the categories that are now selected in the filter
        for (let idCategory of selectedFilterCategories) {

            let category = categories.find(c => c.id == idCategory);
            if (category) {

                categoryList.push(category);
            }

        }

        let selectedCats = this.getTemplateViewModel().selectedCategories();

        //add categories that have not yet been selected
        for (let cat of categoryList) {

            let existingCategory = selectedCats.find(c => c.category.id == cat.id);

            if (!existingCategory) {
                selectedCats.push({id: null, category: cat});
            }
        }

        //remove ones that are no longer selected in the filter
        /*for(let cat of selectedCats){

            let catToRemove = categoryList.find(c => c.id == cat.id);
            if(!catToRemove){
                //selectedCats.splice()
            }
        }*/

        for (let i = selectedCats.length - 1; i >= 0; i--) {

            let catToRemove = categoryList.find(c => c.id == selectedCats[i].category.id);
            if (!catToRemove) {
                selectedCats.splice(i, 1);
            }
        }

        //check if primary category still exists
        let primaryCategory = selectedCats.find(c => c.category.id == idPrimaryCategory);
        if (!primaryCategory) {
            this.getTemplateViewModel().idPrimaryCategory(null);
        }

        this.getTemplateViewModel().selectedCategories([]);
        this.getTemplateViewModel().selectedCategories(selectedCats);
    }
    protected onClickUsePinnedTagAsFeaturedImage(isClicked){
        if(isClicked){


        }
    }
    public onClickTemplateTab(idTemplate, event) {

        this.getTemplateViewModel().idTemplate(idTemplate);
        this.setTemplateLayoutsFiltered(idTemplate);
        let templateDropDown = <HTMLSelectElement>document.getElementById("template_selector");
        let index = templateDropDown.selectedIndex;
        let selected = templateDropDown.options[templateDropDown.selectedIndex];
        this.setTemplate(templateDropDown.options[templateDropDown.selectedIndex].text);

        let contentPresets = this.getTemplateViewModel().contentPresets();
        for (let contentPreset of contentPresets) {
            if (contentPreset['type'] == 'template' && contentPreset['idItem'] == idTemplate && contentPreset['isActive'] == true) {
                this.caller.sendToArticleContent(contentPreset['content']);
            }
        }

        if (idTemplate == 9) {
            this.setBuyersGuideLightTemplateDefaults();
        }
        else if(idTemplate == 10){
            this.setDealsTemplateDefaults();
        }else if (idTemplate == 11){
            this.setVersusTemplateDefaults();
        }else if (idTemplate == 12){
            this.setCollectionTemplateDefaults();
        }else if (idTemplate == 13 || idTemplate == 17){
            this.setSubContentTemplateDefaults();
        }   else if (idTemplate == ID_TEMPLATE_VIDEO){
            this.setVideoTemplateDefaults();
        } else if (idTemplate == ID_TEMPLATE_THREAD){
            this.setThreadTemplateDefaults();
        }
        else {
            this.resetTemplateDefaults(idTemplate);
        }
        this.productReview.setIdTemplate(idTemplate);
        this.productReviewSandbox.setIdTemplate(idTemplate);
        this.productReviewRepublish.setIdTemplate(idTemplate);
        this.recoverySandboxReviewSection.setIdTemplate(idTemplate);
        this.recoveryRepublishReviewSection.setIdTemplate(idTemplate);
        this.recoveryReviewSection.setIdTemplate(idTemplate);
        this.revisionReviewSection.setIdTemplate(idTemplate);
        this.getTemplateViewModel().showSegmentTab(this.getSegments().length);
        this.applyAudioReaderDefaultIfEligible();
    }

    public onClickSegmentTab(idSegment) {

        this.getTemplateViewModel().idSegment(idSegment);
        let segmentDropdown = <HTMLSelectElement>document.getElementById("idSegment");

        this.setSegment(segmentDropdown.options[segmentDropdown.selectedIndex].text);

        let contentPresets = this.getTemplateViewModel().contentPresets();
        for (let contentPreset of contentPresets) {
            if (contentPreset['type'] == 'segment' && contentPreset['idItem'] == idSegment && contentPreset['isActive'] == true) {
                this.caller.sendToArticleContent(contentPreset['content']);
            }
        }

        this.getTemplateViewModel().showSegmentTab(false);
    }

    protected onClickCancel() {

        if (confirm("Are you sure you want to cancel? Any unsaved changes will be lost.")) {

            this.caller.cancelEditArticle();
        }
    }

    public disableSaveButtons() {

        this.getTemplateViewModel().isSaveButtonDisabled(true);
    }

    public enableSaveButtons() {

        this.getTemplateViewModel().isSaveButtonDisabled(false);
    }

    public setLastSaved(lastSaved) {
        this.getTemplateViewModel().lastSaved(lastSaved);
    }

    public enableAutosaveBox() {
        if (this.getTemplateViewModel().lastSaved !== "") {
            //console.log("Enabled autosave box 1");
            this.getTemplateViewModel().showAutoSaveMessage(true);
        }
    }

    public disableAutosaveBox() {
        this.getTemplateViewModel().showAutoSaveMessage(false);
    }

    public showAutoSaveMessage(message) {
        this.getTemplateViewModel().autoSaveMessage(message);
    }

    public clearAutoSaveMessage() {
        this.getTemplateViewModel().autoSaveMessage(null);
    }

    public setIsAutosaving(value) {
        this.getTemplateViewModel().showIsAutosaving(value);
    }

    protected onChangeTemplate(data, event) {

        let idTemplate = event.target.value;
        let template = event.target.options[event.target.selectedIndex].text;
        let oldIdTemplate = Number(this.getIdTemplate());

        if(oldIdTemplate == 15){
            this.getTemplateViewModel().featuredSectionValue(null);
        }
        if(oldIdTemplate == ID_TEMPLATE_THREAD){
            //clear out the image
            this.onClickClearFeaturedImage();
        }

        if (oldIdTemplate == 7 && idTemplate != 7) {
            const directoryItems = this.getDirectoryItems();
            let count = directoryItems.length
            const countItems = (items) => items.reduce((count, item) => {
                if (item.directoryItems().length > 0) {
                    count += countItems(item.directoryItems());
                }
                return count
            }, items.length);

            if (!confirm(`Changing the type of this article will clear ${countItems(directoryItems)} existing directory items. Are you sure you want to continue?`)) {
                this.getTemplateViewModel().idTemplate(null);
                this.getTemplateViewModel().idTemplate(oldIdTemplate);
                return false;
            }
        }

        if(oldIdTemplate == 11 && idTemplate !==15){
            this.getTemplateViewModel().featuredSectionValue('featuredImage');
            this.getTemplateViewModel().showFeaturedImage(true);
            this.onChangeFeaturedSection(true)
        }
        else if(oldIdTemplate ==11 && idTemplate ==15){
            this.getTemplateViewModel().featuredSectionValue('featuredVideo');
            this.onChangeFeaturedSection(true)
        }
        else if(oldIdTemplate ==15 && idTemplate ==11){
            this.getTemplateViewModel().featuredSectionValue('featuredTag');
            this.getTemplateViewModel().showFeaturedImage(true);
            this.onChangeFeaturedSection(true)
        }

        //if thread template, remove premium classification
        let classifications = [...this.getTemplateViewModel().classificationAllOptions()];
        if(idTemplate == ID_TEMPLATE_THREAD){
            classifications = classifications.filter(function( obj ) {
                return obj.id != ID_PREMIUM_CLASSFICATION;
            });
        }
        this.getTemplateViewModel().classificationOptions(classifications);

        // Validate featured content for new template/layout combination
        const currentLayout = this.getTemplateViewModel().templateLayout();
        const validation = this.validateFeaturedContentForTemplateLayout(idTemplate, currentLayout, false);

        if (!validation.isValid) {
            if (!confirm(validation.message)) {
                // Revert template selection
                this.getTemplateViewModel().idTemplate(null);
                this.getTemplateViewModel().idTemplate(oldIdTemplate);
                return false;
            } else {
                // Clear invalid fields
                this.clearInvalidFeaturedFields(validation.invalidFields);
            }
        }

        this.setTemplate(template);
        this.setTemplateLayoutsFiltered(idTemplate);

        if (idTemplate == 9) {
            this.setBuyersGuideLightTemplateDefaults();
        }
        else if(idTemplate == 10){
            this.setDealsTemplateDefaults();
        }else if(idTemplate == 11){
            this.setVersusTemplateDefaults();
        }else if(idTemplate == 12){
            this.setCollectionTemplateDefaults();
        } else if (idTemplate == ID_TEMPLATE_VIDEO){
            this.setVideoTemplateDefaults();
        }  else if (idTemplate == ID_TEMPLATE_THREAD){
            this.setThreadTemplateDefaults();
        }
        else {
            this.resetTemplateDefaults(idTemplate);
        }
        this.productReview.setIdTemplate(idTemplate);
        this.productReviewSandbox.setIdTemplate(idTemplate);
        this.productReviewRepublish.setIdTemplate(idTemplate);
        this.recoverySandboxReviewSection.setIdTemplate(idTemplate);
        this.recoveryRepublishReviewSection.setIdTemplate(idTemplate);
        this.recoveryReviewSection.setIdTemplate(idTemplate);
        this.revisionReviewSection.setIdTemplate(idTemplate);
        this.getTemplateViewModel().idTemplate(idTemplate);
        this.applyAudioReaderDefaultIfEligible();

        return true;
    }

    protected onChangeTemplateLayout(data, event) {
        if (event.isTrusted === true) {
            let sectedOptionText = event.target.options[event.target.selectedIndex].text.toLowerCase();
            let currentTemplate = this.getIdTemplate();

            // Validate featured content for new template/layout combination
            const validation = this.validateFeaturedContentForTemplateLayout(currentTemplate, sectedOptionText, true);

            if (!validation.isValid) {
                if (!confirm(validation.message)) {
                    // Revert layout selection
                    const previousLayout = this.getTemplateViewModel().idTemplateLayoutPrevious();
                    if (previousLayout) {
                        this.setIdTemplateLayout(previousLayout);
                    }
                    return false;
                } else {
                    // Clear invalid fields
                    this.clearInvalidFeaturedFields(validation.invalidFields);
                }
            }

            // Continue with existing layout change logic
            let prompt = "Switching template will clear the existing featured selections. Are you sure you want to continue?";
            let featuredSectionValue = this.getTemplateViewModel().featuredSectionValue();

            if (sectedOptionText == "minimal" || sectedOptionText == "review") {

                this.setIsFeaturedTagDisabled(false);
                this.setIsFeaturedVideoDisabled(true);

                if (featuredSectionValue == "featuredVideo") {
                    if (confirm(prompt) === false) {
                        return false;
                    } else {
                        this.clearFeaturedSection("featuredVideo");
                        this.setIsFeaturedVideoActive(false);
                        this.setIsFeaturedImageActive(true);
                        this.setFeaturedSectionValue("featuredImage");
                    }
                }
                this.setTableOfContents(sectedOptionText == 'review' ? true : false);
            } else {
                if (featuredSectionValue == "featuredTag") {
                    if (confirm(prompt) === false) {
                        return false;
                    } else {
                        this.clearFeaturedSection("featuredTag");
                        this.setIsFeaturedVideoActive(false);
                        this.setIsFeaturedTagActive(false);
                        this.setIsFeaturedImageActive(true);
                        this.imageWidgetForFeaturedImage.setIsFeaturedTagActive(false);
                        this.imageWidgetForFeaturedImage.getTemplateViewModel().imageIsRequired(false);
                        this.setFeaturedSectionValue("featuredImage");
                    }
                }
                this.setIsFeaturedTagDisabled(true);
                this.setIsFeaturedVideoDisabled(false);
                this.setTableOfContents(false);
                if (sectedOptionText == "light-wide") {
                    this.setTableOfContents(true);
                }
            }

            this.setTemplateLayout(sectedOptionText);

            let idTemplateLayout = this.getTemplateViewModel().idTemplateLayout();
            let layout = this.getTemplateViewModel().templateLayouts().find(l => l.id === idTemplateLayout);
            let nameTemplateLayout = layout ? layout.name : undefined;
            if (nameTemplateLayout === 'Leadgen') {
                this.setIsSidebarHidden(true);          
                this.setTableOfContents(true);       
                this.setIsCommentsDisabled(true);            
            }

            this.getTemplateViewModel().isVerticalShortTemplateSelected(false);
            if (sectedOptionText === "vertical short") {
                this.getTemplateViewModel().isVerticalShortTemplateSelected(true);
                this.setDisplayConfiguration(3);
            }
        }
        return true;
    }

    public setIsFeaturedImageActive(isFeaturedImageActive){
        this.getTemplateViewModel().isFeaturedImageActive(isFeaturedImageActive);
    }

    public setIsFeaturedVideoActive(isFeaturedVideoActive): void {
        this.getTemplateViewModel().isFeaturedVideoActive(isFeaturedVideoActive);
    }

    public setFeaturedSectionValue(featuredSectionValue){
        this.getTemplateViewModel().featuredSectionValue(featuredSectionValue);
    }


    protected setTagFilterAutocomplete(tags) {

        this.filterTag.getTemplateViewModel().tags(tags);
    }

    protected setDatasetFilter(datasets) {
        this.tagPicker.setDatasetFilter(datasets);
    }

    protected setReviewTagFilterAutocomplete(tags) {

        this.filterReviewTag.getTemplateViewModel().tags(tags);
    }

    protected onClickTab(tab) {

        if(tab != 'sandbox' && tab != 'republish'){
            this.getTemplateViewModel().selectedTab(tab);
        }
        this.productReview.setSelectedTab(tab);
        this.productReviewSandbox.setSelectedTab(tab);
        this.productReviewRepublish.setSelectedTab(tab);
        this.articleContent.setSelectedTab(tab);
        this.sandboxContent.setSelectedTab(tab);
        this.republishContent.setSelectedTab(tab);
        this.articleReviewHistory.resetFeedbackHistoryOption();

        if(tab == 'article'){
            this.checkIfSandboxHasContent();
            this.checkIfRepublishHasContent();
            this.resizeTextareaOnClick();
        }

        if(tab == "analytics"){
            this.caller.getArticleAnalytics();
            this.caller.getShortTermReport();
        }

        if(tab == 'sandbox' || tab == 'republish'){
            this.checkIfSandboxHasContent();
            this.checkIfRepublishHasContent();
        }

        if(tab == 'newsletter'){
            this.newsletterDateScheduledSelector.setDate(this.getFormattedEasternTimeZoneDateTime())
        }

        if (tab == 'reviews') {
            // setting the 'guidlines' in the articleReviewHistory articleReviewHistory_template to the prompt 'agreement' value for the "Changes Required" status of the current content type..
            let prompt = this.getPromptToShow(3,true,true);
            if (prompt && typeof prompt === 'object' && 'agreement' in prompt) {
                this.articleReviewHistory.setGuidelines(prompt.agreement);
            }

            let idArticle = this.getTemplateViewModel().id();
            if (idArticle) {
                this.caller.getSensaiArticleReferences("article_content", idArticle);
                //this.caller.getAIContent();
            }
        }
        if (tab === 'widgets') {
            this.isQuizAllowedOverride();
            this.isCompletedWithAllowedTypes();
            this.isNewsletterPromotioAllowed();
            this.isThreadSummaryAllowed();
            this.isDealsCategoryPromotioAllowed();
        }
    }

    public onClickOpenSandboxOrRepublish(tab){
        this.getTemplateViewModel().selectedArticleEditmode(tab);
        this.onClickCopyContent(tab)
        this.onClickTab(tab)
    }

    public checkIfSandboxHasContent(){

        let boolean = false;
        let sandboxContent = this.getSandboxContent();
        let sandboxIntroText = this.getSandboxIntroText();
        let sandboxReviewItems = this.getSandboxReviewItems();
        let sandboxDirectoryItems= this.getSandboxDirectoryItems();

        if( sandboxContent != '' || sandboxIntroText != '' || sandboxReviewItems.length > 0 || sandboxDirectoryItems.length > 0 ){
            boolean = true;
        }
        this.getTemplateViewModel().isSandboxActive(boolean);
    }

    public checkIfRepublishHasContent(){

        let boolean = false;
        let republishContent = this.getRepublishContent();
        let republishIntroText = this.getRepublishIntroText();
        let republishReviewItems = this.getRepublishReviewItems();
        let republishDirectoryItems= this.getRepublishDirectoryItems();

        if( republishContent != '' || republishIntroText != '' || republishReviewItems.length > 0 || republishDirectoryItems.length > 0 ){
            boolean = true;
        }
        this.getTemplateViewModel().isRepublishActive(boolean);
    }

    protected onChangeArticleDataListUser(event, idItem) {
        let input = event.target,
            inputVal = input.value,
            optionsList = input.getAttribute('list'),
            options: any = document.getElementById(optionsList).childNodes;

        if (inputVal.length >= 3 && event.inputType != undefined) {
            this.caller.getArticlesSuggestion( inputVal );
            this.getTemplateViewModel().isShowArticleSuggestions(true);
        }

        for (let op of options) {
            if (op.value === inputVal) {
                idItem(op.id);
                input.blur();
                // this.caller.filterSimpleOnChange();
                break;
            }
        }
    }


    protected onClickRevertSandbox() {

        this.caller.revertSandbox();
        this.caller.revertSandboxIntroText();
        this.caller.revertSandboxDirectory();
        this.clearSandboxSection();
    }

    protected onClickCopyContent(tab) {

        this.caller.copyContent(tab);
        this.caller.copyIntroText(tab);
        this.copyContentReviewsItem(tab);
        this.copyDirectoryItems(tab)
    }

    protected onClickAddFaq() {

        this.clearFaqForm();
        this.getTemplateViewModel().isFaqAddFormShown(true);
    }

    protected onClickEditFaq(index) {
        const data = this.getTemplateViewModel().faqs()[index];
        if (data) {
            this.getTemplateViewModel().selectedFaqIndex(index);
            this.getTemplateViewModel().question(data.question);
            this.caller.setFaqAnswer(data.answer);
            this.getTemplateViewModel().isFaqAddFormShown(true);
        }
    }

    protected onClickDeleteFaq(data) {

        let faqs = this.getTemplateViewModel().faqs();
        let index = faqs.findIndex(i => i == data);
        this.getTemplateViewModel().faqToDelete(index);
        this.getTemplateViewModel().isFaqDeleteVisible(true)

    }

    // region Embeds

    public onClickCloseEmbedPopup(){

        this.embedHelper.abortEmbedGeneration();
        this.setContentEmbedContext();
        this.toggleEmbedPopUp(false);
        this.resetEmbedPopUp();
    }

    public onClickCloseSensaiVaultPopup(){
        this.getTemplateViewModel().isSensaiVaultVisible(null);
        this.getTemplateViewModel().isSensaiVaultVisible(false);
    }

    public onClickToggleEmbedTypes(){

        let isFeaturedContext = this.isEmbedContext(EmbedContext.FEATURED);
        this.getTemplateViewModel().embedType(isFeaturedContext ? 'embed_youtube' : 'all');
        document.getElementsByClassName('inner-group')[0].classList.toggle('is-open');
        document.getElementsByClassName('btn-form options')[0].classList.toggle('is-open');

        let element = document.getElementsByClassName('inner-group')[0];
        if(!element.classList.contains('is-open')){

            this.onChangeEmbedInput();
        }
    }

    public toggleEmbedPopUp(value){

        document.body.classList.toggle("is-fixed");
        this.getTemplateViewModel().isEmbedPopUpVisible(value)
    }

    public setEmbedSourceFocused(value){

        setTimeout( () => {
            this.getTemplateViewModel().isEmbedFocused(value);
        }, 100)
    }

    public resetEmbedPopUp(){

        this.getTemplateViewModel().isEmbedFocused(false);
        this.getTemplateViewModel().embedSource(null);
        this.getTemplateViewModel().embedType('all');
        this.clearEmbedFormOutput();
        document.getElementsByClassName('inner-group')[0].classList.remove('is-open');
        document.getElementsByClassName('btn-form options')[0].classList.add('is-open');

    }

    public clearEmbedFormOutput(){

        this.getTemplateViewModel().embedCode(null);
        this.getTemplateViewModel().embedErrors([]);
    }

    protected onClickAddEmbed(){

        let embedContext = this.getTemplateViewModel().embedContext();
        let embedCode = this.getTemplateViewModel().embedCode();

        switch (embedContext) {
            case EmbedContext.FEATURED:
                this.caller.addEmbedCodeToFeaturedEmbed(embedCode);
                break;
            default:
                this.caller.addEmbedCodeToCkEditor(embedCode);
                break;
        }

    }

    public setFeaturedEmbed(embed) {
        this.getTemplateViewModel().featuredEmbed(embed);
    }

    public isEmbedContext(context: string): boolean {
        let embedContext = this.getTemplateViewModel().embedContext();

        return (embedContext == context);
    }
    public setContentEmbedContext() {

        this.getTemplateViewModel().embedType_options(embedTypesList());
        this.getTemplateViewModel().embedType('all');
        this.getTemplateViewModel().embedContext(EmbedContext.CONTENT);
    }

    protected onChangeEmbedInput(){

        //clear result
        this.clearEmbedFormOutput();

        // get input and make call of >3
        let source = this.getTemplateViewModel().embedSource();
        if (source && source.length >= 3) {

            let embedContext = this.getTemplateViewModel().embedContext();

            this.caller.generateEmbed(source, embedContext)
        }
    }

    // endregion embeds

    protected onClickDeleteSelectedTag(data) {

        let idPrimaryTag = this.getTemplateViewModel().idPrimaryTag();
        let selectedTags = this.getTemplateViewModel().selectedTags();
        let index = selectedTags.findIndex(i => i.tag.id == data.tag.id);
        if (index != -1) {
            selectedTags.splice(index, 1);
        }

        if (idPrimaryTag == data.tag.id) {
            this.getTemplateViewModel().idPrimaryTag(null);
        }

        this.getTemplateViewModel().selectedTags(selectedTags);
    }

    protected onClickDeleteSelectedCategory(data) {

        let idPrimaryCategory = this.getTemplateViewModel().idPrimaryCategory();
        let allCategories = this.getTemplateViewModel().categories();
        let selectedCategories = this.getTemplateViewModel().selectedCategories();
        let index = selectedCategories.findIndex(i => i.category.id == data.category.id);
        if (index != -1) {
            selectedCategories.splice(index, 1);
        }

        if (idPrimaryCategory == data.category.id) {
            this.getTemplateViewModel().idPrimaryCategory(null);
        }

        this.getTemplateViewModel().selectedCategories(selectedCategories);

        let selectedFilterCategories = this.filterCategory.getSelectedItems();

        index = selectedFilterCategories.findIndex(i => i == data.category.id);
        if (index != -1) {
            selectedFilterCategories.splice(index, 1);
        }

        let updatedCats = [];
        for (let idCat of selectedFilterCategories) {

            let cat = allCategories.find(c => c.id == idCat);
            if (cat) {
                updatedCats.push(cat);
            }
        }

        this.filterCategory.setSelectedItems(updatedCats);

    }

    protected onClickRevision(index, data ) {

        index = typeof index === "number" ? index : index();
        this.getTemplateViewModel().selectedRevisionIndex( index);
        this.setIdRevisionSelected(data.id);
        this.setRevisionContent(data.content.content);
        this.setRevisionIntroText(data.content.introText);
        this.revisionReviewSection.setReviewItems(data.content.reviewItems);
        this.revisionDirectory.setDirectoryItems(data.content.directoryItems);
    }

    protected onSensaiFeatureFeedbackClose(data: any, event: any) {
    }

    protected onSensaiFeatureFeedbackConfirm(feedbackData: Object = {}, event: any) {
        this.caller.sendSensaiFeatureFeedback(feedbackData);
    }

    protected onReviewItemReversalConfirm() {


        let valueUpdates = this.getTemplateViewModel().fieldValueChanges();
        let reviewItemsToDelete = this.productReview.getTemplateViewModel().reviewItems().map(obj => { return obj.id  } );
        this.productReview.setReviewItemsToDelete(reviewItemsToDelete);
        let valueUpdate, specExtras, updatedValues, updatedValue;
        let updatedReviewItems = this.getTemplateViewModel().updatedReviewItems();
        let valueExisted;
        let sourceOfReversal = this.getTemplateViewModel().sourceOfReversal();

        if ( sourceOfReversal == "sandbox") {

            this.onClickRevertSandbox();
        }
        else if ( sourceOfReversal == "revision") {

            this.onClickRevertRevision();
        }
        else if ( sourceOfReversal == "recovery") {

            this.onClickRevertRecovery();

        }

        for (let i=0; i < updatedReviewItems.length; i++) {

            updatedReviewItems[i].id = null;

            if (sourceOfReversal != "revision")
            {
                for (let j = 0; j <  valueUpdates.length; j++) {

                    valueUpdate = valueUpdates[j]();
                    if (updatedReviewItems[i].tag.id == valueUpdate.tagId) {

                        specExtras = updatedReviewItems[i].tag.specifications_extra;

                        updatedValues = valueUpdate.updatedValues();


                        for (let k=0; k< updatedValues.length; k++) {

                            updatedValue = updatedValues[k]();
                            valueExisted = false;
                            for (let l=0; l < specExtras.length; l++) {

                                if (specExtras[l].idField == updatedValue.fieldId ) {
                                    specExtras[l].value = updatedValue.chosenValue();
                                    valueExisted = true;
                                    break;
                                }
                            }
                            if (!valueExisted) {
                                specExtras.push({
                                    idField:updatedValue.fieldId,
                                    value: updatedValue.chosenValue(),
                                })
                            }
                        }
                        break;
                    }
                }
            }
        }
        this.productReview.setReviewItems(updatedReviewItems)
        this.makeBodyScrollableAgain();
        this.getTemplateViewModel().isReviewItemUpdatesFormShown(false);

    }

    protected onReviewItemUpdateCancel() {

        this.getTemplateViewModel().tagNameChanges([]);
        this.getTemplateViewModel().fieldValueChanges([]);
        this.makeBodyScrollableAgain();
        this.getTemplateViewModel().isReviewItemUpdatesFormShown(false);
    }

    protected onClickRevertRecovery() {

        this.caller.sendToArticleContent(this.getTemplateViewModel().recoveryContent());
        this.caller.sendToArticleIntroText(this.recoveryReviewSection.getIntroText());

        //to delete exiting ones
        let items = this.articleDirectory.getDirectoryItems();
        items.forEach( item =>  this.articleDirectory.getTemplateViewModel().deletedDirectoryItems().push(item));

        this.articleDirectory.setSandboxDirectoryItems(this.recoveryDirectory.getTemplateViewModel().directoryItems());
    }

    protected onClickRevertSandboxRecovery() {

        if (confirm("Are you sure you want to overwrite the article sandbox? You will lose any unsaved changes.")) {
            let sandboxContent = this.getTemplateViewModel().sandboxRecoveryContent();
            this.caller.revertSandboxRecovery(sandboxContent);
            let recoverySandboxIntroText = this.recoverySandboxReviewSection.getIntroText();
            this.caller.revertSandboxIntroTextRecovery(recoverySandboxIntroText);
            let sandboxRecoveryReviewItems = this.recoverySandboxReviewSection.getReviewItems();
            this.productReviewSandbox.setReviewItems(sandboxRecoveryReviewItems);

            const clone = rfdc(); // clone otherwise it will update the originals too
            let sandBoxRecoveryDirectoryItems =  clone(this.recoverySandboxDirectory.getTemplateViewModel().directoryItems());
            this.sandboxDirectory.setDirectoryItems([]);
            this.sandboxDirectory.setSandboxDirectoryItems(sandBoxRecoveryDirectoryItems)

            this.checkIfSandboxHasContent();
        }
    }


    protected onClickRevertRepublishRecovery() {

        if (confirm("Are you sure you want to overwrite the article republish? You will lose any unsaved changes.")) {
            let republishContent = this.getTemplateViewModel().republishRecoveryContent();
            this.caller.revertRepublishRecovery(republishContent);
            let recoveryRepublishIntroText = this.recoveryRepublishReviewSection.getIntroText();
            this.caller.revertRepublishIntroTextRecovery(recoveryRepublishIntroText);
            let republishRecoveryReviewItems = this.recoveryRepublishReviewSection.getReviewItems();
            this.productReviewRepublish.setReviewItems(republishRecoveryReviewItems);

            const clone = rfdc(); // clone otherwise it will update the originals too
            let republishRecoveryDirectoryItems =  clone(this.recoveryRepublishDirectory.getTemplateViewModel().directoryItems());
            this.republishDirectory.setDirectoryItems([]);
            this.republishDirectory.setSandboxDirectoryItems(republishRecoveryDirectoryItems)

            let republishes = this.getTemplateViewModel().republishRecovery().republishes;
            if(republishes && republishes.length > 0) {
                let republish = republishes[0];
                this.republishDatePicker.setDate(republish.dateRepublished);
                if(republish.author) {
                    this.getTemplateViewModel().filterUser_republish_author.user(republish.author.valnet_user.fullNameAndLogin);
                    this.getTemplateViewModel().filterUser_republish_author.idUser(republish.author.id);
                }
                if(republish.editor) {
                    this.getTemplateViewModel().filterUser_republish_SrEditor.user(republish.editor.valnet_user.fullNameAndLogin);
                    this.getTemplateViewModel().filterUser_republish_SrEditor.idUser(republish.editor.id);
                }
                if(republish.juniorEditor) {
                    this.getTemplateViewModel().filterUser_republish_JrEditor.user(republish.juniorEditor ? republish.juniorEditor.valnet_user.fullNameAndLogin : "");
                    this.getTemplateViewModel().filterUser_republish_JrEditor.idUser(republish.juniorEditor ? republish.juniorEditor.id : "");
                }
                if(republish.postPaymentCategory) {
                    this.getTemplateViewModel().paymentCategoryFilter.setSelectedOption(republish.postPaymentCategory.id);
                }
                if (republish.percentageAuthor) {
                    this.getTemplateViewModel().choosenPaymentTypeRepublish(AuthorPaymentTypeForRepublish.PERCENTAGE);
                    this.getTemplateViewModel().percentageAuthor(republish.percentageAuthor);
                }
                if (republish.amountAuthor) {
                    this.getTemplateViewModel().choosenPaymentTypeRepublish(AuthorPaymentTypeForRepublish.AMOUNT);
                    this.getTemplateViewModel().amountAuthor(republish.amountAuthor);
                }
                this.getTemplateViewModel().percentageEditor(republish.percentageEditor);
            }

            this.checkIfRepublishHasContent();
        }
    }

    protected onClickRevertRevision() {

        let revisionIndex = this.getTemplateViewModel().selectedRevisionIndex();
        let revision = this.getTemplateViewModel().revisions()[revisionIndex];

        //to delete exiting ones
        let items = this.articleDirectory.getDirectoryItems();
        items.forEach( item =>  this.articleDirectory.getTemplateViewModel().deletedDirectoryItems().push(item));
        this.articleDirectory.setDirectoryItems([]);

        //set new
        this.articleDirectory.setDirectoryItemsObservable(revision.content.directoryItems);

        this.caller.sendToArticleContent(revision.content.content);
        this.caller.sendToArticleIntroText(revision.content.introText);
    }

    protected onClickCancelFaq() {

        this.getTemplateViewModel().isFaqAddFormShown(false);
    }

    protected onScrollSaveBoxSticky(data, event) {
        console.log(data, event);
        let elem = event.target;
        console.log(elem)
        // continue with scroll
        return true;
    }

    protected onClickSaveFaq() {

        let selectedFaqIndex = this.getTemplateViewModel().selectedFaqIndex();
        let faqs = this.getTemplateViewModel().faqs();
        let question = this.getTemplateViewModel().question();
        let answer = this.caller.getFaqAnswer();

        if (answer != null && answer != "" && question != null && question != "") {

            let faq = {question: question, answer: answer};
            if (selectedFaqIndex != null) {
                faqs[selectedFaqIndex] = faq;
            } else {
                faqs.push(faq);
            }

            this.getTemplateViewModel().faqs(faqs);
            this.getTemplateViewModel().selectedFaqIndex(null);
            this.clearFaqForm();
            this.getTemplateViewModel().isFaqAddFormShown(false);
        }

    }

    protected clearFaqForm() {
        this.getTemplateViewModel().question("");
        this.caller.clearFaqAnswer();
    }


    protected onClickSave() {

        if(!this.validateArticleStatusChange()){
            return;
        }

        let type = "save";
        this.getTemplateViewModel().showNewRepublish(false);

        if (!this.caller.validateArticleSaveFrontEnd()) {
            return;
        }

        if (!this.interuptStatusChange(type)) {

            this.caller.saveEditArticle(type);
        }
    }

    protected onClickSaveAndStay() {

        if(!this.validateArticleStatusChange()){
            return;
        }

        let type = "stay";
        this.getTemplateViewModel().showNewRepublish(false);

        if (!this.caller.validateArticleSaveFrontEnd()) {
            return;
        }

        if (!this.interuptStatusChange(type)) {

            this.getTemplateViewModel().idPreviousStatus(this.getTemplateViewModel().idStatus());
            this.getTemplateViewModel().idPreviousRepublishStatus(this.getTemplateViewModel().idRepublishStatus());
            this.caller.saveEditArticle(type);
        }
    }

    /**
     * Checks for a change in status and interrupts the flow if necessary.
     * If it's interupted is also shows a modal..
     *
     * @return {boolean} Returns true if the flow was interrupted, false otherwise.
     */
    protected interuptStatusChange(type) {
        if (this.getTemplateViewModel().idTemplate() == ID_TEMPLATE_VIDEO 
            || this.getTemplateViewModel().idTemplate() == ID_TEMPLATE_THREAD 
            || this.getTemplateViewModel().idTemplate() == 13
            || this.getTemplateViewModel().idTemplate() == 17
        ) {
            return false;
        }

        let targetStatus = false;
        if (this.getTemplateViewModel().idStatus() !== this.getTemplateViewModel().idPreviousStatus()) {

            targetStatus = this.getTemplateViewModel().idStatus();
        } else if (this.getTemplateViewModel().idRepublishStatus() !== this.getTemplateViewModel().idPreviousRepublishStatus()) {

            targetStatus = this.getTemplateViewModel().idRepublishStatus();
        }

        if (targetStatus) {

            if(!this.validateAiWidgetSuggestions(targetStatus)) {
                const isShown = this.showAiWidgetSuggestionsPrompt(type);
                if(isShown) {
                    return true; // interupt the save
                }
            }


            let promptData = this.getPromptToShow(targetStatus,true,true);
            if (promptData) {

                this.showPromptModal(promptData, type);

                return true; // interupt the save
            }
        }

        return false;
    }

    protected showAiWidgetSuggestionsPrompt(saveType: 'save' | 'stay' | 'republish'): boolean {
        if (!this.getTemplateViewModel().aiSettings().widgetsSuggestionPromptAvailable) {
            return false;
        }
        if (!this.getTemplateViewModel().aiSettings().widgetsSuggestionInterruptSaveEnabled) {
            return false;
        }
        // if the user already dismissed the popup don't show it again
        if (this.isAiWidgetPopupDismissed) {
            return false;
        }

        const chatHistoryEl = this.getAssitantWindowEl();
        if (!chatHistoryEl) {
            return false;
        }

        // If AI has already run and found no recommendation, skip quietly
        const recEl = chatHistoryEl.querySelector('[data-widgets-recommended]') as HTMLElement | null;
        if (recEl && recEl.dataset.widgetsRecommended === "false") {
            return false;
        }

        let anchor: HTMLElement | null;
        let closeOnAnchorClick = false;
        let placement: AnchorPopupPlacement = 'left';
        let aiAlreadyRan = false;

        const insertBtn = this.getRecentAiWidgetInsertButton();
        if (recEl && recEl.dataset.widgetsRecommended === "true" && insertBtn) {
            // AI already ran with a recommendation — anchor to the insert button
            anchor = insertBtn;
            closeOnAnchorClick = true;
            aiAlreadyRan = true;
        } else {
            // AI hasn't run yet — fire the request now so the user message is
            // appended synchronously, then anchor the popup to that message.
            this.getTemplateViewModel().onClickAnalyzeWidgets();
            const messageEl = chatHistoryEl.querySelectorAll('.ai-userMessage-widgets');
            anchor = messageEl.length ? messageEl[messageEl.length - 1] as HTMLElement : chatHistoryEl;
        }

        const actionsTemplate = new publishAIActions_template(
            `publishAiActions_${Date.now()}`,
            {},
            this,
        );

        const popup = new AnchorPopup(anchor, {
            placement,
            closeOnOutsideClick: false,
            closeOnEscape: false,
            closeOnAnchorClick,
            showClose: false,
            showSubmit: false,
            cancelButtonText: 'Dismiss & Save',
            overlay: true,
            contentTemplate: actionsTemplate,
            onCancel: () => {
                this.aiWidgetPublishAnchorPopup = null;
                this.aiWidgetActionsTemplate = null;
                // track the dismiss so we don't show again
                this.isAiWidgetPopupDismissed = true;
                switch(saveType) {
                    case 'save':
                        this.onClickSave();
                        break;
                    case 'stay':
                        this.onClickSaveAndStay();
                        break;
                    case 'republish':
                        this.onClickRepublishCreateAndUpdate();
                        break;
                    default:
                        break;
                }
            },
            onSubmit: () => {
                this.aiWidgetPublishAnchorPopup.close();
                this.aiWidgetActionsTemplate = null;
                this.aiWidgetPublishAnchorPopup = null;
                const insertBtn = this.getRecentAiWidgetInsertButton();
                if(insertBtn) {
                    insertBtn.click();
                }
            }
        });

        this.aiWidgetActionsTemplate = actionsTemplate;
        this.aiWidgetPublishAnchorPopup = popup;

        if (aiAlreadyRan) {
            this.updateAiWidgetPopupFromChatResponse(popup);
            popup.open();
        } else {
            // addAiUserMessage queues its own requestAnimationFrame for scrollChatToBottom.
            // Use a double rAF so that scroll settles before we measure the anchor position.
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    popup.open();
                });
            });
        }

        return true;
    }
    
    protected getAssitantWindowEl(): HTMLElement | null {
        return document.getElementById("title-analysis-window");
    }
    protected getRecentAiWidgetInsertButton(): HTMLButtonElement | null {
        const chatHistoryEl = this.getAssitantWindowEl();
        if (!chatHistoryEl) {
            return null;
        }
        const buttons = chatHistoryEl.querySelectorAll('li.has-insert button[data-field="aiWidgets"]') as NodeListOf<HTMLButtonElement>;
        if (buttons.length === 0) {
            return null;
        }
        return buttons[buttons.length - 1];
    }

    /** Resolves the popup content once the widgets AI response is in the DOM. */
    protected updateAiWidgetPopupFromChatResponse(popup: AnchorPopup): void {
        const actionsTemplate = this.aiWidgetActionsTemplate;
        if (!actionsTemplate) return;

        const insertBtn = this.getRecentAiWidgetInsertButton();
        if (insertBtn) {
            insertBtn.onclick = () => {
                if (!this.aiWidgetPublishAnchorPopup) {
                    return;
                }
                this.aiWidgetPublishAnchorPopup.close();
                this.aiWidgetPublishAnchorPopup = null;
                this.aiWidgetActionsTemplate = null;
            }

            let title;
            const titleEl = insertBtn.parentElement.querySelector('[data-list-item-title]');
            if(titleEl && titleEl.textContent) {
                title = titleEl.textContent.trim();
            }

            actionsTemplate.setStepState(0, 'insert', () => {
                insertBtn.click();
            }, 'Insert At 66% Depth', title);
        } else {
            actionsTemplate.setStepState(0, 'complete');
        }
    }

    /**
     * Called after the widgets AI response has been rendered into the chat.
     * Updates the popup to reflect the recommendation (or auto-continues the save if none).
     * No-op when called outside the deferred-save flow.
     */
    public onWidgetsAiResponseRendered(): void {
        const popup = this.aiWidgetPublishAnchorPopup;
        if (!popup) {
            return;
        }

        const chatHistoryEl = this.getAssitantWindowEl();
        const recEl = chatHistoryEl
            ? (chatHistoryEl.querySelector('[data-widgets-recommended]') as HTMLElement | null)
            : null;

        if (!recEl || recEl.dataset.widgetsRecommended !== "true") {
            // No recommendation — mark the step as complete
            if (this.aiWidgetActionsTemplate) { this.aiWidgetActionsTemplate.setStepState(0, 'complete', null, null, 'No widgets are recommended'); }
            return;
        }

        this.updateAiWidgetPopupFromChatResponse(popup);
    }


    protected validateAiWidgetSuggestions(targetStatus): boolean {
        if (!this.getTemplateViewModel().aiSettings().widgetsSuggestionPromptAvailable) {
            return true;
        }

        const STATUS_CHANGES_REQUIRED = "3";
        const STATUS_COMPLETED = "6";
        
        if(targetStatus == STATUS_CHANGES_REQUIRED || targetStatus == STATUS_COMPLETED) {
            if (this.caller.validateEditorHasWidget()) {
                return true;
            }
            return false;
        }
        return true;
    }

    protected getPromptToShow(targetStatus,commentsRequired,isCancellable): any {

        let promptData: any = false;
        const STATUS_CHANGES_REQUIRED = "3";
        const STATUS_COMPLETED = "6";
        let contentType = this.getTemplateViewModel().idContentType();


        if (targetStatus == STATUS_CHANGES_REQUIRED || targetStatus == STATUS_COMPLETED) {

            this.caller.getSensaiResults("sensai_prompt", this.getTemplateViewModel().idContentType());

            promptData = {
                content: this.getTemplateViewModel().sensaiPromptContent(),
                idTargetStatus: targetStatus,
                commentsRequired: commentsRequired,
                isCancellable: isCancellable
            }

        }

        return promptData;
    }

    protected showPromptModal(promptData, type){

        if (!promptData.content) {
            return; // nothing to show anyway
        }

        this.sensaiPromptTemplate.setContent(promptData.content);
        this.sensaiPromptTemplate.setPromptType("sensaiPrompt");

        this.sensaiPromptTemplate.setAcceptText("Submit Feedback");
        this.sensaiPromptTemplate.setDeclineText("Cancel");
        this.setArticleReviewComments("");
        this.sensaiPromptTemplate.setAgree(this.failArticleReview.bind(this));
        this.sensaiPromptTemplate.setDecline(this.onClickContinueEditingAgreement.bind(this));
        this.sensaiPromptTemplate.setIdStatus(this.getTemplateViewModel().idStatus());
        this.sensaiPromptTemplate.setSaveType(type);
        this.sensaiPromptTemplate.setCommentsRequired(promptData.commentsRequired);
        this.sensaiPromptTemplate.setIsCancellable(promptData.isCancellable);

        // this shows the modal
        this.sensaiPromptTemplate.setShow(true);

    }

    public onClickCreateRepublishAndUpdateArticle(){

        let type = "republish";
        this.getTemplateViewModel().showNewRepublish(true);
        const republishItemsToDelete = this.getDirectoryItemsNotInRepublishDirectory();
        const directoryItemsToDelete = this.articleDirectory.getTemplateViewModel().deletedDirectoryItems();
        this.republishDirectory.getTemplateViewModel().deletedDirectoryItems.push(...directoryItemsToDelete, ...republishItemsToDelete);
        this.caller.save(type);
    }

    protected updateArticleOnRepublish(){

        this.caller.sendToArticleContent(this.getRepublishContent());
        this.caller.sendToArticleIntroText(this.getRepublishIntroText());
        this.productReview.setReviewItems(this.getRepublishReviewItems());
    }

    private validateSandboxOnRepublish(type){

        let isRepublish = this.getTemplateViewModel().showNewRepublish();
        let idRepublish = this.getTemplateViewModel().idRepublish();
        let sandboxData = this.caller.getSandboxEditorContent();
        this.setSaveType(type);
        //if creating new republish and sandbox is not empty, show warning message
        if(isRepublish && !idRepublish && sandboxData && sandboxData.replaceAll(' ','').replaceAll('<br/>','').replaceAll('\n','').replaceAll('&nbsp;','') != ""){

            this.setIsRepublishMessageVisible(true);
            return false;
        }

        return true;
    }

    protected onClickSaveAndPreview(contentType) {

        this.getTemplateViewModel().previewContentType(contentType);
        this.caller.saveEditArticle("preview");
    }

    protected onClickSaveAndPreviewAMP(contentType) {

        this.getTemplateViewModel().previewContentType(contentType);
        this.caller.saveEditArticle("preview-amp");
    }

    protected onClickPreviewNoSave(contentType) {

        this.getTemplateViewModel().previewContentType(contentType);
        this.caller.previewNoSaveArticle("preview", "desktop");
    }

    protected onClickMobilePreviewNoSave(contentType) {

        this.getTemplateViewModel().previewContentType(contentType);
        this.caller.previewNoSaveArticle("preview", "mobile");
    }

    protected onClickDeleteSandbox() {

        this.warningDialog_sandboxDelete.setIsVisible(true);
    }

    protected onClickDeleteRepublish() {

        this.warningDialog_republishDelete.setIsVisible(true);
    }

    protected onClickRepublishCreateAndUpdate() {

        if(!this.validateAiWidgetSuggestions(3)) {
            const isShown = this.showAiWidgetSuggestionsPrompt('republish');
            if(isShown) {
                return;
            }
        }

        this.warningDialog_republishCreateAndUpdate.setIsVisible(true);
    }

    protected onClickPreviewAMPNoSave(contentType) {

        this.getTemplateViewModel().previewContentType(contentType);
        this.caller.previewNoSaveArticle("preview-amp");
    }

    public getContentTypeToPreview(): string {

        let activeTag = this.getTemplateViewModel().previewContentType();
        if (this.previewableTabs.indexOf(activeTag) !== -1) {
            return activeTag;
        }

        return Previewable.ARTICLE;
    }

    protected onClickViewOnSite() {

        let brand = this.getTemplateViewModel().brand();
        let permalink = this.getTemplateViewModel().permalink();
        this.caller.viewArticleOnSite(brand, permalink);
    }

    protected onClickViewOnSiteAMP() {

        let brand = this.getTemplateViewModel().brand();
        let permalink = this.getTemplateViewModel().permalink();
        this.caller.viewArticleOnSiteAMP(brand, permalink);
    }

    public setAutoCategorizationGenerationAttemptsRemaining(attempts): void {

        let attemptsRemaining = 4;

        if(attempts){
            attemptsRemaining = 4 - attempts;

            if (attemptsRemaining < 0) {
                attemptsRemaining = 0;
            }
        }

        this.getTemplateViewModel().autoCategorizationGenerationAttemptsRemaining(attemptsRemaining);
    }

    public setKeyPointsGenerationAttemptsRemaining(id): void {

        //this.getTemplateViewModel().keyPointsGenerationAttemptsRemaining(id);
    }

    public setId(id): void {

        this.getTemplateViewModel().id(id);
    }

    public setDateLastPreview(dateLastPreview): void {

        this.getTemplateViewModel().dateLastPreview(dateLastPreview);
    }


    public getId() {

        return this.getTemplateViewModel().id();
    }

    public getIdContentType() {

        return this.getTemplateViewModel().idContentType();
    }

     public getTitle() {

        return this.getTemplateViewModel().title();
    }

    public setBrand(brand): void {

        this.getTemplateViewModel().brand(brand);
        this.articlePicker.setBrand(brand);
    }

    public setTitle(title): void {

        this.getTemplateViewModel().title(title);

        if(title){
            const fieldElement = document.getElementById('article-title');
            if (fieldElement && fieldElement instanceof HTMLTextAreaElement) {
                setTimeout(() => {
                }, 0);
                fieldElement.style.height = '';
                const neededHeight = fieldElement.scrollHeight;
                fieldElement.style.height = neededHeight + 'px';
            }
        }
        // Resize textarea after setting value
    }

    public setIdTemplate(idTemplate): void {
        this.getTemplateViewModel().idTemplate(idTemplate);
        this.productReview.setIdTemplate(idTemplate);
        this.productReviewSandbox.setIdTemplate(idTemplate);
        this.productReviewRepublish.setIdTemplate(idTemplate);
        this.recoverySandboxReviewSection.setIdTemplate(idTemplate);
        this.recoveryRepublishReviewSection.setIdTemplate(idTemplate);
        this.recoveryReviewSection.setIdTemplate(idTemplate);
        this.revisionReviewSection.setIdTemplate(idTemplate);
    }



    public getIdTemplate() {

        return this.getTemplateViewModel().idTemplate();
    }


    public setDateUpdated(dateUpdated): void{

        this.getTemplateViewModel().dateUpdated(this.formatDateTime(dateUpdated));
    }

    public setDateCreated(dateCreated): void{

        this.getTemplateViewModel().dateCreated(this.formatDateTime(dateCreated));
    }

    public setDateRecovery(dateRecovery): void{

        this.getTemplateViewModel().dateRecovery(dateRecovery);
    }

    public setRecoveryUser(recoveryUser): void{

        this.getTemplateViewModel().recoveryUser(recoveryUser);
    }

    public setRecovery(recovery): void{

        this.getTemplateViewModel().recovery(recovery);
    }

    public setSandboxRecovery(recovery): void{

        this.getTemplateViewModel().sandboxRecovery(recovery);
    }

    public setRepublishRecovery(recovery): void{

        this.getTemplateViewModel().republishRecovery(recovery);
    }

    public setIdRevisionSelected(idRevisionSelected): void{
        this.getTemplateViewModel().idRevisionSelected(idRevisionSelected);
    }

    public setRecoveryContent(recoveryContent): void{

        this.getTemplateViewModel().recoveryContent(recoveryContent);
    }

    public setSandboxRecoveryContent(sandboxRecoveryContent): void{

        this.getTemplateViewModel().sandboxRecoveryContent(sandboxRecoveryContent);
    }

    public setRepublishRecoveryContent(republishRecoveryContent): void{

        this.getTemplateViewModel().republishRecoveryContent(republishRecoveryContent);
    }

    public setRevisionContent(revisionContent): void{

        this.getTemplateViewModel().revisionContent(revisionContent);
    }

    public setRevisionIntroText(revisionIntroText): void{

        this.revisionReviewSection.setIntroText(revisionIntroText);
    }

    public setRevisionReviewItems(revisionReviewItems): void{

        this.revisionReviewSection.setReviewItems(revisionReviewItems);
    }

    public setSandboxRecoveryIntroText(sandboxRecoveryIntroText): void{

        this.recoverySandboxReviewSection.setIntroText(sandboxRecoveryIntroText);
    }

    public setRepublishRecoveryIntroText(republishRecoveryIntroText): void{

        this.recoveryRepublishReviewSection.setIntroText(republishRecoveryIntroText);
    }

    public setRecoveryIntroText(recoveryIntroText): void{

        this.recoveryReviewSection.setIntroText(recoveryIntroText);
    }

    public setSelectedCategories(selectedCategories): void{

        this.getTemplateViewModel().selectedCategories(selectedCategories);
    }


    public setSelectedTags(selectedTags): void {

        selectedTags.forEach((t) => {
            let formattedTagTypeAndDataset = '';
            if (t.tag.type != null) {
                formattedTagTypeAndDataset = ' (' + t.tag.type.name +')';
            }

            if (!t.tag['formattedTagTypeAndDataset']) {

                t.tag['formattedTagTypeAndDataset'] = formattedTagTypeAndDataset
            }
        });

        this.getTemplateViewModel().selectedTags(selectedTags);
    }

    public showReviewItemForm() {

        this.makeBodyUnscrollable();
        this.getTemplateViewModel().isReviewProductFormShown(true);
    }

    public hideReviewItemForm() {

        this.makeBodyScrollableAgain();
        this.getTemplateViewModel().isReviewProductFormShown(false);
        this.clearReviewItemForm();
    }

    public addValidationClass() {

        document.body.classList.add('_form-sub')
    }

    public removeValidationClass() {

        document.body.classList.remove('_form-sub')
    }

    public addTagPickerValidationClass() {

        document.body.classList.add('_tagpicker')
    }

    public removeTagPickerValidationClass() {

        document.body.classList.remove('_tagpicker')
    }

    public setSelectedFilterCategories(categories): void{

        let selectedCategories = [];

        selectedCategories = categories.map(e => e.category);

        this.filterCategory.setSelectedItems(selectedCategories);
    }

    public setIdPrimaryCategory(idPrimaryCategory): void{

        this.getTemplateViewModel().idPrimaryCategory(idPrimaryCategory);
        this.getTemplateViewModel().selectedCategories().forEach( (category) => {
            if(category.category.id == idPrimaryCategory){
                this.getTemplateViewModel().primaryCategoryName(category.category);
            }
        });
    }

    public setIdPrimaryTag(idPrimaryTag): void{

        this.getTemplateViewModel().idPrimaryTag(idPrimaryTag);
        this.getTemplateViewModel().selectedTags().forEach( (tag) => {
            if(tag.tag.id == idPrimaryTag){
                this.getTemplateViewModel().primaryTagName(tag.tag);
            }
        });
    }

    public setCategoryFilterItems(items){

        this.getTemplateViewModel().categories(items);
        this.filterCategory.setItems(items);
    }

    public setContentPresets(contentPresets): void {
        this.getTemplateViewModel().contentPresets(contentPresets);
    }

    public setExcerpt(excerpt): void{

        this.getTemplateViewModel().excerpt(excerpt);

        if(excerpt){
            // Resize textarea after setting value
            const fieldElement = document.getElementById('article-excerpt');
            if (fieldElement && fieldElement instanceof HTMLTextAreaElement) {
                fieldElement.style.height = '';
                const neededHeight = fieldElement.scrollHeight;
                fieldElement.style.height = neededHeight + 'px';
            }

        }
    }

    public setDisplayConfiguration(displayConfiguration): void{

        this.getTemplateViewModel().displayConfiguration(displayConfiguration);
    }

    public setIsAdHidden(isAdHidden): void{

        this.getTemplateViewModel().isAdHidden(isAdHidden);
    }

    public setIsUnderEmbargo(isUnderEmbargo): void{

        this.getTemplateViewModel().isUnderEmbargo(isUnderEmbargo);
    }

    public setIsAmpDisabled(isAmpDisabled): void{

        this.getTemplateViewModel().isAmpDisabled(isAmpDisabled);
    }

    public setIsAffiliateLinkerEnabled(isAffiliateLinkerEnabled): void{

        this.getTemplateViewModel().isAffiliateLinkerEnabled(isAffiliateLinkerEnabled);
    }

    public setInstareadOption(value): void{

        this.getTemplateViewModel().isInstareadEnabled(value);
    }

    public setAudioReaderOption(value): void{

        this.getTemplateViewModel().isAudioReaderEnabled(value);
    }

    public setAudioReaderState(data, clearMessages = true): void{

        const vm = this.getTemplateViewModel();
        data = data || {};
        const latest = data.latest || data.history || null;
        vm.isAudioReaderStateLoading(false);
        vm.isAudioReaderEnabled(data.isAudioReaderEnabled || false);
        vm.audioReaderFileUrl((latest && latest.fileUrl ? latest.fileUrl : "") || data.audioReaderFileUrl || "");
        vm.audioReaderMetadataUrl((latest && latest.metadataUrl ? latest.metadataUrl : "") || data.audioReaderMetadataUrl || "");
        setTimeout(() => this.initializeAudioReaderPreviewPlayer(), 0);
        vm.isAudioReaderDifferentFromSavedContent(data.isCurrentAudioDifferentFromSavedContent || false);

        const isLatestForCurrentInput = latest && latest.inputHash && data.currentInputHash
            ? latest.inputHash === data.currentInputHash
            : true;
        vm.audioReaderStatus(latest && latest.status && isLatestForCurrentInput ? `Audio status: ${latest.status}` : "");
        // Only current-hash queue rows should disable generation; stale rows are
        // ignored so editors can request audio again after changing the article.
        const isBackgroundPending = latest
            && latest.isQueued
            && isLatestForCurrentInput
            && (latest.status === "pending" || latest.status === "generating");
        vm.isAudioReaderBackgroundGenerationPending(!!isBackgroundPending);
        if (clearMessages) {
            if (latest && latest.status === "failed" && latest.errorMessage) {
                vm.audioReaderErrorMessage(latest.errorMessage);
                vm.audioReaderNoticeMessage("");
            } else {
                vm.audioReaderErrorMessage("");
                vm.audioReaderNoticeMessage(isBackgroundPending
                    ? "Audio generation is already scheduled for this article version. You can keep working and check back later."
                    : "");
            }
        }
    }

    public setIsDevelopingStory(isDevelopingStory): void{

        this.getTemplateViewModel().isDevelopingStory(isDevelopingStory);
    }

    public setIsSyndicated(isSyndicated): void{

        this.getTemplateViewModel().isSyndicated(isSyndicated);
    }

    public setNoAuthorship(noAuthorship): void{

        const vm = this.getTemplateViewModel();
        vm.noAuthorship(vm.isSyndicated() && noAuthorship);
    }

    public setExternalAuthorName(externalAuthorName): void{

        this.getTemplateViewModel().externalAuthorName(externalAuthorName || "");
    }

    public setIsLinkToOriginalArticle(isLinkToOriginalArticle): void{

        this.getTemplateViewModel().isLinkToOriginalArticle(isLinkToOriginalArticle || false);
    }

    public setReference(reference): void{

        this.getTemplateViewModel().reference(reference);
    }

    public setAICategories(categories): void{

        let selectedCats = this.getTemplateViewModel().selectedCategories();

        for(let cat of categories){

            let existingCat = selectedCats.find(c => c.category.id == cat.id);

            if (!existingCat) {
                selectedCats.push({id: null, category: cat, isAIGenerated: true});
            }
        }
        this.getTemplateViewModel().selectedCategories(selectedCats);
        this.setSelectedFilterCategories(selectedCats);
    }

    public setAITags(tags): void{

        let selectedTags = this.getTemplateViewModel().selectedTags();

        for(let tag of tags){

            let existingTag = selectedTags.find(t => t.tag.id == tag.id);

            if (!existingTag) {
                if (!tag.formattedTagTypeAndDataset) {
                    tag.formattedTagTypeAndDataset = '';
                }
                if(tag.tagType != null){
                    tag.type = {};
                    tag.type.id = tag.idType;
                    tag.type.name = tag.tagType;
                    tag.formattedTagTypeAndDataset = '(' + tag.tagType + ')';

                }
                selectedTags.push({id: null, tag: tag, isAIGenerated: true});
            }
        }

        this.getTemplateViewModel().selectedTags(selectedTags);
    }

    public setPermalink(permalink): void{

        this.getTemplateViewModel().permalink(permalink);
    }

    public setDatePublished(datePublished): void{

        this.getTemplateViewModel().datePublished(this.formatDateTime(datePublished));
    }

    public getDatePublished(){

        return this.getTemplateViewModel().datePublished();
    }

    public setDateMostRecentPublishedStatus(dateMostRecentPublishedStatus): void{

        this.getTemplateViewModel().dateMostRecentPublishedStatus(this.formatDateTime(dateMostRecentPublishedStatus));
    }

    public setDateLastPublishStatus(dateLastPublishStatus): void{

        this.getTemplateViewModel().dateLastPublishStatus(this.formatDateTime(dateLastPublishStatus));
    }

    public setDateMostRecentPublishStatus(dateMostRecentPublishStatus): void{

        return this.getTemplateViewModel().dateMostRecentPublishStatus(this.formatDateTime(dateMostRecentPublishStatus));
    }

    public setIsUpdateTime(isUpdateTime): void{

        return this.getTemplateViewModel().isUpdateTime(isUpdateTime);
    }

    public setContentKeyPoints(contentKeyPoints): void{

        return this.getTemplateViewModel().contentKeyPoints(contentKeyPoints);
    }

    public setArticlePageSettings(articlePageSettings) {

        this.getTemplateViewModel().articlePageSettings(articlePageSettings);
        this.applyAudioReaderDefaultIfEligible();
    }

    public setDateLastStatus(dateLastStatus): void{

        this.getTemplateViewModel().dateLastStatus(this.formatDateTime(dateLastStatus));
    }

    public setDateLastSyncStatus(dateLastSyncStatus): void{

        this.getTemplateViewModel().dateLastSyncStatus(this.formatDateTime(dateLastSyncStatus));
    }

    public setAuthor(author): void{

        this.getTemplateViewModel().filterUser_author.users(author);
        this.getTemplateViewModel().filterUser_author.user(author.valnet_user.fullNameAndLogin);
        this.getTemplateViewModel().filterUser_author.idUser(author.id);
        this.getTemplateViewModel().author(author);

    }

    public setDisplayAuthors(displayAuthors: Array<User>): void{

        this.display_authors.setUsers(displayAuthors);
        // this.getTemplateViewModel().filterUser_display_author.user(displayAuthor.valnet_user.fullNameAndLogin);
        // this.getTemplateViewModel().filterUser_display_author.idUser(displayAuthor.id);
        // this.getTemplateViewModel().displayAuthor(displayAuthor);

    }

    public setSensaiPrompt(sensaiPrompt): void{
        this.getTemplateViewModel().sensaiPromptContent([]);
        this.getTemplateViewModel().sensaiPromptContent(sensaiPrompt);

    }

    public getSensaiPrompt(): string{
        return this.getTemplateViewModel().sensaiPrompt();
    }

    public disableContributorFields(){

        let permissions = this.getTemplateViewModel().permissions();

        if(!permissions['article_edit_publishingControl'].write){

            this.filterUser_SrEditor.setDisabled(true);
            // this.filterUser_republish_SrEditor.setDisabled(true);
            this.filterUser_JrEditor.setDisabled(true);
            this.filterUser_ideator.setDisabled(true);
            // this.filterUser_republish_JrEditor.setDisabled(true);
            this.filterUser_display_author.setDisabled(true);
        }

        if(!permissions['article_edit_brand'].write){

            this.filterUser_author.setDisabled(true);
            // this.filterUser_republish_author.setDisabled(true);
        }

    }

    public setEditor(editor): void{

        this.getTemplateViewModel().filterUser_SrEditor.users(editor);
        this.getTemplateViewModel().filterUser_SrEditor.user(editor.valnet_user.fullNameAndLogin);
        this.getTemplateViewModel().filterUser_SrEditor.idUser(editor.id);
        this.getTemplateViewModel().editor(editor);
    }

    public setJrEditor(jrEditor): void{

        this.getTemplateViewModel().filterUser_JrEditor.users(jrEditor);
        this.getTemplateViewModel().filterUser_JrEditor.user(jrEditor.valnet_user.fullNameAndLogin);
        this.getTemplateViewModel().filterUser_JrEditor.idUser(jrEditor.id);
        this.getTemplateViewModel().jrEditor(jrEditor);
    }

    public setIdeator(ideator): void{

        this.getTemplateViewModel().filterUser_ideator.users(ideator);
        this.getTemplateViewModel().filterUser_ideator.user(ideator.valnet_user.fullNameAndLogin);
        this.getTemplateViewModel().filterUser_ideator.idUser(ideator.id);
        this.getTemplateViewModel().ideator(ideator);
    }

    public setTargetAudience(targetAudience): void{

        this.getTemplateViewModel().targetAudience(targetAudience);
    }

    public setIntent(intent): void{

        this.getTemplateViewModel().intent(intent);
    }

    public setContentType(contentType): void{

        this.getTemplateViewModel().contentType(contentType);
    }

    public setSegment(segment): void{
        this.getTemplateViewModel().segment(segment);
    }

    public setNetworkCategory(networkCategory): void{

        this.getTemplateViewModel().networkCategory(networkCategory);
    }

    public setPostPaymentCategory(postPaymentCategory): void{

        this.getTemplateViewModel().postPaymentCategory(postPaymentCategory);
    }

    public setAllowEditPermalink(allowEditPermalink): void{

        this.getTemplateViewModel().allowEditPermalink(allowEditPermalink);
    }

    public setAmazonsiteArticleTitle(amazonsiteArticleTitle): void{

        if(amazonsiteArticleTitle) {

            this.getTemplateViewModel().amazonsiteArticleTitle(amazonsiteArticleTitle);
        }else{

            this.getTemplateViewModel().amazonsiteArticleTitle(this.getTemplateViewModel().title());
        }
    }

    public setNewsNowArticleTitle(newsNowArticleTitle): void{

        if(newsNowArticleTitle) {

            this.getTemplateViewModel().newsNowArticleTitle(newsNowArticleTitle);
        }
    }


    public setAmazonsitePublishDate(PublishDate): void{
        if(PublishDate) {
            this.getTemplateViewModel().amazonsitePublishDate(PublishDate);
        }else{
            this.getTemplateViewModel().amazonsitePublishDate(this.getTemplateViewModel().dateMostRecentPublishedStatus());
        }
    }

    public setUpdateAmazonsitePublishDate(updateAmazonsitePublishDate): void{
        this.getTemplateViewModel().updateAmazonsitePublishDate(updateAmazonsitePublishDate);
    }


    public setAmazonOnSiteDate(date): void{
        this.getTemplateViewModel().amazonsitePublishDate(date);
    }

    public setDateScheduled(date): void {

        let permissions = this.getTemplateViewModel().permissions();

        if (!permissions['article_edit_publishingControl'].write) {

            this.scheduleDatePicker.setIsPickerDisabled(true);
        }

        if (date != '') {

            this.scheduleDatePicker.setDate(date);
        } else {

            this.scheduleDatePicker.setDate(this.getFormattedEasternTimeZoneDateTime());
        }
    }

    public setDateDevelopingStoryCoverageStartAndEnd(dateStart, dateEnd?): void {
        this.dateDevelopingStoryCoverageStartPicker.setDate(dateStart);
        if (dateEnd !== undefined && dateEnd !== null) {
            this.dateDevelopingStoryCoverageEndPicker.setDate(dateEnd);
        }
    }

    public setListOrder(listOrder): void{
        this.getTemplateViewModel().listOrder(listOrder);
    }

    public setSeoTitle(seoTitle): void{

        this.getTemplateViewModel().seoTitle(seoTitle);
    }

    public setSeoDescription(seoDescription): void{

        this.getTemplateViewModel().seoDescription(seoDescription);
    }

    public setSmoTitle(smoTitle): void{

        this.getTemplateViewModel().smoTitle(smoTitle);
    }

    public setSmoDescription(smoDescription): void{

        this.getTemplateViewModel().smoDescription(smoDescription);
    }

    public setSocialTagLine(socialTagLine){
        this.getTemplateViewModel().socialTagLine(socialTagLine);
    }

    public setFileUrl(url){

        this.getTemplateViewModel().fileUrl(url);
    }

    public setTableOfContents(tableOfContents){

        this.getTemplateViewModel().tableOfContents(tableOfContents);
    }

    public setIsNewsNowArticle(isNewsNowArticle){
        this.getTemplateViewModel().isNewsNowArticle(isNewsNowArticle);
    }

    public setIsSponsored(isSponsored){
        this.getTemplateViewModel().isSponsored(isSponsored);
    }


    public setImage(image, target){
        if(target == 'thumbnail_image'){
            this.imageWidgetForThumbnailImage.setImage(image)
            this.getTemplateViewModel().featuredThumbnailImage(image);
            this.clearDefaultCropPosition('thumbnailImage');
        }

        if(target == 'alternate_image'){
            this.imageWidgetForAlternateImage.setImage(image)
        }

        if(target == 'featured_image' || target == 'featured_image_embed'){
            this.imageWidgetForFeaturedImage.setImage(image);
            this.getTemplateViewModel().featuredImage(null);
            this.getTemplateViewModel().featuredImage(image);
            this.setIsFeaturedImageMobileOptimized(image.isMobileOptimized);
            this.clearDefaultCropPosition('featuredImage');
        }
    }

    public setImageCropPositions(imageCropPositions): void {
        this.getTemplateViewModel().imageCropPositions(this.normalizeImageCropPositions(imageCropPositions));
        this.refreshCropPreviewImages();
    }

    public getImageCropPositions() {
        return this.normalizeImageCropPositions(this.getTemplateViewModel().imageCropPositions());
    }

    protected normalizeImageCropPositions(imageCropPositions) {
        if (!imageCropPositions) {
            return null;
        }

        const normalized: any = {};
        ['featuredImage', 'thumbnailImage'].forEach((slot) => {
            const crop = imageCropPositions[slot] && imageCropPositions[slot].default;
            if (!crop) {
                return;
            }

            // parseInt yields an integer or NaN, and NaN fails the comparison below
            const x = parseInt(crop.x, 10);
            const y = parseInt(crop.y, 10);

            if (x >= 0 && y >= 0) {
                normalized[slot] = { default: { x, y } };
            }
        });

        return Object.keys(normalized).length > 0 ? normalized : null;
    }

    protected getDefaultCropPosition(slot: string) {
        const imageCropPositions = this.getTemplateViewModel().imageCropPositions();
        return imageCropPositions && imageCropPositions[slot] ? imageCropPositions[slot].default : null;
    }

    protected setDefaultCropPosition(slot: string, x: number, y: number): void {
        const imageCropPositions = this.normalizeImageCropPositions(this.getTemplateViewModel().imageCropPositions()) || {};
        imageCropPositions[slot] = { default: { x, y } };
        this.getTemplateViewModel().imageCropPositions(imageCropPositions);
        this.refreshCropPreviewImages();
    }

    protected clearDefaultCropPosition(slot: string): void {
        const imageCropPositions = this.normalizeImageCropPositions(this.getTemplateViewModel().imageCropPositions()) || {};
        delete imageCropPositions[slot];
        this.getTemplateViewModel().imageCropPositions(Object.keys(imageCropPositions).length > 0 ? imageCropPositions : null);
        this.refreshCropPreviewImages();
    }

    protected buildCropPreviewUrl(image: any, cropPosition: any, width: number, height: number): string {
        if (!image || !image.url) {
            return '';
        }

        const separator = image.url.indexOf('?') === -1 ? '?' : '&';
        const cropUrl = image.url + separator + 'fit=crop&w=' + width + '&h=' + height;

        if (!cropPosition || cropPosition.x === undefined || cropPosition.y === undefined) {
            return cropUrl;
        }

        const cdnCropPosition = this.convertCropPositionToCdnCoordinates(image, cropPosition, width, height);

        return cropUrl + '&g=nowe:' + cdnCropPosition.x + ':' + cdnCropPosition.y;
    }

    protected convertCropPositionToCdnCoordinates(image: any, cropPosition: any, width: number, height: number) {
        const imageWidth = Number(image.width) || 0;
        const imageHeight = Number(image.height) || 0;
        const cropX = Number(cropPosition.x) || 0;
        const cropY = Number(cropPosition.y) || 0;

        if (!imageWidth || !imageHeight || !width || !height) {
            return {
                x: Math.max(0, Math.round(cropX)),
                y: Math.max(0, Math.round(cropY))
            };
        }

        const scale = Math.max(width / imageWidth, height / imageHeight);
        const resizedWidth = Math.round(imageWidth * scale);
        const resizedHeight = Math.round(imageHeight * scale);

        return {
            x: this.clampCropCoordinate(cropX * scale, resizedWidth - width),
            y: this.clampCropCoordinate(cropY * scale, resizedHeight - height)
        };
    }

    protected calculateCropSelectorBounds(imageWidth: number, imageHeight: number, outputWidth: number, outputHeight: number) {
        if (!imageWidth || !imageHeight || !outputWidth || !outputHeight) {
            return {
                cropWidth: imageWidth,
                cropHeight: imageHeight,
                maxX: 0,
                maxY: 0
            };
        }

        const imageAspect = imageWidth / imageHeight;
        const targetAspect = outputWidth / outputHeight;
        let cropWidth = imageWidth;
        let cropHeight = imageHeight;

        if (imageAspect > targetAspect) {
            cropHeight = imageHeight;
            cropWidth = Math.round(imageHeight * targetAspect);
        } else if (imageAspect < targetAspect) {
            cropWidth = imageWidth;
            cropHeight = Math.round(imageWidth / targetAspect);
        }

        cropWidth = Math.min(cropWidth, imageWidth);
        cropHeight = Math.min(cropHeight, imageHeight);

        return {
            cropWidth,
            cropHeight,
            maxX: Math.max(0, imageWidth - cropWidth),
            maxY: Math.max(0, imageHeight - cropHeight)
        };
    }

    protected clampCropCoordinate(value: number, max: number): number {
        return Math.max(0, Math.min(Math.round(value), Math.max(0, max)));
    }

    protected isCropPositionEnabledForCurrentBrand(): boolean {
        const vnAppZone = this.caller ? this.caller.getVnAppZone() : null;

        if (!vnAppZone || !vnAppZone.app || !vnAppZone.app.params) {
            return false;
        }

        return isImageCropPositionEnabled(vnAppZone.app.params.idBrand);
    }

    protected refreshSlotPreviewUrl(imageWidget: any, cropPosition: any, outputSize: { width: number, height: number }): void {
        if (!imageWidget) {
            return;
        }

        const image = imageWidget.getImage();
        if (!image || !image.url) {
            return;
        }

        imageWidget.getTemplateViewModel().imageURL(
            cropPosition
                ? this.buildCropPreviewUrl(image, cropPosition, outputSize.width, outputSize.height)
                : image.url
        );
    }

    protected refreshCropPreviewImages(): void {
        const vm = this.getTemplateViewModel();
        const cropEnabled = this.isCropPositionEnabledForCurrentBrand();
        const featuredImage = this.imageWidgetForFeaturedImage ? this.imageWidgetForFeaturedImage.getImage() : null;
        const featuredCrop = cropEnabled ? this.getDefaultCropPosition('featuredImage') : null;

        this.refreshSlotPreviewUrl(
            this.imageWidgetForFeaturedImage,
            featuredCrop,
            CROP_OUTPUT_SIZES.featuredImage
        );

        if (featuredImage && featuredImage.url && featuredCrop) {
            vm.featuredImageMobilePreviewUrl(
                this.buildCropPreviewUrl(
                    featuredImage,
                    featuredCrop,
                    CROP_OUTPUT_SIZES.featuredImageMobile.width,
                    CROP_OUTPUT_SIZES.featuredImageMobile.height
                )
            );
        } else {
            vm.featuredImageMobilePreviewUrl('');
        }

        this.refreshSlotPreviewUrl(
            this.imageWidgetForThumbnailImage,
            cropEnabled ? this.getDefaultCropPosition('thumbnailImage') : null,
            CROP_OUTPUT_SIZES.thumbnailImage
        );
    }

    public onClickOpenCropSelector(slot: string): void {
        const image = slot === 'thumbnailImage'
            ? this.imageWidgetForThumbnailImage.getImage()
            : this.imageWidgetForFeaturedImage.getImage();

        if (!image || !image.url) {
            return;
        }

        const vm = this.getTemplateViewModel();

        // Bounds derive from the target and image, so both must be set before reading them
        vm.cropSelectorTarget(slot);
        vm.cropSelectorImage(image);

        const cropBounds = vm.cropSelectorBounds();
        const cropPosition = this.getDefaultCropPosition(slot) || {
            x: Math.round(cropBounds.maxX / 2),
            y: Math.round(cropBounds.maxY / 2)
        };

        vm.cropSelectorX(this.clampCropCoordinate(cropPosition.x, cropBounds.maxX));
        vm.cropSelectorY(this.clampCropCoordinate(cropPosition.y, cropBounds.maxY));
        vm.isCropSelectorShown(true);
    }

    public onMouseDownCropSelectorFrame(data: any, event: any): boolean {
        const vm = this.getTemplateViewModel();
        const frameElement = event.currentTarget;
        const cropSurface = frameElement && frameElement.parentElement ? frameElement.parentElement : null;
        if (!cropSurface) {
            return false;
        }

        const surfaceRect = cropSurface.getBoundingClientRect();
        const image = vm.cropSelectorImage();
        const imageWidth = Number(image && image.width) || 1;
        const imageHeight = Number(image && image.height) || 1;
        const scaleX = imageWidth / surfaceRect.width;
        const scaleY = imageHeight / surfaceRect.height;
        const startClientX = event.clientX;
        const startClientY = event.clientY;
        const startX = Number(vm.cropSelectorX()) || 0;
        const startY = Number(vm.cropSelectorY()) || 0;
        const cropBounds = vm.cropSelectorBounds();

        const onMouseMove = (moveEvent: any) => {
            const nextX = startX + ((moveEvent.clientX - startClientX) * scaleX);
            const nextY = startY + ((moveEvent.clientY - startClientY) * scaleY);
            vm.cropSelectorX(this.clampCropCoordinate(nextX, cropBounds.maxX));
            vm.cropSelectorY(this.clampCropCoordinate(nextY, cropBounds.maxY));
            moveEvent.preventDefault();
        };

        const onMouseUp = (): void => {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        };

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        event.preventDefault();

        return false;
    }

    public onClickApplyCropSelector(): void {
        const vm = this.getTemplateViewModel();
        const slot = vm.cropSelectorTarget();
        if (!slot) {
            return;
        }

        const cropBounds = vm.cropSelectorBounds();
        const x = this.clampCropCoordinate(parseInt(vm.cropSelectorX(), 10) || 0, cropBounds.maxX);
        const y = this.clampCropCoordinate(parseInt(vm.cropSelectorY(), 10) || 0, cropBounds.maxY);
        this.setDefaultCropPosition(slot, x, y);
        this.onClickCancelCropSelector();
    }

    public onClickResetCropSelector(): void {
        const slot = this.getTemplateViewModel().cropSelectorTarget();
        if (slot) {
            this.clearDefaultCropPosition(slot);
        }
        this.onClickCancelCropSelector();
    }

    public onClickCancelCropSelector(): void {
        const vm = this.getTemplateViewModel();
        vm.isCropSelectorShown(false);
        vm.cropSelectorTarget(null);
        vm.cropSelectorImage(null);
    }

    public setIsFeaturedImageMobileOptimized(val) {
        this.getTemplateViewModel().IsFeaturedImageMobileOptimized(val);
    }

    public setTagImage(image){

        this.getTemplateViewModel().tagImage(image);
    }

    public setNextArticle(article){

        this.filterArticle.getTemplateViewModel().article(article.title);
        this.filterArticle.getTemplateViewModel().articleObj(article);
        this.filterArticle.getTemplateViewModel().idArticle(article.id);
    }

    public setDirectoryArticle(article) {

        this.getTemplateViewModel().filterArticle.showDetails(true);
        this.filterArticleDirectory.getTemplateViewModel().article(article.title);
        this.filterArticleDirectory.getTemplateViewModel().articleObj(article);
        this.filterArticleDirectory.getTemplateViewModel().idArticle(article.id);
        this.filterArticleDirectory.setDisableField(true);
    }

    public setUsers(users){

        this.getTemplateViewModel().filterUser_author.users(users);
        this.getTemplateViewModel().filterUser_SrEditor.users(users);
        this.getTemplateViewModel().filterUser_JrEditor.users(users);
        this.getTemplateViewModel().filterUser_ideator.users(users);
        this.getTemplateViewModel().filterUser_republish_author.users(users);
        this.getTemplateViewModel().filterUser_republish_SrEditor.users(users);
        this.getTemplateViewModel().filterUser_republish_JrEditor.users(users);
        this.getTemplateViewModel().filterUser_display_author.users(users);
    }

    public setFilterUserAuthor(users){

        this.getTemplateViewModel().filterUser_author.users(users);
    }

    public setFilterUserSrEditor(users){

        this.getTemplateViewModel().filterUser_SrEditor.users(users);
    }

    public setFilterUserJrEditor(users){

        this.getTemplateViewModel().filterUser_JrEditor.users(users);
    }

    public setFilterUserIdeator(users){
        this.getTemplateViewModel().filterUser_ideator.users(users);
    }

    public setFilterUserRepublishAuthor(users){

        this.getTemplateViewModel().filterUser_republish_author.users(users);
    }

    public setFilterUserScheduledRepublishAuthor(users){

        this.getTemplateViewModel().filterUser_scheduled_republish_author.users(users);
    }

    public setFilterUserRepublishSrEditor(users){

        this.getTemplateViewModel().filterUser_republish_SrEditor.users(users);
    }

    public setFilterUserScheduledRepublishSrEditor(users){

        this.getTemplateViewModel().filterUser_scheduled_republish_SrEditor.users(users);
    }

    public setFilterUserRepublishJrEditor(users){

        this.getTemplateViewModel().filterUser_republish_JrEditor.users(users);
    }

    public setFilterUserScheduledRepublishJrEditor(users){

        this.getTemplateViewModel().filterUser_scheduled_republish_JrEditor.users(users);
    }

    public setFilterUserDisplayAuthor(users){

        this.getTemplateViewModel().filterUser_display_author.users(users);
    }

    public setCanSearchUsers(canSearchUsers: boolean){

        this.filterUser_author.setIsVisible(canSearchUsers);
        this.filterUser_SrEditor.setIsVisible(canSearchUsers);
        this.filterUser_JrEditor.setIsVisible(canSearchUsers);
        this.filterUser_ideator.setIsVisible(canSearchUsers);
        this.filterUser_display_author.setIsVisible(canSearchUsers);

        this.filterUser_republish_author.setIsVisible(canSearchUsers);
        this.filterUser_republish_SrEditor.setIsVisible(canSearchUsers);
        this.filterUser_republish_JrEditor.setIsVisible(canSearchUsers);
        this.filterWebsiteUser_prompt_author.setIsVisible(canSearchUsers);
    }

    public deleteScheduledRepublish() {

        this.getTemplateViewModel().idDeleteRepublish(this.getTemplateViewModel().idRepublish());
        this.getTemplateViewModel().showScheduledRepublish(false)
        this.getTemplateViewModel().idRepublish(null);
        this.getTemplateViewModel().filterUser_scheduled_republish_author.user("");
        this.getTemplateViewModel().filterUser_scheduled_republish_author.idUser(null);
        this.getTemplateViewModel().filterUser_scheduled_republish_SrEditor.user("");
        this.getTemplateViewModel().filterUser_scheduled_republish_SrEditor.idUser(null);
        this.getTemplateViewModel().filterUser_scheduled_republish_JrEditor.user("");
        this.getTemplateViewModel().filterUser_scheduled_republish_JrEditor.idUser(null);
        this.getTemplateViewModel().scheduledRepublishPaymentCategoryFilter.setSelectedOption(null);
        this.getTemplateViewModel().showNewRepublish(false);
        this.getTemplateViewModel().showDeleteRepublishButton(false);
        this.getTemplateViewModel().scheduledAmountAuthor(null);
        this.getTemplateViewModel().scheduledPercentageAuthor(null);
        this.getTemplateViewModel().scheduledPercentageEditor(null);
    }

    public setArticleRepublishData(republishes): void {

        //filter to exclude non-reportable republish
        republishes = republishes.filter(republish => { return republish.isReportable == 1})

        //sort the array by date
        republishes.sort((a, b) => new Date(b.dateRepublished).valueOf() - new Date(a.dateRepublished).valueOf());

        //find the one which schedule
        let index = republishes.findIndex(element => element.publishStatus.id == 2);

        if (index != -1) {
            let scheduledRepublish = republishes[index];
            republishes.splice(index, 1);
            this.setScheduledRepublish(scheduledRepublish);
        }

        this.getTemplateViewModel().republishes(republishes);
    }

    public setScheduledRepublish(republish){

        this.getTemplateViewModel().showScheduledRepublish(true);
        this.getTemplateViewModel().showDeleteRepublishButton(true);
        this.getTemplateViewModel().idRepublish(republish.id);
        this.scheduledRepublishDatePicker.setDate(republish.dateRepublished);
        this.getTemplateViewModel().filterUser_scheduled_republish_author.user(republish.author.valnet_user.fullNameAndLogin);
        this.getTemplateViewModel().filterUser_scheduled_republish_author.idUser(republish.author.id);
        this.getTemplateViewModel().filterUser_scheduled_republish_SrEditor.user(republish.editor.valnet_user.fullNameAndLogin);
        this.getTemplateViewModel().filterUser_scheduled_republish_SrEditor.idUser(republish.editor.id);
        this.getTemplateViewModel().filterUser_scheduled_republish_JrEditor.user(republish.juniorEditor ? republish.juniorEditor.valnet_user.fullNameAndLogin : "");
        this.getTemplateViewModel().filterUser_scheduled_republish_JrEditor.idUser(republish.juniorEditor ? republish.juniorEditor.id : "");
        this.getTemplateViewModel().scheduledRepublishPaymentCategoryFilter.setSelectedOption(republish.postPaymentCategory.id);
        this.getTemplateViewModel().scheduledAmountAuthor(republish.amountAuthor);
        this.getTemplateViewModel().scheduledPercentageAuthor(republish.percentageAuthor);
        this.getTemplateViewModel().scheduledPercentageEditor(republish.percentageEditor);

        if(republish.percentageAuthor){
            this.getTemplateViewModel().choosenScheduledPaymentTypeRepublish(AuthorPaymentTypeForRepublish.PERCENTAGE)
        }else if(republish.amountAuthor){
            this.getTemplateViewModel().choosenScheduledPaymentTypeRepublish(AuthorPaymentTypeForRepublish.AMOUNT)
        }

    }

    public setRecoveryRepublishData(republish){

        this.getTemplateViewModel().republishRecoveryDate(republish.dateRepublished ? republish.dateRepublished : '');
        this.getTemplateViewModel().republishRecoveryAuthor(republish.author ? republish.author.valnet_user.fullName : '');
        this.getTemplateViewModel().republishRecoverySrEditor(republish.editor ? republish.editor.valnet_user.fullName : '');
        this.getTemplateViewModel().republishRecoveryJrEditor(republish.juniorEditor ? republish.juniorEditor.valnet_user.fullName : '');
        this.getTemplateViewModel().republishRecoveryPaymentCategory(republish.postPaymentCategory ? republish.postPaymentCategory.name : '');
        this.getTemplateViewModel().republishRecoveryAuthorAmount(republish.amountAuthor ? republish.amountAuthor : '');
        this.getTemplateViewModel().republishRecoveryAuthorPercentage(republish.percentageAuthor ? republish.percentageAuthor : '');
        this.getTemplateViewModel().republishRecoveryEditorPercentage(republish.percentageEditor ? republish.percentageEditor : '');
        this.getTemplateViewModel().republishRecoveryStatus(republish.status ? republish.status.name : '');
    }

    public setPublishStatuses(publishStatuses: Array<{}>): void{

        this.getTemplateViewModel().publishStatuses(publishStatuses);
    }

    public setPermalinkHistory(permalinkHistory) {
        this.getTemplateViewModel().permalinkHistory(permalinkHistory);
    }

    public setPermalinkRedirect(permalinkRedirect){
        this.getTemplateViewModel().permalinkRedirects(permalinkRedirect);
    }

    public setNetworkCategoryOptions(networkCategory_options: Array<{}>): void{

        this.getTemplateViewModel().networkCategory_options(networkCategory_options);
    }

    public setContentTypeOptions(contentType_options: Array<{}>): void{

        this.getTemplateViewModel().contentType_options(contentType_options);
    }

    public setSegmentOptions(segment_options: Array<{}>): void{
        this.getTemplateViewModel().segment_options(segment_options);
    }

    public setIntentOptions(intent_options: Array<{}>): void{

        this.getTemplateViewModel().intent_options(intent_options);
    }

    public setIdNetworkCategory(idNetworkCategory): void{

        this.getTemplateViewModel().idNetworkCategory(idNetworkCategory);
    }

    public setIdContentType(idContentType): void{

        this.getTemplateViewModel().idContentType(idContentType);
        this.applyAudioReaderDefaultIfEligible();
    }

    public setIdSegment(idSegment, segment): void{

        if (segment !== null) {
            const segment_options = this.getTemplateViewModel().segment_options();

            const segmentExists = segment_options.some(opt => opt.id === idSegment);

            if (!segmentExists) {
                this.getTemplateViewModel().segment_options([...segment_options, segment]);
            }
        }

        this.getTemplateViewModel().idSegment(idSegment);
    }

    public setIdIntent(idIntent): void{

        this.getTemplateViewModel().idIntent(idIntent);
    }

    public setPaymentCategoryOptions(paymentCategory_options: Array<{}>): void{

        this.getTemplateViewModel().paymentCategory_options(paymentCategory_options);
    }

    public setIdPaymentCategory(idPaymentCategory): void{

        this.resetPaymentCategoryOptionsWithCurrent(idPaymentCategory);
        this.getTemplateViewModel().idPaymentCategory(idPaymentCategory);
    }

    public resetPaymentCategoryOptionsWithCurrent(idPaymentCategory): void {

        let paymentCategoryOptions = this.getTemplateViewModel().paymentCategory_options();

        let newPaymentCategoryOptions = [];

        for (let i = 0; i < paymentCategoryOptions.length; i++) {
            let newPaymentCategoryGroup = {
                id: paymentCategoryOptions[i].id,
                name: paymentCategoryOptions[i].name,
                paymentCategories: []
            };

            for (let j = 0; j < paymentCategoryOptions[i].paymentCategories.length; j++) {

                let pc = paymentCategoryOptions[i].paymentCategories[j];
                if (pc.id === idPaymentCategory || pc.isDeleted === 0) {
                    newPaymentCategoryGroup.paymentCategories.push(pc);
                }
            }
            newPaymentCategoryOptions.push(newPaymentCategoryGroup);
        }

        this.setPaymentCategoryOptions(newPaymentCategoryOptions);
    }

    public setIdRepublishPaymentCategory(idRepublishPaymentCategory): void{

        this.getTemplateViewModel().idRepublishPaymentCategory(idRepublishPaymentCategory);
    }

    public setReviewCategory(reviewCategory): void{

        this.getTemplateViewModel().reviewCategory(reviewCategory);
    }

    public setReviewItems(reviewItems): void{

        this.productReview.setReviewItems(reviewItems);
    }

    public setSandboxReviewItems(reviewItems): void{

        this.productReviewSandbox.setReviewItems(reviewItems, 'sandbox');
    }

    public setArticleStatusOptions(articleStatus_options: Array<{}>): void{

        this.getTemplateViewModel().articleStatus_options(articleStatus_options);
    }

    public setArticleRepublishStatusOptions(articleRepublishStatus_options): void{

        this.getTemplateViewModel().articleRepublishStatus_options(articleRepublishStatus_options);
    }

    public setAffiliateLinksOptions(affiliateLinks_options: Array<{}>): void {

        this.getTemplateViewModel().affiliateLinks_options(affiliateLinks_options);
    }

    public setReviewItemTagOptions(reviewItemAward_options: Array<{}>): void{

        this.getTemplateViewModel().reviewItemAward_options(reviewItemAward_options);
    }

    public setIdArticleStatus(idStatus): void{

        this.getTemplateViewModel().idStatus(idStatus);
        this.sandboxContent.setIdStatus(idStatus);
        this.republishContent.setIdStatus(idStatus);
        this.articleContent.setIdStatus(idStatus);
        this.productReview.setIdStatus(idStatus);
        this.productReviewSandbox.setIdStatus(idStatus);
        this.productReviewRepublish.setIdStatus(idStatus);
        //
        this.imageWidgetForThumbnailImage.setIdStatus(idStatus);
        this.imageWidgetForAlternateImage.setIdStatus(idStatus);
        this.imageWidgetForFeaturedImage.setIdStatus(idStatus);
        // this.imageWidgetForFeaturedVideo.setIdStatus(idStatus);
    }

    public setPreviousIdArticleStatus(idStatus): void{

        this.getTemplateViewModel().idPreviousStatus(idStatus);
    }

    public setPreviousidRepublishStatus(idStatus): void{

        this.getTemplateViewModel().idPreviousRepublishStatus(idStatus);
    }

    public setIdSyncStatus(idSyncStatus): void{

        this.getTemplateViewModel().idSyncStatus(idSyncStatus);
    }

    public setSyncStatus(syncStatus): void{

        this.getTemplateViewModel().syncStatus(syncStatus);
    }

    public setIdPublishStatus(idPublishStatus): void{

        this.getTemplateViewModel().idPublishStatus(idPublishStatus);
    }

    public setArticleCurrentIdArticleStatus(articleCurrentIdArticleStatus): void{

        this.getTemplateViewModel().articleCurrentIdArticleStatus(articleCurrentIdArticleStatus);
    }


    public setFeaturedVideo(featuredVideo){
        this.getTemplateViewModel().featuredVideo(featuredVideo);
    }

    protected onClickAddMedia(){

        this.showImagePicker("multi-select", "content");
    }

    protected onClickAddFeaturedImage(){

        this.showImagePicker("single-select", "featuredImage");
    }

    protected onClickAddThumbnailImage(){

        this.showImagePicker("single-select", "thumbnailImage");
    }

    protected onClickEditThumbnailImage(){

        let thumbnailImage = this.getTemplateViewModel().thumbnailImage();
        this.showImagePicker("single-select", "thumbnailImage");
        this.imagePicker.editImage(thumbnailImage);
    }

    protected onClickViewThumbnailImage(){

        let thumbnailImageElement = document.getElementById("thumbnail-image");
        thumbnailImageElement.classList.add("is-viewing");
    }

    protected onClickCloseThumbnailImage() {

        let thumbnailImageElement = document.getElementById("thumbnail-image");
        thumbnailImageElement.classList.remove("is-viewing");
    }

    protected onClickAddTagImage(){

        this.showImagePicker("single-select", "tagImage");
    }

    protected onClickSelectProductImages(){

        this.showImagePicker("multi-select", "productImages");
    }


    protected onClickViewFeaturedImage(){
        let featuredImageElement = document.getElementById("featured-image");
        featuredImageElement.classList.add("is-viewing");
    }

    protected onClickCloseFeaturedImage() {

        let featuredImageElement = document.getElementById("featured-image");
        featuredImageElement.classList.remove("is-viewing");
    }

    protected onClickEditTagImage(){

        let tagImage = this.getTemplateViewModel().tagImage();
        this.showImagePicker("single-select", "tagImage");
        this.imagePicker.editImage(tagImage);
    }

    protected onClickViewTagImage(){

        let tagImageElement = document.getElementById("tagImage");
        tagImageElement.classList.add("is-viewing");
    }

    protected onClickCloseTagImage(){

        let tagImageElement = document.getElementById("tagImage");
        tagImageElement.classList.remove("is-viewing");
    }

    protected onClickAddAlternateImage(){

        this.showImagePicker("single-select", "alternateImage");
    }

    protected onClickEditAlternateImage(){

        let alternateImage = this.getTemplateViewModel().alternateImage();
        this.showImagePicker("single-select", "alternateImage");
        this.imagePicker.editImage(alternateImage);
    }

    protected onClickViewAlternateImage(){

        let alternateImageElement = document.getElementById("alternate-image");
        alternateImageElement.classList.add("is-viewing");
    }

    protected onClickCloseAlternateImage(){

        let alternateImageElement = document.getElementById("alternate-image");
        alternateImageElement.classList.remove("is-viewing");
    }

    public getImagePickerTarget(){
        return this.getTemplateViewModel().imagePickerTarget();
    }

    public setImagePickerTarget(imagePickerTarget)
    {
        this.getTemplateViewModel().imagePickerTarget(imagePickerTarget);
    }

    public setTagPickerTarget(tagPickerTarget){
        this.getTemplateViewModel().tagPickerTarget(tagPickerTarget);
    }

    public isImageInsertionSectionOptimizable(target) {

        let optimizableImagesSections: string[] = [
            'article_content',
            'article_faq',
            'article_directory_item_description',
            'article_republish',
            'article_sandbox',
            'featured_image'
        ];
        return (optimizableImagesSections.indexOf(target) != -1);
    }
    public showImagePicker(mode, target, selectedImages = [], keyword = null) {

        let targetName = target;
        if (target.editor) {
            targetName = target.editor;
        }

        let isImageInsertionSectionOptimizable = this.isImageInsertionSectionOptimizable(targetName);
        this.imagePicker.setIsImageOptimizable(isImageInsertionSectionOptimizable);
        this.imagePicker.setMode(mode);
        this.setImagePickerTarget(target);
        this.imagePicker.setTarget(targetName);
        this.imagePicker.setSelectedImages(selectedImages);
        this.caller.getImageData(keyword);
        if(mode == "multi-select"){
            this.caller.getImagesInContent(target);
        }
        this.imagePicker.show();
    }

    public showTagPicker(mode, target, filterKeyword = null){

        this.tagPicker.setMode(mode);
        this.tagPicker.setTarget(target);
        this.tagPicker.setSimpleFilterKeyword(filterKeyword);
        this.setTagPickerTarget(target);
        //this.caller.getTagData();
        this.tagPicker.show();
    }

    public showQuizPicker(mode, target, filterKeyword = null, quizElement = null){

        this.quizPicker.setTarget(target);
        this.quizPicker.setQuizElement(quizElement);
        this.quizPicker.setSimpleFilterKeyword(filterKeyword);
        this.setTagPickerTarget(target);
        //this.caller.getTagData();
        this.quizPicker.show();
    }

    public showPollPicker(mode, target, filterKeyword = null, pollElement = null){

        this.pollPicker.setTarget(target);
        this.pollPicker.setPollElement(pollElement);
        this.pollPicker.setSimpleFilterKeyword(filterKeyword);
        this.setTagPickerTarget(target);
        this.pollPicker.show();
    }

    public editTagElement(tagElement, editor){

        this.showTagPicker("in-content", editor);
        this.tagPicker.editTagElement(tagElement);
    }

    public editTagGroup(groupElement, editor){

        this.showTagPicker("in-content", editor);
        this.tagPicker.setTagGroupElement(groupElement);
    }

    protected onFocusOutTitle(event){

        let titleValue = event.target.value || '';

        if (event.target.value != null && event.target.value != "") {
            this.generatePermalink(event.target.value);
        }

        const cleanedValue = titleValue.replace(/[\r\n]+/g, ' ').trim();
        if (cleanedValue ) {
            this.getTemplateViewModel().title(cleanedValue);
        }
    }

    protected onFocusOutExcerpt(event){
        let excerptValue = event.target.value || '';
        if (excerptValue ) {
            this.getTemplateViewModel().excerpt(excerptValue);
        }
    }

    protected onFocusOutPermalink(event){

        const isHtmlBrand = [50].indexOf(this.caller.getIdBrand()) !== -1;

        let permalinkValue = event.target.value || '';

        // Remove special characters, only allow alphanumeric, "/", "-" and "_"
        let cleanedValue = isHtmlBrand ? permalinkValue.replace(/[^a-zA-Z0-9/\-_.]/g, '') : permalinkValue.replace(/[^a-zA-Z0-9/\-_]/g, '');
        if (isHtmlBrand) {
            // Replace multiple dots with a single dot
            cleanedValue = cleanedValue.replace(/\.{2,}/g, '.');
        }

        // Replace underscores with hyphens
        cleanedValue = cleanedValue.replace(/_/g, '-');

        // Convert all uppercase letters to lowercase
        cleanedValue = cleanedValue.toLowerCase();

        // Strip cases of double hyphens
        cleanedValue = cleanedValue.replace(/--+/g, '-');

        // Ensure it starts with "/"
        if (cleanedValue && !cleanedValue.startsWith('/')) {
            cleanedValue = '/' + cleanedValue;
        }

        // Ensure it ends with "/"
        if (cleanedValue && !cleanedValue.endsWith('/') && !isHtmlBrand) {
            cleanedValue = cleanedValue + '/';
        }

        if (cleanedValue) {
            this.getTemplateViewModel().permalink(cleanedValue);
        }

    }

    protected onFocusOutPrompt(event){

        let isTitleDisabled = this.getTemplateViewModel().isTitleDisabled();
        if (isTitleDisabled) {
            if (event.target.value != null && event.target.value != "") {
                this.generatePermalink(event.target.value);
            }
        }
    }

    protected generatePermalink(title){

        let p = this.getTemplateViewModel().permalink();

        if (p == null || p == "") {
            let permalink = '/' + title.toLowerCase().trim()
                    .replace(/[^\w -]+/g, '')
                    .replace(/[ _]+/g, '-')
                    .replace(/-{2,}/g, '-')
                    .replace(/-$/g, "")
                    .replace(/^-/g, "");

            if ([50].indexOf(this.caller.getIdBrand()) == -1) {
                permalink = permalink + '/';
            }

            permalink = this.prefixPermalink(permalink);
            this.getTemplateViewModel().permalink(permalink);
        }
    }

    protected prefixPermalink(permalink, idTemplate = this.getTemplateViewModel().idTemplate()){
        //console.log("original permlink: " + permalink);

        if (permalink && this.getTemplateViewModel().idStatus() != 6) {

            if (permalink.startsWith("/thread")) {
                permalink = permalink.replace("/thread", "");
            }
            if (permalink.startsWith("/video")) {
                permalink = permalink.replace("/video", "");
            }

            if (idTemplate == ID_TEMPLATE_VIDEO && !permalink.startsWith("/video")) {
                permalink = "/video" + permalink;
            }
            else if (idTemplate == ID_TEMPLATE_THREAD && !permalink.startsWith("/thread")) {
                permalink = "/thread" + permalink;
            }
        }
        //console.log("new permlink: " + permalink);
        return permalink;
    }

    public setIsLockMessageVisible(value) {

        this.getTemplateViewModel().isLockMessageVisible(value);
    }

    public setIsFaqDeleteVisible(value) {

        this.getTemplateViewModel().isFaqDeleteVisible(value);
    }

    public setLockMessage(value) {

        this.getTemplateViewModel().lockMessage(value);
    }

    public setIsKickoutMessageVisible(value) {

        this.getTemplateViewModel().isKickoutMessageVisible(value);
    }

    public setArticleLockedStatus(value) {
        this.getTemplateViewModel().isArticleLocked(value);
    }

    public setArticleReviewComments(value) {
        this.sensaiPromptTemplate.setComments(value);
        this.getTemplateViewModel().articleReviewComments(value);
    }

    public setNoticeMessage(value) {
        this.getTemplateViewModel().noticeMessage(value);
    }

    public setIsNoticeVisible(value) {
        this.getTemplateViewModel().isNoticeVisible(value);
    }

    public setArticleAutoSaveError(value) {
        this.getTemplateViewModel().isArticleAutoSaveError(value);
    }

    public setKickoutkMessage(value) {

        this.getTemplateViewModel().kickoutMessage(value);
    }

    protected onCancelTakeOver(){

        this.setIsLockMessageVisible(false);
        this.caller.cancelTakeOver();
    }

    protected onTakeOver(){

        this.setIsLockMessageVisible(false);
        this.getTemplateViewModel().showAutoSaveMessage(false);
        this.caller.editArticleData(true);
    }

    protected onKickout(){

        this.setIsKickoutMessageVisible(false);
        this.caller.onKickout();
    }

    protected closeNotice() {
        this.setIsNoticeVisible(false);
        this.caller.closeNotice();
    }

    protected onChangeArticleStatus(data) {

        if(data.idStatus() != 6) {
            this.getTemplateViewModel().idPublishStatus(1);
        }
    }

    protected onChangePublishStatus(data) {

        if(data.idPublishStatus() != 1) {
            this.getTemplateViewModel().idStatus(6);
        }
    }

    protected onClickAddReviewItem(){

        this.caller.validateReviewItem();

    }

    protected onClickCancelSaveReviewItem() {

        this.hideReviewItemForm()
        this.clearReviewItemForm();
        this.caller.clearValidationErrors();
    }

    public setProductImages(images) {

        for(let i = 0; i < images.length; i++) {
            this.addProductImage(images[i]);
        }
    }

    public addProductImage(image) {

        let imageSelected = this.getTemplateViewModel().reviewItemImages().find(x => x.id == image.id);
        if (!imageSelected) {
            let images = this.getTemplateViewModel().reviewItemImages();
            images.push(image);
            this.getTemplateViewModel().reviewItemImages([]);
            this.getTemplateViewModel().reviewItemImages(images);
        }
        this.onLoadTemplate('#img_list_product_review .img-article-item', this.reorderReviewItemImages.bind(this));

    }

    public onClickDeleteProductImage(data) {

        let index = this.getTemplateViewModel().reviewItemImages().findIndex(x => x.id == data.id);
        if(index != -1) {
            this.getTemplateViewModel().reviewItemImages.splice(index, 1);
        }
        this.onLoadTemplate('#img_list_product_review .img-article-item', this.reorderReviewItemImages.bind(this));

    }

    protected makeBodyUnscrollable() {
        document.body.classList.add('is-fixed');
    }

    protected makeBodyScrollableAgain() {
        document.body.classList.remove('is-fixed');
    }

    public onClickGenerateArticleSummaries() {
        const vm = this.getTemplateViewModel();
            const factual = vm.factualSummary() && vm.factualSummary().trim() !== "";
            const simple = vm.simpleSummary() && vm.simpleSummary().trim() !== "";
            const satirical = vm.satiricalCommentary() && vm.satiricalCommentary().trim() !== "";

            // If any summary exists, confirm before regenerating
            if (factual || simple || satirical) {
                if (!confirm("Existing article summaries found. Do you want to replace them with new AI-generated summaries? This will  overwrite the existing summaries and cannot be undone.")) {
                    return;
                }
            }
        this.caller.saveArticleAiSummaries(true);
    }

    public onClickGenerateNewsletterPromotion() {

        const vm = this.getTemplateViewModel();
        const text = vm.aiNewsletterPromotionTitle() && vm.aiNewsletterPromotionTitle().trim() !== "";
        const excerpt = vm.aiNewsletterPromotionExcerpt() && vm.aiNewsletterPromotionExcerpt().trim() !== "";

        // If exists, confirm before regenerating
        if (text || excerpt) {
            if (!confirm("Existing article newsletter promotion found. Do you want to replace them with new AI-generated newsletter promotion? This will  overwrite the existing newsletter promotion and cannot be undone.")) {
                return;
            }
        }
        this.caller.saveArticleAiNewsletterPromotion(true);
    }

    public onClickGenerateDealsCategoryPromotion() {

        const vm = this.getTemplateViewModel();
        const text = vm.aiDealsCategoryPromotionTitle() && vm.aiDealsCategoryPromotionTitle().trim() !== "";
        const excerpt = vm.aiDealsCategoryPromotionExcerpt() && vm.aiDealsCategoryPromotionExcerpt().trim() !== "";

        // If exists, confirm before regenerating
        if (text || excerpt) {
            if (!confirm("Existing article deals category promotion found. Do you want to replace them with new AI-generated deals category promotion? This will  overwrite the existing deals category promotion and cannot be undone.")) {
                return;
            }
        }
        this.caller.saveArticleAiDealsCategoryPromotion(true);
    }

    public onClickGenerateArticleQuiz() {
        const quizQuestions = this.getTemplateViewModel().quizQuestions();
        const isQuizEmpty = !quizQuestions || quizQuestions.length === 0 ;
        // If any question exists, confirm before regenerating
        if (!isQuizEmpty) {
            if (!confirm("Existing quiz questions found. Do you want to replace them with new AI-generated quiz questions? This will  overwrite the existing quiz questions and cannot be undone.")) {
                return;
            }
        }
        this.caller.saveQuiz(true);
    }
    public onClickEditReviewItem(index, reviewItems) {

        this.getTemplateViewModel().reviewItemToEdit(index);
        let reviewItem = reviewItems[index];
        this.getTemplateViewModel().idReviewItem(reviewItem.id);
        this.getTemplateViewModel().reviewItemAmazonSummary(reviewItem.amazonSummary);
        this.getTemplateViewModel().reviewItemAmazonHeadline(reviewItem.amazonHeadline);
        this.getTemplateViewModel().reviewItemAmazonAward(reviewItem.amazonAward);
        this.getTemplateViewModel().reviewItemExtraVideos(reviewItem.extraVideos ? [...reviewItem.extraVideos] : []);
        this.getTemplateViewModel().reviewItemImages([...reviewItem.extraImages]);
        this.getTemplateViewModel().reviewItemRating(reviewItem.rating);
        this.getTemplateViewModel().reviewItemAmazonRating(reviewItem.amazonRating);

        this.getTemplateViewModel().reviewItemIdTag(reviewItem.idTag);

        if(reviewItem.reviewText){

            this.caller.setReviewText(reviewItem.reviewText);
        }

        if (reviewItem.tag) {

            this.getTemplateViewModel().tagImage(reviewItem.tag.details ? reviewItem.tag.details.image : null);

            if (reviewItem.tag.type)
            {
                if (reviewItem.tag.type.id != 0)
                {
                    this.filterProductTypes.setOption(reviewItem.tag.type)
                }
                else {

                    this.filterProductTypes.getTemplateViewModel().inputText(reviewItem.tag.type.name);
                    this.filterProductTypes.getTemplateViewModel().newOptionName(reviewItem.tag.type.name);
                    this.filterProductTypes.getTemplateViewModel().addNewSelected(true);

                }
            }

            if (reviewItem.tag.id != 0)
            {
                this.filterProducts.setOption(reviewItem.tag)
            }
            else {
                this.filterProducts.getTemplateViewModel().inputText(reviewItem.tag.name);
                this.filterProducts.getTemplateViewModel().newOptionName(reviewItem.tag.name);
                this.filterProducts.getTemplateViewModel().addNewSelected(true);
            }

        }

        this.getTemplateViewModel().reviewItemTagSpecifications(reviewItem.tagSpecifications ? [...reviewItem.tagSpecifications] : []);
        this.getTemplateViewModel().addedReviewItemTagSpecifications(reviewItem.addedSpecifications ? [...reviewItem.addedSpecifications] : []);
        if (reviewItem.pros) {
            let pros = [];

            reviewItem.pros.forEach( p => {
                pros.push({ data: p })
            })

            this.getTemplateViewModel().reviewItemPros(pros);
        }
        if (reviewItem.cons) {

            let cons = [];

            reviewItem.cons.forEach( c => {
                cons.push({ data: c })
            })

            this.getTemplateViewModel().reviewItemCons(cons);
        }
        if (reviewItem.keyFeatures) {

            let keyFeatures = [];

            reviewItem.keyFeatures.forEach( kf => {
                keyFeatures.push({data:kf})
            })

            this.getTemplateViewModel().reviewItemKeyFeatures(keyFeatures);
        }
        if (reviewItem.extraVideos) {

            let extraVideos = [];

            reviewItem.extraVideos.forEach( v => {
                extraVideos.push({data:v})
            })

            this.getTemplateViewModel().reviewItemExtraVideos(extraVideos);
        }
        this.showReviewItemForm();

        this.getTemplateViewModel().reviewItemSeoDescription(reviewItem.seoDescription);

        this.getTemplateViewModel().reviewItemGiveawayUrl(reviewItem.giveawayUrl);
        if (reviewItem.giveawayExpiryDate) {
            this.giveawayDatePicker.setDate(reviewItem.giveawayExpiryDate);
        }

        if (reviewItem.giveawayUrl || reviewItem.giveawayExpiryDate) {
            this.collapseGiveawaySection();
        }


        this.getTemplateViewModel().reviewItemIdAwardType(reviewItem.idAwardType);
        this.getTemplateViewModel().reviewItemAffiliateLinks(reviewItem.affiliateLinks ? [...reviewItem.affiliateLinks] : []);

        this.onLoadTemplate('#img_list_product_review .img-article-item', this.reorderReviewItemImages.bind(this));
    }

    private clearReviewItemForm() {

        this.getTemplateViewModel().reviewItemAmazonSummary(null);
        this.getTemplateViewModel().reviewItemAmazonHeadline(null);
        this.getTemplateViewModel().reviewItemAmazonAward(null);
        this.getTemplateViewModel().reviewItemExtraVideos([]);
        this.getTemplateViewModel().reviewItemImages([]);
        this.getTemplateViewModel().reviewItemRating(null);
        this.getTemplateViewModel().reviewItemAmazonRating(null);
        this.getTemplateViewModel().reviewItemIdTagType(null);
        this.getTemplateViewModel().reviewItemIdAffiliate(0);
        this.getTemplateViewModel().reviewItemTagName(null);
        this.getTemplateViewModel().reviewItemTagSpecifications([]);
        this.getTemplateViewModel().addedReviewItemTagSpecifications([]);
        this.getTemplateViewModel().reviewItemPros([]);
        this.getTemplateViewModel().reviewItemCons([]);
        this.getTemplateViewModel().reviewItemKeyFeatures([]);
        this.getTemplateViewModel().reviewItemSeoDescription(null);
        this.getTemplateViewModel().tagImage(null);
        this.caller.setReviewText(null);
        this.getTemplateViewModel().isGiveawaySectionCollapsed(false);
        this.getTemplateViewModel().reviewItemGiveawayUrl(null);
        this.getTemplateViewModel().reviewItemGiveawayExpiryDate(null);
        this.giveawayDatePicker.getTemplateViewModel().singleDatePicker(null);
        this.getTemplateViewModel().reviewItemTagTypeName(null);
        this.getTemplateViewModel().reviewItemIdAwardType(null);
        this.getTemplateViewModel().reviewItemAffiliateLinks([]);
        this.getTemplateViewModel().reviewItemIdTag(null);
        this.getTemplateViewModel().idReviewItem(null);
        this.getTemplateViewModel().reviewItemToEdit(null);
        this.filterProducts.clearEverything();
        this.filterProductTypes.clearEverything();
        this.filterAffiliates.clearEverything();
        this.filterAffiliates.setPlaceholder("Affiliate Partner");

    }

    protected onClickAddSpecification() {

        let spec = {
            label: "",
            data: "",
            dataType: 'text'
        }

        this.getTemplateViewModel().addedReviewItemTagSpecifications.push(spec);
    }

    protected onClickDeleteSpecification(data, index) {

        this.getTemplateViewModel().reviewItemTagSpecifications.splice(index(), 1);
    }
    protected onClickDeleteAddedSpecification(data, index) {

        this.getTemplateViewModel().addedReviewItemTagSpecifications.splice(index(), 1);
    }

    protected onClickDeleteAffiliateLinks(data, index) {

        this.getTemplateViewModel().reviewItemAffiliateLinks.splice(index(), 1);
    }

    protected onClickAddReviewItemVideo() {

        this.getTemplateViewModel().reviewItemExtraVideos.push({ data: "" }  );
    }

    protected onClickDeleteReviewItemVideo(data, index) {

        this.getTemplateViewModel().reviewItemExtraVideos.splice(index(), 1);
    }

    protected onClickAddAffiliateLink() {

        let defaultPlaceholder = "Affiliate Partner";
        let noPartnerSelected = "No partner selected";

        if ( this.filterAffiliates.getTemplateViewModel().addNewSelected() ) {

            let optionName = this.filterAffiliates.getTemplateViewModel().newOptionName()

            if (optionName != "") {
                this.filterAffiliates.setPlaceholder(defaultPlaceholder);
                this.getTemplateViewModel().reviewItemAffiliateLinks.push({id: null, type: optionName, value: ""});
            } else {

                this.filterAffiliates.setPlaceholder(noPartnerSelected);
            }

        }
        else if ( this.filterAffiliates.getTemplateViewModel().optionObj() )
        {
            let affiliate = this.filterAffiliates.getTemplateViewModel().optionObj();
            this.filterAffiliates.setPlaceholder(defaultPlaceholder);
            this.getTemplateViewModel().reviewItemAffiliateLinks.push({id: affiliate.id, type: affiliate.name, value: ""});
        }
        else {

            this.filterAffiliates.setPlaceholder(noPartnerSelected);
        }

    }

    public onClickAddAiAgent() {

        const defaultPlaceholder = "Search AI Agents";
        const noneSelected = "No AI Agent selected";

        if (this.filterAiAgent.getTemplateViewModel().addNewSelected()) {
            const agentName = this.filterAiAgent.getTemplateViewModel().newOptionName();
            if (agentName !== "") {
                const alreadyAdded = this.getTemplateViewModel().articleAiAgents().some(a => a.name === agentName);
                if (!alreadyAdded) {
                    this.getTemplateViewModel().articleAiAgents.push({ id: null, name: agentName });
                    this.caller.saveAiAgent(agentName);
                }
                this.filterAiAgent.clearEverything();
                this.filterAiAgent.setPlaceholder(defaultPlaceholder);
            } else {
                this.filterAiAgent.setPlaceholder(noneSelected);
            }
        } else if (this.filterAiAgent.getTemplateViewModel().optionObj()) {
            const agent = this.filterAiAgent.getTemplateViewModel().optionObj();
            const alreadyAdded = this.getTemplateViewModel().articleAiAgents().some(a => a.id === agent.id);
            if (!alreadyAdded) {
                this.getTemplateViewModel().articleAiAgents.push({ id: agent.id, name: agent.name });
            }
            this.filterAiAgent.clearEverything();
            this.filterAiAgent.setPlaceholder(defaultPlaceholder);
        } else {
            this.filterAiAgent.setPlaceholder(noneSelected);
        }
    }

    protected onClickRemoveAiAgent(data, index) {

        this.getTemplateViewModel().articleAiAgents.splice(index(), 1);
    }

    protected onClickAddKeyFeature() {

        this.getTemplateViewModel().reviewItemKeyFeatures.push({ data:"" } );
    }

    protected onClickDeleteKeyFeature(data) {

        let index = this.getTemplateViewModel().reviewItemKeyFeatures().findIndex(element => (element == data));
        if (index > -1) {
            this.getTemplateViewModel().reviewItemKeyFeatures.splice(index, 1);
        }
    }

    protected onClickAddPro() {

        this.getTemplateViewModel().reviewItemPros.push({ data: "" } );
    }

    protected onClickDeletePro(data, index) {

        this.getTemplateViewModel().reviewItemPros.splice(index(), 1);
    }

    protected onClickAddCon() {

        this.getTemplateViewModel().reviewItemCons.push({ data: "" } );
    }

    protected onClickDeleteCon(data, index){

        this.getTemplateViewModel().reviewItemCons.splice(index(), 1);
    }

    public getPinnedTag(){

        return this.filterPinnedTag.getOptionObj();
    }

    public getFeaturedTag(){
        if(this.getTemplateViewModel().featuredTags()){
            return this.getTemplateViewModel().featuredTags().tagObject;
        }else{
            return false;
        }
    }
    public setPinnedTag(pinnedTagObj){

        if(pinnedTagObj){

            this.getTemplateViewModel().isFeaturedTagActive(true);
        }
        this.filterPinnedTag.setOption(pinnedTagObj);
    }

    public onChangeSelectTag() {

        let productsViewModel = this.filterProducts.getTemplateViewModel();
        let typesViewModel = this.filterProductTypes.getTemplateViewModel();
        let productTag = ! productsViewModel.addNewSelected() ?  productsViewModel.optionObj() : null;
        let tagType = ! typesViewModel.addNewSelected() ? typesViewModel.optionObj() : null;
        let specValues = productTag && productTag.specifications_extra ? JSON.parse( JSON.stringify(productTag.specifications_extra)) : [];

        let tagExtra = productTag && productTag.details ? JSON.parse( JSON.stringify(productTag.details)) : [];

        let seoDescription = tagExtra.shortDescription ? tagExtra.shortDescription : null;
        let productText = tagExtra.description ? tagExtra.description : null;
        let affiliateLinks = tagExtra.affiliateLinks ? tagExtra.affiliateLinks : [];
        let image = tagExtra.image ? tagExtra.image : null;

        this.getTemplateViewModel().reviewItemSeoDescription(seoDescription);
        this.getTemplateViewModel().reviewItemAffiliateLinks(affiliateLinks);

        this.caller.setReviewText(productText);

        if(image){

            this.addProductImage(image);
        }

        /*
            Here, the plan is, if you have a type and a product, get specifications extra from tag type field values extra
            otherwise if you only have a type, query for the fields only with

         */

        let specs = [], spec;

        if ( tagType && typeof tagType.fields != "undefined" && tagType.fields.length > 0 ) {

            tagType.fields.forEach( field => {

                spec = {fieldId: field.id, label: field.label, data: null,  dataType: field.dataType};

                for (let i=0; i< specValues.length; i++ ) {

                    if (specValues[i].idField == field.id ) {

                        spec['data'] = specValues[i].value;
                        specValues.splice(i,1);
                        break;
                    }
                }
                specs.push(spec);
            } )
        }
        if (productTag && productTag.details && productTag.details.image) {

            this.getTemplateViewModel().tagImage(productTag.details.image);
        }

        this.getTemplateViewModel().reviewItemTagSpecifications(specs)
    }

    public addReviewItem(response) {

        let reviewItem = response.data;
        if (response.valid) {

            reviewItem.award = {};
            reviewItem.tagAwardClass = '';
            let award = this.getTemplateViewModel().reviewItemAward_options().find(element => (element.id == reviewItem.idAwardType));
            if (award) {
                reviewItem.award = award;
                reviewItem.tagAwardClass = reviewItem.award ? 'i-' + reviewItem.award.name.replace(' ', '-').toLowerCase() : "";
            }
            reviewItem.tag = {
                id: reviewItem.idTag,
                idType: reviewItem.idTagType,
                name: reviewItem.tagName,
                type: {id: reviewItem.idTagType, name: reviewItem.tagTypeName},
                details: {image: this.getTemplateViewModel().tagImage()}
            }

            if (this.getTemplateViewModel().selectedTab() == Tab.ARTICLE) {
                if (this.getTemplateViewModel().idTemplate() == 5) {
                    this.productReview.setReviewItems([]);
                    this.getTemplateViewModel().reviewItemToEdit(null);
                }
                this.productReview.addReviewItem(reviewItem, this.getTemplateViewModel().reviewItemToEdit());
            } else if (this.getTemplateViewModel().selectedTab() == Tab.SANDBOX) {
                if (this.getTemplateViewModel().idTemplate() == 5) {
                    this.productReviewSandbox.setReviewItems([]);
                    this.getTemplateViewModel().reviewItemToEdit(null);
                }
                this.productReviewSandbox.addReviewItem(reviewItem, this.getTemplateViewModel().reviewItemToEdit());
            }else if (this.getTemplateViewModel().selectedTab() == Tab.REPUBLISH) {
                if (this.getTemplateViewModel().idTemplate() == 5) {
                    this.productReviewRepublish.setReviewItems([]);
                    this.getTemplateViewModel().reviewItemToEdit(null);
                }
                this.productReviewRepublish.addReviewItem(reviewItem, this.getTemplateViewModel().reviewItemToEdit());
            }
            this.hideReviewItemForm();

            this.caller.save_recovery('applyProduct');
        }
    }

    private onLoadTemplate(dragItemSelector, sortFunction) {

        var parent = this;
        var dragSrcEl = null;

        function handleDragStart(e) {
            // Target (this) element is the source node.
            dragSrcEl = this;

            //e.dataTransfer.setData('text', 'foo');
            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('text/html', this.outerHTML);

            this.classList.add('dragElem');
        }
        function handleDragOver(e) {
            if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
            }

            let huit_neuf_this = this;
            //var dragItems = document.querySelectorAll('[draggable=true]');
            var dragItems = document.querySelectorAll(dragItemSelector);
            let index = 0;
            let found = false;
            for (let item of dragItems) {
                if (dragSrcEl == item) {

                    huit_neuf_this.classList.add('after');
                    huit_neuf_this.classList.remove('before');
                    found = true;
                    break;
                }
                if (this == item) {

                    huit_neuf_this.classList.add('before');
                    huit_neuf_this.classList.remove('after');
                    found = true;
                    break;
                }
            }

            if (!found) {
                this.classList.add("before");
            }

            e.dataTransfer.dropEffect = 'move';  // See the section on the DataTransfer object.

            return false;
        }

        function handleDragEnter(e) {
            // this / e.target is the current hover target.
            //this.classList.add('over');

            //this.classList.add('before');
        }

        function handleDragLeave(e) {
            this.classList.remove('before');
            this.classList.remove('after');  // this / e.target is previous target element.
        }

        function handleDrop(e) {
            // this/e.target is current target element.

            if (e.stopPropagation) {
                e.stopPropagation(); // Stops some browsers from redirecting.
            }

            if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
            }

            // Don't do anything if dropping the same column we're dragging.
            if (dragSrcEl != this) {


                var dropHTML = e.dataTransfer.getData('text/html');

                if (dropHTML.includes("<li")) {
                    for (let child of this.parentNode.childNodes) {

                        if (child == dragSrcEl) {
                            this.parentNode.removeChild(dragSrcEl);
                        }
                    }

                    if (this.classList.contains("before")) {
                        this.insertAdjacentHTML('beforebegin', dropHTML);
                        var dropElem = this.previousElementSibling;
                    } else {
                        this.insertAdjacentHTML('afterend', dropHTML);
                        var dropElem = this.nextElementSibling;
                    }

                    addDnDHandlers(dropElem);
                    //this.reorderImages();
                }



            }
            sortFunction(parent);
            this.classList.remove('before');
            this.classList.remove('after');
            return false;
        }

        function handleDragEnd(e) {
            // this/e.target is the source node.
            this.classList.remove('before');
            this.classList.remove('after');

            [].forEach.call(cols, function (col) {
                col.classList.remove('before');
                col.classList.remove('after');
            });
        }

        function addDnDHandlers(elem) {
            elem.addEventListener('dragstart', handleDragStart, false);
            elem.addEventListener('dragenter', handleDragEnter, false)
            elem.addEventListener('dragover', handleDragOver, false);
            elem.addEventListener('dragleave', handleDragLeave, false);
            elem.addEventListener('drop', handleDrop, false);
            elem.addEventListener('dragend', handleDragEnd, false);

        }

        //var dragItems = document.querySelectorAll('[draggable=true]');
        var cols = document.querySelectorAll(dragItemSelector);
        [].forEach.call(cols, addDnDHandlers);
    }

    protected reorderReviewItemImages(huit_neuf_this) {
        let images = huit_neuf_this.getTemplateViewModel().reviewItemImages();
        let selector = '#img_list_product_review .img-article-item';
        let liElements = document.querySelectorAll(selector);

        //reorder the images based on HTML order
        let newImages = []
        for (let element of liElements) {

            let idElement = element.id;
            let image = images.find(i => i.id === Number(element.id));
            if (image) {
                newImages.push(image);
            }
        }
        huit_neuf_this.getTemplateViewModel().reviewItemImages([]);
        huit_neuf_this.getTemplateViewModel().reviewItemImages(newImages);
        huit_neuf_this.onLoadTemplate(selector, huit_neuf_this.reorderReviewItemImages.bind(huit_neuf_this));
    }

    private checkIfReviewItemsNeedAnUpdate( sourceOfReversal ) {

        let reviewItems;
        if ( sourceOfReversal == "sandbox") {

            reviewItems = this.productReviewSandbox.getReviewItems();
        }
        else if ( sourceOfReversal == "revision") {

            let index = this.getTemplateViewModel().selectedRevisionIndex();
            reviewItems = this.getTemplateViewModel().revisions()[index].content.reviewItems;
        }
        else if ( sourceOfReversal == "recovery") {

            reviewItems =this.recoveryReviewSection.getReviewItems();
        }

        //HERE set reviewitems based on the source of the call
        //Can be either sandbox, or revision
        if (confirm("Are you sure you want to overwrite the article content? You will lose any unsaved changes.")) {

            this.getTemplateViewModel().sourceOfReversal(sourceOfReversal);
            this.getTemplateViewModel().backupReviewItems(reviewItems);
            this.caller.checkForReviewItemsUpdate(sourceOfReversal);
        }
    }

    private copyContentReviewsItem(tab) {

        this.productReviewSandbox.markReviewItemsAsToDelete();
        let reviewItems = this.productReview.getReviewItems();
        // make a deep copy of content review items before assigning them to sandbox.
        const clone = rfdc();

        let dp = clone(reviewItems);

        dp.forEach((e) => e.id = null);

        if(tab == 'sandbox'){
            this.productReviewSandbox.setReviewItems(dp);
        }

        if(tab == 'republish'){
            this.productReviewRepublish.setReviewItems(dp);
        }

    }

    private copyDirectoryItems(tab){

        let items = this.articleDirectory.getDirectoryItems();
        items = ko.toJS(items); //convert observable array ot simple array

        if(tab == 'sandbox'){
            this.sandboxDirectory.setSandboxDirectoryItems(items);
        }

        if(tab == 'republish'){
            this.republishDirectory.setSandboxDirectoryItems(items);
        }

    }

    public getReviewItems() {

        return this.productReview.getReviewItems();
    }

    public getSandboxReviewItems() {

        return this.productReviewSandbox.getReviewItems();
    }

    public getRepublishReviewItems() {

        return this.productReviewRepublish.getReviewItems();
    }

    public getDirectoryItems() {

        return this.articleDirectory.getDirectoryItems();
    }

    public getSandboxDirectoryItems() {

        return this.sandboxDirectory.getDirectoryItems();
    }

    public getRepublishDirectoryItems() {

        return this.republishDirectory.getDirectoryItems();
    }

    public setRecoveryReviewItems(recoveryReviewItems) {

        this.recoveryReviewSection.setReviewItems(recoveryReviewItems);
    }

    public setRecoverySandboxReviewItems(sandboxRecoveryReviewItems) {

        this.recoverySandboxReviewSection.setReviewItems(sandboxRecoveryReviewItems);
    }

    public setRecoveryRepublishReviewItems(republishRecoveryReviewItems) {

        this.recoveryRepublishReviewSection.setReviewItems(republishRecoveryReviewItems);
    }

    public getReviewItemsToDelete() {

        return this.productReview.getReviewItemsToDelete();
    }

    public getSandboxReviewItemsToDelete() {

        return this.productReviewSandbox.getReviewItemsToDelete();
    }

    public getRepublishReviewItemsToDelete() {

        return this.productReviewRepublish.getReviewItemsToDelete();
    }

    public clearSandboxSection() {

        this.productReviewSandbox.setReviewItems([]);
        this.sandboxDirectory.setDirectoryItems([]);
        this.caller.setSandboxIntroText("");
        this.caller.setSandboxContent("");
        this.getTemplateViewModel().selectedTab('article');
        this.checkIfSandboxHasContent();
        this.checkIfRepublishHasContent();
        this.getTemplateViewModel().selectedArticleEditmode("");
    }

    public clearRepublishSection() {

       this.filterUser_republish_author.clearData();
       this.filterUser_republish_SrEditor.clearData();
       this.filterUser_republish_JrEditor.clearData();
       this.paymentCategoryFilter.setSelectedOption(null);
       this.getTemplateViewModel().choosenPaymentTypeRepublish(null);
       this.getTemplateViewModel().amountAuthor(null);
       this.getTemplateViewModel().percentageAuthor(null);
       this.getTemplateViewModel().percentageEditor(null);
       this.getTemplateViewModel().idRepublishStatus(1);
       this.getTemplateViewModel().idPreviousRepublishStatus(1);
       this.productReviewRepublish.setReviewItems([]);
       this.republishDirectory.setDirectoryItems([]);
       this.caller.setRepublishIntroText("");
       this.caller.setRepublishContent("");
       this.getTemplateViewModel().selectedTab('article');
       this.getTemplateViewModel().showNewRepublish(false);
       this.checkIfSandboxHasContent();
       this.checkIfRepublishHasContent();
       this.getTemplateViewModel().selectedArticleEditmode('');
    }

    private onClickConfirmFaqDelete() {

        let index = this.getTemplateViewModel().faqToDelete();
        this.setIsFaqDeleteVisible(false);
        let faqs = this.getTemplateViewModel().faqs();

        if (index > -1) {
            this.getTemplateViewModel().faqToDelete(null);
            this.getTemplateViewModel().faqsToDelete.push(faqs[index].id);
            this.getTemplateViewModel().faqs.splice(index, 1);
        }
    }

    private onClickCancelFaqDelete() {

        this.setIsFaqDeleteVisible(false);

    }

    public setSandboxIntroTextEditorStatus(result) {
        this.caller.setSandboxIntroTextEditorStatus(result)
    }

    public setIntroTextEditorStatus(result) {
        this.caller.setIntroTextEditorStatus(result);
    }

    public setSandboxEditorStatus(result) {
        this.caller.setSandboxEditorStatus(result)
    }

    public setContentEditorStatus(result) {
        this.caller.setContentEditorStatus(result);
    }

    public setRepublishEditorStatus(result) {
        this.caller.setRepublishEditorStatus(result);
    }

    private createEasternTimeZoneDateTime(date?: Date): Date {

        if (!date) {
            date = new Date();
        }

        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        //checks if DST is currently being observed, adjusts offset accordingly
        let easternTimeOffset = this.isDstObserved(date) ? -240 : -300;
        date.setMinutes(date.getMinutes() + easternTimeOffset);

        return date;
    }

    public isDstObserved (date?: Date) {
        let jan = new Date(date.getFullYear(), 0, 1);
        let jul = new Date(date.getFullYear(), 6, 1);
        let stdTimezoneOffset = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());

        return date.getTimezoneOffset() < stdTimezoneOffset;
    }


    public getFormattedEasternTimeZoneDateTime(_date? : string): any {
        let dateObj: Date | null;
        if (_date) {
            try{
                dateObj = new Date(_date);
            }catch(e){
                dateObj = null;
            }
        }

        const date = this.createEasternTimeZoneDateTime(dateObj);

        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const hour = date.getHours();
        const minutes = date.getMinutes();

        return year + '/' + this.padInteger(month,2) + '/' + this.padInteger(day,2) + ' ' + this.padInteger(hour,2) + ':' + this.padInteger(minutes,2);
    }

    private padInteger(number: number, size: number)
    {
        let s = number+"";
        while (s.length < size) s = "0" + s;
        return s;
    }


    public setEasternTimeOnScheduled(): void {
        this.scheduleDatePicker.setDate(this.getFormattedEasternTimeZoneDateTime());
    }

    public openComparePopup(){

        document.getElementById('compare-popup').classList.add('is-visible');
        document.body.classList.add('is-fixed');

    }

    public addClassToComparePopupHeader(className){
        document.getElementById('compare-revisions').classList.add(className)

    }

    public onClickCloseComparePopUp(){

        document.getElementById('compare-popup').classList.remove('is-visible');
        document.getElementById('compare-revisions').classList.remove('is-nolist', 'is-labelsandbox', 'is-labelrecoverysandbox', 'is-revoverycontent');
        document.body.classList.remove('is-fixed');
    }

    public hideSideListOnComparePopup(){

        document.getElementById('compare-revisions').classList.add('is-nolist');
    }

    public setVersionDiffResult(result): void{

        this.getTemplateViewModel().versionDiffResult(result);
    }

    public compareTwoVersions(){

        let oldVersion = this.getTemplateViewModel().oldVersion();
        let newVersion = this.getTemplateViewModel().newVersion();

        if (oldVersion && newVersion) {
            let newVersionContent = '';
            if(newVersion.content.content != undefined){
                newVersionContent = newVersion.content.content
            }
            let oldVersionContent = '';
            if(oldVersion.content.content != undefined) {
                oldVersionContent = oldVersion.content.content;
            }
            this.caller.diffVersionText(oldVersionContent,  newVersionContent);
        }

    }

    public onClickCompareRevision(){

        this.openComparePopup();
        let revisions = this.getTemplateViewModel().revisions();
        this.setRevisions(revisions);
        if(revisions.length < 3) {
            this.hideSideListOnComparePopup();
        }
    }

    public onClickShowRevision(revision){

        this.onClickCloseComparePopUp();
        this.onClickRevision(revision, 0);
    }

    public onClickCompareRevisionUpdate(data){


        if(data.checked == 'old'){
            this.getTemplateViewModel().oldVersion(data);
        }
        if(data.checked == 'new'){
            this.getTemplateViewModel().newVersion(data);
        }

        let revisions = this.getTemplateViewModel().revisions();
        let index =  revisions.findIndex(element => (element.id == data.id));
        if(index > -1) {

            let lastChecked = data.checked;
            let lastNewChecked = this.getTemplateViewModel().newVersion().checked;
            let lastOldChecked = this.getTemplateViewModel().oldVersion().checked;

            //reset the opposite disable field and empty checked value
            revisions.forEach(revision =>{
                if(lastChecked == 'new') {
                    revision.isOldDisable = false;
                }
                if(lastChecked == 'old') {
                    revision.isNewDisable = false;
                }
                revision.checked = '';
            });

            // put back the checked value of selected one
            data.checked = lastChecked;

            // disable/enable the radio selections
            if (lastChecked == 'old') {
                this.getTemplateViewModel().newVersion().checked = lastNewChecked;
                for (let i = index; i < revisions.length; i++) {
                    revisions[i].isNewDisable = true;
                }
            }
            if (lastChecked == 'new') {
                this.getTemplateViewModel().oldVersion().checked = lastOldChecked;
                for (let i = 0; i <= index; i++) {
                    revisions[i].isOldDisable = true;
                }
            }
        }
        this.getTemplateViewModel().revisions([]);
        this.getTemplateViewModel().revisions(revisions);
        this.compareTwoVersions();

    }

    public setRevisions(revisions): void{

        for(let i = 0 ; i < revisions.length; i++){

            if(i == 0){
                revisions[i].checked = 'new';
                revisions[i].isOldDisable = true;
                this.getTemplateViewModel().newVersion(revisions[0]);
            }else if(i == 1){
                revisions[i].checked = 'old';
                revisions[i].isNewDisable = true;
                this.getTemplateViewModel().oldVersion(revisions[1]);
            }else {
                revisions[i].checked = false;
                revisions[i].isNewDisable = true;
            }
        }
        this.getTemplateViewModel().revisions(revisions);
        this.compareTwoVersions();
    }

    public onClickCompareRecovery(type){

        let revisions = this.getTemplateViewModel().revisions();
        let recovery = this.getTemplateViewModel().recovery();
        let sandboxRecovery = this.getTemplateViewModel().sandboxRecovery();
        let republishRecovery = this.getTemplateViewModel().republishRecovery();

        let newVersion = {'content': recovery};
        let oldVersion = {'content': revisions ? revisions[0].content : ''};
        let className = 'is-revoverycontent';

        if(type == 'sandbox'){

            newVersion = {'content': sandboxRecovery};
            oldVersion = {'content': {'content' : this.getSandboxContent()}};
            className = 'is-labelrecoverysandbox';

        }else if(type == 'republish'){

            newVersion = {'content': republishRecovery};
            oldVersion = {'content': {'content' : this.getRepublishContent()}};
            className = 'is-labelrecoverysandbox';
        }

        if(newVersion && newVersion.content && oldVersion && oldVersion.content) {

            this.getTemplateViewModel().newVersion(newVersion);
            this.getTemplateViewModel().oldVersion(oldVersion);
            this.compareTwoVersions();
            this.openComparePopup();
            this.hideSideListOnComparePopup();
            this.addClassToComparePopupHeader(className);
        }
    }

    public getArticleContent(){

        let content = this.caller.getArticleContent();
        return content;
    }

    public getArticleIntroText(){

        let content = this.caller.getArticleIntroText();
        return content;
    }

    public getSandboxContent(){

        let content = this.caller.getSandboxInViewContent();
        return content;
    }

    public getSandboxIntroText(){

        let content = this.caller.getSandboxIntroText();
        return content;
    }

    public getRepublishContent(){

        let content = this.caller.getRepublishInViewContent();
        return content;
    }

    public getRepublishIntroText(){

        let content = this.caller.getRepublishIntroText();
        return content;
    }

    public onClickCompareSandbox(type){

        let revisions = this.getTemplateViewModel().revisions();

        let content = '';
        let className = 'is-labelsandbox'
        if(type == 'sandbox'){
            content = this.getSandboxContent();
        }else{
            content = this.getRepublishContent();
            className = 'is-labelrepulish'
        }

        if(revisions.length > 0) {

            this.getTemplateViewModel().newVersion({'content': {'content': content }});
            this.getTemplateViewModel().oldVersion(revisions[0]);
            this.compareTwoVersions();
            this.openComparePopup();
            this.hideSideListOnComparePopup();
            this.addClassToComparePopupHeader(className)
        }
    }

    public setIsSandboxContent(data) {

        this.getTemplateViewModel().isSandboxContent(data);
    }

    public setUserPreferences(userPreferences): void {

        //check the value of spellcheck, if userPreference length is 0 (meaning no saved preferences) then use default of spellcheck on
        //There should be no case where user has saved preference without spellcheck option
        if (userPreferences == null || userPreferences['spellcheck'] || userPreferences.length === 0) {

            const script = document.createElement('script');
            script.src = "https://svc.webspellchecker.net/spellcheck31/wscbundle/wscbundle.js"
            document.body.appendChild(script);
        }
    }

    public setTemplate(template): void{

        this.getTemplateViewModel().template(template);
    }

    public setIsFeaturedImageHidden(isFeaturedImageHidden): void {

        this.getTemplateViewModel().isFeaturedImageHidden(isFeaturedImageHidden);
    }

    public setIsCommentsDisabled(isCommentsDisabled): void {

        this.getTemplateViewModel().isCommentsDisabled(isCommentsDisabled);
    }

    public setIsCommentsPaused(isCommentsPaused): void {

        this.getTemplateViewModel().isCommentsPaused(isCommentsPaused);
    }

    public setIsRatingEnabled(isRatingEnabled): void {

        this.getTemplateViewModel().isRatingEnabled(isRatingEnabled);
    }

    public setIsTitleDisabled(isTitleDisabled): void {

        this.getTemplateViewModel().isTitleDisabled(isTitleDisabled);
    }

    public setIsReadNextDisabled(isReadNextDisabled): void {

        this.getTemplateViewModel().isReadNextDisabled(isReadNextDisabled);
    }

    public setIsSidebarHidden(isSidebarHidden): void {

        this.getTemplateViewModel().isSidebarHidden(isSidebarHidden);
    }

    public setIsExcerptHidden(isExcerptHidden): void {

        this.getTemplateViewModel().isExcerptHidden(isExcerptHidden);
    }

    public setIsDisplayCardQuickLinksShown(isDisplayCardQuickLinksShown): void {

        this.getTemplateViewModel().isDisplayCardQuickLinksShown(isDisplayCardQuickLinksShown);
    }

    public setIsDisplayCardQuickLinksMobileShown(isDisplayCardQuickLinksMobileShown): void {

        this.getTemplateViewModel().isDisplayCardQuickLinksMobileShown(isDisplayCardQuickLinksMobileShown);
    }

    public setIsVersusStyle(value){
        this.getTemplateViewModel().isVersusStyle(value);
    }
    public setVersusTemplateDefaults():void{

        this.setIsAmpDisabled(false);
        this.setIsCommentsDisabled(true);
        this.setIsVersusStyle(true);
        this.setIsFeaturedTagActive(true);
        this.setIsSidebarHidden(false);
        this.setIsDisplayCardQuickLinksMobileShown(false);
        this.setIsTitleDisabled(false);

        if(this.getTemplateViewModel().featuredEmbed()){
            this.getTemplateViewModel().featuredEmbed(null);
        }

        if ([4, 20, 29].indexOf(this.caller.getIdBrand()) !== -1) {
            this.setIsSponsored(true);
        }
        this.imageWidgetForFeaturedImage.setIsFeaturedTagActive(this.getTemplateViewModel().isFeaturedTagActive());
        //let featuredTag = {"block":[],"tagObject": [{"id":412467,"name": "Placeholder Tag #1"},{"id":413404, "name":"Placeholder Tag #2"}]}

        if(this.getTemplateViewModel().featuredTags() == null ){

            this.getTemplateViewModel().featuredSectionValue("featuredTag")
            this.getTemplateViewModel().chosenFeaturedSectionValue("featuredTag")

            let featuredTags = this.getDefaultFeaturedTags();
            let defaultFeaturedImage = this.getDefaultFeaturedImage();

            this.getTemplateViewModel().featuredTags([]);
            this.getTemplateViewModel().featuredTags(featuredTags);

            if(defaultFeaturedImage){

                this.imageWidgetForFeaturedImage.setImage(defaultFeaturedImage);
            }

            this.getTemplateViewModel().featuredImage(defaultFeaturedImage);
        }
        this.setIsPromptAuthorVisible(true);
        this.setIsExcerptVisible(true);
        this.setIsSponsored(true);
    }
    public setSubContentTemplateDefaults(): void {
        this.setIsAdHidden(false);
        this.setIsCommentsDisabled(true);
        this.setIsReadNextDisabled(false);
        this.setIsDisplayCardQuickLinksShown(false);
        this.setTableOfContents(false);
        this.setIsAmpDisabled(false);
        this.setIsSponsored(true);
        this.setIsSidebarHidden(true);
        this.setIsDisplayCardQuickLinksMobileShown(false);
        this.setIsSubContent(true);
        this.setIsTitleDisabled(false);
        this.setIsPromptAuthorVisible(true);
        this.setIsExcerptVisible(true);
        this.setIdContentType(40)
    }
    public setCollectionTemplateDefaults(): void {
        this.setIsAdHidden(false);
        this.setIsCommentsDisabled(false);
        this.setIsReadNextDisabled(false);
        this.setIsDisplayCardQuickLinksShown(false);
        this.setTableOfContents(false);
        this.setIsAmpDisabled(false);
        this.setIsSponsored(true);
        this.setIsSidebarHidden(true);
        this.setIsDisplayCardQuickLinksMobileShown(true);
        this.setIsTitleDisabled(false);
        this.setIsPromptAuthorVisible(true);
        this.setIsExcerptVisible(true);
    }
    public setBuyersGuideLightTemplateDefaults(): void {
        this.setIsAdHidden(false);
        this.setIsCommentsDisabled(true);
        this.setIsReadNextDisabled(false);
        this.setIsDisplayCardQuickLinksShown(true);
        this.setTableOfContents(false);
        this.setIsAmpDisabled(false);
        this.setIsTitleDisabled(false);

        if ([4, 20, 29].indexOf(this.caller.getIdBrand()) !== -1) {

            this.setIsSponsored(true);
        }
        this.setIsSidebarHidden(false);
        this.setIsDisplayCardQuickLinksMobileShown(false);
        this.setIsPromptAuthorVisible(true);
        this.setIsExcerptVisible(true);
        this.setIsSponsored(true);
    }

    public setDealsTemplateDefaults(){
        this.setIsAdHidden(true);
        this.setIsCommentsDisabled(true);
        this.setIsAmpDisabled(false);
        this.setIsReadNextDisabled(false);
        this.setIsDisplayCardQuickLinksShown(false);
        this.setTableOfContents(false);
        this.setIsTitleDisabled(false);

        if ([4, 20, 29].indexOf(this.caller.getIdBrand()) !== -1) {
            this.setIsSponsored(true);
        }
        this.setIsSidebarHidden(false);
        this.setIsDisplayCardQuickLinksMobileShown(false);
        this.setIsPromptAuthorVisible(true);
        this.setIsExcerptVisible(true);
        this.setIsSponsored(true);
    }

    public resetTemplateDefaults(idTemplate): void {
        if (idTemplate != ID_TEMPLATE_VIDEO) {
            //this.resetVideoTemplateDefaults();
        }
        if (idTemplate != ID_TEMPLATE_THREAD) {
            this.resetThreadTemplateDefaults();
        }

        this.setIsAdHidden(false);
        this.setIsCommentsDisabled(false);
        this.setIsReadNextDisabled(false);
        this.setIsDisplayCardQuickLinksShown(false);
        this.setIsSidebarHidden(false);
        this.setIsExcerptHidden(false);
        this.setIsDisplayCardQuickLinksMobileShown(false);
        this.setTableOfContents(idTemplate == 7)
        this.setIsAmpDisabled(false);
        this.setIsSidebarHidden(idTemplate == 12);
        this.setIsDisplayCardQuickLinksMobileShown(idTemplate == 12);
        this.setIsSponsored(idTemplate == 5 || idTemplate == 6 || idTemplate == 9 || idTemplate == 12);
        this.setIsSubContent(false);
        this.setIsTitleDisabled(false);
        this.setIsPromptAuthorVisible(true);
        this.setIsExcerptVisible(true);

    }

    public onClickDisplayOptionToggle() {
        document.getElementsByClassName('w-form-dropdown-menu')[0].classList.toggle('is-visible');
    }

    public addDisplayAuthor(): void {

        this.display_authors.addUser(
            this.filterUser_display_author.getUserObject()
        );

        this.filterUser_display_author.clearData();
    }

    public onClickTogglePinnedTagsForm(value){

        this.getTemplateViewModel().isPinnedTagsFormVisible(value);

    }

    public onChangeFeaturedSection(bypassConfirm = false){

        let message : string

        let featuredImage = this.imageWidgetForFeaturedImage.getImage();
        let featuredTag = this.getTemplateViewModel().featuredTags();
        let featuredSectionValue = this.getTemplateViewModel().featuredSectionValue();
        let featuredVideo = this.getTemplateViewModel().featuredVideo();
        let featuredEmbed = this.getTemplateViewModel().featuredEmbed();
        let chosenFeaturedSectionValue = this.getTemplateViewModel().chosenFeaturedSectionValue();

        if(featuredImage || featuredTag || featuredVideo || featuredEmbed){
            message = "Switching featured content will clear the existing selections. Are you sure you want to continue?";
            if(bypassConfirm){
                this.clearFeaturedSection(featuredSectionValue);
                return;
            }
            if(confirm(message)){
                this.clearFeaturedSection(featuredSectionValue);
            }else {
                this.getTemplateViewModel().featuredSectionValue(chosenFeaturedSectionValue)
            }
        }else{
            this.clearFeaturedSection(featuredSectionValue);
        }
    }

    private validateFeaturedContentForTemplateLayout(templateId, layoutName, isLayoutChange = false) {
        const template = parseInt(templateId);
        const isMinimal = layoutName && layoutName.toLowerCase() === 'minimal';

        const featuredImage = this.getTemplateViewModel().featuredImage();
        const featuredVideo = this.getTemplateViewModel().featuredVideo();
        const featuredEmbed = this.getTemplateViewModel().featuredEmbed();
        const featuredTags = this.getTemplateViewModel().featuredTags();

        const invalidFields = [];

        // Image: Invalid only when template is Video (15)
        if (featuredImage && template === 15) {
            invalidFields.push('image');
        }

        // Video: Invalid when template is Thread (16), or when template is not 15/16 and layout is minimal
        if (featuredVideo) {
            if (template === 16) {
                invalidFields.push('video');
            } else if (template !== 15 && template !== 16 && isMinimal) {
                invalidFields.push('video');
            }
        }

        // Embed: Invalid when template is Video (15) or Thread (16), or when template is not 15/16 and layout is minimal
        if (featuredEmbed) {
            if (template === 15 || template === 16) {
                invalidFields.push('embed');
            } else if (isMinimal) {
                invalidFields.push('embed');
            }
        }

        // Tag: Invalid when template is Video (15) or Thread (16), or when template is not 15/16 and layout is NOT minimal
        if (featuredTags) {
            const hasTags = Array.isArray(featuredTags) ? featuredTags.length > 0 : (featuredTags.tagObject && featuredTags.tagObject.length > 0);
            if (hasTags) {
                if (template === 15 || template === 16) {
                    invalidFields.push('tag');
                } else if (!isMinimal) {
                    invalidFields.push('tag');
                }
            }
        }

        const isValid = invalidFields.length === 0;

        // Build confirmation message
        let message = '';
        if (!isValid) {
            const fieldNames = invalidFields.map(field => {
                switch(field) {
                    case 'image': return 'Featured Image';
                    case 'video': return 'Featured Video';
                    case 'embed': return 'Featured Embed';
                    case 'tag': return 'Featured Tag';
                    default: return field;
                }
            });

            const changeType = isLayoutChange ? 'the layout' : 'the template';

            if (fieldNames.length === 1) {
                message = `Changing ${changeType} will clear ${fieldNames[0]}. Are you sure you want to continue?`;
            } else if (fieldNames.length === 2) {
                message = `Changing ${changeType} will clear ${fieldNames[0]} and ${fieldNames[1]}. Are you sure you want to continue?`;
            } else {
                const lastField = fieldNames.pop();
                message = `Changing ${changeType} will clear ${fieldNames.join(', ')}, and ${lastField}. Are you sure you want to continue?`;
            }
        }

        return {
            isValid,
            invalidFields,
            message
        };
    }

    private clearInvalidFeaturedFields(invalidFields) {
        if (!invalidFields || invalidFields.length === 0) {
            return;
        }

        invalidFields.forEach(field => {
            switch(field) {
                case 'video':
                    this.getTemplateViewModel().featuredVideo(null);
                    this.setIsFeaturedVideoActive(false);
                    // If video was the active section, switch to image
                    if (this.getTemplateViewModel().featuredSectionValue() === 'featuredVideo') {
                        this.getTemplateViewModel().featuredSectionValue('featuredImage');
                        this.setIsFeaturedImageActive(true);
                    }
                    break;

                case 'embed':
                    this.getTemplateViewModel().featuredEmbed(null);
                    this.getTemplateViewModel().isFeaturedEmbedActive(false);
                    this.imageWidgetForFeaturedImage.setIsFeaturedEmbedActive(false);
                    // If embed was active, switch to image
                    if (this.getTemplateViewModel().featuredSectionValue() === 'featuredVideo' && !this.getTemplateViewModel().featuredVideo()) {
                        this.getTemplateViewModel().featuredSectionValue('featuredImage');
                        this.setIsFeaturedImageActive(true);
                    }
                    break;

                case 'tag':
                    this.getTemplateViewModel().featuredTags([]);
                    this.setIsFeaturedTagActive(false);
                    this.imageWidgetForFeaturedImage.setIsFeaturedTagActive(false);
                    // If tag was the active section, switch to image
                    if (this.getTemplateViewModel().featuredSectionValue() === 'featuredTag') {
                        this.getTemplateViewModel().featuredSectionValue('featuredImage');
                        this.setIsFeaturedImageActive(true);
                    }
                    break;

                case 'image':
                    this.imageWidgetForFeaturedImage.clearImage();
                    this.getTemplateViewModel().featuredImage(null);
                    // If image was the active section and we're switching to video template, switch to video
                    if (this.getTemplateViewModel().featuredSectionValue() === 'featuredImage') {
                        const template = parseInt(this.getIdTemplate());
                        if (template === 15) {
                            this.getTemplateViewModel().featuredSectionValue('featuredVideo');
                            this.setIsFeaturedVideoActive(true);
                            this.setIsFeaturedImageActive(false);
                        }
                    }
                    break;
            }
        });
    }

    private clearFeaturedSection(featuredSectionValue) {
        this.getTemplateViewModel().isFeaturedTagActive(featuredSectionValue === "featuredTag");
        this.getTemplateViewModel().isFeaturedVideoActive(featuredSectionValue === "featuredVideo");
        this.getTemplateViewModel().isFeaturedEmbedActive(false);
        this.getTemplateViewModel().isFeaturedImageActive(featuredSectionValue === "featuredImage");

        this.imageWidgetForFeaturedImage.setIsFeaturedVideoActive(featuredSectionValue === "featuredVideo");
        this.imageWidgetForFeaturedImage.setIsFeaturedEmbedActive(false);
        this.imageWidgetForFeaturedImage.setIsFeaturedTagActive(this.getTemplateViewModel().isFeaturedTagActive());
        this.getTemplateViewModel().chosenFeaturedSectionValue(featuredSectionValue);

        this.imageWidgetForFeaturedImage.clearImage();
        this.getTemplateViewModel().featuredImage(null)

        if(featuredSectionValue == "featuredTag"){
            this.getTemplateViewModel().featuredTags({ tagObject: [] });
            this.getTemplateViewModel().featuredTags(this.getDefaultFeaturedTags());
        }else{
            this.getTemplateViewModel().featuredTags([]);
        }
        this.getTemplateViewModel().featuredVideo(null);
        this.getTemplateViewModel().featuredEmbed(null);
        this.getTemplateViewModel().isVersusStyle(false);
    }


    public setIsFeaturedTagActive(value){
        this.getTemplateViewModel().isFeaturedTagActive(value);
    }
    public onChangeUpdateLatestRepublishDate(latest_republish): any {
        //Toggle value on change
        if(this.getTemplateViewModel().updateLatestRepublishDateIsChecked()){
            this.getTemplateViewModel().latestRepublishId(latest_republish.id)
        }else{
            this.getTemplateViewModel().latestRepublishId('')
        }

    }

    public addImage(target, viewMode, selectedImages): any {
        this.showImagePicker(viewMode, target, selectedImages);
    }

    public viewImage(target){
        let element = document.getElementById(target);
        element.classList.add("is-viewing");

    }

    public closeImage(target){
        let element = document.getElementById(target);
        element.classList.remove("is-viewing");

    }

    public removeImage(target){

        if(target == 'thumbnail_image'){
            this.imageWidgetForThumbnailImage.clearImage()
            this.clearDefaultCropPosition('thumbnailImage');
        }


        if(target == 'alternate_image'){
            this.imageWidgetForAlternateImage.clearImage()
        }

        if(target == 'featured_image' || target == 'featured_image_embed'){
            this.imageWidgetForFeaturedImage.clearImage()
            if(target == "featured_image") this.getTemplateViewModel().featuredImage(null)
            this.clearDefaultCropPosition('featuredImage');
        }

        if (target == 'video_thumbnail'){
            this.videoPickerHelper.clearThumbnailImage()
        }

    }

    public getFeaturedImage(){
        return this.imageWidgetForFeaturedImage.getImage();
    }

    public getImagePicker(){
        return this.imagePicker;
    }

    public setPlagiarismResults(plagiarismResults): void {

        this.articleAnalytics.setPlagiarismResults(plagiarismResults);
    }

    public setDefaultThreadsImage(defaultThreadsImage): void {

        this.getTemplateViewModel().defaultThreadsImage(defaultThreadsImage);
    }

    public setPlagiarismStatus(plagiarismStatus): void {

        //1: Not Submitted, 2: Pending Submission, 3: Submitted
        switch(plagiarismStatus){
            case 1:
                this.articleAnalytics.setPlagiarismStatus("Not Submitted");
                this.getTemplateViewModel().plagiarismStatus("Not Submitted");
                break;
            case 2:
                this.articleAnalytics.setPlagiarismStatus("Pending Submission");
                this.getTemplateViewModel().plagiarismStatus("Pending Submission");
                break;
            case 3:
                this.articleAnalytics.setPlagiarismStatus("Submitted");
                this.getTemplateViewModel().plagiarismStatus("Submitted");
                break;
        }
    }

    onClickConfirmDialog(idElement){

        switch (idElement) {
            case "dialogArticleLock" :
            case "dialogLogout" :
                this.enablePageLockState()
                break
            default:
                console.log("No action!")
        }
    }

    /**
     *
     */
    public enablePageLockState(){
        disableAllEditors()
        this.getTemplateViewModel().isGlobalLockEnabled(true)
        this.imageWidgetForFeaturedImage.setIsGlobalLockEnabled(true)
        this.imageWidgetForThumbnailImage.setIsGlobalLockEnabled(true)
        this.imageWidgetForAlternateImage.setIsGlobalLockEnabled(true)
        // this.imageWidgetForFeaturedVideo.setIsGlobalLockEnabled(true)
        this.articlePinnedTags.setIsGlobalLockEnabled(true)
        this.articlePinnedTags.filterTagType.setIsGlobalLockEnabled(true)
        this.filterUser_author.setIsGlobalLockEnabled(true)
        this.filterUser_display_author.setIsGlobalLockEnabled(true)
        this.filterUser_SrEditor.setIsGlobalLockEnabled(true)
        this.filterUser_JrEditor.setIsGlobalLockEnabled(true)
        this.filterUser_ideator.setIsGlobalLockEnabled(true)
        this.filterTag.setIsGlobalLockEnabled(true)
        this.filterCategory.setIsDisabled(true)

    }

    public getArticleAnalytics(){
        return this.articleAnalytics;
    }

    public onClickContinueEditing(){
        this.setIsRepublishMessageVisible(false);
    }

    public onClickContinueEditingAgreement(){

        let previousStatus = this.getTemplateViewModel().idPreviousStatus();
        let previousRepublishStatus = this.getTemplateViewModel().idPreviousRepublishStatus();

        this.sensaiPromptTemplate.setContent([]);
        this.getTemplateViewModel().idStatus(this.getTemplateViewModel().idPreviousStatus());
        this.getTemplateViewModel().idRepublishStatus(this.getTemplateViewModel().idPreviousRepublishStatus());
    }

    public onClickConfirmAgreement(comment, type){

        this.getTemplateViewModel().idPreviousStatus(this.getTemplateViewModel().idStatus());
        this.getTemplateViewModel().idPreviousRepublishStatus(this.getTemplateViewModel().idRepublishStatus());
        this.sensaiPromptTemplate.setContent([]);
        this.caller.saveEditArticle(type);
    }

    public failArticleReview(comment, type){

        this.getTemplateViewModel().articleReviewComments(comment); // this will be passed to the controller to log a new comment

        this.getTemplateViewModel().idPreviousStatus(this.getTemplateViewModel().idStatus());
        this.getTemplateViewModel().idPreviousRepublishStatus(this.getTemplateViewModel().idRepublishStatus());
        this.sensaiPromptTemplate.setContent(false);
        this.caller.saveEditArticle(type);
    }

    public onClickSaveAnyway(){

        this.setIsRepublishMessageVisible(false);
        let saveType = this.getTemplateViewModel().saveType();

        this.caller.saveEditArticle(saveType);
    }

    public onClickAutoCategorize(){
         this.addAiUserMessage(' Propose the most relevant existing categories that align with the article’s content.');
         this.caller.analyzeArticleTitle('categorize');

    }

    public onClickAutoTag(){

      this.addAiUserMessage(' Recommend a set of suitable existing tags that best reflect the article’s themes and topics');
      this.caller.analyzeArticleTitle('tag');
    }


    public onClickAnalyzeTitle(type){

        if(type == 'both'){
           this.addAiUserMessage('Generate title suggestions that are optimized based on performant similar articles and refined for relevance and performance.');

        }else if(type == 'ctr'){
              this.addAiUserMessage('Generate Title Suggestions using ctr Optimization');

        }else if(type == 'ctrNewModel'){
              this.addAiUserMessage('Generate Title Suggestions using the new summary embedding model');

        }else if(type == 'optimize'){
             this.addAiUserMessage('Generate Title Suggestions using Discover and Optimize ');

        }
       this.caller.analyzeArticleTitle(type);

    }
    public onClickAnalyzeImage(){
       this.addAiUserMessage('Provide a list of title and image combinations from performant similar articles.');
       this.caller.analyzeArticleByType('image');

    }

     public onClickAnalyzeSeo(){
       this.addAiUserMessage('Draft brief, search-optimized text to help the article stand out in search results.');
       this.caller.analyzeArticleByType('seo');

    }

    public onClickAnalyzeProofread(){
       this.addAiUserMessage('Review the provided text for issues in spelling, grammar, punctuation, word choice, and overall clarity.');
       this.caller.analyzeArticleByType('proofread');

    }  public onClickAnalyzeFactCheck(){
       this.addAiUserMessage('Evaluate the provided text for factual accuracy.');
       this.caller.analyzeArticleByType('factcheck');

    }

    public onClickAnalyzeInterlinking(){
       this.addAiUserMessage('Review the provided text to identify relevant opportunities for linking to other articles or listing pages.', 'preset', 'internalLinking');
       //this.caller.analyzeArticleByType('internalLinkingTags');
       this.caller.analyzeArticleByType('internalLinkingArticlesBrand');
    }

    public onClickAnalyzeInterlinkingNewModel(){
       this.addAiUserMessage('Review the provided text to identify relevant opportunities for linking to other articles using the new summary embedding model.', 'preset', 'internalLinking');
       this.caller.analyzeArticleByType('internalLinkingArticlesBrandNewModel');
    }
     public onClickAnalyzeSocialMedia(){
       this.addAiUserMessage(' Create short, attention-grabbing text for sharing the article on social media.');
       this.caller.analyzeArticleByType('socialmedia');

    }
     public onClickAnalyzeWidgets(){
       this.addAiUserMessage('Evaluate the article to determine which widgets could enhance engagement or utility.', '', '', 'ai-userMessage-widgets');
       this.caller.analyzeArticleByType('widgets');

    }
     public onClickAnalyzeThread(){
       this.addAiUserMessage('  Produce Thread discussion prompts and a short response for each.');
       this.caller.analyzeArticleByType('thread');

    }
    public onClickAnalyzeCustomPrompt(){
       let customPrompt = this.getTemplateViewModel().customPrompt();
       let customPromptLines = customPrompt.split("\n");
       let customPromptHtml = "";
       customPromptLines.forEach(line => {
           if (line.trim() != "") {
               customPromptHtml += line + "<br>";
           }
       });
       this.addAiUserMessage(customPromptHtml ,'customprompt');
       this.caller.analyzeArticleByType('customprompt');
    }

    public onClickAnalyzeExcerpt(){
       this.addAiUserMessage('Suggest short excerpts to preview the article without giving too much away.');
       this.caller.analyzeArticleByType('excerpt');

    }

    public setIsRepublishMessageVisible(isRepublishMessageVisible){
        this.getTemplateViewModel().isRepublishMessageVisible(isRepublishMessageVisible);
    }

    public setSaveType(saveType){
        this.getTemplateViewModel().saveType(saveType);
    }

    public getShortTermReport(){
        this.caller.getShortTermReport();
    }

    public editWatchlist(isAddToWatchlist){
        this.caller.editWatchlist(isAddToWatchlist);
    }

    public isSectionForTagPicker(sectionName: string): boolean {

        let tpSections = ['featuredTag'];

        let fs =  tpSections.filter((s) => s == sectionName );

        return (fs.length > 0);
    }

    public handleDragAndDrop(element, currentObservableArray, childrenSelector, options: any = {}): any {
        DragAndDropHandler.handleDragAndDrop(element, currentObservableArray, childrenSelector, options);
    }

    public setIsOnWatchlist(isOnWatchlist){
        this.articleAnalytics.setIsOnWatchlist(isOnWatchlist);
    }

    public setWatchlistButtonEnabled(watchlistButtonEnabled){
        this.articleAnalytics.setWatchlistButtonEnabled(watchlistButtonEnabled);
    }

    public showVideoPicker(target?, ...args: any[]) {

        this.videoPickerHelper.setTarget(target);
        this.videoPickerHelper.showVideoPicker();
        this.videoPickerHelper.getVideosData();
    }

    public showVideoEmbed(target?, ...args: any[]) {
        this.setFeaturedEmbedContext()
        this.toggleEmbedPopUp(true);
        this.setEmbedSourceFocused(true);
    }

    public setFeaturedEmbedContext() {
        let embedTypes = embedTypesList()
            .filter((embed) => embed.type == 'embed_youtube');

        this.getTemplateViewModel().embedType('embed_youtube');
        this.getTemplateViewModel().embedContext(EmbedContext.FEATURED);

        this.getTemplateViewModel().embedType_options(embedTypes);
    }

    public onClickSelectFeaturedVideo(): any {
        this.showVideoPicker("featured_video");
        this.getTemplateViewModel().featuredSectionValue("featuredVideo");
    }
    onClickSelectFeaturedEmbed(): any {
        this.showVideoEmbed("featured_video");
        this.getTemplateViewModel().featuredSectionValue("featuredVideo");
        this.getTemplateViewModel().articleDetailsModal(false);
    }
    onClickSelectFeaturedEmbedImage(): void {
        this.caller.addImage(this.idElement, 'single-select');
    }

    onClickPreviewFeaturedVideo(){
        const featuredVideo = this.getTemplateViewModel().featuredVideo();
        if(featuredVideo && featuredVideo.url){
            window.open(featuredVideo.url, '_blank');
        }
    }

    onClickEditFeaturedVideo(): void {
        let featuredVideo = this.getTemplateViewModel().featuredVideo();
        this.showVideoPicker("featured_video");
        this.videoPickerHelper.setVideoPickerEditData(featuredVideo);
        this.videoPickerHelper.showVideoPickerEdit();
    }
    onClickRemoveFeaturedVideo(): void {
        const featuredVideo = this.getTemplateViewModel().featuredVideo();
        const featuredEmbed = this.getTemplateViewModel().featuredEmbed();
        const featuredSectionValue = this.getTemplateViewModel().featuredSectionValue();

        this.setFeaturedVideo(null);

        if (featuredEmbed) {
            // If embed exists, activate embed mode
            this.getTemplateViewModel().isFeaturedEmbedActive(true);
            this.imageWidgetForFeaturedImage.setIsFeaturedEmbedActive(true);
        } else if (featuredSectionValue === 'featuredVideo' && featuredVideo) {
            // If video was the primary type and no embed, reset to selection state
            this.getTemplateViewModel().featuredSectionValue(null);
            this.resetToSelectionState();
        }
    }

    onClickRemoveFeaturedEmbed(): void {
        this.setFeaturedEmbed(null);
        this.getTemplateViewModel().isFeaturedEmbedActive(false);
        this.imageWidgetForFeaturedImage.clearImage();
        this.getTemplateViewModel().featuredImage(null)
        this.imageWidgetForFeaturedImage.setIsFeaturedEmbedActive(false);
        this.getTemplateViewModel().isFeaturedImageActive(false);
    }

    public onClickEditFeaturedEmbed(): void {
        // Opens tool without anything selected, allowing replacement
        this.onClickSelectFeaturedEmbed();
    }

    private resetToSelectionState(): void {
        // Reset everything to show selection buttons
        this.getTemplateViewModel().featuredImage(null);
        this.getTemplateViewModel().featuredVideo(null);
        this.getTemplateViewModel().featuredEmbed(null);
        this.getTemplateViewModel().featuredTags(null);
        this.getTemplateViewModel().isFeaturedEmbedActive(false);
        this.getTemplateViewModel().isFeaturedVideoActive(false);
        this.getTemplateViewModel().isFeaturedTagActive(false);
        this.getTemplateViewModel().isFeaturedImageActive(false);
        this.getTemplateViewModel().featuredSectionValue(null);
        this.imageWidgetForFeaturedImage.clearImage();
        this.clearDefaultCropPosition('featuredImage');
        this.imageWidgetForFeaturedImage.setIsFeaturedEmbedActive(false);
        this.imageWidgetForFeaturedImage.setIsFeaturedVideoActive(false);
        this.imageWidgetForFeaturedImage.setIsFeaturedTagActive(false);
    }

    public onClickClearFeaturedEmbed(): void {
        // If embed was the primary type, reset to selection state
        const featuredEmbed = this.getTemplateViewModel().featuredEmbed();
        const featuredVideo = this.getTemplateViewModel().featuredVideo();

        if (featuredEmbed) {
            // Check if embed was the primary type (no video, so embed was primary)
            if (!featuredVideo) {
                // Embed was primary, reset to selection state
                this.onClickRemoveFeaturedEmbed();
                this.resetToSelectionState();
            } else {
                // Video exists, just remove embed (video becomes primary)
                this.onClickRemoveFeaturedEmbed();
            }
        }
    }

    public onClickEditFeaturedTag(): void {
        const featuredTags = this.getTemplateViewModel().featuredTags();

        if (featuredTags && featuredTags.tagObject && featuredTags.tagObject.length > 0) {
            // If already set, opens picker with selection visible. Replacement of selections should be possible.
            this.onClickFeaturedTagEdit();
        } else {
            // If empty, opens picker without any selection
            this.onClickFeaturedTag(null);
        }
    }

    public onClickClearFeaturedTag(): void {
        // If tag was the primary type, reset to selection state
        const featuredSectionValue = this.getTemplateViewModel().featuredSectionValue();
        if (featuredSectionValue === 'featuredTag') {
            this.onClickFeaturedTagDelete();
            // Tag was primary, reset to selection state
            this.resetToSelectionState();
        } else {
            // Tag was not primary, just clear it
            this.onClickFeaturedTagDelete();
        }
    }

    public onClickEditFeaturedImage(): void {
        const featuredImage = this.getTemplateViewModel().featuredImage();
        this.getTemplateViewModel().isFeaturedImageActive(true);
        if (featuredImage) {
            // If already set, opens picker to edit form. Edit form can be exited to allow replacement.
            this.showImagePicker("single-select", "featured_image");
            this.imagePicker.editImage(featuredImage);
        } else {
            // If empty, opens picker without any selection
            this.showImagePicker("single-select", "featured_image");
        }
    }

    public onClickClearFeaturedImage(): void {
        const featuredSectionValue = this.getTemplateViewModel().featuredSectionValue();
        const featuredEmbed = this.getTemplateViewModel().featuredEmbed();
        const featuredTags = this.getTemplateViewModel().featuredTags();

        // Only reset to selection if image was the primary type (not if embed or tag is still active)
        const hasActiveEmbed = !!featuredEmbed;
        const hasActiveTag = featuredTags && featuredTags.tagObject && featuredTags.tagObject.length > 0;

        if (featuredSectionValue === 'featuredImage' && !hasActiveEmbed && !hasActiveTag) {
            // Image was primary, reset to selection state
            this.resetToSelectionState();
        } else {
            // Image was not primary (embed or tag is active), just clear the image
            this.getTemplateViewModel().featuredImage(null);
            this.imageWidgetForFeaturedImage.clearImage();
            this.clearDefaultCropPosition('featuredImage');
        }
    }

    public onClickRemoveThumbnailImage(): void {
        this.removeImage('thumbnail_image');
        this.getTemplateViewModel().featuredThumbnailImage(null);
    }

    public setNewsletterTemplates(newsletterTemplates) {

        this.newsletterTemplateSelector.setOptions(newsletterTemplates)
    }

    public setNewsletterMailingLists(mailingLists) {

        this.getTemplateViewModel().newsletterMailingLists(mailingLists)
    }

    public onClickSendNewsletter() {

        let newsletterRecipientsEmails = this.getTemplateViewModel().newsletterRecipientsEmails().replace(/^\s+|\s+$/g, '');

        if (newsletterRecipientsEmails.length > 0) {
            let newsletterEmailErrors: Array<string> = [];
            let numberOfLineBreaks = (newsletterRecipientsEmails.match(/\n/g)||[]).length;
            if (numberOfLineBreaks > 0) {
                newsletterEmailErrors.push('Line breaks are not allowed.');
            }

            let numberOfHtml = (newsletterRecipientsEmails.match(/<\/?[\w\s="/.':;#-\/\?]+>/gi)||[]).length;
            if (numberOfHtml > 0 ) {

                newsletterEmailErrors.push('Html tags are not allowed.');
            }

            if (newsletterEmailErrors.length > 0) {
                this.getTemplateViewModel().newsletterEmailErrors(newsletterEmailErrors);
                return;
            }

            let emails = newsletterRecipientsEmails.split(',').map((e) => e.trim());

            const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
            for (let email of emails) {

                if (!emailRegex.test(email)) {

                    newsletterEmailErrors.push(email + ' is invalid');
                }
            }
            if (newsletterEmailErrors.length > 0) {
                this.getTemplateViewModel().newsletterEmailErrors(newsletterEmailErrors);
                return;
            }

            this.getTemplateViewModel().newsletterEmailErrors([]);
        }

        let mailingLists = this.getTemplateViewModel().selectedMailingLists();
        let selectedMailingLists = this.getTemplateViewModel().newsletterMailingLists().filter(e =>{
            return mailingLists.includes(e.id)
        })

        let templates = this.getTemplateViewModel().newsletterTemplateSelector.options();
        let idSelectedTemplate = this.getTemplateViewModel().newsletterTemplateSelector.selectedOption();
        let selectedTemplate = templates.find(e =>{
            return e.id == idSelectedTemplate;
        })

        let messageMailingLists = '';
        for (let i = 0; i < selectedMailingLists.length; i++) {
            messageMailingLists += selectedMailingLists[i].name
            if(i != selectedMailingLists.length - 1){
                messageMailingLists += ',';
            }
        }

        let message = '<ul>' +
            '<li>Subject: ' + this.getTemplateViewModel().newsletterSubject() + '</li>'+
            '<li>Preview Text: ' + this.getTemplateViewModel().newsletterPreviewText() + '</li>'+
            '<li>Template: ' + selectedTemplate.name + '</li>'+
            '<li>Date Scheduled: ' + this.getTemplateViewModel().newsletterDateScheduledSelector.singleDatePicker() + '</li>'+
            '<li>Mailing Lists: ' + messageMailingLists + '</li>'+
            '<li>Specific Email Addresses: ' + newsletterRecipientsEmails + '</li>'+
            '</ul>'
        this.warningDialog_newsletterSendingConfirmation.setMessage(message);

        this.warningDialog_newsletterSendingConfirmation.setIsVisible(true);
    }

    public getTagElementInsertedFieldsInOrder(element) {
        return this.tagPicker.getTagElementInsertedFieldsInOrder(element);
    }

    public setTagGroupTagElements(elements) {
        this.tagPicker.setTagGroupTagElements(elements);
    }

    public getTagGroupTagElements() {
        return this.tagPicker.getTagGroupTagElements();
    }

    public handleTagInArticle(target: string): void {
        switch(target) {
            case 'tag_picker_edit_cancel':

                this.caller.clearValidationErrors();
                this.removeTagPickerValidationClass();
                this.tagPicker.tagEdit.hide();
                break;
            case 'tag_picker_edit':
                this.tagPicker.tagEdit.setGroupings(this.tagPicker.getGroupings());
                this.tagPicker.tagEdit.setTag(this.caller.getTagToEdit());
                this.tagPicker.tagEdit.show();
                break;
        }
    }

    public handleInDirectoryState(): void {
        let idArticle = this.getTemplateViewModel().filterArticleDirectory.idArticle;
        if (idArticle) {
            this.filterArticleDirectory.setDisableField(true);
        }
    }


    async setEmbedData(embedData: EmbedInfo) {

        this.getTemplateViewModel().previewEmbedType('embed_'+ embedData.name);

        let embedContext = this.getTemplateViewModel().embedContext();

        let markup = embedData.html;
        if (embedContext == EmbedContext.CONTENT) {
            markup = await this.embedHelper.processContentEmbed(embedData);
        }

        this.getTemplateViewModel().embedCode(markup);
    }

    private isFixedHeightEmbed(embedName: string): boolean {
        return (['play_store_app', 'edge', 'fdroid', 'gog', 'huawei', 'microsoft_store', 'snapcraft'].indexOf(embedName) !== -1);
    }

    public setEmbedErrors(embedErrors) {
        this.getTemplateViewModel().embedErrors(embedErrors);
    }

    public setSegments(segments : Array<object>){
        this.getTemplateViewModel().segments(segments)
    }

    public getSegments(){
        return this.getTemplateViewModel().segments()
    }

    public showArticlePicker(target, selectedText = null){

        this.articlePicker.showArticlePicker(target, selectedText);
    }

    public showVignettePicker(target){

        this.vignettePicker.showVignettePicker(target);
    }

    public editArticleElement(articleElement, target){

        this.articlePicker.showArticlePickerView(articleElement, target);
    }

    public editArticleGroup(groupElement, target){
        this.articlePicker.setTarget(target);
        this.articlePicker.show();
        this.articlePicker.fillPage();
        this.articlePicker.setArticleGroupElement(groupElement);
    }

    public setArticleGroupArticleElements(elements){
        this.articlePicker.setArticleGroupArticleElements(elements);
    }

    public getArticleGroupArticleElements(){
        return this.articlePicker.getArticleGroupArticleElements();
    }

    public getArticleElementInsertedFieldsInOrder(element){
        return this.articlePicker.getArticleElementInsertedFieldsInOrder(element);
    }

    public editVignetteElement(vignetteElement, target){
        this.vignettePicker.showVignettePickerInsertForm(vignetteElement, target);
    }

    public setVideoTemplateDefaults(): void {
        this.setShowSubContent(false);
        this.setShowFeaturedImage(false);
        this.setShowSelectFeaturedEmbed(false);
        this.setShowSEO(true);
        this.setIsFeaturedVideoActive(true);
        this.setShowContent(false);
        this.setShowSponsoredDisclaimer(false);
        this.setShowDevelopingStoryDisclaimer(false);
        this.setShowTableOfContents(false);
        this.setShowQuickShopLinks(false);
        this.setIsTitleDisabled(false);
        this.setIsPromptAuthorVisible(true);
        this.setIsExcerptVisible(true);
        // this.imageWidgetForFeaturedImage.clearImage();
        // this.imageWidgetForThumbnailImage.clearImage();
        this.getTemplateViewModel().featuredSectionValue('featuredVideo');
    }

    public resetVideoTemplateDefaults(): void {
        this.setShowSubContent(true);
        this.onChangeFeaturedSection();
        //this.setShowFeaturedImage(true);
        //this.setShowSelectFeaturedEmbed(true);
        this.setShowSEO(true);
        this.setShowContent(true);
        this.setShowSponsoredDisclaimer(true);
        this.setShowDevelopingStoryDisclaimer(true);
        this.setShowTableOfContents(true);
        this.setShowQuickShopLinks(true);
        this.setIsPromptAuthorVisible(true);
        this.setIsExcerptVisible(true);
    }

    public setThreadTemplateDefaults(): void {
        this.setShowSelectFeaturedVideo(false);
        this.setShowSelectFeaturedEmbed(false);
        this.setShowFeaturedImage(true);
        this.setIsFeaturedTagDisabled(true);
        this.setShowSEO(false);
        this.setShowContent(false);
        this.setShowSponsoredDisclaimer(false);
        this.setShowDevelopingStoryDisclaimer(false);
        this.setShowTableOfContents(false);
        this.setShowQuickShopLinks(false);
        this.setFeaturedVideo(null);
        this.setIsTitleDisabled(true);
        this.setDisplayConfiguration(2);
        this.setIdContentType(41);
        this.setIdIntent(15);
        this.setIsPromptAuthorVisible(true);
        this.setIsExcerptVisible(false);

        //check if featured image is empty, set it to placeholder image if so
        let featuredImage = this.imageWidgetForFeaturedImage.getImage();
        if(featuredImage == null){
            this.setThreadsPlaceHolderFeaturedImage();
        }

    }

    public setThreadsPlaceHolderFeaturedImage(){

        let defaultThreadsImage = this.getTemplateViewModel().defaultThreadsImage();

        if(defaultThreadsImage){
            this.setImage(defaultThreadsImage, 'featured_image');
        }

    }

    public resetThreadTemplateDefaults(): void {
        this.setShowSubContent(true);
        this.setShowFeaturedImage(true);

        this.setShowSelectFeaturedVideo(true);
        this.setShowSelectFeaturedEmbed(true);
        this.setShowSEO(true);
        this.setShowContent(true);
        this.setShowSponsoredDisclaimer(true);
        this.setShowDevelopingStoryDisclaimer(true);
        this.setShowTableOfContents(true);
        this.setShowQuickShopLinks(true);
        this.setIsTitleDisabled(false);
        this.setDisplayConfiguration(1);
        this.setIsPromptAuthorVisible(true);
        this.setIsExcerptVisible(true);
    }

    public setPrompt(prompt): void {
        this.getTemplateViewModel().prompt(prompt);
    }

    public setPromptResponse(promptResponse): void {
        this.getTemplateViewModel().promptResponse(promptResponse);
    }

    public setShowSubContent(showSubContent): void {
        this.getTemplateViewModel().showSubContent(showSubContent);
    }

    public setShowFeaturedImage(showFeaturedImage): void {
        this.getTemplateViewModel().showFeaturedImage(showFeaturedImage);
    }

    public setShowSelectFeaturedEmbed(showSelectFeaturedEmbed): void {
        this.getTemplateViewModel().showSelectFeaturedEmbed(showSelectFeaturedEmbed);
    }

    public setShowSelectFeaturedVideo(showSelectFeaturedVideo): void {
        this.getTemplateViewModel().showSelectFeaturedVideo(showSelectFeaturedVideo);
    }

    public setShowSEO(showSEO): void {
        this.getTemplateViewModel().showSEO(showSEO);
    }

    public setArticleTypesWithFAQ(articleTypes): void {
        this.getTemplateViewModel().articleTypesWithFAQ(articleTypes);
    }

    public setAudioReaderAllowedTemplateIds(templateIds): void {
        this.getTemplateViewModel().audioReaderAllowedTemplateIds(templateIds || []);
    }

    public setShowContent(showContent): void {
        this.getTemplateViewModel().showContent(showContent);
    }

    public setShowSponsoredDisclaimer(showSponsoredDisclaimer): void {
        this.getTemplateViewModel().showSponsoredDisclaimer(showSponsoredDisclaimer);
    }

    public setShowDevelopingStoryDisclaimer(showDevelopingStoryDisclaimer): void {
        this.getTemplateViewModel().showDevelopingStoryDisclaimer(showDevelopingStoryDisclaimer);
    }

    public setShowTableOfContents(showTableOfContents): void {
        this.getTemplateViewModel().showTableOfContents(showTableOfContents);
    }

    public setShowQuickShopLinks(showQuickShopLinks): void {
        this.getTemplateViewModel().showQuickShopLinks(showQuickShopLinks);
    }

    public setFeaturedVideoTitle(featuredVideoTitle): void {
        this.getTemplateViewModel().featuredVideoTitle(featuredVideoTitle);
    }

    public setShowFeaturedVideoTitle(showFeaturedVideoTitle): void {
        this.getTemplateViewModel().showFeaturedVideoTitle(showFeaturedVideoTitle);
    }

    public setFeaturedVideoDescription(featuredVideoDescription): void {
        this.getTemplateViewModel().featuredVideoDescription(featuredVideoDescription);
    }

    public setShowFeaturedVideoDescription(showFeaturedVideoDescription): void {
        this.getTemplateViewModel().showFeaturedVideoDescription(showFeaturedVideoDescription);
    }

    public setSavedFeedbacksHistoryOptions(options): void {

        let nonCurrent = options.filter((option) => option.id != 0);
        this.articleReviewHistory.showDropdown((nonCurrent.length > 0));

        this.articleReviewHistory.setSavedFeedbacksHistoryOptions(options);

        let id = this.getTemplateViewModel().id();
        let uuid = this.getFeedbackHistoryOption();
        if (id && uuid != 0) {
            this.caller.filterFeedBackHistory(id, uuid);
        } else {

            this.caller.getSensaiResults("article_content", this.getTemplateViewModel().idContentType());
        }
    }

    public getFeedbackHistoryOption() {
        return this.articleReviewHistory.getFeedbackHistoryOption();
    }

    public showFeedbackTabLoading(): void {
        this.articleReviewHistory.showLoading();
    }


    public hideFeedbackTabLoading(): void {
        this.articleReviewHistory.hideLoading();
    }

    public isArticleActiveTab(tabName: string): boolean {
        return (this.getTemplateViewModel().selectedTab() == tabName);
    }

    public setTemplateLayouts(templateLayouts) {
        this.getTemplateViewModel().templateLayouts(templateLayouts);
    }

    public setIdTemplateLayout(idTemplateLayout) {
        this.getTemplateViewModel().idTemplateLayout(idTemplateLayout);
    }

    public setIdTemplateLayoutPrevious(idTemplateLayout) {
        this.getTemplateViewModel().idTemplateLayoutPrevious(idTemplateLayout);
    }

    public setTemplateLayout(templateLayout) {
        if (templateLayout !== null) {
            templateLayout = templateLayout.toLowerCase()
        }
        this.getTemplateViewModel().templateLayout(templateLayout);
    }

    public setTemplateLayoutsFiltered(idTemplate, idDefault = null) {
        let templateLayoutsFiltered = [];
        let idTemplateLayoutDefault = null;
        let templateLayoutDefault = null;

        this.getTemplateViewModel().templateLayouts().forEach(tl => {
            if (tl.idTemplate == idTemplate) {
                templateLayoutsFiltered.push(tl);
                if (tl.isDefault == 1) {
                    idTemplateLayoutDefault = tl.id;
                    templateLayoutDefault = tl.name;
                }
            }
        });

        idTemplateLayoutDefault = (idDefault !== null) ? idDefault : idTemplateLayoutDefault;
        const currentLayout = (idDefault !== null) ? templateLayoutsFiltered.find(tl => tl.id == idDefault) : null;
        if (currentLayout) {
            templateLayoutDefault = currentLayout.name;
        }

        this.getTemplateViewModel().templateLayoutsFiltered(templateLayoutsFiltered);
        this.setIdTemplateLayout(idTemplateLayoutDefault);
        this.setIdTemplateLayoutPrevious(idTemplateLayoutDefault);
        this.setTemplateLayout(templateLayoutDefault);

        // Set Portrait Header availability based on template layout on page load
        this.getTemplateViewModel().isPortraitHeaderEnabled(idTemplateLayoutDefault === 36);
        if (idTemplateLayoutDefault !== 36) {
            this.getTemplateViewModel().isPortraitHeader(false);
        }

        if (templateLayoutDefault != null && (templateLayoutDefault.toLowerCase() == "minimal" || templateLayoutDefault.toLowerCase() == "review")) {
            this.setIsFeaturedTagDisabled(false);
            this.setIsFeaturedVideoDisabled(true);
        } else {
            this.setIsFeaturedTagDisabled(true);
            this.setIsFeaturedVideoDisabled(false);
        }

    }

    public setIsFeaturedTagDisabled(isFeaturedTagDisabled) {
        this.getTemplateViewModel().isFeaturedTagDisabled(isFeaturedTagDisabled);
    }

    public setIsFeaturedVideoDisabled(isFeaturedVideoDisabled) {
        this.getTemplateViewModel().isFeaturedVideoDisabled(isFeaturedVideoDisabled);
    }

    public getSubjectCoverage(){
        return this.articleReviewHistory.getSubjectCoverage();
    }

    public showSubjectCoverageLoading(target){
        this.articleReviewHistory.showLoadingSubjectCoverage(target);
    }

    public hideSubjectCoverageLoading(target){

        this.articleReviewHistory.hideLoadingSubjectCoverage(target);
    }

    public showScoreLoading(target){

        this.articleReviewHistory.showScoreLoading(target);
    }

    public hideScoreLoading(target){
        this.articleReviewHistory.hideScoreLoading(target);
    }

    public setIsAdmin(isAdmin){
        this.getTemplateViewModel().isAdmin(isAdmin);
    }

    public getIsAdmin(){
        return this.getTemplateViewModel().isAdmin();
    }

    public setFilterUserPromptAuthor(users){
        this.getTemplateViewModel().filterWebsiteUser_prompt_author.users(users);
    }

    public setPromptAuthor(promptAuthor): void {
        this.getTemplateViewModel().filterWebsiteUser_prompt_author.users(promptAuthor);
        this.getTemplateViewModel().filterWebsiteUser_prompt_author.user(`${promptAuthor.displayName} (#${promptAuthor.idProfile})`);
        this.getTemplateViewModel().filterWebsiteUser_prompt_author.idUser(promptAuthor.id);
        this.filterWebsiteUser_prompt_author.toggleCloseButton()
    }


    public setViewModelFromRequest(urlParams){
        this.caller.setDataFromBackend(urlParams);
    }
    public setPromptLink(promptLink): void {
        this.getTemplateViewModel().promptLink(promptLink);
    }

    public setIsPromptAuthorVisible(visible: boolean): void {
        //this.getTemplateViewModel().filterUser_prompt_author.disabled(disabled);
        return this.getTemplateViewModel().isPromptAuthorVisible(visible);
    }

    public setIsExcerptVisible(visible): boolean {
        return this.getTemplateViewModel().isExcerptVisible(visible);
    }

    public setShowSegmentTab(showSegmentTab): void {
        this.getTemplateViewModel().showSegmentTab(showSegmentTab);
    }

    private validateArticleStatusChange() {

        const { idPublishStatus, previousIdPublishStatus } = this.getTemplateViewModel();

        if (previousIdPublishStatus() === 3  && previousIdPublishStatus() !== idPublishStatus()) {
            const confirmPublishStatusChange = confirm("Changing the Publish Status will Unpublish this article - Do you want to continue?");
            if (!confirmPublishStatusChange) {
                return false;
            }
        }

        previousIdPublishStatus(idPublishStatus())
        return true;
    }

    public getTotalSensaiScore(){
        return this.articleReviewHistory.getTotalSensaiScore();
    }

    public setTotalSensaiScore(){

        let sensaiCoverageScore = this.getTemplateViewModel().sensaiCoverageScore() ? this.getTemplateViewModel().sensaiCoverageScore() : 0;
        let sensaiRuleScore = this.getTemplateViewModel().sensaiRuleScore() ? this.getTemplateViewModel().sensaiRuleScore() : 0;
        let totalScore = (parseFloat(sensaiCoverageScore) + parseFloat(sensaiRuleScore)).toFixed(2);

        this.articleReviewHistory.setSensaiCoverageScore(sensaiCoverageScore);
        this.articleReviewHistory.setTotalSensaiScore(totalScore);

        this.sensaiPromptTemplate.setSensaiCoverageScore(sensaiCoverageScore);
        this.sensaiPromptTemplate.setTotalSensaiScore(totalScore);
    }

    public getTotalSensaiScoreFromProgressBar(){
        const vm = this.getTemplateViewModel();
        let sensaiCoverageScore = vm.sensaiCoverageScore() ? vm.sensaiCoverageScore() : 0;
        let sensaiRuleScore = vm.sensaiRuleScore() ? vm.sensaiRuleScore() : 0;
        return parseFloat((parseFloat(sensaiCoverageScore) + parseFloat(sensaiRuleScore)).toFixed(2));
    }

    public setEeatScoresFromArticleData(articleData: any): void {
        const vm = this.getTemplateViewModel();
        vm.eeatExperienceScore(articleData["eeatExperienceScore"] != null ? articleData["eeatExperienceScore"] : null);
        vm.eeatExpertiseScore(articleData["eeatExpertiseScore"] != null ? articleData["eeatExpertiseScore"] : null);
        vm.eeatAuthorityScore(articleData["eeatAuthorityScore"] != null ? articleData["eeatAuthorityScore"] : null);
        vm.eeatTrustScore(articleData["eeatTrustScore"] != null ? articleData["eeatTrustScore"] : null);
        vm.eeatExperienceExplanation(articleData["eeatExperienceExplanation"] != null ? articleData["eeatExperienceExplanation"] : null);
        vm.eeatExpertiseExplanation(articleData["eeatExpertiseExplanation"] != null ? articleData["eeatExpertiseExplanation"] : null);
        vm.eeatAuthorityExplanation(articleData["eeatAuthorityExplanation"] != null ? articleData["eeatAuthorityExplanation"] : null);
        vm.eeatTrustExplanation(articleData["eeatTrustExplanation"] != null ? articleData["eeatTrustExplanation"] : null);
    }

    public getContentGuidelineScore(){
        return this.articleReviewHistory.getContentGuidelineScore();
    }

    public getSensaiCoverageScore(){
        return this.articleReviewHistory.getSensaiCoverageScore();
    }

    public setSensaiCoverageScore(sensaiCoverageScore){
        this.getTemplateViewModel().sensaiCoverageScore(sensaiCoverageScore);
    }

    public setSensaiRuleScore(totalSensaiScore){
        this.getTemplateViewModel().sensaiRuleScore(totalSensaiScore);
    }

    public setSensaiRulePointThreshold(threshold){
        this.sensaiPromptTemplate.setSensaiRulePointThreshold(threshold);
        this.getTemplateViewModel().sensaiRulePointThreshold(threshold);
    }

    public getSensaiRulePointThreshold(){
        return this.getTemplateViewModel().sensaiRulePointThreshold();
    }

    public getDirectoryItemsNotInRepublishDirectory() {
        var returnItems = [];
        const directoryItems = this.getDirectoryItems();
        const republishDirectoryItems = this.getRepublishDirectoryItems();

        // recursively flatten directory items so we can compare them later
        const flattenDirectoryItems = (items) => items.reduce((flattenedItems, item) => {
            if (item.directoryItems().length > 0) {
                return [item, ...flattenedItems, ...flattenDirectoryItems(item.directoryItems())];
            }
            return [item, ...flattenedItems]
        }, []);

        const flatDirectoryItems = (directoryItems);
        const flatRepublishDirectoryItems = flattenDirectoryItems(republishDirectoryItems);

        flatDirectoryItems.forEach(item => {
            if (flatRepublishDirectoryItems.filter(repItem => repItem.id() == item.id()).length == 0) {
                returnItems.push(item)
            }
        });

        return returnItems;
    }



    public setShowPinnedTags(showPinnedTags){

        this.getTemplateViewModel().showPinnedTags(showPinnedTags);
    }

    public onClickClosePermalinkHistoryModal(data) {
        this.getTemplateViewModel().isPermalinkPopupShown(false);
    }

    public onClickShowPermalinkHistoryModal(data) {
        this.getTemplateViewModel().isPermalinkPopupShown(true);
        this.getTemplateViewModel().articleDetailsModal(false);
    }
    public setChannel(channel) {
        this.getTemplateViewModel().idChannel(channel.id);
        this.getTemplateViewModel().channelName(channel.name);
    }

    public getPlaylists() {
        return this.getTemplateViewModel().playlists();
    }

    public setPlaylists(playlists) {
        this.getTemplateViewModel().playlists(playlists);
    }

    public setRepublishesCount(count: number){
        this.getTemplateViewModel().republishesCount(count);
    }

    protected setTagTypeDropdown(tagTypes) {
        this.tagPicker.setTagTypeDropdown(tagTypes);
    }
    public deleteAllSelectedTagType(){
        this.tagPicker.deleteAllSelectedTagType();
    }

    public onClickQuickPrompt(data, event) {
        this.initiateSensaiChat(data, true);
        this.getTemplateViewModel().hideHistoryTitle();
        const textarea = document.querySelector('.sensai-vault-user-query textarea') as HTMLTextAreaElement;
        if (textarea) {
            textarea.style.height = "auto";
        }
        // Add the 'clicked' class to the container
        const container = document.querySelector('.sensai-vault-user-query-container');
        if (container) {
            container.classList.add('clicked');
        }
    }

    public onClickClearChatHistory(){

    }

    public onClickImage(data, event){
        const imgElement = event.target.closest("div").querySelector("img");

        if (!imgElement) {
            console.error("No image found in the clicked section.");
            return;
        }
        let editor = {
            name: "article_content",
        };
        // const imageId = imgElement.id;
        // this.caller.getImagesInContent(imageId);
        this.caller.onClickCkEditorElement(imgElement, editor);
    }

    public onClickNewTab(data,event){
        const imgElement = event.target.closest("div").querySelector("img"); // Find the image in the same div
        if (!imgElement) {
            console.error("No image found to open in new tab.");
            return;
        }

        const imageUrl = imgElement.src;
        let cleanUrl = imageUrl.split('?')[0];
        window.open(cleanUrl, "_blank");
    }

    public showArticlePickerSensai(data, event){
        const articleId = event.target.closest("button").getAttribute("data-id");
        const articleElement = document.querySelector(`.emaki-article-card[data-id='${articleId}']`);
        let editor = {
            name: "article_content",
        };
        this.caller.onClickCkEditorElement(articleElement, editor, true);
    }

    public onClickOpenArticleNewTab(data, event){
        const articleElement = event.target.closest(".emaki-article-container").querySelector(".emaki-article-card");

        if (!articleElement) {
            console.error("No article element found.");
            return;
        }

        const articleUrl = articleElement.getAttribute("data-permalink");

        if (!articleUrl) {
            console.error("No valid permalink found.");
            return;
        }

        window.open(articleUrl, "_blank");
    }

    public copyPermalink(data, event){

        const articleElement = event.target.closest(".emaki-article-container").querySelector(".emaki-article-card");

        if (!articleElement) {
            console.error("No article element found.");
            return;
        }

        const permalink = articleElement.getAttribute("data-permalink");

        if (!permalink) {
            console.error("No permalink found.");
            return;
        }

        // Create a temporary input field for copying
        const tempInput = document.createElement("textarea");
        tempInput.value = permalink;
        document.body.appendChild(tempInput);

        // Select and copy the text
        tempInput.select();
        document.execCommand("copy");

        // Remove the temporary input field
        document.body.removeChild(tempInput);
    }

    public onClickTag(data, event){
        let tagElement = event.target.closest('.emaki-displayCard.tag');

        let editor = {
            name: "article_content",
        };
        this.caller.onClickCkEditorElement(tagElement, editor);

    }

    public onClickTagOpenInNewTab(data, event){
        const tagPermalink = event.target.getAttribute("data-permalink");
        window.open(tagPermalink, "_blank");
    }

    private initiateSensaiChat(query, isQuickPrompt = false){
        if (query === null) {
            query = this.getTemplateViewModel().userQuery();
        }

        if (query !== "") {
            this.addToChatHistory(query, "user");
            this.caller.initiateSensaiChat(query, isQuickPrompt);
            this.getTemplateViewModel().userQuery("");
        }
    }

    public clearChatHistory(){
        this.getTemplateViewModel().chatHistory([]);
    }

    public addToChatHistory(historyItem, type) {
        let chatHistory = this.getTemplateViewModel().chatHistory();
        chatHistory.push({ content: historyItem, role: type});

        this.getTemplateViewModel().chatHistory();
        this.getTemplateViewModel().chatHistory(chatHistory);

        if(type === "system" ) {
            if(historyItem.includes("onClickImage")) {

                let galleryElements = document.querySelectorAll('.image-gallery');
                galleryElements.forEach(galleryElement => {
                    if (!galleryElement.querySelector('[data-bind]') || !ko.dataFor(galleryElement.querySelector('[data-bind]'))) {
                        ko.applyBindingsToDescendants(this.getTemplateViewModel(), galleryElement);
                    }
                });
            }else if (historyItem.includes("showArticlePickerSensai") || historyItem.includes("copyPermalink")) {
                let articleElements = document.querySelectorAll('.emaki-article-container');
                articleElements.forEach(articleElement => {
                    if (!articleElement.querySelector('[data-bind]') || !ko.dataFor(articleElement.querySelector('[data-bind]'))) {
                        ko.applyBindingsToDescendants(this.getTemplateViewModel(), articleElement);
                    }
                })

            }else if (historyItem.includes("emaki-displayCard tag") && historyItem.includes("onClickTag")) {
                let tagElements = document.querySelectorAll('.emaki-displayCard.tag');
                tagElements.forEach(tagElement => {
                    if (!tagElement.querySelector('[data-bind]') || !ko.dataFor(tagElement.querySelector('[data-bind]'))) {
                        const descendants = tagElement.querySelectorAll('[data-bind]');

                        if(descendants.length > 0) {
                            for (const el of descendants) {
                                if (!ko.dataFor(el)) {
                                    ko.applyBindingsToDescendants(this.getTemplateViewModel(), tagElement);
                                }
                            }

                        }
                    }
                })
            }

        }
    }
    protected scrappingExternalSourceNewsUrl({sourceUrl, isLoadingSrcTimeBtn}){
        (this.caller as articles_edit_new).scrappingExternalSourceNewsUrl({sourceUrl, isLoadingSrcTimeBtn});
    }

    public isNewsArticleHightlighted(){
        const targetDiv = document.querySelector('.w-timeliness');
        if (targetDiv) {
            const elementRect = targetDiv.getBoundingClientRect();
            const absoluteElementTop = elementRect.top + window.pageYOffset;
            const middle = absoluteElementTop - (window.innerHeight / 2) + (elementRect.height / 2);
            window.scrollTo({
                top: middle,
                behavior: 'smooth'
            });

            targetDiv.classList.add('pulse-border');
            setTimeout(() => {
                targetDiv.classList.remove('pulse-border');
            }, 3000);
        }
    }

    public setQuizQuestions(quizQuestions) {
        const templateViewModel = this.getTemplateViewModel();
        templateViewModel.quizQuestions(quizQuestions);
    }

    public addQuizQuestion() {
        const quizQuestions = this.getTemplateViewModel().quizQuestions;

        const existingQuestions = quizQuestions();
        if (existingQuestions && existingQuestions.length > 0) {
            if (existingQuestions.length > quizUniqueIdCounter) {
                quizUniqueIdCounter = existingQuestions.length;
            }
            existingQuestions.forEach(q => {
                const uid = q.uniqueId;
                if (uid && typeof uid === 'string' && uid.startsWith('quiz_new_')) {
                    const num = parseInt(uid.replace('quiz_new_', ''), 10);
                    if (!isNaN(num) && num > quizUniqueIdCounter) {
                        quizUniqueIdCounter = num;
                    }
                }
            });
        }

        const newQuestion = {
            uniqueId: "quiz_new_" + (++quizUniqueIdCounter),
            question: ko.observable(""),
            difficulty: ko.observable("easy"),
            basis: ko.observable("article"),
            rationale: ko.observable(""),
            correctOptionIndex: ko.observable(0),
            isCollapsed: ko.observable(false),
            isFromAi: ko.observable(false),
            toggleCollapsed() {
                this.isCollapsed(!this.isCollapsed());
            },
            options: ko.observableArray([
                { text: ko.observable(""), isCorrect: ko.observable(false) },
                { text: ko.observable(""), isCorrect: ko.observable(false) },
                { text: ko.observable(""), isCorrect: ko.observable(false) },
                { text: ko.observable(""), isCorrect: ko.observable(false) }
            ]),
            isQuestionValid : null
        };

        newQuestion.isQuestionValid = ko.pureComputed(() => {
            const question = newQuestion.question() || "";
            const rationale = newQuestion.rationale() || "";
            const options = newQuestion.options() || [];

            if (question.trim() === "" || rationale.trim() === "" || options.length === 0) {
                return false;
            }

            return options.every(option => option.text().trim() !== "");
        });

        quizQuestions.push(newQuestion);
    }

    public toggleAllQuizQuestions() {
        const quizQuestions = this.getTemplateViewModel().quizQuestions();
        if (quizQuestions.length === 0) return;

        const anyExpanded = quizQuestions.some(q => !ko.unwrap(q.isCollapsed));
        quizQuestions.forEach(q => {
            if (typeof q.isCollapsed === "function") {
                q.isCollapsed(anyExpanded);
            }
        });
    }

    public addQuizOption(question) {
        question.options.push({ text: ko.observable(""), isCorrect: ko.observable(false) });
    }

    public removeQuizOption(question, optionIndex) {
        question.options.splice(optionIndex, 1);
    }

    public removeQuizQuestion(questionIndex) {
        this.getTemplateViewModel().quizQuestions.splice(questionIndex, 1);
    }

    public saveQuiz() {
       this.caller.saveQuiz();
    }

    public setQuizDynamicPlacementAttr(isDynamic: boolean) {
       this.caller.setQuizDynamicPlacementAttr(isDynamic);
    }


    public isCompletedWithAllowedTypes() {
        let responseParsed = this.getTemplateViewModel().aiSettings();
        const ALLOWED_CONTENT_TYPES = responseParsed.summaryEnabledContentTypes || [4,2,29,30,28,27,13];
        const ALLOWED_TEMPLATE_TYPES = responseParsed.summaryEnabledTemplates || [2,3,7];
        const SUMMARY_AVAILABLE = typeof responseParsed.summaryAvailable === "boolean" ? responseParsed.summaryAvailable : true;
        const vm = this.getTemplateViewModel();
        //const isCompleted = vm.idStatus && typeof vm.idStatus === "function" ? vm.idStatus() === 6 : false;
        const hasAllowedContentType = vm.idContentType && typeof vm.idContentType === "function"
        ? ALLOWED_CONTENT_TYPES.indexOf(parseInt(vm.idContentType() as string, 10)) > -1
        : false;
        const hasAllowedTemplateType = vm.idTemplate && typeof vm.idTemplate === "function"
            ? ALLOWED_TEMPLATE_TYPES.indexOf(parseInt(vm.idTemplate() as string, 10)) > -1
            : false;
        //this.getTemplateViewModel().showSummary(SUMMARY_AVAILABLE && isCompleted && hasAllowedContentType && hasAllowedTemplateType);
        const isEligible = SUMMARY_AVAILABLE && hasAllowedContentType && hasAllowedTemplateType;
        this.getTemplateViewModel().showSummary(isEligible);

        if (vm.isSummaryFetched === undefined || vm.isSummaryFetched === false) {
            const onByDefault = responseParsed.isSummaryOnByDefault !== false;
            vm.isFactualSummaryEnabled(isEligible && onByDefault);
            vm.isSimpleSummaryEnabled(isEligible && onByDefault);
            vm.isSatiricalCommentaryEnabled(isEligible && onByDefault);
        }
    }

    public isNewsletterPromotioAllowed() {

        let responseParsed = this.getTemplateViewModel().aiSettings();
        // Define your allowed types here
        const ALLOWED_CONTENT_TYPES = responseParsed.newsletterPromotionEnabledContentTypes || [4,2,29,30,28,27,13];
        const ALLOWED_TEMPLATE_TYPES = responseParsed.newsletterPromotionEnabledArticleTypes || [2,3,7];
        const IS_AVAILABLE = typeof responseParsed.isNewsletterPromotionEnabled === "boolean" ? responseParsed.isNewsletterPromotionEnabled : true;

        const vm = this.getTemplateViewModel();
        const hasAllowedContentType = vm.idContentType && typeof vm.idContentType === "function"
        ? ALLOWED_CONTENT_TYPES.indexOf(parseInt(vm.idContentType() as string, 10)) > -1
        : false;
        const hasAllowedTemplateType = vm.idTemplate && typeof vm.idTemplate === "function"
            ? ALLOWED_TEMPLATE_TYPES.indexOf(parseInt(vm.idTemplate() as string, 10)) > -1
            : false;
        const isEligible = IS_AVAILABLE && hasAllowedContentType && hasAllowedTemplateType;
        vm.showNewsletterPromotion(isEligible);

        if (vm.isNewsletterPromotionFetched === undefined || vm.isNewsletterPromotionFetched === false) {
            const onByDefault = responseParsed.isNewsletterPromotionOnByDefault !== false;
            vm.isAiNewsletterPromotionEnabled(isEligible && onByDefault);
        }
    }

    public isDealsCategoryPromotioAllowed() {

        let responseParsed = this.getTemplateViewModel().aiSettings();
        // Define your allowed types here
        const ALLOWED_CONTENT_TYPES = responseParsed.dealsCategoryPromotionEnabledContentTypes || [4,2,29,30,28,27,13];
        const ALLOWED_TEMPLATE_TYPES = responseParsed.dealsCategoryPromotionEnabledArticleTypes || [2,3,7];
        const IS_AVAILABLE = typeof responseParsed.isDealsCategoryPromotionEnabled === "boolean" ? responseParsed.isDealsCategoryPromotionEnabled : true;

        const vm = this.getTemplateViewModel();
        const hasAllowedContentType = vm.idContentType && typeof vm.idContentType === "function"
            ? ALLOWED_CONTENT_TYPES.indexOf(parseInt(vm.idContentType() as string, 10)) > -1
            : false;
        const hasAllowedTemplateType = vm.idTemplate && typeof vm.idTemplate === "function"
            ? ALLOWED_TEMPLATE_TYPES.indexOf(parseInt(vm.idTemplate() as string, 10)) > -1
            : false;
        const isEligible = IS_AVAILABLE && hasAllowedContentType && hasAllowedTemplateType;
        vm.showDealsCategoryPromotion(isEligible);

        if (vm.isDealsCategoryPromotionFetched === undefined || vm.isDealsCategoryPromotionFetched === false) {
            const onByDefault = responseParsed.isDealsCategoryPromotionOnByDefault !== false;
            vm.isAiDealsCategoryPromotionEnabled(isEligible && onByDefault);
        }
    }


    public updateAiDealsCategoryPromotionListingPageId() {
        const idListingPage = this.dealsCategoryPromotionListingPageFilter.getTemplateViewModel().idListingPage();
        this.getTemplateViewModel().aiDealsCategoryPromotionListingPageId(idListingPage);
    }

    public setDealsCategoryListingPage(listingPage) {
        this.dealsCategoryPromotionListingPageFilter.setListingPage(listingPage);
    }

    public isQuizAllowedOverride() {
        this.getTemplateViewModel().showQuiz(true);
    }

    public isThreadSummaryAllowed() {
        let responseParsed = this.getTemplateViewModel().aiSettings();
        const ALLOWED_CONTENT_TYPES = responseParsed.threadSummaryEnabledContentTypes || [];
        const ALLOWED_TEMPLATE_TYPES = responseParsed.threadSummaryEnabledArticleTypes || [];
        const THREAD_SUMMARY_AVAILABLE = typeof responseParsed.threadSummaryAvailable === "boolean" ? responseParsed.threadSummaryAvailable : false;
        const vm = this.getTemplateViewModel();
        const hasAllowedContentType = vm.idContentType && typeof vm.idContentType === "function"
            ? ALLOWED_CONTENT_TYPES.indexOf(parseInt(vm.idContentType() as string, 10)) > -1
            : false;
        const hasAllowedTemplateType = vm.idTemplate && typeof vm.idTemplate === "function"
            ? ALLOWED_TEMPLATE_TYPES.indexOf(parseInt(vm.idTemplate() as string, 10)) > -1
            : false;
        const isEligible = THREAD_SUMMARY_AVAILABLE && hasAllowedContentType && hasAllowedTemplateType;
        this.getTemplateViewModel().aiThreadSummaryFeatureAvailable(isEligible);

        if (vm.isThreadSummaryFetched === undefined || vm.isThreadSummaryFetched === false) {
            const onByDefault = responseParsed.isThreadOnByDefault !== false;
            this.setisAiThreadSummaryEnabled(isEligible && onByDefault);
        }
    }

    public isQuizAllowed(_responseParsed): boolean {
        return true;
    }

    public isAiFaqAllowed(responseParsed): boolean {
        // faqEnabledContentTypes' => $faqEnabledContentTypes,
        //     'faqEnabledArticleTypes' => $faqEnabledArticleTypes,
        //     'aiFaqEnabled' => $aiSettings->faqAvailable ? $aiSettings->faqAvailable : false,

        const ALLOWED_CONTENT_TYPES = responseParsed.faqEnabledContentTypes || [];
        const ALLOWED_TEMPLATE_TYPES = responseParsed.faqEnabledArticleTypes || [];
        const AI_FAQ_AVAILABLE = typeof responseParsed.aiFaqEnabled === "boolean" ? responseParsed.aiFaqEnabled : false;

        const vm = this.getTemplateViewModel();
        const isCompleted = vm.idStatus && typeof vm.idStatus === "function" ? vm.idStatus() === 6 : false;
        const hasAllowedContentType = vm.idContentType && typeof vm.idContentType === "function"
            ? ALLOWED_CONTENT_TYPES.indexOf(parseInt(vm.idContentType() as string, 10)) > -1
            : false;
        const hasAllowedTemplateType = vm.idTemplate && typeof vm.idTemplate === "function"
            ? ALLOWED_TEMPLATE_TYPES.indexOf(parseInt(vm.idTemplate() as string, 10)) > -1
            : false;


        return AI_FAQ_AVAILABLE && isCompleted && hasAllowedContentType && hasAllowedTemplateType;
        //return false; // Temporarily disabled

    }

    public addAiUserMessage(message, type = 'preset', functionName = '', className = '') {
            const userMessageEl = document.createElement("div");
            if(type === 'customprompt') {
                    userMessageEl.id = "custom-prompts-content-userMessage";

            }else{
                   userMessageEl.id = "title-analysis-content-userMessage";

            }
            userMessageEl.classList.add("ai-userMessage");
            if(className) {
                userMessageEl.classList.add(className);
            }
            const messageLength = message.split(/<br>/).reduce((acc, curr) => acc + Math.ceil(curr.length / 40) * 40, 0);

           userMessageEl.innerHTML = `
            <div class="message-body truncated">
                ${message}
            </div>
            ${messageLength > 200 ? `<button class="read-more-btn">Show More</button>` : ''}
            <div class="ai-userMessage-selectedMode">

                ${functionName == 'internalLinking' && this.getTemplateViewModel().aiPromptSelectedTextIncluded() && this.getTemplateViewModel().aiPromptSelectedTextIncludedEnabled() ? `  <div class="ai-context-label-type" title="Passed Selected Text" ><span class="icon i-regular-template"></span>  </div>` : ''}
                ${functionName == 'internalLinking' && (!this.getTemplateViewModel().aiPromptSelectedTextIncluded() || !this.getTemplateViewModel().aiPromptSelectedTextIncludedEnabled()) ? '<div class="ai-context-label-type" title="Passed Full Article Content" ><span class="icon i-article"></span></div>' : ''}
                ${functionName !== 'internalLinking' && this.getTemplateViewModel().aiPromptSelectedTextIncluded() && this.getTemplateViewModel().aiPromptSelectedTextIncludedEnabled() ? `  <div class="ai-context-label-type" title="Passed Selected Text" ><span class="icon i-regular-template"></span>  </div>` : ''}
                ${functionName !== 'internalLinking' && this.getTemplateViewModel().aiPromptArticleIncluded() && (!this.getTemplateViewModel().aiPromptSelectedTextIncluded() || !this.getTemplateViewModel().aiPromptSelectedTextIncludedEnabled()) ? `<div class="ai-context-label-type" title="Passed Full Article Content" ><span class="icon i-article"></span></div>` : ''}
                ${functionName !== 'internalLinking' && this.getTemplateViewModel().aiPromptBrandContextIncluded() && this.getTemplateViewModel().aiPromptBrandContextIncludedEnabled() ? `  <div class="ai-context-label-type" title="Used Brand Context" ><span class="icon i-brand-2"></span>  </div>` : ''}
                ${functionName !== 'internalLinking' && this.getTemplateViewModel().aiPromptAuthorToneIncluded() && this.getTemplateViewModel().aiPromptAuthorToneIncludedEnabled() ? `  <div class="ai-context-label-type" title="Used Author Tone" ><span class="icon i-user2 "></span>  </div>` : ''}
            </div>
            `;

            // Append to container
            if(type === 'customprompt') {
                const articleSuggestionEl = document.getElementById("custom-prompts-content");
                articleSuggestionEl.appendChild(userMessageEl);

            }else{
                const articleSuggestionEl = document.getElementById("title-analysis-content");
                articleSuggestionEl.appendChild(userMessageEl);

            }

            if (messageLength > 200) {
                // Toggle logic
                const messageBody = userMessageEl.querySelector(".message-body");
                const toggleBtn = userMessageEl.querySelector(".read-more-btn");

                toggleBtn.addEventListener("click", () => {
                    const isExpanded = !messageBody.classList.contains("truncated");

                    if (isExpanded) {
                        messageBody.classList.add("truncated");
                        toggleBtn.textContent = "Show More";
                    } else {
                        messageBody.classList.remove("truncated");
                        toggleBtn.textContent = "Hide";
                    }
                });
            }
          this.addAiBotThinking(type);
          this.scrollChatToBottom(false,type);
    }

    public addAiBotThinking(type = 'preset') {

        if(type === 'customprompt') {
            const articleSuggestionEl = document.getElementById("custom-prompts-content");
            const generatingCoverMessageEl = document.createElement("div");
            generatingCoverMessageEl.id = "custom-prompts-content-generating-cover";
            generatingCoverMessageEl.classList.add("ai-thinking");
            generatingCoverMessageEl.innerHTML = `
                                    <div class="loader-dot"></div>
                                `;
            articleSuggestionEl.appendChild(generatingCoverMessageEl);
        }else{
            const articleSuggestionEl = document.getElementById("title-analysis-content");
            const generatingCoverMessageEl = document.createElement("div");
            generatingCoverMessageEl.id = "title-analysis-content-generating-cover";
            generatingCoverMessageEl.classList.add("ai-thinking");
            generatingCoverMessageEl.innerHTML = `
                                        <div class="loader-dot"></div>
                                    `;
            articleSuggestionEl.appendChild(generatingCoverMessageEl);
        }

    }
  public scrollChatToBottom(Tobuttom = false ,type = 'preset') {
    let container;
    if(type === 'customprompt') {
         container = document.getElementById('custom-prompts-content');
    }else{
         container = document.getElementById('title-analysis-content');
    }
    const messages = container.querySelectorAll('.ai-userMessage');
    if(Tobuttom) {
        container.scrollTo({
            top: container.scrollHeight+100,
            behavior: 'smooth'
        });
        return
    }
    if (container && messages && messages.length > 0) {
        const lastMessage = messages[messages.length - 1] as HTMLElement;

        // Remove old spacer if it exists
        const existingSpacer = container.querySelector('.ai-scroll-spacer');
        if (existingSpacer) {
            existingSpacer.remove();
        }

        // Calculate dynamic height
        const containerHeight = container.clientHeight;
        const messageHeight = lastMessage.offsetHeight;
        const dynamicSpacerHeight = Math.max(0, containerHeight - messageHeight);

        // Create new spacer
        const spacer = document.createElement('div');
        spacer.className = 'ai-scroll-spacer';
        spacer.style.height = `${dynamicSpacerHeight}px`;
        spacer.style.opacity = '0';
        spacer.setAttribute('aria-hidden', 'true');

        // Insert spacer after the message
        container.appendChild( spacer);

        // Scroll so the message aligns to the top
        container.scrollTo({
            top: lastMessage.offsetTop,
            behavior: 'smooth'
        });
    }
}

    public formatDateTime(dateInput) {
        if (!dateInput) {
            return dateInput;
        }

        const date = new Date(dateInput);

        const pad = (num) => num.toString().padStart(2, '0');

        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1); // getMonth is 0-based
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());

        return `${year}-${month}-${day} ${hours}:${minutes}`;
    }

    onIntentChange(data){

        const idTemplate = data.idTemplate();
        const idIntent = data.idIntent();

        if(['9', '10', '11', '12'].indexOf(idTemplate) > -1) {
            return;
        }

        this.setIsSponsored(idIntent === 7);
    }

    onSyndicatedChange(data){
        const isSyndicated = data.isSyndicated();

        if (isSyndicated) {
            this.setIdIntent(16);
        } else {
            this.setNoAuthorship(false);
        }
    }

    public onClickGenerateArticleFaqs(data, event) {
        if(this.getTemplateViewModel().aiFaqs().length > 0) {
            this.warningDialog_articleAiFaq.setIsVisible(true);

        }else{
            this.caller.saveArticleFaqs(true);
        }
    }

    public onClickGenerateAudioReader() {
        if(this.getTemplateViewModel().audioReaderFileUrl()) {
            this.warningDialog_audioReader.setIsVisible(true);
        }else{
            this.caller.generateArticleAudioReader();
        }
    }

    protected formatAudioReaderTime(seconds): string {
        if (!isFinite(seconds) || seconds < 0) {
            seconds = 0;
        }

        const rounded = Math.floor(seconds);
        const hours = Math.floor(rounded / 3600);
        const minutes = Math.floor((rounded % 3600) / 60);
        const remainingSeconds = rounded % 60;
        const paddedSeconds = remainingSeconds < 10 ? "0" + remainingSeconds : remainingSeconds.toString();
        const paddedMinutes = minutes < 10 ? "0" + minutes : minutes.toString();

        return hours > 0 ? `${hours}:${paddedMinutes}:${paddedSeconds}` : `${minutes}:${paddedSeconds}`;
    }

    protected initializeAudioReaderPreviewPlayer(): void {
        const players = document.querySelectorAll("#audio-reader-section [data-audio-reader-player]");
        Array.prototype.forEach.call(players, (player) => {
            const audio = player.querySelector("audio") as HTMLAudioElement;
            const toggle = player.querySelector("[data-audio-reader-toggle]");
            const rewind = player.querySelector("[data-audio-reader-rewind]");
            const forward = player.querySelector("[data-audio-reader-forward]");
            const progress = player.querySelector("[data-audio-reader-progress]") as HTMLInputElement;
            const current = player.querySelector("[data-audio-reader-current]");
            const total = player.querySelector("[data-audio-reader-total]");
            const durationLabel = player.querySelector("[data-audio-reader-duration]");
            const speed = player.querySelector("[data-audio-reader-speed]") as HTMLSelectElement;
            const waveform = player.querySelector("[data-audio-reader-waveform]");
            const metadataUrl = this.getAudioReaderMetadataUrlForPlayer(player, audio);
            if (player.getAttribute("data-audio-reader-ready") === "true") {
                const bars = waveform ? waveform.querySelectorAll("span") : [];
                if (metadataUrl && metadataUrl !== player.getAttribute("data-audio-reader-metadata-rendered-url")) {
                    this.loadAudioReaderMetadata(player, audio, bars, durationLabel, total);
                }
                return;
            }

            player.setAttribute("data-audio-reader-ready", "true");
            if (waveform && !waveform.children.length) {
                const barCount = parseInt(waveform.getAttribute("data-waveform-bars") || "200", 10);
                for (let i = 0; i < barCount; i++) {
                    const bar = document.createElement("span");
                    bar.style.height = "20%";
                    waveform.appendChild(bar);
                }
            }
            const bars = waveform ? waveform.querySelectorAll("span") : [];

            if (!audio || !toggle || !rewind || !forward || !progress || !current || !total || !durationLabel || !speed) {
                return;
            }

            speed.value = "1";
            audio.playbackRate = 1;
            let knownDuration = 0;

            const getDuration = () => audio.duration || Number(player.getAttribute("data-audio-reader-known-duration") || 0) || knownDuration || 0;

            const ensureAudioLoaded = () => {
                if (!audio.getAttribute("src")) {
                    const audioUrl = audio.getAttribute("data-src") || "";
                    if (!audioUrl) {
                        return false;
                    }
                    audio.setAttribute("src", audioUrl);
                    audio.load();
                }

                return true;
            };

            const updatePlayerState = () => {
                const duration = getDuration();
                const ratio = duration ? audio.currentTime / duration : 0;
                const playedBars = Math.round(ratio * bars.length);

                progress.value = Math.round(ratio * 1000).toString();
                current.textContent = this.formatAudioReaderTime(audio.currentTime);
                total.textContent = this.formatAudioReaderTime(duration);
                durationLabel.textContent = this.formatAudioReaderTime(duration);

                Array.prototype.forEach.call(bars, (bar, index) => {
                    bar.classList.toggle("is-played", index < playedBars);
                });
            };

            const setPlaybackPosition = (seconds) => {
                const duration = getDuration();
                if (!duration) {
                    return;
                }

                if (!ensureAudioLoaded()) {
                    return;
                }
                audio.currentTime = Math.max(0, Math.min(duration, seconds));
                updatePlayerState();
            };

            toggle.addEventListener("click", () => {
                if (audio.paused) {
                    if (!ensureAudioLoaded()) {
                        return;
                    }
                    audio.play();
                } else {
                    audio.pause();
                }
            });

            rewind.addEventListener("click", () => setPlaybackPosition(audio.currentTime - 15));
            forward.addEventListener("click", () => setPlaybackPosition(audio.currentTime + 15));
            progress.addEventListener("input", () => setPlaybackPosition((parseInt(progress.value, 10) / 1000) * getDuration()));
            speed.addEventListener("change", () => audio.playbackRate = parseFloat(speed.value));

            if (waveform) {
                waveform.addEventListener("click", (event) => {
                    const bounds = waveform.getBoundingClientRect();
                    const ratio = (event.clientX - bounds.left) / bounds.width;
                    setPlaybackPosition(ratio * getDuration());
                });
            }

            audio.addEventListener("loadedmetadata", updatePlayerState);
            audio.addEventListener("timeupdate", updatePlayerState);
            audio.addEventListener("play", () => {
                toggle.textContent = "Pause";
                toggle.setAttribute("aria-label", "Pause Audio Reader");
            });
            audio.addEventListener("pause", () => {
                toggle.textContent = "Play";
                toggle.setAttribute("aria-label", "Play Audio Reader");
            });
            audio.addEventListener("ended", () => {
                toggle.textContent = "Play";
                toggle.setAttribute("aria-label", "Play Audio Reader");
                updatePlayerState();
            });

            updatePlayerState();
            this.loadAudioReaderMetadata(player, audio, bars, durationLabel, total, (duration) => {
                knownDuration = duration;
                updatePlayerState();
            });
        });
    }

    protected loadAudioReaderMetadata(player: Element, audio: HTMLAudioElement, bars, durationLabel?: Element | null, total?: Element | null, onDuration?: (duration: number) => void): void {
        const metadataUrl = this.getAudioReaderMetadataUrlForPlayer(player, audio);
        if (!metadataUrl) {
            return;
        }

        fetch(metadataUrl, { credentials: "same-origin" })
            .then((response) => response.ok ? response.json() : null)
            .then((metadata) => {
                if (!metadata || typeof metadata !== "object") {
                    return;
                }

                const duration = Number(metadata.duration || 0);
                if (duration > 0) {
                    player.setAttribute("data-audio-reader-known-duration", duration.toString());
                    if (durationLabel) {
                        durationLabel.textContent = this.formatAudioReaderTime(duration);
                    }
                    if (total) {
                        total.textContent = this.formatAudioReaderTime(duration);
                    }
                    if (onDuration) {
                        onDuration(duration);
                    }
                }

                if (metadata.waveform && Array.isArray(metadata.waveform.peaks) && bars && bars.length) {
                    metadata.waveform.peaks.slice(0, bars.length).forEach((peak, index) => {
                        const normalizedPeak = Math.max(0, Math.min(1, Number(peak)));
                        const height = 12 + Math.round(normalizedPeak * 88);
                        (bars[index] as HTMLElement).style.height = `${height}%`;
                    });
                }
                player.setAttribute("data-audio-reader-metadata-rendered-url", metadataUrl);
            })
            .catch(() => {
                // Leave placeholder bars and default times in place when the
                // optional metadata JSON is unavailable. Playback still works.
            });
    }

    protected getAudioReaderMetadataUrlForPlayer(player: Element, audio: HTMLAudioElement | null): string {
        const waveform = player.querySelector("[data-audio-reader-waveform]");
        const configuredUrl = waveform ? waveform.getAttribute("data-audio-reader-metadata-url") : "";

        return configuredUrl || (audio ? this.getAudioReaderMetadataUrl(audio.currentSrc || audio.src || audio.getAttribute("data-src") || "") : "");
    }

    protected getAudioReaderMetadataUrl(audioUrl: string): string {
        if (!audioUrl || !/\.mp3($|\?)/i.test(audioUrl)) {
            return "";
        }

        return audioUrl.replace(/\.mp3(?=($|\?))/i, ".metadata.json");
    }

    public setAiArticleFaqs(faqs) {
        if(faqs){

            this.getTemplateViewModel().aiFaqs(faqs || []);
        }
    }

    public setisAiFaqEnabled(isAiFaqEnabled: boolean) {
        this.getTemplateViewModel().isAiFaqEnabled(isAiFaqEnabled);
    }

    onContentTypeChange(data){
        const idContentType = data.idContentType();
        const idBrand = this.caller.getVnAppZone().app.params.idBrand
        const displayConfiguration = data.displayConfiguration;
        const idTemplateLayout = data.idTemplateLayout(); //vertical-short
        const brands = ["4", "20", "29", "43", "49"]; // TG, GR, DS, HG, POLY
        // if contentType = guide or long guide, hide from the homepage
        if(idBrand && brands.indexOf(idBrand) > -1 && idTemplateLayout != 43 && (idContentType === 25 || idContentType === 35 )){
            this.setDisplayConfiguration(2);
        }
        this.applyAudioReaderDefaultIfEligible();
    }

    public isAudioReaderAvailableForArticleType(): boolean {
        const allowedTemplateIds = this.getTemplateViewModel().audioReaderAllowedTemplateIds() || [];
        const idTemplate = parseInt(this.getTemplateViewModel().idTemplate(), 10);

        return allowedTemplateIds.indexOf(idTemplate) !== -1;
    }

    public applyAudioReaderDefaultIfEligible(): void {
        if (this.getId()) {
            return;
        }

        const vm = this.getTemplateViewModel();
        const settings = vm.articlePageSettings() || {};
        // Brand defaults only apply during article creation. Existing articles
        // keep their explicit Audio Reader checkbox value.
        if (!settings.isAudioReaderDefaultEnabled || !this.isAudioReaderAvailableForArticleType()) {
            vm.isAudioReaderEnabled(false);
            return;
        }

        const selectedContentTypes = settings.audioReaderDefaultContentTypes || [];
        if (!selectedContentTypes.length) {
            // Empty brand dropdown means "all content types", per the feature
            // spec, not "no content types".
            vm.isAudioReaderEnabled(true);
            return;
        }

        const idContentType = parseInt(vm.idContentType(), 10);
        const isAllowedContentType = selectedContentTypes.some((contentType) => parseInt(contentType.id, 10) === idContentType);
        vm.isAudioReaderEnabled(isAllowedContentType);
    }

    // NEW Article Form Methods
    public onClickOpenArticleDetailsModal(data, elementIdToFocus = null){
        //copy the current values over to a temporary observable
        const vm = this.getTemplateViewModel();
        const articleDetailsModalOpen = vm.articleDetailsModal();

        if(articleDetailsModalOpen && vm.previousDetailsModal() !== data){
            //reset the previous modal first
            switch(vm.previousDetailsModal()){
                case 'articleHeader':
                    //this.onClickCloseArticleHeader();
                    break;

                case 'articleFeaturedSection':
                    //this.onClickCloseFeaturedItems();
                    break;
                case 'articleTagSection':
                    this.onClickCloseTagItems();
                    break;
                case 'articleCategorySection':
                    this.onClickCloseCategoryItems();
                    break;
            }

        }

        switch(data){
            case 'articleHeader':
                vm.articleDetailsModalType('articleHeader');
                this.saveArticleHeaderState();
                //vm.articleDetailsModal(true);
                vm.previousDetailsModal('articleHeader');
                break;

            case 'articleFeaturedSection':
                vm.articleDetailsModalType('articleFeaturedSection');
                //this.saveArticleFeaturedSectionState();
                //vm.previousDetailsModal('articleFeaturedSection');
                //vm.articleDetailsModal(true);
                break;
            case 'articleTagSection':
                vm.articleDetailsModalType('articleTagSection');
                this.saveArticleTagSectionState();
                vm.previousDetailsModal('articleTagSection');
                vm.articleDetailsModal(true);
                break;
            case 'articleCategorySection':
                vm.articleDetailsModalType('articleCategorySection');
                vm.previousDetailsModal('articleCategorySection');
                this.saveArticleCategorySectionState();
                vm.articleDetailsModal(true);
                break;
        }
        if(elementIdToFocus){

            this.setFocusOnElementInModal(elementIdToFocus);
        }

    }

    public setFocusOnElementInModal(elementId) {
        setTimeout(function() {
            if (!elementId) return;

            var container = document.getElementById(elementId);
            if (!container) return;

            var input = null;

            // If container itself is an input or textarea
            if (container.tagName === 'INPUT' || container.tagName === 'TEXTAREA') {
                input = container;
            } else {
                // Otherwise, find the first input or textarea inside
                input = container.querySelector('input, textarea');
            }

            if (input && input.focus) {
                input.focus();

                // Move cursor to end (for text inputs and textareas only)
                var tag = input.tagName.toUpperCase();
                if (tag === 'INPUT' || tag === 'TEXTAREA') {
                    var val = (input as HTMLInputElement).value;
                    try {
                        (input as HTMLInputElement).setSelectionRange(val.length, val.length);
                    } catch (e) {
                        // setSelectionRange not supported (e.g. type="number") — ignore
                    }
                }
            }
        }, 150);
    }


    public saveArticleHeaderState(){
        const vm = this.getTemplateViewModel();

        vm.tempTitle = ko.observable(vm.title());
        vm.tempPermalink = ko.observable(vm.permalink());
        vm.tempExcerpt = ko.observable(vm.excerpt());

    }

    public resetHeaderValues(boxName: string){
        const vm = this.getTemplateViewModel();

        switch (boxName) {
            case 'title':
                vm.title('');
                vm.title(vm.tempTitle());
                break;
            case 'permalink':
                vm.permalink('');
                vm.permalink(vm.tempPermalink());
                break;
            case 'excerpt':
                vm.excerpt('');
                vm.excerpt(vm.tempExcerpt());
                break;
            default:
                break;
        }
    }

    public onClickConfirmHeader(boxName: string){
        const fieldElement = document.getElementById(`article-${boxName}`);
        if (fieldElement) {
            const target = fieldElement as HTMLInputElement | HTMLTextAreaElement;
            if(boxName === 'title') {
                let cleanedValue = target.value.replace(/[\r\n]+/g, " ").trim();
                if (cleanedValue) {
                    this.getTemplateViewModel().title(cleanedValue);
                }
            }else{
                let value = target.value;
                if (value) {
                    this.getTemplateViewModel()[boxName](value);
                }
            }
            target.blur();
        }
    }

    public onClickCancelHeader(boxName: string){
        this.resetHeaderValues(boxName);
        const fieldElement = document.getElementById(`article-${boxName}`);
        if (fieldElement) {
            const target = fieldElement as HTMLInputElement | HTMLTextAreaElement;
            target.blur();
        }
    }

    public onClickSaveArticleHeader(){
        const vm = this.getTemplateViewModel();
        vm.tempTitle(null);
        vm.tempPermalink(null);
        vm.tempExcerpt(null);
        vm.articleDetailsModal(!vm.articleDetailsModal());
        vm.articleDetailsModalType("");
    }

    public saveArticleFeaturedSectionState(){
        const vm = this.getTemplateViewModel();

        vm.tempWidgetFeaturedImage  = ko.observable(this.imageWidgetForFeaturedImage.getImage());
        vm.tempThumbnailImage       = ko.observable(this.imageWidgetForThumbnailImage.getImage());
        vm.tempFeaturedTag          = ko.observable(vm.featuredTags());
        vm.tempFeaturedVideo        = ko.observable(vm.featuredVideo());
        vm.tempFeaturedEmbed        = ko.observable(vm.featuredEmbed());
        vm.tempFeaturedSectionValue = ko.observable(vm.featuredSectionValue());
        vm.tempFeaturedImage        = ko.observable(vm.featuredImage());
        vm.tempIsVersusStyle        = ko.observable(vm.isVersusStyle());
    }

    public onClickCloseFeaturedItems(){
        const vm = this.getTemplateViewModel();

        this.clearFeaturedSection(vm.tempFeaturedSectionValue());
        if(vm.tempThumbnailImage()){
            this.imageWidgetForThumbnailImage.setImage(vm.tempThumbnailImage());
            this.getTemplateViewModel().featuredThumbnailImage(vm.tempThumbnailImage());
        }else{
            this.getTemplateViewModel().featuredThumbnailImage(null);
        }
        if(vm.tempWidgetFeaturedImage()){

            this.imageWidgetForFeaturedImage.setImage(vm.tempWidgetFeaturedImage());
            this.getTemplateViewModel().featuredImage(vm.tempWidgetFeaturedImage());
        }else{
            this.getTemplateViewModel().featuredImage(null);
        }


        vm.featuredTags(vm.tempFeaturedTag());
        vm.featuredVideo(vm.tempFeaturedVideo());
        vm.featuredEmbed(vm.tempFeaturedEmbed());
        vm.featuredSectionValue(vm.tempFeaturedSectionValue());
        vm.tempFeaturedImage(vm.tempFeaturedImage());
        vm.isVersusStyle(vm.tempIsVersusStyle());

        vm.tempWidgetFeaturedImage(null);
        vm.tempThumbnailImage(null);
        vm.tempFeaturedTag(null);
        vm.tempFeaturedVideo(null);
        vm.tempFeaturedEmbed(null);
        vm.tempFeaturedSectionValue(null);
        vm.tempFeaturedImage(null);
        vm.tempIsVersusStyle(null);
        vm.articleDetailsModalType("");

        vm.articleDetailsModal(!vm.articleDetailsModal());
    }

    public onClickSaveFeaturedItems(){
        const vm = this.getTemplateViewModel();

        vm.tempWidgetFeaturedImage(null);
        vm.tempFeaturedTag(null);
        vm.tempFeaturedVideo(null);
        vm.tempFeaturedEmbed(null);
        vm.tempFeaturedSectionValue(null);
        vm.tempFeaturedImage(null);
        vm.tempThumbnailImage(null);
        vm.tempIsVersusStyle(null);
        vm.articleDetailsModalType("");

        if(!this.imageWidgetForThumbnailImage.getImage()){
            this.getTemplateViewModel().featuredThumbnailImage(null);
        }
        vm.articleDetailsModal(!vm.articleDetailsModal());
    }

    public onClickCloseTagItems() {

        const vm   = this.getTemplateViewModel();
        const ftVM = this.filterTag.getTemplateViewModel();
        const rtVM = this.filterReviewTag.getTemplateViewModel();

        // Fresh arrays so KO detects change
        const restoredTagObjs    = vm.tempTagObjs() ? JSON.parse(JSON.stringify(vm.tempTagObjs())) : [];
        const restoredSelTags    = vm.tempSelectedTags() ? JSON.parse(JSON.stringify(vm.tempSelectedTags())) : [];
        const restoredPrimary    = vm.tempIdPrimaryTag();
        const restoredReviewedBy = vm.tempTagReviewedByArticle();

        // Restore view models
        ftVM.tagObjs(restoredTagObjs);
        rtVM.optionObj(restoredReviewedBy);
        vm.selectedTags(restoredSelTags);
        vm.idPrimaryTag(restoredPrimary);

        // Sync the manual DOM (tag container)
        const tagContainer = this.filterTag.getTagContainer();
        if (tagContainer) tagContainer.innerHTML = '';

        if (restoredTagObjs.length > 0) {
            // Recreate buttons + caption exactly like initial state
            this.filterTag.setTagObjs([]);
            this.filterTag.setTagObjs(restoredTagObjs);
            restoredTagObjs.forEach(tag => this.filterTag['addHtmlTag'](tag));
        } else {
            this.filterTag.resetTagContainer();
        }

        if(restoredReviewedBy){
            this.filterReviewTag.setOption(restoredReviewedBy);
        }

        // Clear temps
        vm.tempTagObjs(null);
        vm.tempSelectedTags(null);
        vm.tempIdPrimaryTag(null);
        vm.tempTagReviewedByArticle(null);
        vm.articleDetailsModalType("");

        vm.articleDetailsModal(false);
    }

    public onClickSaveTagItems(){
        const vm = this.getTemplateViewModel();
        const reviewTag = this.filterReviewTag.getOptionObj();

        if(reviewTag && reviewTag.id){
            this.getTemplateViewModel().tagReviewedByArticle(reviewTag);
        }else{
            this.getTemplateViewModel().tagReviewedByArticle(null);
        }
        vm.tempTagObjs(null);
        vm.tempSelectedTags(null);
        vm.tempIdPrimaryTag(null);
        vm.tempTagReviewedByArticle(null);
        vm.articleDetailsModalType("");

        vm.articleDetailsModal(false);
    }

    public saveArticleTagSectionState(){
        const vm = this.getTemplateViewModel();
        const ftVM = this.filterTag.getTemplateViewModel();

        // Deep clones so edits won't mutate the temps
        vm.tempTagObjs = ko.observable( JSON.parse(JSON.stringify(ftVM.tagObjs() || [])) );
        vm.tempSelectedTags = ko.observable( JSON.parse(JSON.stringify(vm.selectedTags() || [])) );
        vm.tempIdPrimaryTag = ko.observable(vm.idPrimaryTag());
        vm.tempTagReviewedByArticle = ko.observable(JSON.parse(JSON.stringify(vm.tagReviewedByArticle() || [])) );
    }

    public saveArticleCategorySectionState() {
        const vm = this.getTemplateViewModel();

        // Deep clone current state so changes inside the modal don’t leak
        vm.tempSelectedCategories = ko.observable(JSON.parse(JSON.stringify(vm.selectedCategories() || [])));
        vm.tempIdPrimaryCategory = ko.observable(vm.idPrimaryCategory());
        vm.tempCategoryItems = ko.observable(JSON.parse(JSON.stringify(this.filterCategory.getSelectedItems() || [])));
    }


    public onClickCloseCategoryItems() {
        const vm = this.getTemplateViewModel();
        const filterCategoryVM = this.filterCategory.getTemplateViewModel();
        const restoredSelected = JSON.parse(JSON.stringify(vm.tempSelectedCategories() || []));
        const restoredPrimary = vm.tempIdPrimaryCategory();

        // Restore observables
        vm.selectedCategories(restoredSelected);
        vm.idPrimaryCategory(restoredPrimary);

        // Reset the dropdown & tag container UI
        const tagContainer = this.filterCategory && this.filterCategory.getTagContainer
        ? this.filterCategory.getTagContainer()
        : null;

        if (tagContainer) {
            tagContainer.innerHTML = '';
        }

        // Rebuild the DOM display using the multipleSelector_template helper
        this.filterCategory.setSelectedItems(restoredSelected.map(c => c.category)); // expects array of {id}
        this.filterCategory.setTags(
            this.filterCategory.getSelectedItems(),
            this.filterCategory.getItems()
        );

        // Clear temp vars
        vm.tempSelectedCategories([]);
        vm.tempIdPrimaryCategory(null);
        vm.tempCategoryItems([]);
        vm.articleDetailsModalType("");

        // Close modal/lightbox
        vm.articleDetailsModal(false);
    }

    public onClickSaveCategoryItems() {
        const vm = this.getTemplateViewModel();

        vm.tempSelectedCategories([]);
        vm.tempIdPrimaryCategory(null);
        vm.tempCategoryItems([]);
        vm.articleDetailsModalType("");

        // Close modal/lightbox
        vm.articleDetailsModal(false);
    }

    public resetArticleDetailsModalTemps(){
        //this.onClickCloseArticleHeader();
        this.onClickCloseFeaturedItems();
        this.onClickCloseTagItems();
        this.onClickCloseCategoryItems();
    }

    public attachClickHandler() {
        this.documentClickHandler = (event: MouseEvent) => {
            const dropdown = document.getElementById('display-options-dropdown-menu');
            const toggleButton = document.querySelector('[data-bind*="onClickDisplayOptionToggle"]');
            if (!dropdown || !toggleButton) return;

            const target = event.target as Node;
            if (!dropdown.contains(target) && !toggleButton.contains(target)) {
            dropdown.classList.remove('is-visible');
            }
        };

        document.addEventListener('click', this.documentClickHandler);

        this.popstateHandler = () => this.detachClickHandler();
        window.addEventListener('popstate', this.popstateHandler);
    }

    public attachWindowResizeHandler(){
        window.addEventListener('resize', () => {
            this.resizeTextareaOnClick();
        });
    }

    public resizeTextareaOnClick() {
        document.querySelectorAll('textarea.auto-resize').forEach((el: any) => {
            el.style.height = '';
            const neededHeight = el.scrollHeight;
            el.style.height = neededHeight + 'px';
        });
    }

    public detachClickHandler() {
        if (this.documentClickHandler) {
            document.removeEventListener('click', this.documentClickHandler);
            this.documentClickHandler = undefined;
        }
        if (this.popstateHandler) {
            window.removeEventListener('popstate', this.popstateHandler);
            this.popstateHandler = undefined;
        }
        // Also cleanup save shortcut when navigating away
        this.detachSaveShortcut();
    }

    public onClickGenerateThreadSummary(data, event) {
        if(this.getTemplateViewModel().aiThreadSummary()) {
            this.warningDialog_threadSummary.setIsVisible(true);
        }else{
            this.caller.saveThreadSummary(true);
        }
    }

    public setisAiThreadSummaryEnabled(isAiThreadSummaryEnabled: boolean) {
        this.getTemplateViewModel().isAiThreadSummaryEnabled(isAiThreadSummaryEnabled);
    }

    public setAiArticleThreadSummary(threadSummary) {
        if(threadSummary){
            this.getTemplateViewModel().aiThreadSummary(threadSummary);
        }
    }

    public setAiArticleThreadSummaryFeatureAvailable(toggle) {
        this.getTemplateViewModel().aiThreadSummaryFeatureAvailable(toggle);
    }

    public updateArticleRecommendationAtIndex(index, article) {
        this.articleRecommendations.updateArticleRecommendationAtIndex(index, article);
    }

    public onPermalinkFocus (_data: any, _event: FocusEvent){
        const vm = this.getTemplateViewModel();

        vm.tempPermalink = ko.observable(vm.permalink());
    }

    public onTitleFocus (_data: any, _event){
        const vm = this.getTemplateViewModel();

        vm.tempTitle = ko.observable(vm.title());
        this.resizeTextareaOnClick();
    }

    public onExcerptFocus (_data: any, _event: FocusEvent) {
        const vm = this.getTemplateViewModel();
        vm.tempExcerpt = ko.observable(vm.excerpt());
        this.resizeTextareaOnClick();
    }

    public onEnterAndTabBehavior(event){

        const vm = this.getTemplateViewModel();
        if (event.key === 'Tab' && event.shiftKey) {
            return;
        }

        event.preventDefault();
        const focusables = Array.from(
            document.querySelectorAll<HTMLElement>(
            'input, textarea, [tabindex]:not([tabindex="-1"])'
            )
        ).filter(el => !(el as any).disabled && el.offsetParent !== null);

        const target = event.target as HTMLElement;
        const idx = focusables.indexOf(target);
        if (idx > -1 && idx + 1 < focusables.length) {
            focusables[idx + 1].focus();
        }

    }

    public onClickOpenThumbnail(){
        const vm = this.getTemplateViewModel();
        const thumbnailImage = this.imageWidgetForThumbnailImage.getImage();
        vm.tempThumbnailImage       = ko.observable(thumbnailImage);

        if(thumbnailImage){
            this.imageWidgetForThumbnailImage.editImage();
        }else{
            this.imageWidgetForThumbnailImage.addImage();
        }

    }

    public onClickSelectFeaturedImage() {
        // TODO: Implement featured image selection logic
        this.getTemplateViewModel().featuredSectionValue("featuredImage");
        this.imagePickerHelper.addImage("featured_image","single-select");
    }

    public onClickSelectFeaturedTag() {
        // TODO: Implement featured tag selection logic
        this.getTemplateViewModel().featuredSectionValue("featuredTag");
        this.onClickFeaturedTag(null);
    }

    public onClickToggleFeaturedToolbar() {
        const vm = this.getTemplateViewModel();
        vm.isFeaturedToolbarVisible(!vm.isFeaturedToolbarVisible());
    }

    public attachSaveShortcut(){
        //Call save and stay with CMD + Shift + S in mac and CTRL + Shift + S in windows
        const isMac = /Mac|iPhone|iPod|iPad/i.test(navigator.platform) ||
                         /Mac|iPhone|iPod|iPad/i.test(navigator.userAgent);

        // Store the handler so we can remove it later
        this.saveShortcutHandler = (event: any) => {
            var e = event || window.event;

            // Detect Cmd+S (Mac)
            if (isMac && e.metaKey && !e.shiftKey && e.keyCode === 83) {
                e.preventDefault();
                e.stopPropagation();
                this.onClickSaveAndStay();
                return false;
            }

            // Detect Ctrl+S (Windows)
            if (!isMac && e.ctrlKey && !e.shiftKey && e.keyCode === 83) {
                e.preventDefault();
                e.stopPropagation();
                this.onClickSaveAndStay();
                return false;
            }
        };

        window.addEventListener('keydown', this.saveShortcutHandler);

        // Also listen for navigation events to cleanup
        this.saveShortcutPopstateHandler = () => this.detachSaveShortcut();
        window.addEventListener('popstate', this.saveShortcutPopstateHandler);

        // Listen for beforeunload to cleanup
        this.saveShortcutBeforeUnloadHandler = () => this.detachSaveShortcut();
        window.addEventListener('beforeunload', this.saveShortcutBeforeUnloadHandler);
    }

    public detachSaveShortcut() {
        if (this.saveShortcutHandler) {
            window.removeEventListener('keydown', this.saveShortcutHandler);
            this.saveShortcutHandler = undefined;
        }
        if (this.saveShortcutPopstateHandler) {
            window.removeEventListener('popstate', this.saveShortcutPopstateHandler);
            this.saveShortcutPopstateHandler = undefined;
        }
        if (this.saveShortcutBeforeUnloadHandler) {
            window.removeEventListener('beforeunload', this.saveShortcutBeforeUnloadHandler);
            this.saveShortcutBeforeUnloadHandler = undefined;
        }
    }

    public setIsAutoLinkerEnabled(isAutoLinkerEnabled) {
        this.getTemplateViewModel().isAutoLinkerEnabled(isAutoLinkerEnabled);
    }

    public getIsAutoLinkerEnabled() {
        return this.getTemplateViewModel().isAutoLinkerEnabled();
    }

    public setFilterListingPagesAutoComplete(listingPages: Array<HubPageSearchResult>, listingPageIdElement: string): void {


        switch (listingPageIdElement) {
            case 'dealsCategoryPromotionListingPageFilter':
                this.dealsCategoryPromotionListingPageFilter.setOptions(listingPages);
                break;
            default:
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/articlesEdit_template_new.ts